/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.FindProviderRequest = (function() {

    /**
     * Properties of a FindProviderRequest.
     * @exports IFindProviderRequest
     * @interface IFindProviderRequest
     * @property {string|null} [category] FindProviderRequest category
     * @property {number|null} [north] FindProviderRequest north
     * @property {number|null} [south] FindProviderRequest south
     * @property {number|null} [east] FindProviderRequest east
     * @property {number|null} [west] FindProviderRequest west
     * @property {number|null} [page] FindProviderRequest page
     */

    /**
     * Constructs a new FindProviderRequest.
     * @exports FindProviderRequest
     * @classdesc Represents a FindProviderRequest.
     * @implements IFindProviderRequest
     * @constructor
     * @param {IFindProviderRequest=} [properties] Properties to set
     */
    function FindProviderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FindProviderRequest category.
     * @member {string} category
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.category = "";

    /**
     * FindProviderRequest north.
     * @member {number} north
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.north = 0;

    /**
     * FindProviderRequest south.
     * @member {number} south
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.south = 0;

    /**
     * FindProviderRequest east.
     * @member {number} east
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.east = 0;

    /**
     * FindProviderRequest west.
     * @member {number} west
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.west = 0;

    /**
     * FindProviderRequest page.
     * @member {number} page
     * @memberof FindProviderRequest
     * @instance
     */
    FindProviderRequest.prototype.page = 0;

    /**
     * Creates a new FindProviderRequest instance using the specified properties.
     * @function create
     * @memberof FindProviderRequest
     * @static
     * @param {IFindProviderRequest=} [properties] Properties to set
     * @returns {FindProviderRequest} FindProviderRequest instance
     */
    FindProviderRequest.create = function create(properties) {
        return new FindProviderRequest(properties);
    };

    /**
     * Encodes the specified FindProviderRequest message. Does not implicitly {@link FindProviderRequest.verify|verify} messages.
     * @function encode
     * @memberof FindProviderRequest
     * @static
     * @param {IFindProviderRequest} message FindProviderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FindProviderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.category != null && Object.hasOwnProperty.call(message, "category"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.category);
        if (message.north != null && Object.hasOwnProperty.call(message, "north"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.north);
        if (message.south != null && Object.hasOwnProperty.call(message, "south"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.south);
        if (message.east != null && Object.hasOwnProperty.call(message, "east"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.east);
        if (message.west != null && Object.hasOwnProperty.call(message, "west"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.west);
        if (message.page != null && Object.hasOwnProperty.call(message, "page"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.page);
        return writer;
    };

    /**
     * Encodes the specified FindProviderRequest message, length delimited. Does not implicitly {@link FindProviderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FindProviderRequest
     * @static
     * @param {IFindProviderRequest} message FindProviderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FindProviderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FindProviderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof FindProviderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FindProviderRequest} FindProviderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FindProviderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FindProviderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.category = reader.string();
                    break;
                }
            case 2: {
                    message.north = reader.double();
                    break;
                }
            case 3: {
                    message.south = reader.double();
                    break;
                }
            case 4: {
                    message.east = reader.double();
                    break;
                }
            case 5: {
                    message.west = reader.double();
                    break;
                }
            case 10: {
                    message.page = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FindProviderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FindProviderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FindProviderRequest} FindProviderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FindProviderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FindProviderRequest message.
     * @function verify
     * @memberof FindProviderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FindProviderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.category != null && message.hasOwnProperty("category"))
            if (!$util.isString(message.category))
                return "category: string expected";
        if (message.north != null && message.hasOwnProperty("north"))
            if (typeof message.north !== "number")
                return "north: number expected";
        if (message.south != null && message.hasOwnProperty("south"))
            if (typeof message.south !== "number")
                return "south: number expected";
        if (message.east != null && message.hasOwnProperty("east"))
            if (typeof message.east !== "number")
                return "east: number expected";
        if (message.west != null && message.hasOwnProperty("west"))
            if (typeof message.west !== "number")
                return "west: number expected";
        if (message.page != null && message.hasOwnProperty("page"))
            if (!$util.isInteger(message.page))
                return "page: integer expected";
        return null;
    };

    /**
     * Creates a FindProviderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FindProviderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FindProviderRequest} FindProviderRequest
     */
    FindProviderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.FindProviderRequest)
            return object;
        var message = new $root.FindProviderRequest();
        if (object.category != null)
            message.category = String(object.category);
        if (object.north != null)
            message.north = Number(object.north);
        if (object.south != null)
            message.south = Number(object.south);
        if (object.east != null)
            message.east = Number(object.east);
        if (object.west != null)
            message.west = Number(object.west);
        if (object.page != null)
            message.page = object.page | 0;
        return message;
    };

    /**
     * Creates a plain object from a FindProviderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FindProviderRequest
     * @static
     * @param {FindProviderRequest} message FindProviderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FindProviderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.category = "";
            object.north = 0;
            object.south = 0;
            object.east = 0;
            object.west = 0;
            object.page = 0;
        }
        if (message.category != null && message.hasOwnProperty("category"))
            object.category = message.category;
        if (message.north != null && message.hasOwnProperty("north"))
            object.north = options.json && !isFinite(message.north) ? String(message.north) : message.north;
        if (message.south != null && message.hasOwnProperty("south"))
            object.south = options.json && !isFinite(message.south) ? String(message.south) : message.south;
        if (message.east != null && message.hasOwnProperty("east"))
            object.east = options.json && !isFinite(message.east) ? String(message.east) : message.east;
        if (message.west != null && message.hasOwnProperty("west"))
            object.west = options.json && !isFinite(message.west) ? String(message.west) : message.west;
        if (message.page != null && message.hasOwnProperty("page"))
            object.page = message.page;
        return object;
    };

    /**
     * Converts this FindProviderRequest to JSON.
     * @function toJSON
     * @memberof FindProviderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FindProviderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FindProviderRequest
     * @function getTypeUrl
     * @memberof FindProviderRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FindProviderRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FindProviderRequest";
    };

    return FindProviderRequest;
})();

$root.FindProviderResponse = (function() {

    /**
     * Properties of a FindProviderResponse.
     * @exports IFindProviderResponse
     * @interface IFindProviderResponse
     * @property {boolean|null} [okay] FindProviderResponse okay
     * @property {Array.<IProviderSearchResult>|null} [providers] FindProviderResponse providers
     * @property {boolean|null} [viewportTooLarge] FindProviderResponse viewportTooLarge
     */

    /**
     * Constructs a new FindProviderResponse.
     * @exports FindProviderResponse
     * @classdesc Represents a FindProviderResponse.
     * @implements IFindProviderResponse
     * @constructor
     * @param {IFindProviderResponse=} [properties] Properties to set
     */
    function FindProviderResponse(properties) {
        this.providers = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FindProviderResponse okay.
     * @member {boolean} okay
     * @memberof FindProviderResponse
     * @instance
     */
    FindProviderResponse.prototype.okay = false;

    /**
     * FindProviderResponse providers.
     * @member {Array.<IProviderSearchResult>} providers
     * @memberof FindProviderResponse
     * @instance
     */
    FindProviderResponse.prototype.providers = $util.emptyArray;

    /**
     * FindProviderResponse viewportTooLarge.
     * @member {boolean} viewportTooLarge
     * @memberof FindProviderResponse
     * @instance
     */
    FindProviderResponse.prototype.viewportTooLarge = false;

    /**
     * Creates a new FindProviderResponse instance using the specified properties.
     * @function create
     * @memberof FindProviderResponse
     * @static
     * @param {IFindProviderResponse=} [properties] Properties to set
     * @returns {FindProviderResponse} FindProviderResponse instance
     */
    FindProviderResponse.create = function create(properties) {
        return new FindProviderResponse(properties);
    };

    /**
     * Encodes the specified FindProviderResponse message. Does not implicitly {@link FindProviderResponse.verify|verify} messages.
     * @function encode
     * @memberof FindProviderResponse
     * @static
     * @param {IFindProviderResponse} message FindProviderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FindProviderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.providers != null && message.providers.length)
            for (var i = 0; i < message.providers.length; ++i)
                $root.ProviderSearchResult.encode(message.providers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.viewportTooLarge != null && Object.hasOwnProperty.call(message, "viewportTooLarge"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.viewportTooLarge);
        return writer;
    };

    /**
     * Encodes the specified FindProviderResponse message, length delimited. Does not implicitly {@link FindProviderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FindProviderResponse
     * @static
     * @param {IFindProviderResponse} message FindProviderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FindProviderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FindProviderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof FindProviderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FindProviderResponse} FindProviderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FindProviderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FindProviderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.providers && message.providers.length))
                        message.providers = [];
                    message.providers.push($root.ProviderSearchResult.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.viewportTooLarge = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FindProviderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FindProviderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FindProviderResponse} FindProviderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FindProviderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FindProviderResponse message.
     * @function verify
     * @memberof FindProviderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FindProviderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.providers != null && message.hasOwnProperty("providers")) {
            if (!Array.isArray(message.providers))
                return "providers: array expected";
            for (var i = 0; i < message.providers.length; ++i) {
                var error = $root.ProviderSearchResult.verify(message.providers[i]);
                if (error)
                    return "providers." + error;
            }
        }
        if (message.viewportTooLarge != null && message.hasOwnProperty("viewportTooLarge"))
            if (typeof message.viewportTooLarge !== "boolean")
                return "viewportTooLarge: boolean expected";
        return null;
    };

    /**
     * Creates a FindProviderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FindProviderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FindProviderResponse} FindProviderResponse
     */
    FindProviderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.FindProviderResponse)
            return object;
        var message = new $root.FindProviderResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.providers) {
            if (!Array.isArray(object.providers))
                throw TypeError(".FindProviderResponse.providers: array expected");
            message.providers = [];
            for (var i = 0; i < object.providers.length; ++i) {
                if (typeof object.providers[i] !== "object")
                    throw TypeError(".FindProviderResponse.providers: object expected");
                message.providers[i] = $root.ProviderSearchResult.fromObject(object.providers[i]);
            }
        }
        if (object.viewportTooLarge != null)
            message.viewportTooLarge = Boolean(object.viewportTooLarge);
        return message;
    };

    /**
     * Creates a plain object from a FindProviderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FindProviderResponse
     * @static
     * @param {FindProviderResponse} message FindProviderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FindProviderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.providers = [];
        if (options.defaults) {
            object.okay = false;
            object.viewportTooLarge = false;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.providers && message.providers.length) {
            object.providers = [];
            for (var j = 0; j < message.providers.length; ++j)
                object.providers[j] = $root.ProviderSearchResult.toObject(message.providers[j], options);
        }
        if (message.viewportTooLarge != null && message.hasOwnProperty("viewportTooLarge"))
            object.viewportTooLarge = message.viewportTooLarge;
        return object;
    };

    /**
     * Converts this FindProviderResponse to JSON.
     * @function toJSON
     * @memberof FindProviderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FindProviderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FindProviderResponse
     * @function getTypeUrl
     * @memberof FindProviderResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FindProviderResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FindProviderResponse";
    };

    return FindProviderResponse;
})();

$root.ProviderSearchResult = (function() {

    /**
     * Properties of a ProviderSearchResult.
     * @exports IProviderSearchResult
     * @interface IProviderSearchResult
     * @property {string|null} [businessId] ProviderSearchResult businessId
     * @property {IPublicBusinessProfileProto|null} [businessProfile] ProviderSearchResult businessProfile
     * @property {space.kenko.proto.IBusinessLocationProto|null} [location] ProviderSearchResult location
     */

    /**
     * Constructs a new ProviderSearchResult.
     * @exports ProviderSearchResult
     * @classdesc Represents a ProviderSearchResult.
     * @implements IProviderSearchResult
     * @constructor
     * @param {IProviderSearchResult=} [properties] Properties to set
     */
    function ProviderSearchResult(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ProviderSearchResult businessId.
     * @member {string} businessId
     * @memberof ProviderSearchResult
     * @instance
     */
    ProviderSearchResult.prototype.businessId = "";

    /**
     * ProviderSearchResult businessProfile.
     * @member {IPublicBusinessProfileProto|null|undefined} businessProfile
     * @memberof ProviderSearchResult
     * @instance
     */
    ProviderSearchResult.prototype.businessProfile = null;

    /**
     * ProviderSearchResult location.
     * @member {space.kenko.proto.IBusinessLocationProto|null|undefined} location
     * @memberof ProviderSearchResult
     * @instance
     */
    ProviderSearchResult.prototype.location = null;

    /**
     * Creates a new ProviderSearchResult instance using the specified properties.
     * @function create
     * @memberof ProviderSearchResult
     * @static
     * @param {IProviderSearchResult=} [properties] Properties to set
     * @returns {ProviderSearchResult} ProviderSearchResult instance
     */
    ProviderSearchResult.create = function create(properties) {
        return new ProviderSearchResult(properties);
    };

    /**
     * Encodes the specified ProviderSearchResult message. Does not implicitly {@link ProviderSearchResult.verify|verify} messages.
     * @function encode
     * @memberof ProviderSearchResult
     * @static
     * @param {IProviderSearchResult} message ProviderSearchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderSearchResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.businessProfile != null && Object.hasOwnProperty.call(message, "businessProfile"))
            $root.PublicBusinessProfileProto.encode(message.businessProfile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
            $root.space.kenko.proto.BusinessLocationProto.encode(message.location, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ProviderSearchResult message, length delimited. Does not implicitly {@link ProviderSearchResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProviderSearchResult
     * @static
     * @param {IProviderSearchResult} message ProviderSearchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderSearchResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProviderSearchResult message from the specified reader or buffer.
     * @function decode
     * @memberof ProviderSearchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProviderSearchResult} ProviderSearchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderSearchResult.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProviderSearchResult();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.businessProfile = $root.PublicBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.location = $root.space.kenko.proto.BusinessLocationProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProviderSearchResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProviderSearchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProviderSearchResult} ProviderSearchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderSearchResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProviderSearchResult message.
     * @function verify
     * @memberof ProviderSearchResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProviderSearchResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile")) {
            var error = $root.PublicBusinessProfileProto.verify(message.businessProfile);
            if (error)
                return "businessProfile." + error;
        }
        if (message.location != null && message.hasOwnProperty("location")) {
            var error = $root.space.kenko.proto.BusinessLocationProto.verify(message.location);
            if (error)
                return "location." + error;
        }
        return null;
    };

    /**
     * Creates a ProviderSearchResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProviderSearchResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProviderSearchResult} ProviderSearchResult
     */
    ProviderSearchResult.fromObject = function fromObject(object) {
        if (object instanceof $root.ProviderSearchResult)
            return object;
        var message = new $root.ProviderSearchResult();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.businessProfile != null) {
            if (typeof object.businessProfile !== "object")
                throw TypeError(".ProviderSearchResult.businessProfile: object expected");
            message.businessProfile = $root.PublicBusinessProfileProto.fromObject(object.businessProfile);
        }
        if (object.location != null) {
            if (typeof object.location !== "object")
                throw TypeError(".ProviderSearchResult.location: object expected");
            message.location = $root.space.kenko.proto.BusinessLocationProto.fromObject(object.location);
        }
        return message;
    };

    /**
     * Creates a plain object from a ProviderSearchResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProviderSearchResult
     * @static
     * @param {ProviderSearchResult} message ProviderSearchResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProviderSearchResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.businessProfile = null;
            object.location = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile"))
            object.businessProfile = $root.PublicBusinessProfileProto.toObject(message.businessProfile, options);
        if (message.location != null && message.hasOwnProperty("location"))
            object.location = $root.space.kenko.proto.BusinessLocationProto.toObject(message.location, options);
        return object;
    };

    /**
     * Converts this ProviderSearchResult to JSON.
     * @function toJSON
     * @memberof ProviderSearchResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProviderSearchResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ProviderSearchResult
     * @function getTypeUrl
     * @memberof ProviderSearchResult
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ProviderSearchResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProviderSearchResult";
    };

    return ProviderSearchResult;
})();

$root.PublicBusinessProfileProto = (function() {

    /**
     * Properties of a PublicBusinessProfileProto.
     * @exports IPublicBusinessProfileProto
     * @interface IPublicBusinessProfileProto
     * @property {string|null} [businessName] PublicBusinessProfileProto businessName
     * @property {string|null} [businessDescription] PublicBusinessProfileProto businessDescription
     * @property {string|null} [websiteUrl] PublicBusinessProfileProto websiteUrl
     * @property {string|null} [imageUrl] PublicBusinessProfileProto imageUrl
     * @property {Array.<string>|null} [servicesOffered] PublicBusinessProfileProto servicesOffered
     * @property {boolean|null} [hasBooking] PublicBusinessProfileProto hasBooking
     */

    /**
     * Constructs a new PublicBusinessProfileProto.
     * @exports PublicBusinessProfileProto
     * @classdesc Represents a PublicBusinessProfileProto.
     * @implements IPublicBusinessProfileProto
     * @constructor
     * @param {IPublicBusinessProfileProto=} [properties] Properties to set
     */
    function PublicBusinessProfileProto(properties) {
        this.servicesOffered = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PublicBusinessProfileProto businessName.
     * @member {string} businessName
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.businessName = "";

    /**
     * PublicBusinessProfileProto businessDescription.
     * @member {string} businessDescription
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.businessDescription = "";

    /**
     * PublicBusinessProfileProto websiteUrl.
     * @member {string} websiteUrl
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.websiteUrl = "";

    /**
     * PublicBusinessProfileProto imageUrl.
     * @member {string} imageUrl
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.imageUrl = "";

    /**
     * PublicBusinessProfileProto servicesOffered.
     * @member {Array.<string>} servicesOffered
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.servicesOffered = $util.emptyArray;

    /**
     * PublicBusinessProfileProto hasBooking.
     * @member {boolean} hasBooking
     * @memberof PublicBusinessProfileProto
     * @instance
     */
    PublicBusinessProfileProto.prototype.hasBooking = false;

    /**
     * Creates a new PublicBusinessProfileProto instance using the specified properties.
     * @function create
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {IPublicBusinessProfileProto=} [properties] Properties to set
     * @returns {PublicBusinessProfileProto} PublicBusinessProfileProto instance
     */
    PublicBusinessProfileProto.create = function create(properties) {
        return new PublicBusinessProfileProto(properties);
    };

    /**
     * Encodes the specified PublicBusinessProfileProto message. Does not implicitly {@link PublicBusinessProfileProto.verify|verify} messages.
     * @function encode
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {IPublicBusinessProfileProto} message PublicBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBusinessProfileProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
        if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessDescription);
        if (message.websiteUrl != null && Object.hasOwnProperty.call(message, "websiteUrl"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.websiteUrl);
        if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.imageUrl);
        if (message.servicesOffered != null && message.servicesOffered.length)
            for (var i = 0; i < message.servicesOffered.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.servicesOffered[i]);
        if (message.hasBooking != null && Object.hasOwnProperty.call(message, "hasBooking"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.hasBooking);
        return writer;
    };

    /**
     * Encodes the specified PublicBusinessProfileProto message, length delimited. Does not implicitly {@link PublicBusinessProfileProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {IPublicBusinessProfileProto} message PublicBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PublicBusinessProfileProto message from the specified reader or buffer.
     * @function decode
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicBusinessProfileProto} PublicBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBusinessProfileProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicBusinessProfileProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessName = reader.string();
                    break;
                }
            case 2: {
                    message.businessDescription = reader.string();
                    break;
                }
            case 3: {
                    message.websiteUrl = reader.string();
                    break;
                }
            case 4: {
                    message.imageUrl = reader.string();
                    break;
                }
            case 5: {
                    if (!(message.servicesOffered && message.servicesOffered.length))
                        message.servicesOffered = [];
                    message.servicesOffered.push(reader.string());
                    break;
                }
            case 6: {
                    message.hasBooking = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PublicBusinessProfileProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicBusinessProfileProto} PublicBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PublicBusinessProfileProto message.
     * @function verify
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicBusinessProfileProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessName != null && message.hasOwnProperty("businessName"))
            if (!$util.isString(message.businessName))
                return "businessName: string expected";
        if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
            if (!$util.isString(message.businessDescription))
                return "businessDescription: string expected";
        if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
            if (!$util.isString(message.websiteUrl))
                return "websiteUrl: string expected";
        if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
            if (!$util.isString(message.imageUrl))
                return "imageUrl: string expected";
        if (message.servicesOffered != null && message.hasOwnProperty("servicesOffered")) {
            if (!Array.isArray(message.servicesOffered))
                return "servicesOffered: array expected";
            for (var i = 0; i < message.servicesOffered.length; ++i)
                if (!$util.isString(message.servicesOffered[i]))
                    return "servicesOffered: string[] expected";
        }
        if (message.hasBooking != null && message.hasOwnProperty("hasBooking"))
            if (typeof message.hasBooking !== "boolean")
                return "hasBooking: boolean expected";
        return null;
    };

    /**
     * Creates a PublicBusinessProfileProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicBusinessProfileProto} PublicBusinessProfileProto
     */
    PublicBusinessProfileProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicBusinessProfileProto)
            return object;
        var message = new $root.PublicBusinessProfileProto();
        if (object.businessName != null)
            message.businessName = String(object.businessName);
        if (object.businessDescription != null)
            message.businessDescription = String(object.businessDescription);
        if (object.websiteUrl != null)
            message.websiteUrl = String(object.websiteUrl);
        if (object.imageUrl != null)
            message.imageUrl = String(object.imageUrl);
        if (object.servicesOffered) {
            if (!Array.isArray(object.servicesOffered))
                throw TypeError(".PublicBusinessProfileProto.servicesOffered: array expected");
            message.servicesOffered = [];
            for (var i = 0; i < object.servicesOffered.length; ++i)
                message.servicesOffered[i] = String(object.servicesOffered[i]);
        }
        if (object.hasBooking != null)
            message.hasBooking = Boolean(object.hasBooking);
        return message;
    };

    /**
     * Creates a plain object from a PublicBusinessProfileProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {PublicBusinessProfileProto} message PublicBusinessProfileProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicBusinessProfileProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.servicesOffered = [];
        if (options.defaults) {
            object.businessName = "";
            object.businessDescription = "";
            object.websiteUrl = "";
            object.imageUrl = "";
            object.hasBooking = false;
        }
        if (message.businessName != null && message.hasOwnProperty("businessName"))
            object.businessName = message.businessName;
        if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
            object.businessDescription = message.businessDescription;
        if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
            object.websiteUrl = message.websiteUrl;
        if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
            object.imageUrl = message.imageUrl;
        if (message.servicesOffered && message.servicesOffered.length) {
            object.servicesOffered = [];
            for (var j = 0; j < message.servicesOffered.length; ++j)
                object.servicesOffered[j] = message.servicesOffered[j];
        }
        if (message.hasBooking != null && message.hasOwnProperty("hasBooking"))
            object.hasBooking = message.hasBooking;
        return object;
    };

    /**
     * Converts this PublicBusinessProfileProto to JSON.
     * @function toJSON
     * @memberof PublicBusinessProfileProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicBusinessProfileProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PublicBusinessProfileProto
     * @function getTypeUrl
     * @memberof PublicBusinessProfileProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicBusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicBusinessProfileProto";
    };

    return PublicBusinessProfileProto;
})();

$root.GetBookingInfoRequest = (function() {

    /**
     * Properties of a GetBookingInfoRequest.
     * @exports IGetBookingInfoRequest
     * @interface IGetBookingInfoRequest
     * @property {string|null} [businessId] GetBookingInfoRequest businessId
     * @property {string|null} [version] GetBookingInfoRequest version
     */

    /**
     * Constructs a new GetBookingInfoRequest.
     * @exports GetBookingInfoRequest
     * @classdesc Represents a GetBookingInfoRequest.
     * @implements IGetBookingInfoRequest
     * @constructor
     * @param {IGetBookingInfoRequest=} [properties] Properties to set
     */
    function GetBookingInfoRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBookingInfoRequest businessId.
     * @member {string} businessId
     * @memberof GetBookingInfoRequest
     * @instance
     */
    GetBookingInfoRequest.prototype.businessId = "";

    /**
     * GetBookingInfoRequest version.
     * @member {string} version
     * @memberof GetBookingInfoRequest
     * @instance
     */
    GetBookingInfoRequest.prototype.version = "";

    /**
     * Creates a new GetBookingInfoRequest instance using the specified properties.
     * @function create
     * @memberof GetBookingInfoRequest
     * @static
     * @param {IGetBookingInfoRequest=} [properties] Properties to set
     * @returns {GetBookingInfoRequest} GetBookingInfoRequest instance
     */
    GetBookingInfoRequest.create = function create(properties) {
        return new GetBookingInfoRequest(properties);
    };

    /**
     * Encodes the specified GetBookingInfoRequest message. Does not implicitly {@link GetBookingInfoRequest.verify|verify} messages.
     * @function encode
     * @memberof GetBookingInfoRequest
     * @static
     * @param {IGetBookingInfoRequest} message GetBookingInfoRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingInfoRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
        return writer;
    };

    /**
     * Encodes the specified GetBookingInfoRequest message, length delimited. Does not implicitly {@link GetBookingInfoRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetBookingInfoRequest
     * @static
     * @param {IGetBookingInfoRequest} message GetBookingInfoRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingInfoRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBookingInfoRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetBookingInfoRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetBookingInfoRequest} GetBookingInfoRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingInfoRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetBookingInfoRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.version = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetBookingInfoRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetBookingInfoRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetBookingInfoRequest} GetBookingInfoRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingInfoRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBookingInfoRequest message.
     * @function verify
     * @memberof GetBookingInfoRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBookingInfoRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isString(message.version))
                return "version: string expected";
        return null;
    };

    /**
     * Creates a GetBookingInfoRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetBookingInfoRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetBookingInfoRequest} GetBookingInfoRequest
     */
    GetBookingInfoRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetBookingInfoRequest)
            return object;
        var message = new $root.GetBookingInfoRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.version != null)
            message.version = String(object.version);
        return message;
    };

    /**
     * Creates a plain object from a GetBookingInfoRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetBookingInfoRequest
     * @static
     * @param {GetBookingInfoRequest} message GetBookingInfoRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBookingInfoRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.version = "";
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        return object;
    };

    /**
     * Converts this GetBookingInfoRequest to JSON.
     * @function toJSON
     * @memberof GetBookingInfoRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBookingInfoRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetBookingInfoRequest
     * @function getTypeUrl
     * @memberof GetBookingInfoRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetBookingInfoRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetBookingInfoRequest";
    };

    return GetBookingInfoRequest;
})();

$root.GetBookingInfoResponse = (function() {

    /**
     * Properties of a GetBookingInfoResponse.
     * @exports IGetBookingInfoResponse
     * @interface IGetBookingInfoResponse
     * @property {boolean|null} [okay] GetBookingInfoResponse okay
     * @property {IApiBusinessProfileProto|null} [businessProfile] GetBookingInfoResponse businessProfile
     * @property {IClientRelationshipDetailsProto|null} [clientRelationship] GetBookingInfoResponse clientRelationship
     * @property {IPublicBusinessInfoProto|null} [business] GetBookingInfoResponse business
     */

    /**
     * Constructs a new GetBookingInfoResponse.
     * @exports GetBookingInfoResponse
     * @classdesc Represents a GetBookingInfoResponse.
     * @implements IGetBookingInfoResponse
     * @constructor
     * @param {IGetBookingInfoResponse=} [properties] Properties to set
     */
    function GetBookingInfoResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBookingInfoResponse okay.
     * @member {boolean} okay
     * @memberof GetBookingInfoResponse
     * @instance
     */
    GetBookingInfoResponse.prototype.okay = false;

    /**
     * GetBookingInfoResponse businessProfile.
     * @member {IApiBusinessProfileProto|null|undefined} businessProfile
     * @memberof GetBookingInfoResponse
     * @instance
     */
    GetBookingInfoResponse.prototype.businessProfile = null;

    /**
     * GetBookingInfoResponse clientRelationship.
     * @member {IClientRelationshipDetailsProto|null|undefined} clientRelationship
     * @memberof GetBookingInfoResponse
     * @instance
     */
    GetBookingInfoResponse.prototype.clientRelationship = null;

    /**
     * GetBookingInfoResponse business.
     * @member {IPublicBusinessInfoProto|null|undefined} business
     * @memberof GetBookingInfoResponse
     * @instance
     */
    GetBookingInfoResponse.prototype.business = null;

    /**
     * Creates a new GetBookingInfoResponse instance using the specified properties.
     * @function create
     * @memberof GetBookingInfoResponse
     * @static
     * @param {IGetBookingInfoResponse=} [properties] Properties to set
     * @returns {GetBookingInfoResponse} GetBookingInfoResponse instance
     */
    GetBookingInfoResponse.create = function create(properties) {
        return new GetBookingInfoResponse(properties);
    };

    /**
     * Encodes the specified GetBookingInfoResponse message. Does not implicitly {@link GetBookingInfoResponse.verify|verify} messages.
     * @function encode
     * @memberof GetBookingInfoResponse
     * @static
     * @param {IGetBookingInfoResponse} message GetBookingInfoResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingInfoResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.businessProfile != null && Object.hasOwnProperty.call(message, "businessProfile"))
            $root.ApiBusinessProfileProto.encode(message.businessProfile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.clientRelationship != null && Object.hasOwnProperty.call(message, "clientRelationship"))
            $root.ClientRelationshipDetailsProto.encode(message.clientRelationship, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.PublicBusinessInfoProto.encode(message.business, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetBookingInfoResponse message, length delimited. Does not implicitly {@link GetBookingInfoResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetBookingInfoResponse
     * @static
     * @param {IGetBookingInfoResponse} message GetBookingInfoResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingInfoResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBookingInfoResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetBookingInfoResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetBookingInfoResponse} GetBookingInfoResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingInfoResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetBookingInfoResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.businessProfile = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.clientRelationship = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.business = $root.PublicBusinessInfoProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetBookingInfoResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetBookingInfoResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetBookingInfoResponse} GetBookingInfoResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingInfoResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBookingInfoResponse message.
     * @function verify
     * @memberof GetBookingInfoResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBookingInfoResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile")) {
            var error = $root.ApiBusinessProfileProto.verify(message.businessProfile);
            if (error)
                return "businessProfile." + error;
        }
        if (message.clientRelationship != null && message.hasOwnProperty("clientRelationship")) {
            var error = $root.ClientRelationshipDetailsProto.verify(message.clientRelationship);
            if (error)
                return "clientRelationship." + error;
        }
        if (message.business != null && message.hasOwnProperty("business")) {
            var error = $root.PublicBusinessInfoProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        return null;
    };

    /**
     * Creates a GetBookingInfoResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetBookingInfoResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetBookingInfoResponse} GetBookingInfoResponse
     */
    GetBookingInfoResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetBookingInfoResponse)
            return object;
        var message = new $root.GetBookingInfoResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.businessProfile != null) {
            if (typeof object.businessProfile !== "object")
                throw TypeError(".GetBookingInfoResponse.businessProfile: object expected");
            message.businessProfile = $root.ApiBusinessProfileProto.fromObject(object.businessProfile);
        }
        if (object.clientRelationship != null) {
            if (typeof object.clientRelationship !== "object")
                throw TypeError(".GetBookingInfoResponse.clientRelationship: object expected");
            message.clientRelationship = $root.ClientRelationshipDetailsProto.fromObject(object.clientRelationship);
        }
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".GetBookingInfoResponse.business: object expected");
            message.business = $root.PublicBusinessInfoProto.fromObject(object.business);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetBookingInfoResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetBookingInfoResponse
     * @static
     * @param {GetBookingInfoResponse} message GetBookingInfoResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBookingInfoResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.businessProfile = null;
            object.clientRelationship = null;
            object.business = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile"))
            object.businessProfile = $root.ApiBusinessProfileProto.toObject(message.businessProfile, options);
        if (message.clientRelationship != null && message.hasOwnProperty("clientRelationship"))
            object.clientRelationship = $root.ClientRelationshipDetailsProto.toObject(message.clientRelationship, options);
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.PublicBusinessInfoProto.toObject(message.business, options);
        return object;
    };

    /**
     * Converts this GetBookingInfoResponse to JSON.
     * @function toJSON
     * @memberof GetBookingInfoResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBookingInfoResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetBookingInfoResponse
     * @function getTypeUrl
     * @memberof GetBookingInfoResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetBookingInfoResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetBookingInfoResponse";
    };

    return GetBookingInfoResponse;
})();

$root.PublicBusinessInfoProto = (function() {

    /**
     * Properties of a PublicBusinessInfoProto.
     * @exports IPublicBusinessInfoProto
     * @interface IPublicBusinessInfoProto
     * @property {boolean|null} [newClientsMustInquire] PublicBusinessInfoProto newClientsMustInquire
     * @property {boolean|null} [offersAppointments] PublicBusinessInfoProto offersAppointments
     * @property {boolean|null} [offersClasses] PublicBusinessInfoProto offersClasses
     */

    /**
     * Constructs a new PublicBusinessInfoProto.
     * @exports PublicBusinessInfoProto
     * @classdesc Represents a PublicBusinessInfoProto.
     * @implements IPublicBusinessInfoProto
     * @constructor
     * @param {IPublicBusinessInfoProto=} [properties] Properties to set
     */
    function PublicBusinessInfoProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PublicBusinessInfoProto newClientsMustInquire.
     * @member {boolean} newClientsMustInquire
     * @memberof PublicBusinessInfoProto
     * @instance
     */
    PublicBusinessInfoProto.prototype.newClientsMustInquire = false;

    /**
     * PublicBusinessInfoProto offersAppointments.
     * @member {boolean} offersAppointments
     * @memberof PublicBusinessInfoProto
     * @instance
     */
    PublicBusinessInfoProto.prototype.offersAppointments = false;

    /**
     * PublicBusinessInfoProto offersClasses.
     * @member {boolean} offersClasses
     * @memberof PublicBusinessInfoProto
     * @instance
     */
    PublicBusinessInfoProto.prototype.offersClasses = false;

    /**
     * Creates a new PublicBusinessInfoProto instance using the specified properties.
     * @function create
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {IPublicBusinessInfoProto=} [properties] Properties to set
     * @returns {PublicBusinessInfoProto} PublicBusinessInfoProto instance
     */
    PublicBusinessInfoProto.create = function create(properties) {
        return new PublicBusinessInfoProto(properties);
    };

    /**
     * Encodes the specified PublicBusinessInfoProto message. Does not implicitly {@link PublicBusinessInfoProto.verify|verify} messages.
     * @function encode
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {IPublicBusinessInfoProto} message PublicBusinessInfoProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBusinessInfoProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.newClientsMustInquire != null && Object.hasOwnProperty.call(message, "newClientsMustInquire"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.newClientsMustInquire);
        if (message.offersAppointments != null && Object.hasOwnProperty.call(message, "offersAppointments"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.offersAppointments);
        if (message.offersClasses != null && Object.hasOwnProperty.call(message, "offersClasses"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.offersClasses);
        return writer;
    };

    /**
     * Encodes the specified PublicBusinessInfoProto message, length delimited. Does not implicitly {@link PublicBusinessInfoProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {IPublicBusinessInfoProto} message PublicBusinessInfoProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublicBusinessInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PublicBusinessInfoProto message from the specified reader or buffer.
     * @function decode
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublicBusinessInfoProto} PublicBusinessInfoProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBusinessInfoProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublicBusinessInfoProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.newClientsMustInquire = reader.bool();
                    break;
                }
            case 2: {
                    message.offersAppointments = reader.bool();
                    break;
                }
            case 3: {
                    message.offersClasses = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PublicBusinessInfoProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublicBusinessInfoProto} PublicBusinessInfoProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublicBusinessInfoProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PublicBusinessInfoProto message.
     * @function verify
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublicBusinessInfoProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
            if (typeof message.newClientsMustInquire !== "boolean")
                return "newClientsMustInquire: boolean expected";
        if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
            if (typeof message.offersAppointments !== "boolean")
                return "offersAppointments: boolean expected";
        if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
            if (typeof message.offersClasses !== "boolean")
                return "offersClasses: boolean expected";
        return null;
    };

    /**
     * Creates a PublicBusinessInfoProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublicBusinessInfoProto} PublicBusinessInfoProto
     */
    PublicBusinessInfoProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PublicBusinessInfoProto)
            return object;
        var message = new $root.PublicBusinessInfoProto();
        if (object.newClientsMustInquire != null)
            message.newClientsMustInquire = Boolean(object.newClientsMustInquire);
        if (object.offersAppointments != null)
            message.offersAppointments = Boolean(object.offersAppointments);
        if (object.offersClasses != null)
            message.offersClasses = Boolean(object.offersClasses);
        return message;
    };

    /**
     * Creates a plain object from a PublicBusinessInfoProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {PublicBusinessInfoProto} message PublicBusinessInfoProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublicBusinessInfoProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.newClientsMustInquire = false;
            object.offersAppointments = false;
            object.offersClasses = false;
        }
        if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
            object.newClientsMustInquire = message.newClientsMustInquire;
        if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
            object.offersAppointments = message.offersAppointments;
        if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
            object.offersClasses = message.offersClasses;
        return object;
    };

    /**
     * Converts this PublicBusinessInfoProto to JSON.
     * @function toJSON
     * @memberof PublicBusinessInfoProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublicBusinessInfoProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PublicBusinessInfoProto
     * @function getTypeUrl
     * @memberof PublicBusinessInfoProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublicBusinessInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublicBusinessInfoProto";
    };

    return PublicBusinessInfoProto;
})();

$root.ApiBusinessProfileProto = (function() {

    /**
     * Properties of an ApiBusinessProfileProto.
     * @exports IApiBusinessProfileProto
     * @interface IApiBusinessProfileProto
     * @property {string|null} [versionId] ApiBusinessProfileProto versionId
     * @property {number|Long|null} [lastModifiedTimestamp] ApiBusinessProfileProto lastModifiedTimestamp
     * @property {number|Long|null} [reviewTimestamp] ApiBusinessProfileProto reviewTimestamp
     * @property {space.kenko.proto.IBusinessProfileProto|null} [proto] ApiBusinessProfileProto proto
     * @property {Array.<space.kenko.proto.IBusinessLocationProto>|null} [locations] ApiBusinessProfileProto locations
     * @property {Array.<space.kenko.proto.IPractitionerProto>|null} [providers] ApiBusinessProfileProto providers
     * @property {string|null} [businessId] ApiBusinessProfileProto businessId
     * @property {boolean|null} [offersAppointments] ApiBusinessProfileProto offersAppointments
     * @property {boolean|null} [offersClasses] ApiBusinessProfileProto offersClasses
     * @property {space.kenko.proto.IPricingDetailsProto|null} [pricing] ApiBusinessProfileProto pricing
     * @property {space.kenko.proto.IPracticeDetailsProto|null} [practice] ApiBusinessProfileProto practice
     * @property {space.kenko.proto.IStudioDetailsProto|null} [studio] ApiBusinessProfileProto studio
     */

    /**
     * Constructs a new ApiBusinessProfileProto.
     * @exports ApiBusinessProfileProto
     * @classdesc Represents an ApiBusinessProfileProto.
     * @implements IApiBusinessProfileProto
     * @constructor
     * @param {IApiBusinessProfileProto=} [properties] Properties to set
     */
    function ApiBusinessProfileProto(properties) {
        this.locations = [];
        this.providers = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiBusinessProfileProto versionId.
     * @member {string} versionId
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.versionId = "";

    /**
     * ApiBusinessProfileProto lastModifiedTimestamp.
     * @member {number|Long} lastModifiedTimestamp
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.lastModifiedTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ApiBusinessProfileProto reviewTimestamp.
     * @member {number|Long} reviewTimestamp
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.reviewTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ApiBusinessProfileProto proto.
     * @member {space.kenko.proto.IBusinessProfileProto|null|undefined} proto
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.proto = null;

    /**
     * ApiBusinessProfileProto locations.
     * @member {Array.<space.kenko.proto.IBusinessLocationProto>} locations
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.locations = $util.emptyArray;

    /**
     * ApiBusinessProfileProto providers.
     * @member {Array.<space.kenko.proto.IPractitionerProto>} providers
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.providers = $util.emptyArray;

    /**
     * ApiBusinessProfileProto businessId.
     * @member {string} businessId
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.businessId = "";

    /**
     * ApiBusinessProfileProto offersAppointments.
     * @member {boolean} offersAppointments
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.offersAppointments = false;

    /**
     * ApiBusinessProfileProto offersClasses.
     * @member {boolean} offersClasses
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.offersClasses = false;

    /**
     * ApiBusinessProfileProto pricing.
     * @member {space.kenko.proto.IPricingDetailsProto|null|undefined} pricing
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.pricing = null;

    /**
     * ApiBusinessProfileProto practice.
     * @member {space.kenko.proto.IPracticeDetailsProto|null|undefined} practice
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.practice = null;

    /**
     * ApiBusinessProfileProto studio.
     * @member {space.kenko.proto.IStudioDetailsProto|null|undefined} studio
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.studio = null;

    /**
     * Creates a new ApiBusinessProfileProto instance using the specified properties.
     * @function create
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto=} [properties] Properties to set
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto instance
     */
    ApiBusinessProfileProto.create = function create(properties) {
        return new ApiBusinessProfileProto(properties);
    };

    /**
     * Encodes the specified ApiBusinessProfileProto message. Does not implicitly {@link ApiBusinessProfileProto.verify|verify} messages.
     * @function encode
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto} message ApiBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProfileProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.versionId);
        if (message.lastModifiedTimestamp != null && Object.hasOwnProperty.call(message, "lastModifiedTimestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.lastModifiedTimestamp);
        if (message.reviewTimestamp != null && Object.hasOwnProperty.call(message, "reviewTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.reviewTimestamp);
        if (message.proto != null && Object.hasOwnProperty.call(message, "proto"))
            $root.space.kenko.proto.BusinessProfileProto.encode(message.proto, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.locations != null && message.locations.length)
            for (var i = 0; i < message.locations.length; ++i)
                $root.space.kenko.proto.BusinessLocationProto.encode(message.locations[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.providers != null && message.providers.length)
            for (var i = 0; i < message.providers.length; ++i)
                $root.space.kenko.proto.PractitionerProto.encode(message.providers[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.businessId);
        if (message.offersAppointments != null && Object.hasOwnProperty.call(message, "offersAppointments"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.offersAppointments);
        if (message.offersClasses != null && Object.hasOwnProperty.call(message, "offersClasses"))
            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.offersClasses);
        if (message.pricing != null && Object.hasOwnProperty.call(message, "pricing"))
            $root.space.kenko.proto.PricingDetailsProto.encode(message.pricing, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
        if (message.practice != null && Object.hasOwnProperty.call(message, "practice"))
            $root.space.kenko.proto.PracticeDetailsProto.encode(message.practice, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        if (message.studio != null && Object.hasOwnProperty.call(message, "studio"))
            $root.space.kenko.proto.StudioDetailsProto.encode(message.studio, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiBusinessProfileProto message, length delimited. Does not implicitly {@link ApiBusinessProfileProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto} message ApiBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiBusinessProfileProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProfileProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiBusinessProfileProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.versionId = reader.string();
                    break;
                }
            case 2: {
                    message.lastModifiedTimestamp = reader.int64();
                    break;
                }
            case 3: {
                    message.reviewTimestamp = reader.int64();
                    break;
                }
            case 10: {
                    message.proto = $root.space.kenko.proto.BusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    if (!(message.locations && message.locations.length))
                        message.locations = [];
                    message.locations.push($root.space.kenko.proto.BusinessLocationProto.decode(reader, reader.uint32()));
                    break;
                }
            case 12: {
                    if (!(message.providers && message.providers.length))
                        message.providers = [];
                    message.providers.push($root.space.kenko.proto.PractitionerProto.decode(reader, reader.uint32()));
                    break;
                }
            case 13: {
                    message.businessId = reader.string();
                    break;
                }
            case 14: {
                    message.offersAppointments = reader.bool();
                    break;
                }
            case 15: {
                    message.offersClasses = reader.bool();
                    break;
                }
            case 16: {
                    message.pricing = $root.space.kenko.proto.PricingDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.practice = $root.space.kenko.proto.PracticeDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 101: {
                    message.studio = $root.space.kenko.proto.StudioDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiBusinessProfileProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiBusinessProfileProto message.
     * @function verify
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiBusinessProfileProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.versionId != null && message.hasOwnProperty("versionId"))
            if (!$util.isString(message.versionId))
                return "versionId: string expected";
        if (message.lastModifiedTimestamp != null && message.hasOwnProperty("lastModifiedTimestamp"))
            if (!$util.isInteger(message.lastModifiedTimestamp) && !(message.lastModifiedTimestamp && $util.isInteger(message.lastModifiedTimestamp.low) && $util.isInteger(message.lastModifiedTimestamp.high)))
                return "lastModifiedTimestamp: integer|Long expected";
        if (message.reviewTimestamp != null && message.hasOwnProperty("reviewTimestamp"))
            if (!$util.isInteger(message.reviewTimestamp) && !(message.reviewTimestamp && $util.isInteger(message.reviewTimestamp.low) && $util.isInteger(message.reviewTimestamp.high)))
                return "reviewTimestamp: integer|Long expected";
        if (message.proto != null && message.hasOwnProperty("proto")) {
            var error = $root.space.kenko.proto.BusinessProfileProto.verify(message.proto);
            if (error)
                return "proto." + error;
        }
        if (message.locations != null && message.hasOwnProperty("locations")) {
            if (!Array.isArray(message.locations))
                return "locations: array expected";
            for (var i = 0; i < message.locations.length; ++i) {
                var error = $root.space.kenko.proto.BusinessLocationProto.verify(message.locations[i]);
                if (error)
                    return "locations." + error;
            }
        }
        if (message.providers != null && message.hasOwnProperty("providers")) {
            if (!Array.isArray(message.providers))
                return "providers: array expected";
            for (var i = 0; i < message.providers.length; ++i) {
                var error = $root.space.kenko.proto.PractitionerProto.verify(message.providers[i]);
                if (error)
                    return "providers." + error;
            }
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
            if (typeof message.offersAppointments !== "boolean")
                return "offersAppointments: boolean expected";
        if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
            if (typeof message.offersClasses !== "boolean")
                return "offersClasses: boolean expected";
        if (message.pricing != null && message.hasOwnProperty("pricing")) {
            var error = $root.space.kenko.proto.PricingDetailsProto.verify(message.pricing);
            if (error)
                return "pricing." + error;
        }
        if (message.practice != null && message.hasOwnProperty("practice")) {
            var error = $root.space.kenko.proto.PracticeDetailsProto.verify(message.practice);
            if (error)
                return "practice." + error;
        }
        if (message.studio != null && message.hasOwnProperty("studio")) {
            var error = $root.space.kenko.proto.StudioDetailsProto.verify(message.studio);
            if (error)
                return "studio." + error;
        }
        return null;
    };

    /**
     * Creates an ApiBusinessProfileProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     */
    ApiBusinessProfileProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiBusinessProfileProto)
            return object;
        var message = new $root.ApiBusinessProfileProto();
        if (object.versionId != null)
            message.versionId = String(object.versionId);
        if (object.lastModifiedTimestamp != null)
            if ($util.Long)
                (message.lastModifiedTimestamp = $util.Long.fromValue(object.lastModifiedTimestamp)).unsigned = false;
            else if (typeof object.lastModifiedTimestamp === "string")
                message.lastModifiedTimestamp = parseInt(object.lastModifiedTimestamp, 10);
            else if (typeof object.lastModifiedTimestamp === "number")
                message.lastModifiedTimestamp = object.lastModifiedTimestamp;
            else if (typeof object.lastModifiedTimestamp === "object")
                message.lastModifiedTimestamp = new $util.LongBits(object.lastModifiedTimestamp.low >>> 0, object.lastModifiedTimestamp.high >>> 0).toNumber();
        if (object.reviewTimestamp != null)
            if ($util.Long)
                (message.reviewTimestamp = $util.Long.fromValue(object.reviewTimestamp)).unsigned = false;
            else if (typeof object.reviewTimestamp === "string")
                message.reviewTimestamp = parseInt(object.reviewTimestamp, 10);
            else if (typeof object.reviewTimestamp === "number")
                message.reviewTimestamp = object.reviewTimestamp;
            else if (typeof object.reviewTimestamp === "object")
                message.reviewTimestamp = new $util.LongBits(object.reviewTimestamp.low >>> 0, object.reviewTimestamp.high >>> 0).toNumber();
        if (object.proto != null) {
            if (typeof object.proto !== "object")
                throw TypeError(".ApiBusinessProfileProto.proto: object expected");
            message.proto = $root.space.kenko.proto.BusinessProfileProto.fromObject(object.proto);
        }
        if (object.locations) {
            if (!Array.isArray(object.locations))
                throw TypeError(".ApiBusinessProfileProto.locations: array expected");
            message.locations = [];
            for (var i = 0; i < object.locations.length; ++i) {
                if (typeof object.locations[i] !== "object")
                    throw TypeError(".ApiBusinessProfileProto.locations: object expected");
                message.locations[i] = $root.space.kenko.proto.BusinessLocationProto.fromObject(object.locations[i]);
            }
        }
        if (object.providers) {
            if (!Array.isArray(object.providers))
                throw TypeError(".ApiBusinessProfileProto.providers: array expected");
            message.providers = [];
            for (var i = 0; i < object.providers.length; ++i) {
                if (typeof object.providers[i] !== "object")
                    throw TypeError(".ApiBusinessProfileProto.providers: object expected");
                message.providers[i] = $root.space.kenko.proto.PractitionerProto.fromObject(object.providers[i]);
            }
        }
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.offersAppointments != null)
            message.offersAppointments = Boolean(object.offersAppointments);
        if (object.offersClasses != null)
            message.offersClasses = Boolean(object.offersClasses);
        if (object.pricing != null) {
            if (typeof object.pricing !== "object")
                throw TypeError(".ApiBusinessProfileProto.pricing: object expected");
            message.pricing = $root.space.kenko.proto.PricingDetailsProto.fromObject(object.pricing);
        }
        if (object.practice != null) {
            if (typeof object.practice !== "object")
                throw TypeError(".ApiBusinessProfileProto.practice: object expected");
            message.practice = $root.space.kenko.proto.PracticeDetailsProto.fromObject(object.practice);
        }
        if (object.studio != null) {
            if (typeof object.studio !== "object")
                throw TypeError(".ApiBusinessProfileProto.studio: object expected");
            message.studio = $root.space.kenko.proto.StudioDetailsProto.fromObject(object.studio);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiBusinessProfileProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {ApiBusinessProfileProto} message ApiBusinessProfileProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiBusinessProfileProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.locations = [];
            object.providers = [];
        }
        if (options.defaults) {
            object.versionId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.lastModifiedTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lastModifiedTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.reviewTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.reviewTimestamp = options.longs === String ? "0" : 0;
            object.proto = null;
            object.businessId = "";
            object.offersAppointments = false;
            object.offersClasses = false;
            object.pricing = null;
            object.practice = null;
            object.studio = null;
        }
        if (message.versionId != null && message.hasOwnProperty("versionId"))
            object.versionId = message.versionId;
        if (message.lastModifiedTimestamp != null && message.hasOwnProperty("lastModifiedTimestamp"))
            if (typeof message.lastModifiedTimestamp === "number")
                object.lastModifiedTimestamp = options.longs === String ? String(message.lastModifiedTimestamp) : message.lastModifiedTimestamp;
            else
                object.lastModifiedTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedTimestamp) : options.longs === Number ? new $util.LongBits(message.lastModifiedTimestamp.low >>> 0, message.lastModifiedTimestamp.high >>> 0).toNumber() : message.lastModifiedTimestamp;
        if (message.reviewTimestamp != null && message.hasOwnProperty("reviewTimestamp"))
            if (typeof message.reviewTimestamp === "number")
                object.reviewTimestamp = options.longs === String ? String(message.reviewTimestamp) : message.reviewTimestamp;
            else
                object.reviewTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.reviewTimestamp) : options.longs === Number ? new $util.LongBits(message.reviewTimestamp.low >>> 0, message.reviewTimestamp.high >>> 0).toNumber() : message.reviewTimestamp;
        if (message.proto != null && message.hasOwnProperty("proto"))
            object.proto = $root.space.kenko.proto.BusinessProfileProto.toObject(message.proto, options);
        if (message.locations && message.locations.length) {
            object.locations = [];
            for (var j = 0; j < message.locations.length; ++j)
                object.locations[j] = $root.space.kenko.proto.BusinessLocationProto.toObject(message.locations[j], options);
        }
        if (message.providers && message.providers.length) {
            object.providers = [];
            for (var j = 0; j < message.providers.length; ++j)
                object.providers[j] = $root.space.kenko.proto.PractitionerProto.toObject(message.providers[j], options);
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
            object.offersAppointments = message.offersAppointments;
        if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
            object.offersClasses = message.offersClasses;
        if (message.pricing != null && message.hasOwnProperty("pricing"))
            object.pricing = $root.space.kenko.proto.PricingDetailsProto.toObject(message.pricing, options);
        if (message.practice != null && message.hasOwnProperty("practice"))
            object.practice = $root.space.kenko.proto.PracticeDetailsProto.toObject(message.practice, options);
        if (message.studio != null && message.hasOwnProperty("studio"))
            object.studio = $root.space.kenko.proto.StudioDetailsProto.toObject(message.studio, options);
        return object;
    };

    /**
     * Converts this ApiBusinessProfileProto to JSON.
     * @function toJSON
     * @memberof ApiBusinessProfileProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiBusinessProfileProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiBusinessProfileProto
     * @function getTypeUrl
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiBusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiBusinessProfileProto";
    };

    return ApiBusinessProfileProto;
})();

$root.GetAvailableAppointmentsRequest = (function() {

    /**
     * Properties of a GetAvailableAppointmentsRequest.
     * @exports IGetAvailableAppointmentsRequest
     * @interface IGetAvailableAppointmentsRequest
     * @property {string|null} [sku] GetAvailableAppointmentsRequest sku
     * @property {string|null} [businessId] GetAvailableAppointmentsRequest businessId
     * @property {string|null} [practitionerId] GetAvailableAppointmentsRequest practitionerId
     * @property {number|Long|null} [fromTimestampMs] GetAvailableAppointmentsRequest fromTimestampMs
     * @property {number|Long|null} [toTimestampMs] GetAvailableAppointmentsRequest toTimestampMs
     * @property {string|null} [profileVersion] GetAvailableAppointmentsRequest profileVersion
     */

    /**
     * Constructs a new GetAvailableAppointmentsRequest.
     * @exports GetAvailableAppointmentsRequest
     * @classdesc Represents a GetAvailableAppointmentsRequest.
     * @implements IGetAvailableAppointmentsRequest
     * @constructor
     * @param {IGetAvailableAppointmentsRequest=} [properties] Properties to set
     */
    function GetAvailableAppointmentsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetAvailableAppointmentsRequest sku.
     * @member {string} sku
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.sku = "";

    /**
     * GetAvailableAppointmentsRequest businessId.
     * @member {string} businessId
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.businessId = "";

    /**
     * GetAvailableAppointmentsRequest practitionerId.
     * @member {string} practitionerId
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.practitionerId = "";

    /**
     * GetAvailableAppointmentsRequest fromTimestampMs.
     * @member {number|Long} fromTimestampMs
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.fromTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * GetAvailableAppointmentsRequest toTimestampMs.
     * @member {number|Long} toTimestampMs
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.toTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * GetAvailableAppointmentsRequest profileVersion.
     * @member {string} profileVersion
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     */
    GetAvailableAppointmentsRequest.prototype.profileVersion = "";

    /**
     * Creates a new GetAvailableAppointmentsRequest instance using the specified properties.
     * @function create
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {IGetAvailableAppointmentsRequest=} [properties] Properties to set
     * @returns {GetAvailableAppointmentsRequest} GetAvailableAppointmentsRequest instance
     */
    GetAvailableAppointmentsRequest.create = function create(properties) {
        return new GetAvailableAppointmentsRequest(properties);
    };

    /**
     * Encodes the specified GetAvailableAppointmentsRequest message. Does not implicitly {@link GetAvailableAppointmentsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {IGetAvailableAppointmentsRequest} message GetAvailableAppointmentsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAvailableAppointmentsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sku != null && Object.hasOwnProperty.call(message, "sku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sku);
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
        if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.practitionerId);
        if (message.fromTimestampMs != null && Object.hasOwnProperty.call(message, "fromTimestampMs"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.fromTimestampMs);
        if (message.toTimestampMs != null && Object.hasOwnProperty.call(message, "toTimestampMs"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.toTimestampMs);
        if (message.profileVersion != null && Object.hasOwnProperty.call(message, "profileVersion"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.profileVersion);
        return writer;
    };

    /**
     * Encodes the specified GetAvailableAppointmentsRequest message, length delimited. Does not implicitly {@link GetAvailableAppointmentsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {IGetAvailableAppointmentsRequest} message GetAvailableAppointmentsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAvailableAppointmentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetAvailableAppointmentsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetAvailableAppointmentsRequest} GetAvailableAppointmentsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAvailableAppointmentsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetAvailableAppointmentsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.sku = reader.string();
                    break;
                }
            case 2: {
                    message.businessId = reader.string();
                    break;
                }
            case 3: {
                    message.practitionerId = reader.string();
                    break;
                }
            case 4: {
                    message.fromTimestampMs = reader.int64();
                    break;
                }
            case 5: {
                    message.toTimestampMs = reader.int64();
                    break;
                }
            case 6: {
                    message.profileVersion = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetAvailableAppointmentsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetAvailableAppointmentsRequest} GetAvailableAppointmentsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAvailableAppointmentsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetAvailableAppointmentsRequest message.
     * @function verify
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetAvailableAppointmentsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sku != null && message.hasOwnProperty("sku"))
            if (!$util.isString(message.sku))
                return "sku: string expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            if (!$util.isString(message.practitionerId))
                return "practitionerId: string expected";
        if (message.fromTimestampMs != null && message.hasOwnProperty("fromTimestampMs"))
            if (!$util.isInteger(message.fromTimestampMs) && !(message.fromTimestampMs && $util.isInteger(message.fromTimestampMs.low) && $util.isInteger(message.fromTimestampMs.high)))
                return "fromTimestampMs: integer|Long expected";
        if (message.toTimestampMs != null && message.hasOwnProperty("toTimestampMs"))
            if (!$util.isInteger(message.toTimestampMs) && !(message.toTimestampMs && $util.isInteger(message.toTimestampMs.low) && $util.isInteger(message.toTimestampMs.high)))
                return "toTimestampMs: integer|Long expected";
        if (message.profileVersion != null && message.hasOwnProperty("profileVersion"))
            if (!$util.isString(message.profileVersion))
                return "profileVersion: string expected";
        return null;
    };

    /**
     * Creates a GetAvailableAppointmentsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetAvailableAppointmentsRequest} GetAvailableAppointmentsRequest
     */
    GetAvailableAppointmentsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetAvailableAppointmentsRequest)
            return object;
        var message = new $root.GetAvailableAppointmentsRequest();
        if (object.sku != null)
            message.sku = String(object.sku);
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.practitionerId != null)
            message.practitionerId = String(object.practitionerId);
        if (object.fromTimestampMs != null)
            if ($util.Long)
                (message.fromTimestampMs = $util.Long.fromValue(object.fromTimestampMs)).unsigned = false;
            else if (typeof object.fromTimestampMs === "string")
                message.fromTimestampMs = parseInt(object.fromTimestampMs, 10);
            else if (typeof object.fromTimestampMs === "number")
                message.fromTimestampMs = object.fromTimestampMs;
            else if (typeof object.fromTimestampMs === "object")
                message.fromTimestampMs = new $util.LongBits(object.fromTimestampMs.low >>> 0, object.fromTimestampMs.high >>> 0).toNumber();
        if (object.toTimestampMs != null)
            if ($util.Long)
                (message.toTimestampMs = $util.Long.fromValue(object.toTimestampMs)).unsigned = false;
            else if (typeof object.toTimestampMs === "string")
                message.toTimestampMs = parseInt(object.toTimestampMs, 10);
            else if (typeof object.toTimestampMs === "number")
                message.toTimestampMs = object.toTimestampMs;
            else if (typeof object.toTimestampMs === "object")
                message.toTimestampMs = new $util.LongBits(object.toTimestampMs.low >>> 0, object.toTimestampMs.high >>> 0).toNumber();
        if (object.profileVersion != null)
            message.profileVersion = String(object.profileVersion);
        return message;
    };

    /**
     * Creates a plain object from a GetAvailableAppointmentsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {GetAvailableAppointmentsRequest} message GetAvailableAppointmentsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetAvailableAppointmentsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.sku = "";
            object.businessId = "";
            object.practitionerId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.fromTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fromTimestampMs = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.toTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.toTimestampMs = options.longs === String ? "0" : 0;
            object.profileVersion = "";
        }
        if (message.sku != null && message.hasOwnProperty("sku"))
            object.sku = message.sku;
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            object.practitionerId = message.practitionerId;
        if (message.fromTimestampMs != null && message.hasOwnProperty("fromTimestampMs"))
            if (typeof message.fromTimestampMs === "number")
                object.fromTimestampMs = options.longs === String ? String(message.fromTimestampMs) : message.fromTimestampMs;
            else
                object.fromTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.fromTimestampMs) : options.longs === Number ? new $util.LongBits(message.fromTimestampMs.low >>> 0, message.fromTimestampMs.high >>> 0).toNumber() : message.fromTimestampMs;
        if (message.toTimestampMs != null && message.hasOwnProperty("toTimestampMs"))
            if (typeof message.toTimestampMs === "number")
                object.toTimestampMs = options.longs === String ? String(message.toTimestampMs) : message.toTimestampMs;
            else
                object.toTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.toTimestampMs) : options.longs === Number ? new $util.LongBits(message.toTimestampMs.low >>> 0, message.toTimestampMs.high >>> 0).toNumber() : message.toTimestampMs;
        if (message.profileVersion != null && message.hasOwnProperty("profileVersion"))
            object.profileVersion = message.profileVersion;
        return object;
    };

    /**
     * Converts this GetAvailableAppointmentsRequest to JSON.
     * @function toJSON
     * @memberof GetAvailableAppointmentsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetAvailableAppointmentsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetAvailableAppointmentsRequest
     * @function getTypeUrl
     * @memberof GetAvailableAppointmentsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetAvailableAppointmentsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetAvailableAppointmentsRequest";
    };

    return GetAvailableAppointmentsRequest;
})();

$root.ClientServiceProto = (function() {

    /**
     * Properties of a ClientServiceProto.
     * @exports IClientServiceProto
     * @interface IClientServiceProto
     * @property {string|null} [sku] ClientServiceProto sku
     * @property {string|null} [name] ClientServiceProto name
     * @property {string|null} [description] ClientServiceProto description
     * @property {number|null} [lengthMinutes] ClientServiceProto lengthMinutes
     * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ClientServiceProto paymentPolicy
     */

    /**
     * Constructs a new ClientServiceProto.
     * @exports ClientServiceProto
     * @classdesc Represents a ClientServiceProto.
     * @implements IClientServiceProto
     * @constructor
     * @param {IClientServiceProto=} [properties] Properties to set
     */
    function ClientServiceProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientServiceProto sku.
     * @member {string} sku
     * @memberof ClientServiceProto
     * @instance
     */
    ClientServiceProto.prototype.sku = "";

    /**
     * ClientServiceProto name.
     * @member {string} name
     * @memberof ClientServiceProto
     * @instance
     */
    ClientServiceProto.prototype.name = "";

    /**
     * ClientServiceProto description.
     * @member {string} description
     * @memberof ClientServiceProto
     * @instance
     */
    ClientServiceProto.prototype.description = "";

    /**
     * ClientServiceProto lengthMinutes.
     * @member {number} lengthMinutes
     * @memberof ClientServiceProto
     * @instance
     */
    ClientServiceProto.prototype.lengthMinutes = 0;

    /**
     * ClientServiceProto paymentPolicy.
     * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
     * @memberof ClientServiceProto
     * @instance
     */
    ClientServiceProto.prototype.paymentPolicy = null;

    /**
     * Creates a new ClientServiceProto instance using the specified properties.
     * @function create
     * @memberof ClientServiceProto
     * @static
     * @param {IClientServiceProto=} [properties] Properties to set
     * @returns {ClientServiceProto} ClientServiceProto instance
     */
    ClientServiceProto.create = function create(properties) {
        return new ClientServiceProto(properties);
    };

    /**
     * Encodes the specified ClientServiceProto message. Does not implicitly {@link ClientServiceProto.verify|verify} messages.
     * @function encode
     * @memberof ClientServiceProto
     * @static
     * @param {IClientServiceProto} message ClientServiceProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientServiceProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sku != null && Object.hasOwnProperty.call(message, "sku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sku);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
        if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
        if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
            $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientServiceProto message, length delimited. Does not implicitly {@link ClientServiceProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientServiceProto
     * @static
     * @param {IClientServiceProto} message ClientServiceProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientServiceProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientServiceProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientServiceProto} ClientServiceProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientServiceProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientServiceProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.sku = reader.string();
                    break;
                }
            case 2: {
                    message.name = reader.string();
                    break;
                }
            case 3: {
                    message.description = reader.string();
                    break;
                }
            case 4: {
                    message.lengthMinutes = reader.int32();
                    break;
                }
            case 5: {
                    message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientServiceProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientServiceProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientServiceProto} ClientServiceProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientServiceProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientServiceProto message.
     * @function verify
     * @memberof ClientServiceProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientServiceProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sku != null && message.hasOwnProperty("sku"))
            if (!$util.isString(message.sku))
                return "sku: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.description != null && message.hasOwnProperty("description"))
            if (!$util.isString(message.description))
                return "description: string expected";
        if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
            if (!$util.isInteger(message.lengthMinutes))
                return "lengthMinutes: integer expected";
        if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
            var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
            if (error)
                return "paymentPolicy." + error;
        }
        return null;
    };

    /**
     * Creates a ClientServiceProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientServiceProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientServiceProto} ClientServiceProto
     */
    ClientServiceProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientServiceProto)
            return object;
        var message = new $root.ClientServiceProto();
        if (object.sku != null)
            message.sku = String(object.sku);
        if (object.name != null)
            message.name = String(object.name);
        if (object.description != null)
            message.description = String(object.description);
        if (object.lengthMinutes != null)
            message.lengthMinutes = object.lengthMinutes | 0;
        if (object.paymentPolicy != null) {
            if (typeof object.paymentPolicy !== "object")
                throw TypeError(".ClientServiceProto.paymentPolicy: object expected");
            message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientServiceProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientServiceProto
     * @static
     * @param {ClientServiceProto} message ClientServiceProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientServiceProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.sku = "";
            object.name = "";
            object.description = "";
            object.lengthMinutes = 0;
            object.paymentPolicy = null;
        }
        if (message.sku != null && message.hasOwnProperty("sku"))
            object.sku = message.sku;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.description != null && message.hasOwnProperty("description"))
            object.description = message.description;
        if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
            object.lengthMinutes = message.lengthMinutes;
        if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
            object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
        return object;
    };

    /**
     * Converts this ClientServiceProto to JSON.
     * @function toJSON
     * @memberof ClientServiceProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientServiceProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientServiceProto
     * @function getTypeUrl
     * @memberof ClientServiceProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientServiceProto";
    };

    return ClientServiceProto;
})();

$root.GetAvailableAppointmentsResponse = (function() {

    /**
     * Properties of a GetAvailableAppointmentsResponse.
     * @exports IGetAvailableAppointmentsResponse
     * @interface IGetAvailableAppointmentsResponse
     * @property {boolean|null} [okay] GetAvailableAppointmentsResponse okay
     * @property {IClientServiceProto|null} [service] GetAvailableAppointmentsResponse service
     * @property {Array.<IAppointmentTimesForProvider>|null} [availableTimes] GetAvailableAppointmentsResponse availableTimes
     */

    /**
     * Constructs a new GetAvailableAppointmentsResponse.
     * @exports GetAvailableAppointmentsResponse
     * @classdesc Represents a GetAvailableAppointmentsResponse.
     * @implements IGetAvailableAppointmentsResponse
     * @constructor
     * @param {IGetAvailableAppointmentsResponse=} [properties] Properties to set
     */
    function GetAvailableAppointmentsResponse(properties) {
        this.availableTimes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetAvailableAppointmentsResponse okay.
     * @member {boolean} okay
     * @memberof GetAvailableAppointmentsResponse
     * @instance
     */
    GetAvailableAppointmentsResponse.prototype.okay = false;

    /**
     * GetAvailableAppointmentsResponse service.
     * @member {IClientServiceProto|null|undefined} service
     * @memberof GetAvailableAppointmentsResponse
     * @instance
     */
    GetAvailableAppointmentsResponse.prototype.service = null;

    /**
     * GetAvailableAppointmentsResponse availableTimes.
     * @member {Array.<IAppointmentTimesForProvider>} availableTimes
     * @memberof GetAvailableAppointmentsResponse
     * @instance
     */
    GetAvailableAppointmentsResponse.prototype.availableTimes = $util.emptyArray;

    /**
     * Creates a new GetAvailableAppointmentsResponse instance using the specified properties.
     * @function create
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {IGetAvailableAppointmentsResponse=} [properties] Properties to set
     * @returns {GetAvailableAppointmentsResponse} GetAvailableAppointmentsResponse instance
     */
    GetAvailableAppointmentsResponse.create = function create(properties) {
        return new GetAvailableAppointmentsResponse(properties);
    };

    /**
     * Encodes the specified GetAvailableAppointmentsResponse message. Does not implicitly {@link GetAvailableAppointmentsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {IGetAvailableAppointmentsResponse} message GetAvailableAppointmentsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAvailableAppointmentsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.service != null && Object.hasOwnProperty.call(message, "service"))
            $root.ClientServiceProto.encode(message.service, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.availableTimes != null && message.availableTimes.length)
            for (var i = 0; i < message.availableTimes.length; ++i)
                $root.AppointmentTimesForProvider.encode(message.availableTimes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetAvailableAppointmentsResponse message, length delimited. Does not implicitly {@link GetAvailableAppointmentsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {IGetAvailableAppointmentsResponse} message GetAvailableAppointmentsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetAvailableAppointmentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetAvailableAppointmentsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetAvailableAppointmentsResponse} GetAvailableAppointmentsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAvailableAppointmentsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetAvailableAppointmentsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.service = $root.ClientServiceProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.availableTimes && message.availableTimes.length))
                        message.availableTimes = [];
                    message.availableTimes.push($root.AppointmentTimesForProvider.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetAvailableAppointmentsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetAvailableAppointmentsResponse} GetAvailableAppointmentsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetAvailableAppointmentsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetAvailableAppointmentsResponse message.
     * @function verify
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetAvailableAppointmentsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.service != null && message.hasOwnProperty("service")) {
            var error = $root.ClientServiceProto.verify(message.service);
            if (error)
                return "service." + error;
        }
        if (message.availableTimes != null && message.hasOwnProperty("availableTimes")) {
            if (!Array.isArray(message.availableTimes))
                return "availableTimes: array expected";
            for (var i = 0; i < message.availableTimes.length; ++i) {
                var error = $root.AppointmentTimesForProvider.verify(message.availableTimes[i]);
                if (error)
                    return "availableTimes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetAvailableAppointmentsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetAvailableAppointmentsResponse} GetAvailableAppointmentsResponse
     */
    GetAvailableAppointmentsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetAvailableAppointmentsResponse)
            return object;
        var message = new $root.GetAvailableAppointmentsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.service != null) {
            if (typeof object.service !== "object")
                throw TypeError(".GetAvailableAppointmentsResponse.service: object expected");
            message.service = $root.ClientServiceProto.fromObject(object.service);
        }
        if (object.availableTimes) {
            if (!Array.isArray(object.availableTimes))
                throw TypeError(".GetAvailableAppointmentsResponse.availableTimes: array expected");
            message.availableTimes = [];
            for (var i = 0; i < object.availableTimes.length; ++i) {
                if (typeof object.availableTimes[i] !== "object")
                    throw TypeError(".GetAvailableAppointmentsResponse.availableTimes: object expected");
                message.availableTimes[i] = $root.AppointmentTimesForProvider.fromObject(object.availableTimes[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetAvailableAppointmentsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {GetAvailableAppointmentsResponse} message GetAvailableAppointmentsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetAvailableAppointmentsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.availableTimes = [];
        if (options.defaults) {
            object.okay = false;
            object.service = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.service != null && message.hasOwnProperty("service"))
            object.service = $root.ClientServiceProto.toObject(message.service, options);
        if (message.availableTimes && message.availableTimes.length) {
            object.availableTimes = [];
            for (var j = 0; j < message.availableTimes.length; ++j)
                object.availableTimes[j] = $root.AppointmentTimesForProvider.toObject(message.availableTimes[j], options);
        }
        return object;
    };

    /**
     * Converts this GetAvailableAppointmentsResponse to JSON.
     * @function toJSON
     * @memberof GetAvailableAppointmentsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetAvailableAppointmentsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetAvailableAppointmentsResponse
     * @function getTypeUrl
     * @memberof GetAvailableAppointmentsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetAvailableAppointmentsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetAvailableAppointmentsResponse";
    };

    return GetAvailableAppointmentsResponse;
})();

$root.AppointmentTimesForProvider = (function() {

    /**
     * Properties of an AppointmentTimesForProvider.
     * @exports IAppointmentTimesForProvider
     * @interface IAppointmentTimesForProvider
     * @property {space.kenko.proto.IPractitionerProto|null} [provider] AppointmentTimesForProvider provider
     * @property {Array.<number|Long>|null} [availableTimes] AppointmentTimesForProvider availableTimes
     */

    /**
     * Constructs a new AppointmentTimesForProvider.
     * @exports AppointmentTimesForProvider
     * @classdesc Represents an AppointmentTimesForProvider.
     * @implements IAppointmentTimesForProvider
     * @constructor
     * @param {IAppointmentTimesForProvider=} [properties] Properties to set
     */
    function AppointmentTimesForProvider(properties) {
        this.availableTimes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AppointmentTimesForProvider provider.
     * @member {space.kenko.proto.IPractitionerProto|null|undefined} provider
     * @memberof AppointmentTimesForProvider
     * @instance
     */
    AppointmentTimesForProvider.prototype.provider = null;

    /**
     * AppointmentTimesForProvider availableTimes.
     * @member {Array.<number|Long>} availableTimes
     * @memberof AppointmentTimesForProvider
     * @instance
     */
    AppointmentTimesForProvider.prototype.availableTimes = $util.emptyArray;

    /**
     * Creates a new AppointmentTimesForProvider instance using the specified properties.
     * @function create
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {IAppointmentTimesForProvider=} [properties] Properties to set
     * @returns {AppointmentTimesForProvider} AppointmentTimesForProvider instance
     */
    AppointmentTimesForProvider.create = function create(properties) {
        return new AppointmentTimesForProvider(properties);
    };

    /**
     * Encodes the specified AppointmentTimesForProvider message. Does not implicitly {@link AppointmentTimesForProvider.verify|verify} messages.
     * @function encode
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {IAppointmentTimesForProvider} message AppointmentTimesForProvider message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentTimesForProvider.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.space.kenko.proto.PractitionerProto.encode(message.provider, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.availableTimes != null && message.availableTimes.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (var i = 0; i < message.availableTimes.length; ++i)
                writer.int64(message.availableTimes[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified AppointmentTimesForProvider message, length delimited. Does not implicitly {@link AppointmentTimesForProvider.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {IAppointmentTimesForProvider} message AppointmentTimesForProvider message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentTimesForProvider.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AppointmentTimesForProvider message from the specified reader or buffer.
     * @function decode
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AppointmentTimesForProvider} AppointmentTimesForProvider
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentTimesForProvider.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AppointmentTimesForProvider();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.provider = $root.space.kenko.proto.PractitionerProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    if (!(message.availableTimes && message.availableTimes.length))
                        message.availableTimes = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.availableTimes.push(reader.int64());
                    } else
                        message.availableTimes.push(reader.int64());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AppointmentTimesForProvider message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AppointmentTimesForProvider} AppointmentTimesForProvider
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentTimesForProvider.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AppointmentTimesForProvider message.
     * @function verify
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AppointmentTimesForProvider.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.provider != null && message.hasOwnProperty("provider")) {
            var error = $root.space.kenko.proto.PractitionerProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        if (message.availableTimes != null && message.hasOwnProperty("availableTimes")) {
            if (!Array.isArray(message.availableTimes))
                return "availableTimes: array expected";
            for (var i = 0; i < message.availableTimes.length; ++i)
                if (!$util.isInteger(message.availableTimes[i]) && !(message.availableTimes[i] && $util.isInteger(message.availableTimes[i].low) && $util.isInteger(message.availableTimes[i].high)))
                    return "availableTimes: integer|Long[] expected";
        }
        return null;
    };

    /**
     * Creates an AppointmentTimesForProvider message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AppointmentTimesForProvider} AppointmentTimesForProvider
     */
    AppointmentTimesForProvider.fromObject = function fromObject(object) {
        if (object instanceof $root.AppointmentTimesForProvider)
            return object;
        var message = new $root.AppointmentTimesForProvider();
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".AppointmentTimesForProvider.provider: object expected");
            message.provider = $root.space.kenko.proto.PractitionerProto.fromObject(object.provider);
        }
        if (object.availableTimes) {
            if (!Array.isArray(object.availableTimes))
                throw TypeError(".AppointmentTimesForProvider.availableTimes: array expected");
            message.availableTimes = [];
            for (var i = 0; i < object.availableTimes.length; ++i)
                if ($util.Long)
                    (message.availableTimes[i] = $util.Long.fromValue(object.availableTimes[i])).unsigned = false;
                else if (typeof object.availableTimes[i] === "string")
                    message.availableTimes[i] = parseInt(object.availableTimes[i], 10);
                else if (typeof object.availableTimes[i] === "number")
                    message.availableTimes[i] = object.availableTimes[i];
                else if (typeof object.availableTimes[i] === "object")
                    message.availableTimes[i] = new $util.LongBits(object.availableTimes[i].low >>> 0, object.availableTimes[i].high >>> 0).toNumber();
        }
        return message;
    };

    /**
     * Creates a plain object from an AppointmentTimesForProvider message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {AppointmentTimesForProvider} message AppointmentTimesForProvider
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AppointmentTimesForProvider.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.availableTimes = [];
        if (options.defaults)
            object.provider = null;
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.space.kenko.proto.PractitionerProto.toObject(message.provider, options);
        if (message.availableTimes && message.availableTimes.length) {
            object.availableTimes = [];
            for (var j = 0; j < message.availableTimes.length; ++j)
                if (typeof message.availableTimes[j] === "number")
                    object.availableTimes[j] = options.longs === String ? String(message.availableTimes[j]) : message.availableTimes[j];
                else
                    object.availableTimes[j] = options.longs === String ? $util.Long.prototype.toString.call(message.availableTimes[j]) : options.longs === Number ? new $util.LongBits(message.availableTimes[j].low >>> 0, message.availableTimes[j].high >>> 0).toNumber() : message.availableTimes[j];
        }
        return object;
    };

    /**
     * Converts this AppointmentTimesForProvider to JSON.
     * @function toJSON
     * @memberof AppointmentTimesForProvider
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AppointmentTimesForProvider.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AppointmentTimesForProvider
     * @function getTypeUrl
     * @memberof AppointmentTimesForProvider
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AppointmentTimesForProvider.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AppointmentTimesForProvider";
    };

    return AppointmentTimesForProvider;
})();

$root.GetUserProfileRequest = (function() {

    /**
     * Properties of a GetUserProfileRequest.
     * @exports IGetUserProfileRequest
     * @interface IGetUserProfileRequest
     */

    /**
     * Constructs a new GetUserProfileRequest.
     * @exports GetUserProfileRequest
     * @classdesc Represents a GetUserProfileRequest.
     * @implements IGetUserProfileRequest
     * @constructor
     * @param {IGetUserProfileRequest=} [properties] Properties to set
     */
    function GetUserProfileRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GetUserProfileRequest instance using the specified properties.
     * @function create
     * @memberof GetUserProfileRequest
     * @static
     * @param {IGetUserProfileRequest=} [properties] Properties to set
     * @returns {GetUserProfileRequest} GetUserProfileRequest instance
     */
    GetUserProfileRequest.create = function create(properties) {
        return new GetUserProfileRequest(properties);
    };

    /**
     * Encodes the specified GetUserProfileRequest message. Does not implicitly {@link GetUserProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof GetUserProfileRequest
     * @static
     * @param {IGetUserProfileRequest} message GetUserProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetUserProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GetUserProfileRequest message, length delimited. Does not implicitly {@link GetUserProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetUserProfileRequest
     * @static
     * @param {IGetUserProfileRequest} message GetUserProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetUserProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetUserProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetUserProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetUserProfileRequest} GetUserProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetUserProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetUserProfileRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetUserProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetUserProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetUserProfileRequest} GetUserProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetUserProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetUserProfileRequest message.
     * @function verify
     * @memberof GetUserProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetUserProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GetUserProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetUserProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetUserProfileRequest} GetUserProfileRequest
     */
    GetUserProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetUserProfileRequest)
            return object;
        return new $root.GetUserProfileRequest();
    };

    /**
     * Creates a plain object from a GetUserProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetUserProfileRequest
     * @static
     * @param {GetUserProfileRequest} message GetUserProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetUserProfileRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GetUserProfileRequest to JSON.
     * @function toJSON
     * @memberof GetUserProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetUserProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetUserProfileRequest
     * @function getTypeUrl
     * @memberof GetUserProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetUserProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetUserProfileRequest";
    };

    return GetUserProfileRequest;
})();

$root.GetUserProfileResponse = (function() {

    /**
     * Properties of a GetUserProfileResponse.
     * @exports IGetUserProfileResponse
     * @interface IGetUserProfileResponse
     * @property {boolean|null} [okay] GetUserProfileResponse okay
     * @property {IApiUserProto|null} [profile] GetUserProfileResponse profile
     */

    /**
     * Constructs a new GetUserProfileResponse.
     * @exports GetUserProfileResponse
     * @classdesc Represents a GetUserProfileResponse.
     * @implements IGetUserProfileResponse
     * @constructor
     * @param {IGetUserProfileResponse=} [properties] Properties to set
     */
    function GetUserProfileResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetUserProfileResponse okay.
     * @member {boolean} okay
     * @memberof GetUserProfileResponse
     * @instance
     */
    GetUserProfileResponse.prototype.okay = false;

    /**
     * GetUserProfileResponse profile.
     * @member {IApiUserProto|null|undefined} profile
     * @memberof GetUserProfileResponse
     * @instance
     */
    GetUserProfileResponse.prototype.profile = null;

    /**
     * Creates a new GetUserProfileResponse instance using the specified properties.
     * @function create
     * @memberof GetUserProfileResponse
     * @static
     * @param {IGetUserProfileResponse=} [properties] Properties to set
     * @returns {GetUserProfileResponse} GetUserProfileResponse instance
     */
    GetUserProfileResponse.create = function create(properties) {
        return new GetUserProfileResponse(properties);
    };

    /**
     * Encodes the specified GetUserProfileResponse message. Does not implicitly {@link GetUserProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof GetUserProfileResponse
     * @static
     * @param {IGetUserProfileResponse} message GetUserProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetUserProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.ApiUserProto.encode(message.profile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetUserProfileResponse message, length delimited. Does not implicitly {@link GetUserProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetUserProfileResponse
     * @static
     * @param {IGetUserProfileResponse} message GetUserProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetUserProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetUserProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetUserProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetUserProfileResponse} GetUserProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetUserProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetUserProfileResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.profile = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetUserProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetUserProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetUserProfileResponse} GetUserProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetUserProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetUserProfileResponse message.
     * @function verify
     * @memberof GetUserProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetUserProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.profile != null && message.hasOwnProperty("profile")) {
            var error = $root.ApiUserProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        return null;
    };

    /**
     * Creates a GetUserProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetUserProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetUserProfileResponse} GetUserProfileResponse
     */
    GetUserProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetUserProfileResponse)
            return object;
        var message = new $root.GetUserProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".GetUserProfileResponse.profile: object expected");
            message.profile = $root.ApiUserProto.fromObject(object.profile);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetUserProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetUserProfileResponse
     * @static
     * @param {GetUserProfileResponse} message GetUserProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetUserProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.profile = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.ApiUserProto.toObject(message.profile, options);
        return object;
    };

    /**
     * Converts this GetUserProfileResponse to JSON.
     * @function toJSON
     * @memberof GetUserProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetUserProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetUserProfileResponse
     * @function getTypeUrl
     * @memberof GetUserProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetUserProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetUserProfileResponse";
    };

    return GetUserProfileResponse;
})();

$root.UpdateUserProfileRequest = (function() {

    /**
     * Properties of an UpdateUserProfileRequest.
     * @exports IUpdateUserProfileRequest
     * @interface IUpdateUserProfileRequest
     * @property {string|null} [firstName] UpdateUserProfileRequest firstName
     * @property {string|null} [lastName] UpdateUserProfileRequest lastName
     * @property {string|null} [contactEmail] UpdateUserProfileRequest contactEmail
     * @property {string|null} [mobileNumber] UpdateUserProfileRequest mobileNumber
     */

    /**
     * Constructs a new UpdateUserProfileRequest.
     * @exports UpdateUserProfileRequest
     * @classdesc Represents an UpdateUserProfileRequest.
     * @implements IUpdateUserProfileRequest
     * @constructor
     * @param {IUpdateUserProfileRequest=} [properties] Properties to set
     */
    function UpdateUserProfileRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateUserProfileRequest firstName.
     * @member {string} firstName
     * @memberof UpdateUserProfileRequest
     * @instance
     */
    UpdateUserProfileRequest.prototype.firstName = "";

    /**
     * UpdateUserProfileRequest lastName.
     * @member {string} lastName
     * @memberof UpdateUserProfileRequest
     * @instance
     */
    UpdateUserProfileRequest.prototype.lastName = "";

    /**
     * UpdateUserProfileRequest contactEmail.
     * @member {string} contactEmail
     * @memberof UpdateUserProfileRequest
     * @instance
     */
    UpdateUserProfileRequest.prototype.contactEmail = "";

    /**
     * UpdateUserProfileRequest mobileNumber.
     * @member {string} mobileNumber
     * @memberof UpdateUserProfileRequest
     * @instance
     */
    UpdateUserProfileRequest.prototype.mobileNumber = "";

    /**
     * Creates a new UpdateUserProfileRequest instance using the specified properties.
     * @function create
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {IUpdateUserProfileRequest=} [properties] Properties to set
     * @returns {UpdateUserProfileRequest} UpdateUserProfileRequest instance
     */
    UpdateUserProfileRequest.create = function create(properties) {
        return new UpdateUserProfileRequest(properties);
    };

    /**
     * Encodes the specified UpdateUserProfileRequest message. Does not implicitly {@link UpdateUserProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {IUpdateUserProfileRequest} message UpdateUserProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateUserProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);
        if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.contactEmail);
        if (message.mobileNumber != null && Object.hasOwnProperty.call(message, "mobileNumber"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.mobileNumber);
        return writer;
    };

    /**
     * Encodes the specified UpdateUserProfileRequest message, length delimited. Does not implicitly {@link UpdateUserProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {IUpdateUserProfileRequest} message UpdateUserProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateUserProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateUserProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateUserProfileRequest} UpdateUserProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateUserProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateUserProfileRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.firstName = reader.string();
                    break;
                }
            case 2: {
                    message.lastName = reader.string();
                    break;
                }
            case 3: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 4: {
                    message.mobileNumber = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateUserProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateUserProfileRequest} UpdateUserProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateUserProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateUserProfileRequest message.
     * @function verify
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateUserProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.firstName != null && message.hasOwnProperty("firstName"))
            if (!$util.isString(message.firstName))
                return "firstName: string expected";
        if (message.lastName != null && message.hasOwnProperty("lastName"))
            if (!$util.isString(message.lastName))
                return "lastName: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            if (!$util.isString(message.mobileNumber))
                return "mobileNumber: string expected";
        return null;
    };

    /**
     * Creates an UpdateUserProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateUserProfileRequest} UpdateUserProfileRequest
     */
    UpdateUserProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateUserProfileRequest)
            return object;
        var message = new $root.UpdateUserProfileRequest();
        if (object.firstName != null)
            message.firstName = String(object.firstName);
        if (object.lastName != null)
            message.lastName = String(object.lastName);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.mobileNumber != null)
            message.mobileNumber = String(object.mobileNumber);
        return message;
    };

    /**
     * Creates a plain object from an UpdateUserProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {UpdateUserProfileRequest} message UpdateUserProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateUserProfileRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.firstName = "";
            object.lastName = "";
            object.contactEmail = "";
            object.mobileNumber = "";
        }
        if (message.firstName != null && message.hasOwnProperty("firstName"))
            object.firstName = message.firstName;
        if (message.lastName != null && message.hasOwnProperty("lastName"))
            object.lastName = message.lastName;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            object.mobileNumber = message.mobileNumber;
        return object;
    };

    /**
     * Converts this UpdateUserProfileRequest to JSON.
     * @function toJSON
     * @memberof UpdateUserProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateUserProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateUserProfileRequest
     * @function getTypeUrl
     * @memberof UpdateUserProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateUserProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateUserProfileRequest";
    };

    return UpdateUserProfileRequest;
})();

$root.UpdateUserProfileResponse = (function() {

    /**
     * Properties of an UpdateUserProfileResponse.
     * @exports IUpdateUserProfileResponse
     * @interface IUpdateUserProfileResponse
     * @property {boolean|null} [okay] UpdateUserProfileResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] UpdateUserProfileResponse errors
     * @property {IApiUserProto|null} [updatedProfile] UpdateUserProfileResponse updatedProfile
     */

    /**
     * Constructs a new UpdateUserProfileResponse.
     * @exports UpdateUserProfileResponse
     * @classdesc Represents an UpdateUserProfileResponse.
     * @implements IUpdateUserProfileResponse
     * @constructor
     * @param {IUpdateUserProfileResponse=} [properties] Properties to set
     */
    function UpdateUserProfileResponse(properties) {
        this.errors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateUserProfileResponse okay.
     * @member {boolean} okay
     * @memberof UpdateUserProfileResponse
     * @instance
     */
    UpdateUserProfileResponse.prototype.okay = false;

    /**
     * UpdateUserProfileResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof UpdateUserProfileResponse
     * @instance
     */
    UpdateUserProfileResponse.prototype.errors = $util.emptyArray;

    /**
     * UpdateUserProfileResponse updatedProfile.
     * @member {IApiUserProto|null|undefined} updatedProfile
     * @memberof UpdateUserProfileResponse
     * @instance
     */
    UpdateUserProfileResponse.prototype.updatedProfile = null;

    /**
     * Creates a new UpdateUserProfileResponse instance using the specified properties.
     * @function create
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {IUpdateUserProfileResponse=} [properties] Properties to set
     * @returns {UpdateUserProfileResponse} UpdateUserProfileResponse instance
     */
    UpdateUserProfileResponse.create = function create(properties) {
        return new UpdateUserProfileResponse(properties);
    };

    /**
     * Encodes the specified UpdateUserProfileResponse message. Does not implicitly {@link UpdateUserProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {IUpdateUserProfileResponse} message UpdateUserProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateUserProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (var i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.updatedProfile != null && Object.hasOwnProperty.call(message, "updatedProfile"))
            $root.ApiUserProto.encode(message.updatedProfile, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateUserProfileResponse message, length delimited. Does not implicitly {@link UpdateUserProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {IUpdateUserProfileResponse} message UpdateUserProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateUserProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateUserProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateUserProfileResponse} UpdateUserProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateUserProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateUserProfileResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.updatedProfile = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateUserProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateUserProfileResponse} UpdateUserProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateUserProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateUserProfileResponse message.
     * @function verify
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateUserProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (var i = 0; i < message.errors.length; ++i) {
                var error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        if (message.updatedProfile != null && message.hasOwnProperty("updatedProfile")) {
            var error = $root.ApiUserProto.verify(message.updatedProfile);
            if (error)
                return "updatedProfile." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateUserProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateUserProfileResponse} UpdateUserProfileResponse
     */
    UpdateUserProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateUserProfileResponse)
            return object;
        var message = new $root.UpdateUserProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".UpdateUserProfileResponse.errors: array expected");
            message.errors = [];
            for (var i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".UpdateUserProfileResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        if (object.updatedProfile != null) {
            if (typeof object.updatedProfile !== "object")
                throw TypeError(".UpdateUserProfileResponse.updatedProfile: object expected");
            message.updatedProfile = $root.ApiUserProto.fromObject(object.updatedProfile);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateUserProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {UpdateUserProfileResponse} message UpdateUserProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateUserProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.updatedProfile = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (var j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        if (message.updatedProfile != null && message.hasOwnProperty("updatedProfile"))
            object.updatedProfile = $root.ApiUserProto.toObject(message.updatedProfile, options);
        return object;
    };

    /**
     * Converts this UpdateUserProfileResponse to JSON.
     * @function toJSON
     * @memberof UpdateUserProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateUserProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateUserProfileResponse
     * @function getTypeUrl
     * @memberof UpdateUserProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateUserProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateUserProfileResponse";
    };

    return UpdateUserProfileResponse;
})();

$root.CreateUserRequest = (function() {

    /**
     * Properties of a CreateUserRequest.
     * @exports ICreateUserRequest
     * @interface ICreateUserRequest
     * @property {string|null} [givenName] CreateUserRequest givenName
     * @property {string|null} [familyName] CreateUserRequest familyName
     * @property {string|null} [contactEmail] CreateUserRequest contactEmail
     * @property {string|null} [acceptedTermsVersion] CreateUserRequest acceptedTermsVersion
     */

    /**
     * Constructs a new CreateUserRequest.
     * @exports CreateUserRequest
     * @classdesc Represents a CreateUserRequest.
     * @implements ICreateUserRequest
     * @constructor
     * @param {ICreateUserRequest=} [properties] Properties to set
     */
    function CreateUserRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateUserRequest givenName.
     * @member {string} givenName
     * @memberof CreateUserRequest
     * @instance
     */
    CreateUserRequest.prototype.givenName = "";

    /**
     * CreateUserRequest familyName.
     * @member {string} familyName
     * @memberof CreateUserRequest
     * @instance
     */
    CreateUserRequest.prototype.familyName = "";

    /**
     * CreateUserRequest contactEmail.
     * @member {string} contactEmail
     * @memberof CreateUserRequest
     * @instance
     */
    CreateUserRequest.prototype.contactEmail = "";

    /**
     * CreateUserRequest acceptedTermsVersion.
     * @member {string} acceptedTermsVersion
     * @memberof CreateUserRequest
     * @instance
     */
    CreateUserRequest.prototype.acceptedTermsVersion = "";

    /**
     * Creates a new CreateUserRequest instance using the specified properties.
     * @function create
     * @memberof CreateUserRequest
     * @static
     * @param {ICreateUserRequest=} [properties] Properties to set
     * @returns {CreateUserRequest} CreateUserRequest instance
     */
    CreateUserRequest.create = function create(properties) {
        return new CreateUserRequest(properties);
    };

    /**
     * Encodes the specified CreateUserRequest message. Does not implicitly {@link CreateUserRequest.verify|verify} messages.
     * @function encode
     * @memberof CreateUserRequest
     * @static
     * @param {ICreateUserRequest} message CreateUserRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateUserRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.givenName != null && Object.hasOwnProperty.call(message, "givenName"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.givenName);
        if (message.familyName != null && Object.hasOwnProperty.call(message, "familyName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.familyName);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.contactEmail);
        if (message.acceptedTermsVersion != null && Object.hasOwnProperty.call(message, "acceptedTermsVersion"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.acceptedTermsVersion);
        return writer;
    };

    /**
     * Encodes the specified CreateUserRequest message, length delimited. Does not implicitly {@link CreateUserRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateUserRequest
     * @static
     * @param {ICreateUserRequest} message CreateUserRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateUserRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateUserRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CreateUserRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateUserRequest} CreateUserRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateUserRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateUserRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.givenName = reader.string();
                    break;
                }
            case 2: {
                    message.familyName = reader.string();
                    break;
                }
            case 3: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 4: {
                    message.acceptedTermsVersion = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateUserRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateUserRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateUserRequest} CreateUserRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateUserRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateUserRequest message.
     * @function verify
     * @memberof CreateUserRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateUserRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            if (!$util.isString(message.givenName))
                return "givenName: string expected";
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            if (!$util.isString(message.familyName))
                return "familyName: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.acceptedTermsVersion != null && message.hasOwnProperty("acceptedTermsVersion"))
            if (!$util.isString(message.acceptedTermsVersion))
                return "acceptedTermsVersion: string expected";
        return null;
    };

    /**
     * Creates a CreateUserRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateUserRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateUserRequest} CreateUserRequest
     */
    CreateUserRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateUserRequest)
            return object;
        var message = new $root.CreateUserRequest();
        if (object.givenName != null)
            message.givenName = String(object.givenName);
        if (object.familyName != null)
            message.familyName = String(object.familyName);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.acceptedTermsVersion != null)
            message.acceptedTermsVersion = String(object.acceptedTermsVersion);
        return message;
    };

    /**
     * Creates a plain object from a CreateUserRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateUserRequest
     * @static
     * @param {CreateUserRequest} message CreateUserRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateUserRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.givenName = "";
            object.familyName = "";
            object.contactEmail = "";
            object.acceptedTermsVersion = "";
        }
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            object.givenName = message.givenName;
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            object.familyName = message.familyName;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.acceptedTermsVersion != null && message.hasOwnProperty("acceptedTermsVersion"))
            object.acceptedTermsVersion = message.acceptedTermsVersion;
        return object;
    };

    /**
     * Converts this CreateUserRequest to JSON.
     * @function toJSON
     * @memberof CreateUserRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateUserRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateUserRequest
     * @function getTypeUrl
     * @memberof CreateUserRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateUserRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateUserRequest";
    };

    return CreateUserRequest;
})();

$root.CreateUserResponse = (function() {

    /**
     * Properties of a CreateUserResponse.
     * @exports ICreateUserResponse
     * @interface ICreateUserResponse
     * @property {boolean|null} [okay] CreateUserResponse okay
     * @property {IApiUserProto|null} [profile] CreateUserResponse profile
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] CreateUserResponse errors
     */

    /**
     * Constructs a new CreateUserResponse.
     * @exports CreateUserResponse
     * @classdesc Represents a CreateUserResponse.
     * @implements ICreateUserResponse
     * @constructor
     * @param {ICreateUserResponse=} [properties] Properties to set
     */
    function CreateUserResponse(properties) {
        this.errors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateUserResponse okay.
     * @member {boolean} okay
     * @memberof CreateUserResponse
     * @instance
     */
    CreateUserResponse.prototype.okay = false;

    /**
     * CreateUserResponse profile.
     * @member {IApiUserProto|null|undefined} profile
     * @memberof CreateUserResponse
     * @instance
     */
    CreateUserResponse.prototype.profile = null;

    /**
     * CreateUserResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof CreateUserResponse
     * @instance
     */
    CreateUserResponse.prototype.errors = $util.emptyArray;

    /**
     * Creates a new CreateUserResponse instance using the specified properties.
     * @function create
     * @memberof CreateUserResponse
     * @static
     * @param {ICreateUserResponse=} [properties] Properties to set
     * @returns {CreateUserResponse} CreateUserResponse instance
     */
    CreateUserResponse.create = function create(properties) {
        return new CreateUserResponse(properties);
    };

    /**
     * Encodes the specified CreateUserResponse message. Does not implicitly {@link CreateUserResponse.verify|verify} messages.
     * @function encode
     * @memberof CreateUserResponse
     * @static
     * @param {ICreateUserResponse} message CreateUserResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateUserResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.ApiUserProto.encode(message.profile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.errors != null && message.errors.length)
            for (var i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CreateUserResponse message, length delimited. Does not implicitly {@link CreateUserResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateUserResponse
     * @static
     * @param {ICreateUserResponse} message CreateUserResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateUserResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateUserResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CreateUserResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateUserResponse} CreateUserResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateUserResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateUserResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.profile = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateUserResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateUserResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateUserResponse} CreateUserResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateUserResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateUserResponse message.
     * @function verify
     * @memberof CreateUserResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateUserResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.profile != null && message.hasOwnProperty("profile")) {
            var error = $root.ApiUserProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (var i = 0; i < message.errors.length; ++i) {
                var error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a CreateUserResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateUserResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateUserResponse} CreateUserResponse
     */
    CreateUserResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateUserResponse)
            return object;
        var message = new $root.CreateUserResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".CreateUserResponse.profile: object expected");
            message.profile = $root.ApiUserProto.fromObject(object.profile);
        }
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".CreateUserResponse.errors: array expected");
            message.errors = [];
            for (var i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".CreateUserResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a CreateUserResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateUserResponse
     * @static
     * @param {CreateUserResponse} message CreateUserResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateUserResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.profile = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.ApiUserProto.toObject(message.profile, options);
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (var j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        return object;
    };

    /**
     * Converts this CreateUserResponse to JSON.
     * @function toJSON
     * @memberof CreateUserResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateUserResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateUserResponse
     * @function getTypeUrl
     * @memberof CreateUserResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateUserResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateUserResponse";
    };

    return CreateUserResponse;
})();

$root.CheckInvitationRequest = (function() {

    /**
     * Properties of a CheckInvitationRequest.
     * @exports ICheckInvitationRequest
     * @interface ICheckInvitationRequest
     * @property {string|null} [networkId] CheckInvitationRequest networkId
     * @property {string|null} [inviteCode] CheckInvitationRequest inviteCode
     */

    /**
     * Constructs a new CheckInvitationRequest.
     * @exports CheckInvitationRequest
     * @classdesc Represents a CheckInvitationRequest.
     * @implements ICheckInvitationRequest
     * @constructor
     * @param {ICheckInvitationRequest=} [properties] Properties to set
     */
    function CheckInvitationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckInvitationRequest networkId.
     * @member {string} networkId
     * @memberof CheckInvitationRequest
     * @instance
     */
    CheckInvitationRequest.prototype.networkId = "";

    /**
     * CheckInvitationRequest inviteCode.
     * @member {string} inviteCode
     * @memberof CheckInvitationRequest
     * @instance
     */
    CheckInvitationRequest.prototype.inviteCode = "";

    /**
     * Creates a new CheckInvitationRequest instance using the specified properties.
     * @function create
     * @memberof CheckInvitationRequest
     * @static
     * @param {ICheckInvitationRequest=} [properties] Properties to set
     * @returns {CheckInvitationRequest} CheckInvitationRequest instance
     */
    CheckInvitationRequest.create = function create(properties) {
        return new CheckInvitationRequest(properties);
    };

    /**
     * Encodes the specified CheckInvitationRequest message. Does not implicitly {@link CheckInvitationRequest.verify|verify} messages.
     * @function encode
     * @memberof CheckInvitationRequest
     * @static
     * @param {ICheckInvitationRequest} message CheckInvitationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckInvitationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.networkId != null && Object.hasOwnProperty.call(message, "networkId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.networkId);
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.inviteCode);
        return writer;
    };

    /**
     * Encodes the specified CheckInvitationRequest message, length delimited. Does not implicitly {@link CheckInvitationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckInvitationRequest
     * @static
     * @param {ICheckInvitationRequest} message CheckInvitationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckInvitationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckInvitationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CheckInvitationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckInvitationRequest} CheckInvitationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckInvitationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckInvitationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.networkId = reader.string();
                    break;
                }
            case 2: {
                    message.inviteCode = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckInvitationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckInvitationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckInvitationRequest} CheckInvitationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckInvitationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckInvitationRequest message.
     * @function verify
     * @memberof CheckInvitationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckInvitationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.networkId != null && message.hasOwnProperty("networkId"))
            if (!$util.isString(message.networkId))
                return "networkId: string expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        return null;
    };

    /**
     * Creates a CheckInvitationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckInvitationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckInvitationRequest} CheckInvitationRequest
     */
    CheckInvitationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckInvitationRequest)
            return object;
        var message = new $root.CheckInvitationRequest();
        if (object.networkId != null)
            message.networkId = String(object.networkId);
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        return message;
    };

    /**
     * Creates a plain object from a CheckInvitationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckInvitationRequest
     * @static
     * @param {CheckInvitationRequest} message CheckInvitationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckInvitationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.networkId = "";
            object.inviteCode = "";
        }
        if (message.networkId != null && message.hasOwnProperty("networkId"))
            object.networkId = message.networkId;
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        return object;
    };

    /**
     * Converts this CheckInvitationRequest to JSON.
     * @function toJSON
     * @memberof CheckInvitationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckInvitationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckInvitationRequest
     * @function getTypeUrl
     * @memberof CheckInvitationRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckInvitationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckInvitationRequest";
    };

    return CheckInvitationRequest;
})();

$root.CheckInvitationResponse = (function() {

    /**
     * Properties of a CheckInvitationResponse.
     * @exports ICheckInvitationResponse
     * @interface ICheckInvitationResponse
     * @property {boolean|null} [okay] CheckInvitationResponse okay
     */

    /**
     * Constructs a new CheckInvitationResponse.
     * @exports CheckInvitationResponse
     * @classdesc Represents a CheckInvitationResponse.
     * @implements ICheckInvitationResponse
     * @constructor
     * @param {ICheckInvitationResponse=} [properties] Properties to set
     */
    function CheckInvitationResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckInvitationResponse okay.
     * @member {boolean} okay
     * @memberof CheckInvitationResponse
     * @instance
     */
    CheckInvitationResponse.prototype.okay = false;

    /**
     * Creates a new CheckInvitationResponse instance using the specified properties.
     * @function create
     * @memberof CheckInvitationResponse
     * @static
     * @param {ICheckInvitationResponse=} [properties] Properties to set
     * @returns {CheckInvitationResponse} CheckInvitationResponse instance
     */
    CheckInvitationResponse.create = function create(properties) {
        return new CheckInvitationResponse(properties);
    };

    /**
     * Encodes the specified CheckInvitationResponse message. Does not implicitly {@link CheckInvitationResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckInvitationResponse
     * @static
     * @param {ICheckInvitationResponse} message CheckInvitationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckInvitationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified CheckInvitationResponse message, length delimited. Does not implicitly {@link CheckInvitationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckInvitationResponse
     * @static
     * @param {ICheckInvitationResponse} message CheckInvitationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckInvitationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckInvitationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckInvitationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckInvitationResponse} CheckInvitationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckInvitationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckInvitationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckInvitationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckInvitationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckInvitationResponse} CheckInvitationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckInvitationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckInvitationResponse message.
     * @function verify
     * @memberof CheckInvitationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckInvitationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates a CheckInvitationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckInvitationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckInvitationResponse} CheckInvitationResponse
     */
    CheckInvitationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckInvitationResponse)
            return object;
        var message = new $root.CheckInvitationResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from a CheckInvitationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckInvitationResponse
     * @static
     * @param {CheckInvitationResponse} message CheckInvitationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckInvitationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this CheckInvitationResponse to JSON.
     * @function toJSON
     * @memberof CheckInvitationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckInvitationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckInvitationResponse
     * @function getTypeUrl
     * @memberof CheckInvitationResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckInvitationResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckInvitationResponse";
    };

    return CheckInvitationResponse;
})();

$root.DeleteProfileRequest = (function() {

    /**
     * Properties of a DeleteProfileRequest.
     * @exports IDeleteProfileRequest
     * @interface IDeleteProfileRequest
     * @property {boolean|null} [nukeAccount] DeleteProfileRequest nukeAccount
     */

    /**
     * Constructs a new DeleteProfileRequest.
     * @exports DeleteProfileRequest
     * @classdesc Represents a DeleteProfileRequest.
     * @implements IDeleteProfileRequest
     * @constructor
     * @param {IDeleteProfileRequest=} [properties] Properties to set
     */
    function DeleteProfileRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteProfileRequest nukeAccount.
     * @member {boolean} nukeAccount
     * @memberof DeleteProfileRequest
     * @instance
     */
    DeleteProfileRequest.prototype.nukeAccount = false;

    /**
     * Creates a new DeleteProfileRequest instance using the specified properties.
     * @function create
     * @memberof DeleteProfileRequest
     * @static
     * @param {IDeleteProfileRequest=} [properties] Properties to set
     * @returns {DeleteProfileRequest} DeleteProfileRequest instance
     */
    DeleteProfileRequest.create = function create(properties) {
        return new DeleteProfileRequest(properties);
    };

    /**
     * Encodes the specified DeleteProfileRequest message. Does not implicitly {@link DeleteProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof DeleteProfileRequest
     * @static
     * @param {IDeleteProfileRequest} message DeleteProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.nukeAccount != null && Object.hasOwnProperty.call(message, "nukeAccount"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.nukeAccount);
        return writer;
    };

    /**
     * Encodes the specified DeleteProfileRequest message, length delimited. Does not implicitly {@link DeleteProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeleteProfileRequest
     * @static
     * @param {IDeleteProfileRequest} message DeleteProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DeleteProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeleteProfileRequest} DeleteProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeleteProfileRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.nukeAccount = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeleteProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeleteProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeleteProfileRequest} DeleteProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteProfileRequest message.
     * @function verify
     * @memberof DeleteProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.nukeAccount != null && message.hasOwnProperty("nukeAccount"))
            if (typeof message.nukeAccount !== "boolean")
                return "nukeAccount: boolean expected";
        return null;
    };

    /**
     * Creates a DeleteProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeleteProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeleteProfileRequest} DeleteProfileRequest
     */
    DeleteProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DeleteProfileRequest)
            return object;
        var message = new $root.DeleteProfileRequest();
        if (object.nukeAccount != null)
            message.nukeAccount = Boolean(object.nukeAccount);
        return message;
    };

    /**
     * Creates a plain object from a DeleteProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeleteProfileRequest
     * @static
     * @param {DeleteProfileRequest} message DeleteProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteProfileRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.nukeAccount = false;
        if (message.nukeAccount != null && message.hasOwnProperty("nukeAccount"))
            object.nukeAccount = message.nukeAccount;
        return object;
    };

    /**
     * Converts this DeleteProfileRequest to JSON.
     * @function toJSON
     * @memberof DeleteProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeleteProfileRequest
     * @function getTypeUrl
     * @memberof DeleteProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeleteProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeleteProfileRequest";
    };

    return DeleteProfileRequest;
})();

$root.DeleteProfileResponse = (function() {

    /**
     * Properties of a DeleteProfileResponse.
     * @exports IDeleteProfileResponse
     * @interface IDeleteProfileResponse
     * @property {boolean|null} [okay] DeleteProfileResponse okay
     * @property {IApiUserProto|null} [updated] DeleteProfileResponse updated
     */

    /**
     * Constructs a new DeleteProfileResponse.
     * @exports DeleteProfileResponse
     * @classdesc Represents a DeleteProfileResponse.
     * @implements IDeleteProfileResponse
     * @constructor
     * @param {IDeleteProfileResponse=} [properties] Properties to set
     */
    function DeleteProfileResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteProfileResponse okay.
     * @member {boolean} okay
     * @memberof DeleteProfileResponse
     * @instance
     */
    DeleteProfileResponse.prototype.okay = false;

    /**
     * DeleteProfileResponse updated.
     * @member {IApiUserProto|null|undefined} updated
     * @memberof DeleteProfileResponse
     * @instance
     */
    DeleteProfileResponse.prototype.updated = null;

    /**
     * Creates a new DeleteProfileResponse instance using the specified properties.
     * @function create
     * @memberof DeleteProfileResponse
     * @static
     * @param {IDeleteProfileResponse=} [properties] Properties to set
     * @returns {DeleteProfileResponse} DeleteProfileResponse instance
     */
    DeleteProfileResponse.create = function create(properties) {
        return new DeleteProfileResponse(properties);
    };

    /**
     * Encodes the specified DeleteProfileResponse message. Does not implicitly {@link DeleteProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof DeleteProfileResponse
     * @static
     * @param {IDeleteProfileResponse} message DeleteProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.ApiUserProto.encode(message.updated, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DeleteProfileResponse message, length delimited. Does not implicitly {@link DeleteProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeleteProfileResponse
     * @static
     * @param {IDeleteProfileResponse} message DeleteProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DeleteProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeleteProfileResponse} DeleteProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeleteProfileResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.updated = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeleteProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeleteProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeleteProfileResponse} DeleteProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteProfileResponse message.
     * @function verify
     * @memberof DeleteProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.updated != null && message.hasOwnProperty("updated")) {
            var error = $root.ApiUserProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        return null;
    };

    /**
     * Creates a DeleteProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeleteProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeleteProfileResponse} DeleteProfileResponse
     */
    DeleteProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DeleteProfileResponse)
            return object;
        var message = new $root.DeleteProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".DeleteProfileResponse.updated: object expected");
            message.updated = $root.ApiUserProto.fromObject(object.updated);
        }
        return message;
    };

    /**
     * Creates a plain object from a DeleteProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeleteProfileResponse
     * @static
     * @param {DeleteProfileResponse} message DeleteProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.ApiUserProto.toObject(message.updated, options);
        return object;
    };

    /**
     * Converts this DeleteProfileResponse to JSON.
     * @function toJSON
     * @memberof DeleteProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeleteProfileResponse
     * @function getTypeUrl
     * @memberof DeleteProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeleteProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeleteProfileResponse";
    };

    return DeleteProfileResponse;
})();

$root.BookAppointmentRequest = (function() {

    /**
     * Properties of a BookAppointmentRequest.
     * @exports IBookAppointmentRequest
     * @interface IBookAppointmentRequest
     * @property {string|null} [businessId] BookAppointmentRequest businessId
     * @property {string|null} [practitionerId] BookAppointmentRequest practitionerId
     * @property {string|null} [serviceId] BookAppointmentRequest serviceId
     * @property {string|null} [locationId] BookAppointmentRequest locationId
     * @property {number|Long|null} [appointmentTime] BookAppointmentRequest appointmentTime
     * @property {space.kenko.proto.IBookingPurchaseOption|null} [purchaseOption] BookAppointmentRequest purchaseOption
     * @property {boolean|null} [virtualAppt] BookAppointmentRequest virtualAppt
     */

    /**
     * Constructs a new BookAppointmentRequest.
     * @exports BookAppointmentRequest
     * @classdesc Represents a BookAppointmentRequest.
     * @implements IBookAppointmentRequest
     * @constructor
     * @param {IBookAppointmentRequest=} [properties] Properties to set
     */
    function BookAppointmentRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookAppointmentRequest businessId.
     * @member {string} businessId
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.businessId = "";

    /**
     * BookAppointmentRequest practitionerId.
     * @member {string} practitionerId
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.practitionerId = "";

    /**
     * BookAppointmentRequest serviceId.
     * @member {string} serviceId
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.serviceId = "";

    /**
     * BookAppointmentRequest locationId.
     * @member {string} locationId
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.locationId = "";

    /**
     * BookAppointmentRequest appointmentTime.
     * @member {number|Long} appointmentTime
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.appointmentTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * BookAppointmentRequest purchaseOption.
     * @member {space.kenko.proto.IBookingPurchaseOption|null|undefined} purchaseOption
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.purchaseOption = null;

    /**
     * BookAppointmentRequest virtualAppt.
     * @member {boolean} virtualAppt
     * @memberof BookAppointmentRequest
     * @instance
     */
    BookAppointmentRequest.prototype.virtualAppt = false;

    /**
     * Creates a new BookAppointmentRequest instance using the specified properties.
     * @function create
     * @memberof BookAppointmentRequest
     * @static
     * @param {IBookAppointmentRequest=} [properties] Properties to set
     * @returns {BookAppointmentRequest} BookAppointmentRequest instance
     */
    BookAppointmentRequest.create = function create(properties) {
        return new BookAppointmentRequest(properties);
    };

    /**
     * Encodes the specified BookAppointmentRequest message. Does not implicitly {@link BookAppointmentRequest.verify|verify} messages.
     * @function encode
     * @memberof BookAppointmentRequest
     * @static
     * @param {IBookAppointmentRequest} message BookAppointmentRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookAppointmentRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerId);
        if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.serviceId);
        if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationId);
        if (message.appointmentTime != null && Object.hasOwnProperty.call(message, "appointmentTime"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.appointmentTime);
        if (message.purchaseOption != null && Object.hasOwnProperty.call(message, "purchaseOption"))
            $root.space.kenko.proto.BookingPurchaseOption.encode(message.purchaseOption, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.virtualAppt != null && Object.hasOwnProperty.call(message, "virtualAppt"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.virtualAppt);
        return writer;
    };

    /**
     * Encodes the specified BookAppointmentRequest message, length delimited. Does not implicitly {@link BookAppointmentRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookAppointmentRequest
     * @static
     * @param {IBookAppointmentRequest} message BookAppointmentRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookAppointmentRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookAppointmentRequest message from the specified reader or buffer.
     * @function decode
     * @memberof BookAppointmentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookAppointmentRequest} BookAppointmentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookAppointmentRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookAppointmentRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.practitionerId = reader.string();
                    break;
                }
            case 3: {
                    message.serviceId = reader.string();
                    break;
                }
            case 4: {
                    message.locationId = reader.string();
                    break;
                }
            case 5: {
                    message.appointmentTime = reader.int64();
                    break;
                }
            case 6: {
                    message.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.virtualAppt = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookAppointmentRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookAppointmentRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookAppointmentRequest} BookAppointmentRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookAppointmentRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookAppointmentRequest message.
     * @function verify
     * @memberof BookAppointmentRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookAppointmentRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            if (!$util.isString(message.practitionerId))
                return "practitionerId: string expected";
        if (message.serviceId != null && message.hasOwnProperty("serviceId"))
            if (!$util.isString(message.serviceId))
                return "serviceId: string expected";
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            if (!$util.isString(message.locationId))
                return "locationId: string expected";
        if (message.appointmentTime != null && message.hasOwnProperty("appointmentTime"))
            if (!$util.isInteger(message.appointmentTime) && !(message.appointmentTime && $util.isInteger(message.appointmentTime.low) && $util.isInteger(message.appointmentTime.high)))
                return "appointmentTime: integer|Long expected";
        if (message.purchaseOption != null && message.hasOwnProperty("purchaseOption")) {
            var error = $root.space.kenko.proto.BookingPurchaseOption.verify(message.purchaseOption);
            if (error)
                return "purchaseOption." + error;
        }
        if (message.virtualAppt != null && message.hasOwnProperty("virtualAppt"))
            if (typeof message.virtualAppt !== "boolean")
                return "virtualAppt: boolean expected";
        return null;
    };

    /**
     * Creates a BookAppointmentRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookAppointmentRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookAppointmentRequest} BookAppointmentRequest
     */
    BookAppointmentRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BookAppointmentRequest)
            return object;
        var message = new $root.BookAppointmentRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.practitionerId != null)
            message.practitionerId = String(object.practitionerId);
        if (object.serviceId != null)
            message.serviceId = String(object.serviceId);
        if (object.locationId != null)
            message.locationId = String(object.locationId);
        if (object.appointmentTime != null)
            if ($util.Long)
                (message.appointmentTime = $util.Long.fromValue(object.appointmentTime)).unsigned = false;
            else if (typeof object.appointmentTime === "string")
                message.appointmentTime = parseInt(object.appointmentTime, 10);
            else if (typeof object.appointmentTime === "number")
                message.appointmentTime = object.appointmentTime;
            else if (typeof object.appointmentTime === "object")
                message.appointmentTime = new $util.LongBits(object.appointmentTime.low >>> 0, object.appointmentTime.high >>> 0).toNumber();
        if (object.purchaseOption != null) {
            if (typeof object.purchaseOption !== "object")
                throw TypeError(".BookAppointmentRequest.purchaseOption: object expected");
            message.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.fromObject(object.purchaseOption);
        }
        if (object.virtualAppt != null)
            message.virtualAppt = Boolean(object.virtualAppt);
        return message;
    };

    /**
     * Creates a plain object from a BookAppointmentRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookAppointmentRequest
     * @static
     * @param {BookAppointmentRequest} message BookAppointmentRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookAppointmentRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.practitionerId = "";
            object.serviceId = "";
            object.locationId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.appointmentTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.appointmentTime = options.longs === String ? "0" : 0;
            object.purchaseOption = null;
            object.virtualAppt = false;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            object.practitionerId = message.practitionerId;
        if (message.serviceId != null && message.hasOwnProperty("serviceId"))
            object.serviceId = message.serviceId;
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            object.locationId = message.locationId;
        if (message.appointmentTime != null && message.hasOwnProperty("appointmentTime"))
            if (typeof message.appointmentTime === "number")
                object.appointmentTime = options.longs === String ? String(message.appointmentTime) : message.appointmentTime;
            else
                object.appointmentTime = options.longs === String ? $util.Long.prototype.toString.call(message.appointmentTime) : options.longs === Number ? new $util.LongBits(message.appointmentTime.low >>> 0, message.appointmentTime.high >>> 0).toNumber() : message.appointmentTime;
        if (message.purchaseOption != null && message.hasOwnProperty("purchaseOption"))
            object.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.toObject(message.purchaseOption, options);
        if (message.virtualAppt != null && message.hasOwnProperty("virtualAppt"))
            object.virtualAppt = message.virtualAppt;
        return object;
    };

    /**
     * Converts this BookAppointmentRequest to JSON.
     * @function toJSON
     * @memberof BookAppointmentRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookAppointmentRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookAppointmentRequest
     * @function getTypeUrl
     * @memberof BookAppointmentRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookAppointmentRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookAppointmentRequest";
    };

    return BookAppointmentRequest;
})();

$root.BookAppointmentResponse = (function() {

    /**
     * Properties of a BookAppointmentResponse.
     * @exports IBookAppointmentResponse
     * @interface IBookAppointmentResponse
     * @property {boolean|null} [okay] BookAppointmentResponse okay
     * @property {string|null} [error] BookAppointmentResponse error
     * @property {space.kenko.proto.IApiBookingProto|null} [appointment] BookAppointmentResponse appointment
     * @property {IApiUserProto|null} [updatedProfile] BookAppointmentResponse updatedProfile
     */

    /**
     * Constructs a new BookAppointmentResponse.
     * @exports BookAppointmentResponse
     * @classdesc Represents a BookAppointmentResponse.
     * @implements IBookAppointmentResponse
     * @constructor
     * @param {IBookAppointmentResponse=} [properties] Properties to set
     */
    function BookAppointmentResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookAppointmentResponse okay.
     * @member {boolean} okay
     * @memberof BookAppointmentResponse
     * @instance
     */
    BookAppointmentResponse.prototype.okay = false;

    /**
     * BookAppointmentResponse error.
     * @member {string} error
     * @memberof BookAppointmentResponse
     * @instance
     */
    BookAppointmentResponse.prototype.error = "";

    /**
     * BookAppointmentResponse appointment.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} appointment
     * @memberof BookAppointmentResponse
     * @instance
     */
    BookAppointmentResponse.prototype.appointment = null;

    /**
     * BookAppointmentResponse updatedProfile.
     * @member {IApiUserProto|null|undefined} updatedProfile
     * @memberof BookAppointmentResponse
     * @instance
     */
    BookAppointmentResponse.prototype.updatedProfile = null;

    /**
     * Creates a new BookAppointmentResponse instance using the specified properties.
     * @function create
     * @memberof BookAppointmentResponse
     * @static
     * @param {IBookAppointmentResponse=} [properties] Properties to set
     * @returns {BookAppointmentResponse} BookAppointmentResponse instance
     */
    BookAppointmentResponse.create = function create(properties) {
        return new BookAppointmentResponse(properties);
    };

    /**
     * Encodes the specified BookAppointmentResponse message. Does not implicitly {@link BookAppointmentResponse.verify|verify} messages.
     * @function encode
     * @memberof BookAppointmentResponse
     * @static
     * @param {IBookAppointmentResponse} message BookAppointmentResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookAppointmentResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.appointment != null && Object.hasOwnProperty.call(message, "appointment"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.appointment, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.updatedProfile != null && Object.hasOwnProperty.call(message, "updatedProfile"))
            $root.ApiUserProto.encode(message.updatedProfile, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BookAppointmentResponse message, length delimited. Does not implicitly {@link BookAppointmentResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookAppointmentResponse
     * @static
     * @param {IBookAppointmentResponse} message BookAppointmentResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookAppointmentResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookAppointmentResponse message from the specified reader or buffer.
     * @function decode
     * @memberof BookAppointmentResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookAppointmentResponse} BookAppointmentResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookAppointmentResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookAppointmentResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    message.appointment = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.updatedProfile = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookAppointmentResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookAppointmentResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookAppointmentResponse} BookAppointmentResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookAppointmentResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookAppointmentResponse message.
     * @function verify
     * @memberof BookAppointmentResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookAppointmentResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.appointment != null && message.hasOwnProperty("appointment")) {
            var error = $root.space.kenko.proto.ApiBookingProto.verify(message.appointment);
            if (error)
                return "appointment." + error;
        }
        if (message.updatedProfile != null && message.hasOwnProperty("updatedProfile")) {
            var error = $root.ApiUserProto.verify(message.updatedProfile);
            if (error)
                return "updatedProfile." + error;
        }
        return null;
    };

    /**
     * Creates a BookAppointmentResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookAppointmentResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookAppointmentResponse} BookAppointmentResponse
     */
    BookAppointmentResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.BookAppointmentResponse)
            return object;
        var message = new $root.BookAppointmentResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.appointment != null) {
            if (typeof object.appointment !== "object")
                throw TypeError(".BookAppointmentResponse.appointment: object expected");
            message.appointment = $root.space.kenko.proto.ApiBookingProto.fromObject(object.appointment);
        }
        if (object.updatedProfile != null) {
            if (typeof object.updatedProfile !== "object")
                throw TypeError(".BookAppointmentResponse.updatedProfile: object expected");
            message.updatedProfile = $root.ApiUserProto.fromObject(object.updatedProfile);
        }
        return message;
    };

    /**
     * Creates a plain object from a BookAppointmentResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookAppointmentResponse
     * @static
     * @param {BookAppointmentResponse} message BookAppointmentResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookAppointmentResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.error = "";
            object.appointment = null;
            object.updatedProfile = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.appointment != null && message.hasOwnProperty("appointment"))
            object.appointment = $root.space.kenko.proto.ApiBookingProto.toObject(message.appointment, options);
        if (message.updatedProfile != null && message.hasOwnProperty("updatedProfile"))
            object.updatedProfile = $root.ApiUserProto.toObject(message.updatedProfile, options);
        return object;
    };

    /**
     * Converts this BookAppointmentResponse to JSON.
     * @function toJSON
     * @memberof BookAppointmentResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookAppointmentResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookAppointmentResponse
     * @function getTypeUrl
     * @memberof BookAppointmentResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookAppointmentResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookAppointmentResponse";
    };

    return BookAppointmentResponse;
})();

$root.GetClassScheduleRequest = (function() {

    /**
     * Properties of a GetClassScheduleRequest.
     * @exports IGetClassScheduleRequest
     * @interface IGetClassScheduleRequest
     * @property {string|null} [businessId] GetClassScheduleRequest businessId
     * @property {string|null} [profileVersion] GetClassScheduleRequest profileVersion
     * @property {number|Long|null} [fromTimestampMs] GetClassScheduleRequest fromTimestampMs
     * @property {number|Long|null} [toTimestampMs] GetClassScheduleRequest toTimestampMs
     */

    /**
     * Constructs a new GetClassScheduleRequest.
     * @exports GetClassScheduleRequest
     * @classdesc Represents a GetClassScheduleRequest.
     * @implements IGetClassScheduleRequest
     * @constructor
     * @param {IGetClassScheduleRequest=} [properties] Properties to set
     */
    function GetClassScheduleRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClassScheduleRequest businessId.
     * @member {string} businessId
     * @memberof GetClassScheduleRequest
     * @instance
     */
    GetClassScheduleRequest.prototype.businessId = "";

    /**
     * GetClassScheduleRequest profileVersion.
     * @member {string} profileVersion
     * @memberof GetClassScheduleRequest
     * @instance
     */
    GetClassScheduleRequest.prototype.profileVersion = "";

    /**
     * GetClassScheduleRequest fromTimestampMs.
     * @member {number|Long} fromTimestampMs
     * @memberof GetClassScheduleRequest
     * @instance
     */
    GetClassScheduleRequest.prototype.fromTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * GetClassScheduleRequest toTimestampMs.
     * @member {number|Long} toTimestampMs
     * @memberof GetClassScheduleRequest
     * @instance
     */
    GetClassScheduleRequest.prototype.toTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new GetClassScheduleRequest instance using the specified properties.
     * @function create
     * @memberof GetClassScheduleRequest
     * @static
     * @param {IGetClassScheduleRequest=} [properties] Properties to set
     * @returns {GetClassScheduleRequest} GetClassScheduleRequest instance
     */
    GetClassScheduleRequest.create = function create(properties) {
        return new GetClassScheduleRequest(properties);
    };

    /**
     * Encodes the specified GetClassScheduleRequest message. Does not implicitly {@link GetClassScheduleRequest.verify|verify} messages.
     * @function encode
     * @memberof GetClassScheduleRequest
     * @static
     * @param {IGetClassScheduleRequest} message GetClassScheduleRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassScheduleRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.profileVersion != null && Object.hasOwnProperty.call(message, "profileVersion"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.profileVersion);
        if (message.fromTimestampMs != null && Object.hasOwnProperty.call(message, "fromTimestampMs"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.fromTimestampMs);
        if (message.toTimestampMs != null && Object.hasOwnProperty.call(message, "toTimestampMs"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.toTimestampMs);
        return writer;
    };

    /**
     * Encodes the specified GetClassScheduleRequest message, length delimited. Does not implicitly {@link GetClassScheduleRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClassScheduleRequest
     * @static
     * @param {IGetClassScheduleRequest} message GetClassScheduleRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClassScheduleRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetClassScheduleRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClassScheduleRequest} GetClassScheduleRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassScheduleRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClassScheduleRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.profileVersion = reader.string();
                    break;
                }
            case 4: {
                    message.fromTimestampMs = reader.int64();
                    break;
                }
            case 5: {
                    message.toTimestampMs = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClassScheduleRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClassScheduleRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClassScheduleRequest} GetClassScheduleRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClassScheduleRequest message.
     * @function verify
     * @memberof GetClassScheduleRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClassScheduleRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.profileVersion != null && message.hasOwnProperty("profileVersion"))
            if (!$util.isString(message.profileVersion))
                return "profileVersion: string expected";
        if (message.fromTimestampMs != null && message.hasOwnProperty("fromTimestampMs"))
            if (!$util.isInteger(message.fromTimestampMs) && !(message.fromTimestampMs && $util.isInteger(message.fromTimestampMs.low) && $util.isInteger(message.fromTimestampMs.high)))
                return "fromTimestampMs: integer|Long expected";
        if (message.toTimestampMs != null && message.hasOwnProperty("toTimestampMs"))
            if (!$util.isInteger(message.toTimestampMs) && !(message.toTimestampMs && $util.isInteger(message.toTimestampMs.low) && $util.isInteger(message.toTimestampMs.high)))
                return "toTimestampMs: integer|Long expected";
        return null;
    };

    /**
     * Creates a GetClassScheduleRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClassScheduleRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClassScheduleRequest} GetClassScheduleRequest
     */
    GetClassScheduleRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClassScheduleRequest)
            return object;
        var message = new $root.GetClassScheduleRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.profileVersion != null)
            message.profileVersion = String(object.profileVersion);
        if (object.fromTimestampMs != null)
            if ($util.Long)
                (message.fromTimestampMs = $util.Long.fromValue(object.fromTimestampMs)).unsigned = false;
            else if (typeof object.fromTimestampMs === "string")
                message.fromTimestampMs = parseInt(object.fromTimestampMs, 10);
            else if (typeof object.fromTimestampMs === "number")
                message.fromTimestampMs = object.fromTimestampMs;
            else if (typeof object.fromTimestampMs === "object")
                message.fromTimestampMs = new $util.LongBits(object.fromTimestampMs.low >>> 0, object.fromTimestampMs.high >>> 0).toNumber();
        if (object.toTimestampMs != null)
            if ($util.Long)
                (message.toTimestampMs = $util.Long.fromValue(object.toTimestampMs)).unsigned = false;
            else if (typeof object.toTimestampMs === "string")
                message.toTimestampMs = parseInt(object.toTimestampMs, 10);
            else if (typeof object.toTimestampMs === "number")
                message.toTimestampMs = object.toTimestampMs;
            else if (typeof object.toTimestampMs === "object")
                message.toTimestampMs = new $util.LongBits(object.toTimestampMs.low >>> 0, object.toTimestampMs.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a GetClassScheduleRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClassScheduleRequest
     * @static
     * @param {GetClassScheduleRequest} message GetClassScheduleRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClassScheduleRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.profileVersion = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.fromTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.fromTimestampMs = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.toTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.toTimestampMs = options.longs === String ? "0" : 0;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.profileVersion != null && message.hasOwnProperty("profileVersion"))
            object.profileVersion = message.profileVersion;
        if (message.fromTimestampMs != null && message.hasOwnProperty("fromTimestampMs"))
            if (typeof message.fromTimestampMs === "number")
                object.fromTimestampMs = options.longs === String ? String(message.fromTimestampMs) : message.fromTimestampMs;
            else
                object.fromTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.fromTimestampMs) : options.longs === Number ? new $util.LongBits(message.fromTimestampMs.low >>> 0, message.fromTimestampMs.high >>> 0).toNumber() : message.fromTimestampMs;
        if (message.toTimestampMs != null && message.hasOwnProperty("toTimestampMs"))
            if (typeof message.toTimestampMs === "number")
                object.toTimestampMs = options.longs === String ? String(message.toTimestampMs) : message.toTimestampMs;
            else
                object.toTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.toTimestampMs) : options.longs === Number ? new $util.LongBits(message.toTimestampMs.low >>> 0, message.toTimestampMs.high >>> 0).toNumber() : message.toTimestampMs;
        return object;
    };

    /**
     * Converts this GetClassScheduleRequest to JSON.
     * @function toJSON
     * @memberof GetClassScheduleRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClassScheduleRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClassScheduleRequest
     * @function getTypeUrl
     * @memberof GetClassScheduleRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClassScheduleRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClassScheduleRequest";
    };

    return GetClassScheduleRequest;
})();

$root.GetClassScheduleResponse = (function() {

    /**
     * Properties of a GetClassScheduleResponse.
     * @exports IGetClassScheduleResponse
     * @interface IGetClassScheduleResponse
     * @property {boolean|null} [okay] GetClassScheduleResponse okay
     * @property {Array.<IScheduledClassProto>|null} [classes] GetClassScheduleResponse classes
     */

    /**
     * Constructs a new GetClassScheduleResponse.
     * @exports GetClassScheduleResponse
     * @classdesc Represents a GetClassScheduleResponse.
     * @implements IGetClassScheduleResponse
     * @constructor
     * @param {IGetClassScheduleResponse=} [properties] Properties to set
     */
    function GetClassScheduleResponse(properties) {
        this.classes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClassScheduleResponse okay.
     * @member {boolean} okay
     * @memberof GetClassScheduleResponse
     * @instance
     */
    GetClassScheduleResponse.prototype.okay = false;

    /**
     * GetClassScheduleResponse classes.
     * @member {Array.<IScheduledClassProto>} classes
     * @memberof GetClassScheduleResponse
     * @instance
     */
    GetClassScheduleResponse.prototype.classes = $util.emptyArray;

    /**
     * Creates a new GetClassScheduleResponse instance using the specified properties.
     * @function create
     * @memberof GetClassScheduleResponse
     * @static
     * @param {IGetClassScheduleResponse=} [properties] Properties to set
     * @returns {GetClassScheduleResponse} GetClassScheduleResponse instance
     */
    GetClassScheduleResponse.create = function create(properties) {
        return new GetClassScheduleResponse(properties);
    };

    /**
     * Encodes the specified GetClassScheduleResponse message. Does not implicitly {@link GetClassScheduleResponse.verify|verify} messages.
     * @function encode
     * @memberof GetClassScheduleResponse
     * @static
     * @param {IGetClassScheduleResponse} message GetClassScheduleResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassScheduleResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.classes != null && message.classes.length)
            for (var i = 0; i < message.classes.length; ++i)
                $root.ScheduledClassProto.encode(message.classes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetClassScheduleResponse message, length delimited. Does not implicitly {@link GetClassScheduleResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClassScheduleResponse
     * @static
     * @param {IGetClassScheduleResponse} message GetClassScheduleResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassScheduleResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClassScheduleResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetClassScheduleResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClassScheduleResponse} GetClassScheduleResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassScheduleResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClassScheduleResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.classes && message.classes.length))
                        message.classes = [];
                    message.classes.push($root.ScheduledClassProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClassScheduleResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClassScheduleResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClassScheduleResponse} GetClassScheduleResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassScheduleResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClassScheduleResponse message.
     * @function verify
     * @memberof GetClassScheduleResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClassScheduleResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.classes != null && message.hasOwnProperty("classes")) {
            if (!Array.isArray(message.classes))
                return "classes: array expected";
            for (var i = 0; i < message.classes.length; ++i) {
                var error = $root.ScheduledClassProto.verify(message.classes[i]);
                if (error)
                    return "classes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetClassScheduleResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClassScheduleResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClassScheduleResponse} GetClassScheduleResponse
     */
    GetClassScheduleResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClassScheduleResponse)
            return object;
        var message = new $root.GetClassScheduleResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.classes) {
            if (!Array.isArray(object.classes))
                throw TypeError(".GetClassScheduleResponse.classes: array expected");
            message.classes = [];
            for (var i = 0; i < object.classes.length; ++i) {
                if (typeof object.classes[i] !== "object")
                    throw TypeError(".GetClassScheduleResponse.classes: object expected");
                message.classes[i] = $root.ScheduledClassProto.fromObject(object.classes[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetClassScheduleResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClassScheduleResponse
     * @static
     * @param {GetClassScheduleResponse} message GetClassScheduleResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClassScheduleResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.classes = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.classes && message.classes.length) {
            object.classes = [];
            for (var j = 0; j < message.classes.length; ++j)
                object.classes[j] = $root.ScheduledClassProto.toObject(message.classes[j], options);
        }
        return object;
    };

    /**
     * Converts this GetClassScheduleResponse to JSON.
     * @function toJSON
     * @memberof GetClassScheduleResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClassScheduleResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClassScheduleResponse
     * @function getTypeUrl
     * @memberof GetClassScheduleResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClassScheduleResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClassScheduleResponse";
    };

    return GetClassScheduleResponse;
})();

$root.ScheduledClassProto = (function() {

    /**
     * Properties of a ScheduledClassProto.
     * @exports IScheduledClassProto
     * @interface IScheduledClassProto
     * @property {string|null} [businessId] ScheduledClassProto businessId
     * @property {string|null} [eventInstanceId] ScheduledClassProto eventInstanceId
     * @property {number|Long|null} [startTimestamp] ScheduledClassProto startTimestamp
     * @property {number|Long|null} [endTimestamp] ScheduledClassProto endTimestamp
     * @property {string|null} [className] ScheduledClassProto className
     * @property {string|null} [teacherName] ScheduledClassProto teacherName
     * @property {string|null} [locationId] ScheduledClassProto locationId
     * @property {string|null} [locationName] ScheduledClassProto locationName
     * @property {string|null} [locationAddress] ScheduledClassProto locationAddress
     * @property {number|null} [spotsRemaining] ScheduledClassProto spotsRemaining
     * @property {boolean|null} [isUserInClass] ScheduledClassProto isUserInClass
     * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ScheduledClassProto paymentPolicy
     * @property {string|null} [classTemplateId] ScheduledClassProto classTemplateId
     */

    /**
     * Constructs a new ScheduledClassProto.
     * @exports ScheduledClassProto
     * @classdesc Represents a ScheduledClassProto.
     * @implements IScheduledClassProto
     * @constructor
     * @param {IScheduledClassProto=} [properties] Properties to set
     */
    function ScheduledClassProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ScheduledClassProto businessId.
     * @member {string} businessId
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.businessId = "";

    /**
     * ScheduledClassProto eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.eventInstanceId = "";

    /**
     * ScheduledClassProto startTimestamp.
     * @member {number|Long} startTimestamp
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.startTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ScheduledClassProto endTimestamp.
     * @member {number|Long} endTimestamp
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.endTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ScheduledClassProto className.
     * @member {string} className
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.className = "";

    /**
     * ScheduledClassProto teacherName.
     * @member {string} teacherName
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.teacherName = "";

    /**
     * ScheduledClassProto locationId.
     * @member {string} locationId
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.locationId = "";

    /**
     * ScheduledClassProto locationName.
     * @member {string} locationName
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.locationName = "";

    /**
     * ScheduledClassProto locationAddress.
     * @member {string} locationAddress
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.locationAddress = "";

    /**
     * ScheduledClassProto spotsRemaining.
     * @member {number} spotsRemaining
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.spotsRemaining = 0;

    /**
     * ScheduledClassProto isUserInClass.
     * @member {boolean} isUserInClass
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.isUserInClass = false;

    /**
     * ScheduledClassProto paymentPolicy.
     * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.paymentPolicy = null;

    /**
     * ScheduledClassProto classTemplateId.
     * @member {string} classTemplateId
     * @memberof ScheduledClassProto
     * @instance
     */
    ScheduledClassProto.prototype.classTemplateId = "";

    /**
     * Creates a new ScheduledClassProto instance using the specified properties.
     * @function create
     * @memberof ScheduledClassProto
     * @static
     * @param {IScheduledClassProto=} [properties] Properties to set
     * @returns {ScheduledClassProto} ScheduledClassProto instance
     */
    ScheduledClassProto.create = function create(properties) {
        return new ScheduledClassProto(properties);
    };

    /**
     * Encodes the specified ScheduledClassProto message. Does not implicitly {@link ScheduledClassProto.verify|verify} messages.
     * @function encode
     * @memberof ScheduledClassProto
     * @static
     * @param {IScheduledClassProto} message ScheduledClassProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScheduledClassProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventInstanceId);
        if (message.startTimestamp != null && Object.hasOwnProperty.call(message, "startTimestamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.startTimestamp);
        if (message.endTimestamp != null && Object.hasOwnProperty.call(message, "endTimestamp"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.endTimestamp);
        if (message.className != null && Object.hasOwnProperty.call(message, "className"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.className);
        if (message.teacherName != null && Object.hasOwnProperty.call(message, "teacherName"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.teacherName);
        if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.locationId);
        if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.locationName);
        if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.locationAddress);
        if (message.spotsRemaining != null && Object.hasOwnProperty.call(message, "spotsRemaining"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.spotsRemaining);
        if (message.isUserInClass != null && Object.hasOwnProperty.call(message, "isUserInClass"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isUserInClass);
        if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
            $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.classTemplateId);
        return writer;
    };

    /**
     * Encodes the specified ScheduledClassProto message, length delimited. Does not implicitly {@link ScheduledClassProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ScheduledClassProto
     * @static
     * @param {IScheduledClassProto} message ScheduledClassProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ScheduledClassProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ScheduledClassProto message from the specified reader or buffer.
     * @function decode
     * @memberof ScheduledClassProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ScheduledClassProto} ScheduledClassProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScheduledClassProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ScheduledClassProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            case 4: {
                    message.startTimestamp = reader.int64();
                    break;
                }
            case 5: {
                    message.endTimestamp = reader.int64();
                    break;
                }
            case 6: {
                    message.className = reader.string();
                    break;
                }
            case 7: {
                    message.teacherName = reader.string();
                    break;
                }
            case 8: {
                    message.locationId = reader.string();
                    break;
                }
            case 9: {
                    message.locationName = reader.string();
                    break;
                }
            case 10: {
                    message.locationAddress = reader.string();
                    break;
                }
            case 11: {
                    message.spotsRemaining = reader.int32();
                    break;
                }
            case 12: {
                    message.isUserInClass = reader.bool();
                    break;
                }
            case 13: {
                    message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                    break;
                }
            case 14: {
                    message.classTemplateId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ScheduledClassProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ScheduledClassProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ScheduledClassProto} ScheduledClassProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ScheduledClassProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ScheduledClassProto message.
     * @function verify
     * @memberof ScheduledClassProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ScheduledClassProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        if (message.startTimestamp != null && message.hasOwnProperty("startTimestamp"))
            if (!$util.isInteger(message.startTimestamp) && !(message.startTimestamp && $util.isInteger(message.startTimestamp.low) && $util.isInteger(message.startTimestamp.high)))
                return "startTimestamp: integer|Long expected";
        if (message.endTimestamp != null && message.hasOwnProperty("endTimestamp"))
            if (!$util.isInteger(message.endTimestamp) && !(message.endTimestamp && $util.isInteger(message.endTimestamp.low) && $util.isInteger(message.endTimestamp.high)))
                return "endTimestamp: integer|Long expected";
        if (message.className != null && message.hasOwnProperty("className"))
            if (!$util.isString(message.className))
                return "className: string expected";
        if (message.teacherName != null && message.hasOwnProperty("teacherName"))
            if (!$util.isString(message.teacherName))
                return "teacherName: string expected";
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            if (!$util.isString(message.locationId))
                return "locationId: string expected";
        if (message.locationName != null && message.hasOwnProperty("locationName"))
            if (!$util.isString(message.locationName))
                return "locationName: string expected";
        if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
            if (!$util.isString(message.locationAddress))
                return "locationAddress: string expected";
        if (message.spotsRemaining != null && message.hasOwnProperty("spotsRemaining"))
            if (!$util.isInteger(message.spotsRemaining))
                return "spotsRemaining: integer expected";
        if (message.isUserInClass != null && message.hasOwnProperty("isUserInClass"))
            if (typeof message.isUserInClass !== "boolean")
                return "isUserInClass: boolean expected";
        if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
            var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
            if (error)
                return "paymentPolicy." + error;
        }
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            if (!$util.isString(message.classTemplateId))
                return "classTemplateId: string expected";
        return null;
    };

    /**
     * Creates a ScheduledClassProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ScheduledClassProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ScheduledClassProto} ScheduledClassProto
     */
    ScheduledClassProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ScheduledClassProto)
            return object;
        var message = new $root.ScheduledClassProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        if (object.startTimestamp != null)
            if ($util.Long)
                (message.startTimestamp = $util.Long.fromValue(object.startTimestamp)).unsigned = false;
            else if (typeof object.startTimestamp === "string")
                message.startTimestamp = parseInt(object.startTimestamp, 10);
            else if (typeof object.startTimestamp === "number")
                message.startTimestamp = object.startTimestamp;
            else if (typeof object.startTimestamp === "object")
                message.startTimestamp = new $util.LongBits(object.startTimestamp.low >>> 0, object.startTimestamp.high >>> 0).toNumber();
        if (object.endTimestamp != null)
            if ($util.Long)
                (message.endTimestamp = $util.Long.fromValue(object.endTimestamp)).unsigned = false;
            else if (typeof object.endTimestamp === "string")
                message.endTimestamp = parseInt(object.endTimestamp, 10);
            else if (typeof object.endTimestamp === "number")
                message.endTimestamp = object.endTimestamp;
            else if (typeof object.endTimestamp === "object")
                message.endTimestamp = new $util.LongBits(object.endTimestamp.low >>> 0, object.endTimestamp.high >>> 0).toNumber();
        if (object.className != null)
            message.className = String(object.className);
        if (object.teacherName != null)
            message.teacherName = String(object.teacherName);
        if (object.locationId != null)
            message.locationId = String(object.locationId);
        if (object.locationName != null)
            message.locationName = String(object.locationName);
        if (object.locationAddress != null)
            message.locationAddress = String(object.locationAddress);
        if (object.spotsRemaining != null)
            message.spotsRemaining = object.spotsRemaining | 0;
        if (object.isUserInClass != null)
            message.isUserInClass = Boolean(object.isUserInClass);
        if (object.paymentPolicy != null) {
            if (typeof object.paymentPolicy !== "object")
                throw TypeError(".ScheduledClassProto.paymentPolicy: object expected");
            message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
        }
        if (object.classTemplateId != null)
            message.classTemplateId = String(object.classTemplateId);
        return message;
    };

    /**
     * Creates a plain object from a ScheduledClassProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ScheduledClassProto
     * @static
     * @param {ScheduledClassProto} message ScheduledClassProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ScheduledClassProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.eventInstanceId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.startTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.endTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.endTimestamp = options.longs === String ? "0" : 0;
            object.className = "";
            object.teacherName = "";
            object.locationId = "";
            object.locationName = "";
            object.locationAddress = "";
            object.spotsRemaining = 0;
            object.isUserInClass = false;
            object.paymentPolicy = null;
            object.classTemplateId = "";
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        if (message.startTimestamp != null && message.hasOwnProperty("startTimestamp"))
            if (typeof message.startTimestamp === "number")
                object.startTimestamp = options.longs === String ? String(message.startTimestamp) : message.startTimestamp;
            else
                object.startTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.startTimestamp) : options.longs === Number ? new $util.LongBits(message.startTimestamp.low >>> 0, message.startTimestamp.high >>> 0).toNumber() : message.startTimestamp;
        if (message.endTimestamp != null && message.hasOwnProperty("endTimestamp"))
            if (typeof message.endTimestamp === "number")
                object.endTimestamp = options.longs === String ? String(message.endTimestamp) : message.endTimestamp;
            else
                object.endTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.endTimestamp) : options.longs === Number ? new $util.LongBits(message.endTimestamp.low >>> 0, message.endTimestamp.high >>> 0).toNumber() : message.endTimestamp;
        if (message.className != null && message.hasOwnProperty("className"))
            object.className = message.className;
        if (message.teacherName != null && message.hasOwnProperty("teacherName"))
            object.teacherName = message.teacherName;
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            object.locationId = message.locationId;
        if (message.locationName != null && message.hasOwnProperty("locationName"))
            object.locationName = message.locationName;
        if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
            object.locationAddress = message.locationAddress;
        if (message.spotsRemaining != null && message.hasOwnProperty("spotsRemaining"))
            object.spotsRemaining = message.spotsRemaining;
        if (message.isUserInClass != null && message.hasOwnProperty("isUserInClass"))
            object.isUserInClass = message.isUserInClass;
        if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
            object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            object.classTemplateId = message.classTemplateId;
        return object;
    };

    /**
     * Converts this ScheduledClassProto to JSON.
     * @function toJSON
     * @memberof ScheduledClassProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ScheduledClassProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ScheduledClassProto
     * @function getTypeUrl
     * @memberof ScheduledClassProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ScheduledClassProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ScheduledClassProto";
    };

    return ScheduledClassProto;
})();

$root.BookClassRequest = (function() {

    /**
     * Properties of a BookClassRequest.
     * @exports IBookClassRequest
     * @interface IBookClassRequest
     * @property {string|null} [businessId] BookClassRequest businessId
     * @property {string|null} [eventInstanceId] BookClassRequest eventInstanceId
     * @property {space.kenko.proto.IBookingPurchaseOption|null} [purchaseOption] BookClassRequest purchaseOption
     */

    /**
     * Constructs a new BookClassRequest.
     * @exports BookClassRequest
     * @classdesc Represents a BookClassRequest.
     * @implements IBookClassRequest
     * @constructor
     * @param {IBookClassRequest=} [properties] Properties to set
     */
    function BookClassRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookClassRequest businessId.
     * @member {string} businessId
     * @memberof BookClassRequest
     * @instance
     */
    BookClassRequest.prototype.businessId = "";

    /**
     * BookClassRequest eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof BookClassRequest
     * @instance
     */
    BookClassRequest.prototype.eventInstanceId = "";

    /**
     * BookClassRequest purchaseOption.
     * @member {space.kenko.proto.IBookingPurchaseOption|null|undefined} purchaseOption
     * @memberof BookClassRequest
     * @instance
     */
    BookClassRequest.prototype.purchaseOption = null;

    /**
     * Creates a new BookClassRequest instance using the specified properties.
     * @function create
     * @memberof BookClassRequest
     * @static
     * @param {IBookClassRequest=} [properties] Properties to set
     * @returns {BookClassRequest} BookClassRequest instance
     */
    BookClassRequest.create = function create(properties) {
        return new BookClassRequest(properties);
    };

    /**
     * Encodes the specified BookClassRequest message. Does not implicitly {@link BookClassRequest.verify|verify} messages.
     * @function encode
     * @memberof BookClassRequest
     * @static
     * @param {IBookClassRequest} message BookClassRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookClassRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventInstanceId);
        if (message.purchaseOption != null && Object.hasOwnProperty.call(message, "purchaseOption"))
            $root.space.kenko.proto.BookingPurchaseOption.encode(message.purchaseOption, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BookClassRequest message, length delimited. Does not implicitly {@link BookClassRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookClassRequest
     * @static
     * @param {IBookClassRequest} message BookClassRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookClassRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookClassRequest message from the specified reader or buffer.
     * @function decode
     * @memberof BookClassRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookClassRequest} BookClassRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookClassRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookClassRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            case 3: {
                    message.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookClassRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookClassRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookClassRequest} BookClassRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookClassRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookClassRequest message.
     * @function verify
     * @memberof BookClassRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookClassRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        if (message.purchaseOption != null && message.hasOwnProperty("purchaseOption")) {
            var error = $root.space.kenko.proto.BookingPurchaseOption.verify(message.purchaseOption);
            if (error)
                return "purchaseOption." + error;
        }
        return null;
    };

    /**
     * Creates a BookClassRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookClassRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookClassRequest} BookClassRequest
     */
    BookClassRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BookClassRequest)
            return object;
        var message = new $root.BookClassRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        if (object.purchaseOption != null) {
            if (typeof object.purchaseOption !== "object")
                throw TypeError(".BookClassRequest.purchaseOption: object expected");
            message.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.fromObject(object.purchaseOption);
        }
        return message;
    };

    /**
     * Creates a plain object from a BookClassRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookClassRequest
     * @static
     * @param {BookClassRequest} message BookClassRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookClassRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.eventInstanceId = "";
            object.purchaseOption = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        if (message.purchaseOption != null && message.hasOwnProperty("purchaseOption"))
            object.purchaseOption = $root.space.kenko.proto.BookingPurchaseOption.toObject(message.purchaseOption, options);
        return object;
    };

    /**
     * Converts this BookClassRequest to JSON.
     * @function toJSON
     * @memberof BookClassRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookClassRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookClassRequest
     * @function getTypeUrl
     * @memberof BookClassRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookClassRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookClassRequest";
    };

    return BookClassRequest;
})();

$root.BookClassResponse = (function() {

    /**
     * Properties of a BookClassResponse.
     * @exports IBookClassResponse
     * @interface IBookClassResponse
     * @property {boolean|null} [okay] BookClassResponse okay
     * @property {string|null} [error] BookClassResponse error
     * @property {space.kenko.proto.IApiBookingProto|null} [newBooking] BookClassResponse newBooking
     */

    /**
     * Constructs a new BookClassResponse.
     * @exports BookClassResponse
     * @classdesc Represents a BookClassResponse.
     * @implements IBookClassResponse
     * @constructor
     * @param {IBookClassResponse=} [properties] Properties to set
     */
    function BookClassResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookClassResponse okay.
     * @member {boolean} okay
     * @memberof BookClassResponse
     * @instance
     */
    BookClassResponse.prototype.okay = false;

    /**
     * BookClassResponse error.
     * @member {string} error
     * @memberof BookClassResponse
     * @instance
     */
    BookClassResponse.prototype.error = "";

    /**
     * BookClassResponse newBooking.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} newBooking
     * @memberof BookClassResponse
     * @instance
     */
    BookClassResponse.prototype.newBooking = null;

    /**
     * Creates a new BookClassResponse instance using the specified properties.
     * @function create
     * @memberof BookClassResponse
     * @static
     * @param {IBookClassResponse=} [properties] Properties to set
     * @returns {BookClassResponse} BookClassResponse instance
     */
    BookClassResponse.create = function create(properties) {
        return new BookClassResponse(properties);
    };

    /**
     * Encodes the specified BookClassResponse message. Does not implicitly {@link BookClassResponse.verify|verify} messages.
     * @function encode
     * @memberof BookClassResponse
     * @static
     * @param {IBookClassResponse} message BookClassResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookClassResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.newBooking != null && Object.hasOwnProperty.call(message, "newBooking"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.newBooking, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BookClassResponse message, length delimited. Does not implicitly {@link BookClassResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookClassResponse
     * @static
     * @param {IBookClassResponse} message BookClassResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookClassResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookClassResponse message from the specified reader or buffer.
     * @function decode
     * @memberof BookClassResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookClassResponse} BookClassResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookClassResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookClassResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    message.newBooking = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookClassResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookClassResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookClassResponse} BookClassResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookClassResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookClassResponse message.
     * @function verify
     * @memberof BookClassResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookClassResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.newBooking != null && message.hasOwnProperty("newBooking")) {
            var error = $root.space.kenko.proto.ApiBookingProto.verify(message.newBooking);
            if (error)
                return "newBooking." + error;
        }
        return null;
    };

    /**
     * Creates a BookClassResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookClassResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookClassResponse} BookClassResponse
     */
    BookClassResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.BookClassResponse)
            return object;
        var message = new $root.BookClassResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.newBooking != null) {
            if (typeof object.newBooking !== "object")
                throw TypeError(".BookClassResponse.newBooking: object expected");
            message.newBooking = $root.space.kenko.proto.ApiBookingProto.fromObject(object.newBooking);
        }
        return message;
    };

    /**
     * Creates a plain object from a BookClassResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookClassResponse
     * @static
     * @param {BookClassResponse} message BookClassResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookClassResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.error = "";
            object.newBooking = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.newBooking != null && message.hasOwnProperty("newBooking"))
            object.newBooking = $root.space.kenko.proto.ApiBookingProto.toObject(message.newBooking, options);
        return object;
    };

    /**
     * Converts this BookClassResponse to JSON.
     * @function toJSON
     * @memberof BookClassResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookClassResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookClassResponse
     * @function getTypeUrl
     * @memberof BookClassResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookClassResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookClassResponse";
    };

    return BookClassResponse;
})();

$root.GetBookingsRequest = (function() {

    /**
     * Properties of a GetBookingsRequest.
     * @exports IGetBookingsRequest
     * @interface IGetBookingsRequest
     * @property {string|null} [optionalBookingId] GetBookingsRequest optionalBookingId
     */

    /**
     * Constructs a new GetBookingsRequest.
     * @exports GetBookingsRequest
     * @classdesc Represents a GetBookingsRequest.
     * @implements IGetBookingsRequest
     * @constructor
     * @param {IGetBookingsRequest=} [properties] Properties to set
     */
    function GetBookingsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBookingsRequest optionalBookingId.
     * @member {string} optionalBookingId
     * @memberof GetBookingsRequest
     * @instance
     */
    GetBookingsRequest.prototype.optionalBookingId = "";

    /**
     * Creates a new GetBookingsRequest instance using the specified properties.
     * @function create
     * @memberof GetBookingsRequest
     * @static
     * @param {IGetBookingsRequest=} [properties] Properties to set
     * @returns {GetBookingsRequest} GetBookingsRequest instance
     */
    GetBookingsRequest.create = function create(properties) {
        return new GetBookingsRequest(properties);
    };

    /**
     * Encodes the specified GetBookingsRequest message. Does not implicitly {@link GetBookingsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetBookingsRequest
     * @static
     * @param {IGetBookingsRequest} message GetBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.optionalBookingId != null && Object.hasOwnProperty.call(message, "optionalBookingId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.optionalBookingId);
        return writer;
    };

    /**
     * Encodes the specified GetBookingsRequest message, length delimited. Does not implicitly {@link GetBookingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetBookingsRequest
     * @static
     * @param {IGetBookingsRequest} message GetBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBookingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetBookingsRequest} GetBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetBookingsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.optionalBookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetBookingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetBookingsRequest} GetBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBookingsRequest message.
     * @function verify
     * @memberof GetBookingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBookingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.optionalBookingId != null && message.hasOwnProperty("optionalBookingId"))
            if (!$util.isString(message.optionalBookingId))
                return "optionalBookingId: string expected";
        return null;
    };

    /**
     * Creates a GetBookingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetBookingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetBookingsRequest} GetBookingsRequest
     */
    GetBookingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetBookingsRequest)
            return object;
        var message = new $root.GetBookingsRequest();
        if (object.optionalBookingId != null)
            message.optionalBookingId = String(object.optionalBookingId);
        return message;
    };

    /**
     * Creates a plain object from a GetBookingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetBookingsRequest
     * @static
     * @param {GetBookingsRequest} message GetBookingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBookingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.optionalBookingId = "";
        if (message.optionalBookingId != null && message.hasOwnProperty("optionalBookingId"))
            object.optionalBookingId = message.optionalBookingId;
        return object;
    };

    /**
     * Converts this GetBookingsRequest to JSON.
     * @function toJSON
     * @memberof GetBookingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBookingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetBookingsRequest
     * @function getTypeUrl
     * @memberof GetBookingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetBookingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetBookingsRequest";
    };

    return GetBookingsRequest;
})();

$root.GetBookingsResponse = (function() {

    /**
     * Properties of a GetBookingsResponse.
     * @exports IGetBookingsResponse
     * @interface IGetBookingsResponse
     * @property {boolean|null} [okay] GetBookingsResponse okay
     * @property {Array.<space.kenko.proto.IApiBookingProto>|null} [booking] GetBookingsResponse booking
     */

    /**
     * Constructs a new GetBookingsResponse.
     * @exports GetBookingsResponse
     * @classdesc Represents a GetBookingsResponse.
     * @implements IGetBookingsResponse
     * @constructor
     * @param {IGetBookingsResponse=} [properties] Properties to set
     */
    function GetBookingsResponse(properties) {
        this.booking = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBookingsResponse okay.
     * @member {boolean} okay
     * @memberof GetBookingsResponse
     * @instance
     */
    GetBookingsResponse.prototype.okay = false;

    /**
     * GetBookingsResponse booking.
     * @member {Array.<space.kenko.proto.IApiBookingProto>} booking
     * @memberof GetBookingsResponse
     * @instance
     */
    GetBookingsResponse.prototype.booking = $util.emptyArray;

    /**
     * Creates a new GetBookingsResponse instance using the specified properties.
     * @function create
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse=} [properties] Properties to set
     * @returns {GetBookingsResponse} GetBookingsResponse instance
     */
    GetBookingsResponse.create = function create(properties) {
        return new GetBookingsResponse(properties);
    };

    /**
     * Encodes the specified GetBookingsResponse message. Does not implicitly {@link GetBookingsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse} message GetBookingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.booking != null && message.booking.length)
            for (var i = 0; i < message.booking.length; ++i)
                $root.space.kenko.proto.ApiBookingProto.encode(message.booking[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetBookingsResponse message, length delimited. Does not implicitly {@link GetBookingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse} message GetBookingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBookingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetBookingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetBookingsResponse} GetBookingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetBookingsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.booking && message.booking.length))
                        message.booking = [];
                    message.booking.push($root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetBookingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetBookingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetBookingsResponse} GetBookingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBookingsResponse message.
     * @function verify
     * @memberof GetBookingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBookingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.booking != null && message.hasOwnProperty("booking")) {
            if (!Array.isArray(message.booking))
                return "booking: array expected";
            for (var i = 0; i < message.booking.length; ++i) {
                var error = $root.space.kenko.proto.ApiBookingProto.verify(message.booking[i]);
                if (error)
                    return "booking." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetBookingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetBookingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetBookingsResponse} GetBookingsResponse
     */
    GetBookingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetBookingsResponse)
            return object;
        var message = new $root.GetBookingsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.booking) {
            if (!Array.isArray(object.booking))
                throw TypeError(".GetBookingsResponse.booking: array expected");
            message.booking = [];
            for (var i = 0; i < object.booking.length; ++i) {
                if (typeof object.booking[i] !== "object")
                    throw TypeError(".GetBookingsResponse.booking: object expected");
                message.booking[i] = $root.space.kenko.proto.ApiBookingProto.fromObject(object.booking[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetBookingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetBookingsResponse
     * @static
     * @param {GetBookingsResponse} message GetBookingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBookingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.booking = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.booking && message.booking.length) {
            object.booking = [];
            for (var j = 0; j < message.booking.length; ++j)
                object.booking[j] = $root.space.kenko.proto.ApiBookingProto.toObject(message.booking[j], options);
        }
        return object;
    };

    /**
     * Converts this GetBookingsResponse to JSON.
     * @function toJSON
     * @memberof GetBookingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBookingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetBookingsResponse
     * @function getTypeUrl
     * @memberof GetBookingsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetBookingsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetBookingsResponse";
    };

    return GetBookingsResponse;
})();

$root.CancelBookingRequest = (function() {

    /**
     * Properties of a CancelBookingRequest.
     * @exports ICancelBookingRequest
     * @interface ICancelBookingRequest
     * @property {string|null} [bookingId] CancelBookingRequest bookingId
     */

    /**
     * Constructs a new CancelBookingRequest.
     * @exports CancelBookingRequest
     * @classdesc Represents a CancelBookingRequest.
     * @implements ICancelBookingRequest
     * @constructor
     * @param {ICancelBookingRequest=} [properties] Properties to set
     */
    function CancelBookingRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CancelBookingRequest bookingId.
     * @member {string} bookingId
     * @memberof CancelBookingRequest
     * @instance
     */
    CancelBookingRequest.prototype.bookingId = "";

    /**
     * Creates a new CancelBookingRequest instance using the specified properties.
     * @function create
     * @memberof CancelBookingRequest
     * @static
     * @param {ICancelBookingRequest=} [properties] Properties to set
     * @returns {CancelBookingRequest} CancelBookingRequest instance
     */
    CancelBookingRequest.create = function create(properties) {
        return new CancelBookingRequest(properties);
    };

    /**
     * Encodes the specified CancelBookingRequest message. Does not implicitly {@link CancelBookingRequest.verify|verify} messages.
     * @function encode
     * @memberof CancelBookingRequest
     * @static
     * @param {ICancelBookingRequest} message CancelBookingRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelBookingRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
        return writer;
    };

    /**
     * Encodes the specified CancelBookingRequest message, length delimited. Does not implicitly {@link CancelBookingRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelBookingRequest
     * @static
     * @param {ICancelBookingRequest} message CancelBookingRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelBookingRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelBookingRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CancelBookingRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelBookingRequest} CancelBookingRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelBookingRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelBookingRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.bookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelBookingRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelBookingRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelBookingRequest} CancelBookingRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelBookingRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelBookingRequest message.
     * @function verify
     * @memberof CancelBookingRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelBookingRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            if (!$util.isString(message.bookingId))
                return "bookingId: string expected";
        return null;
    };

    /**
     * Creates a CancelBookingRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelBookingRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelBookingRequest} CancelBookingRequest
     */
    CancelBookingRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelBookingRequest)
            return object;
        var message = new $root.CancelBookingRequest();
        if (object.bookingId != null)
            message.bookingId = String(object.bookingId);
        return message;
    };

    /**
     * Creates a plain object from a CancelBookingRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelBookingRequest
     * @static
     * @param {CancelBookingRequest} message CancelBookingRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelBookingRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.bookingId = "";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            object.bookingId = message.bookingId;
        return object;
    };

    /**
     * Converts this CancelBookingRequest to JSON.
     * @function toJSON
     * @memberof CancelBookingRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelBookingRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CancelBookingRequest
     * @function getTypeUrl
     * @memberof CancelBookingRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CancelBookingRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CancelBookingRequest";
    };

    return CancelBookingRequest;
})();

$root.CancelBookingResponse = (function() {

    /**
     * Properties of a CancelBookingResponse.
     * @exports ICancelBookingResponse
     * @interface ICancelBookingResponse
     * @property {boolean|null} [okay] CancelBookingResponse okay
     * @property {string|null} [deletedBookingId] CancelBookingResponse deletedBookingId
     */

    /**
     * Constructs a new CancelBookingResponse.
     * @exports CancelBookingResponse
     * @classdesc Represents a CancelBookingResponse.
     * @implements ICancelBookingResponse
     * @constructor
     * @param {ICancelBookingResponse=} [properties] Properties to set
     */
    function CancelBookingResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CancelBookingResponse okay.
     * @member {boolean} okay
     * @memberof CancelBookingResponse
     * @instance
     */
    CancelBookingResponse.prototype.okay = false;

    /**
     * CancelBookingResponse deletedBookingId.
     * @member {string} deletedBookingId
     * @memberof CancelBookingResponse
     * @instance
     */
    CancelBookingResponse.prototype.deletedBookingId = "";

    /**
     * Creates a new CancelBookingResponse instance using the specified properties.
     * @function create
     * @memberof CancelBookingResponse
     * @static
     * @param {ICancelBookingResponse=} [properties] Properties to set
     * @returns {CancelBookingResponse} CancelBookingResponse instance
     */
    CancelBookingResponse.create = function create(properties) {
        return new CancelBookingResponse(properties);
    };

    /**
     * Encodes the specified CancelBookingResponse message. Does not implicitly {@link CancelBookingResponse.verify|verify} messages.
     * @function encode
     * @memberof CancelBookingResponse
     * @static
     * @param {ICancelBookingResponse} message CancelBookingResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelBookingResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.deletedBookingId != null && Object.hasOwnProperty.call(message, "deletedBookingId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.deletedBookingId);
        return writer;
    };

    /**
     * Encodes the specified CancelBookingResponse message, length delimited. Does not implicitly {@link CancelBookingResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelBookingResponse
     * @static
     * @param {ICancelBookingResponse} message CancelBookingResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelBookingResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelBookingResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CancelBookingResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelBookingResponse} CancelBookingResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelBookingResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelBookingResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.deletedBookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelBookingResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelBookingResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelBookingResponse} CancelBookingResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelBookingResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelBookingResponse message.
     * @function verify
     * @memberof CancelBookingResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelBookingResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.deletedBookingId != null && message.hasOwnProperty("deletedBookingId"))
            if (!$util.isString(message.deletedBookingId))
                return "deletedBookingId: string expected";
        return null;
    };

    /**
     * Creates a CancelBookingResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelBookingResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelBookingResponse} CancelBookingResponse
     */
    CancelBookingResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelBookingResponse)
            return object;
        var message = new $root.CancelBookingResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.deletedBookingId != null)
            message.deletedBookingId = String(object.deletedBookingId);
        return message;
    };

    /**
     * Creates a plain object from a CancelBookingResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelBookingResponse
     * @static
     * @param {CancelBookingResponse} message CancelBookingResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelBookingResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.deletedBookingId = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.deletedBookingId != null && message.hasOwnProperty("deletedBookingId"))
            object.deletedBookingId = message.deletedBookingId;
        return object;
    };

    /**
     * Converts this CancelBookingResponse to JSON.
     * @function toJSON
     * @memberof CancelBookingResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelBookingResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CancelBookingResponse
     * @function getTypeUrl
     * @memberof CancelBookingResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CancelBookingResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CancelBookingResponse";
    };

    return CancelBookingResponse;
})();

$root.GetClientRelationshipRequest = (function() {

    /**
     * Properties of a GetClientRelationshipRequest.
     * @exports IGetClientRelationshipRequest
     * @interface IGetClientRelationshipRequest
     * @property {string|null} [businessId] GetClientRelationshipRequest businessId
     */

    /**
     * Constructs a new GetClientRelationshipRequest.
     * @exports GetClientRelationshipRequest
     * @classdesc Represents a GetClientRelationshipRequest.
     * @implements IGetClientRelationshipRequest
     * @constructor
     * @param {IGetClientRelationshipRequest=} [properties] Properties to set
     */
    function GetClientRelationshipRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientRelationshipRequest businessId.
     * @member {string} businessId
     * @memberof GetClientRelationshipRequest
     * @instance
     */
    GetClientRelationshipRequest.prototype.businessId = "";

    /**
     * Creates a new GetClientRelationshipRequest instance using the specified properties.
     * @function create
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {IGetClientRelationshipRequest=} [properties] Properties to set
     * @returns {GetClientRelationshipRequest} GetClientRelationshipRequest instance
     */
    GetClientRelationshipRequest.create = function create(properties) {
        return new GetClientRelationshipRequest(properties);
    };

    /**
     * Encodes the specified GetClientRelationshipRequest message. Does not implicitly {@link GetClientRelationshipRequest.verify|verify} messages.
     * @function encode
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {IGetClientRelationshipRequest} message GetClientRelationshipRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientRelationshipRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        return writer;
    };

    /**
     * Encodes the specified GetClientRelationshipRequest message, length delimited. Does not implicitly {@link GetClientRelationshipRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {IGetClientRelationshipRequest} message GetClientRelationshipRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientRelationshipRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientRelationshipRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientRelationshipRequest} GetClientRelationshipRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientRelationshipRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientRelationshipRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientRelationshipRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientRelationshipRequest} GetClientRelationshipRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientRelationshipRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientRelationshipRequest message.
     * @function verify
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientRelationshipRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        return null;
    };

    /**
     * Creates a GetClientRelationshipRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientRelationshipRequest} GetClientRelationshipRequest
     */
    GetClientRelationshipRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientRelationshipRequest)
            return object;
        var message = new $root.GetClientRelationshipRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        return message;
    };

    /**
     * Creates a plain object from a GetClientRelationshipRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {GetClientRelationshipRequest} message GetClientRelationshipRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientRelationshipRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.businessId = "";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        return object;
    };

    /**
     * Converts this GetClientRelationshipRequest to JSON.
     * @function toJSON
     * @memberof GetClientRelationshipRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientRelationshipRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientRelationshipRequest
     * @function getTypeUrl
     * @memberof GetClientRelationshipRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientRelationshipRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientRelationshipRequest";
    };

    return GetClientRelationshipRequest;
})();

$root.GetClientRelationshipResponse = (function() {

    /**
     * Properties of a GetClientRelationshipResponse.
     * @exports IGetClientRelationshipResponse
     * @interface IGetClientRelationshipResponse
     * @property {boolean|null} [okay] GetClientRelationshipResponse okay
     * @property {IClientRelationshipProto|null} [relationship] GetClientRelationshipResponse relationship
     */

    /**
     * Constructs a new GetClientRelationshipResponse.
     * @exports GetClientRelationshipResponse
     * @classdesc Represents a GetClientRelationshipResponse.
     * @implements IGetClientRelationshipResponse
     * @constructor
     * @param {IGetClientRelationshipResponse=} [properties] Properties to set
     */
    function GetClientRelationshipResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientRelationshipResponse okay.
     * @member {boolean} okay
     * @memberof GetClientRelationshipResponse
     * @instance
     */
    GetClientRelationshipResponse.prototype.okay = false;

    /**
     * GetClientRelationshipResponse relationship.
     * @member {IClientRelationshipProto|null|undefined} relationship
     * @memberof GetClientRelationshipResponse
     * @instance
     */
    GetClientRelationshipResponse.prototype.relationship = null;

    /**
     * Creates a new GetClientRelationshipResponse instance using the specified properties.
     * @function create
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {IGetClientRelationshipResponse=} [properties] Properties to set
     * @returns {GetClientRelationshipResponse} GetClientRelationshipResponse instance
     */
    GetClientRelationshipResponse.create = function create(properties) {
        return new GetClientRelationshipResponse(properties);
    };

    /**
     * Encodes the specified GetClientRelationshipResponse message. Does not implicitly {@link GetClientRelationshipResponse.verify|verify} messages.
     * @function encode
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {IGetClientRelationshipResponse} message GetClientRelationshipResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientRelationshipResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.relationship != null && Object.hasOwnProperty.call(message, "relationship"))
            $root.ClientRelationshipProto.encode(message.relationship, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetClientRelationshipResponse message, length delimited. Does not implicitly {@link GetClientRelationshipResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {IGetClientRelationshipResponse} message GetClientRelationshipResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientRelationshipResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientRelationshipResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientRelationshipResponse} GetClientRelationshipResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientRelationshipResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientRelationshipResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.relationship = $root.ClientRelationshipProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientRelationshipResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientRelationshipResponse} GetClientRelationshipResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientRelationshipResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientRelationshipResponse message.
     * @function verify
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientRelationshipResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.relationship != null && message.hasOwnProperty("relationship")) {
            var error = $root.ClientRelationshipProto.verify(message.relationship);
            if (error)
                return "relationship." + error;
        }
        return null;
    };

    /**
     * Creates a GetClientRelationshipResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientRelationshipResponse} GetClientRelationshipResponse
     */
    GetClientRelationshipResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientRelationshipResponse)
            return object;
        var message = new $root.GetClientRelationshipResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.relationship != null) {
            if (typeof object.relationship !== "object")
                throw TypeError(".GetClientRelationshipResponse.relationship: object expected");
            message.relationship = $root.ClientRelationshipProto.fromObject(object.relationship);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetClientRelationshipResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {GetClientRelationshipResponse} message GetClientRelationshipResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientRelationshipResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.relationship = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.relationship != null && message.hasOwnProperty("relationship"))
            object.relationship = $root.ClientRelationshipProto.toObject(message.relationship, options);
        return object;
    };

    /**
     * Converts this GetClientRelationshipResponse to JSON.
     * @function toJSON
     * @memberof GetClientRelationshipResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientRelationshipResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientRelationshipResponse
     * @function getTypeUrl
     * @memberof GetClientRelationshipResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientRelationshipResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientRelationshipResponse";
    };

    return GetClientRelationshipResponse;
})();

$root.CreateInquiryRequest = (function() {

    /**
     * Properties of a CreateInquiryRequest.
     * @exports ICreateInquiryRequest
     * @interface ICreateInquiryRequest
     * @property {string|null} [message] CreateInquiryRequest message
     * @property {string|null} [businessId] CreateInquiryRequest businessId
     */

    /**
     * Constructs a new CreateInquiryRequest.
     * @exports CreateInquiryRequest
     * @classdesc Represents a CreateInquiryRequest.
     * @implements ICreateInquiryRequest
     * @constructor
     * @param {ICreateInquiryRequest=} [properties] Properties to set
     */
    function CreateInquiryRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateInquiryRequest message.
     * @member {string} message
     * @memberof CreateInquiryRequest
     * @instance
     */
    CreateInquiryRequest.prototype.message = "";

    /**
     * CreateInquiryRequest businessId.
     * @member {string} businessId
     * @memberof CreateInquiryRequest
     * @instance
     */
    CreateInquiryRequest.prototype.businessId = "";

    /**
     * Creates a new CreateInquiryRequest instance using the specified properties.
     * @function create
     * @memberof CreateInquiryRequest
     * @static
     * @param {ICreateInquiryRequest=} [properties] Properties to set
     * @returns {CreateInquiryRequest} CreateInquiryRequest instance
     */
    CreateInquiryRequest.create = function create(properties) {
        return new CreateInquiryRequest(properties);
    };

    /**
     * Encodes the specified CreateInquiryRequest message. Does not implicitly {@link CreateInquiryRequest.verify|verify} messages.
     * @function encode
     * @memberof CreateInquiryRequest
     * @static
     * @param {ICreateInquiryRequest} message CreateInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateInquiryRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
        return writer;
    };

    /**
     * Encodes the specified CreateInquiryRequest message, length delimited. Does not implicitly {@link CreateInquiryRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateInquiryRequest
     * @static
     * @param {ICreateInquiryRequest} message CreateInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateInquiryRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateInquiryRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CreateInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateInquiryRequest} CreateInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateInquiryRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateInquiryRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.message = reader.string();
                    break;
                }
            case 2: {
                    message.businessId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateInquiryRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateInquiryRequest} CreateInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateInquiryRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateInquiryRequest message.
     * @function verify
     * @memberof CreateInquiryRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateInquiryRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        return null;
    };

    /**
     * Creates a CreateInquiryRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateInquiryRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateInquiryRequest} CreateInquiryRequest
     */
    CreateInquiryRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateInquiryRequest)
            return object;
        var message = new $root.CreateInquiryRequest();
        if (object.message != null)
            message.message = String(object.message);
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        return message;
    };

    /**
     * Creates a plain object from a CreateInquiryRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateInquiryRequest
     * @static
     * @param {CreateInquiryRequest} message CreateInquiryRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateInquiryRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.message = "";
            object.businessId = "";
        }
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        return object;
    };

    /**
     * Converts this CreateInquiryRequest to JSON.
     * @function toJSON
     * @memberof CreateInquiryRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateInquiryRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateInquiryRequest
     * @function getTypeUrl
     * @memberof CreateInquiryRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateInquiryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateInquiryRequest";
    };

    return CreateInquiryRequest;
})();

$root.CreateInquiryResponse = (function() {

    /**
     * Properties of a CreateInquiryResponse.
     * @exports ICreateInquiryResponse
     * @interface ICreateInquiryResponse
     * @property {boolean|null} [okay] CreateInquiryResponse okay
     */

    /**
     * Constructs a new CreateInquiryResponse.
     * @exports CreateInquiryResponse
     * @classdesc Represents a CreateInquiryResponse.
     * @implements ICreateInquiryResponse
     * @constructor
     * @param {ICreateInquiryResponse=} [properties] Properties to set
     */
    function CreateInquiryResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateInquiryResponse okay.
     * @member {boolean} okay
     * @memberof CreateInquiryResponse
     * @instance
     */
    CreateInquiryResponse.prototype.okay = false;

    /**
     * Creates a new CreateInquiryResponse instance using the specified properties.
     * @function create
     * @memberof CreateInquiryResponse
     * @static
     * @param {ICreateInquiryResponse=} [properties] Properties to set
     * @returns {CreateInquiryResponse} CreateInquiryResponse instance
     */
    CreateInquiryResponse.create = function create(properties) {
        return new CreateInquiryResponse(properties);
    };

    /**
     * Encodes the specified CreateInquiryResponse message. Does not implicitly {@link CreateInquiryResponse.verify|verify} messages.
     * @function encode
     * @memberof CreateInquiryResponse
     * @static
     * @param {ICreateInquiryResponse} message CreateInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateInquiryResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified CreateInquiryResponse message, length delimited. Does not implicitly {@link CreateInquiryResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateInquiryResponse
     * @static
     * @param {ICreateInquiryResponse} message CreateInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateInquiryResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateInquiryResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CreateInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateInquiryResponse} CreateInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateInquiryResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateInquiryResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateInquiryResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateInquiryResponse} CreateInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateInquiryResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateInquiryResponse message.
     * @function verify
     * @memberof CreateInquiryResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateInquiryResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates a CreateInquiryResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateInquiryResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateInquiryResponse} CreateInquiryResponse
     */
    CreateInquiryResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateInquiryResponse)
            return object;
        var message = new $root.CreateInquiryResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from a CreateInquiryResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateInquiryResponse
     * @static
     * @param {CreateInquiryResponse} message CreateInquiryResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateInquiryResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this CreateInquiryResponse to JSON.
     * @function toJSON
     * @memberof CreateInquiryResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateInquiryResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateInquiryResponse
     * @function getTypeUrl
     * @memberof CreateInquiryResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateInquiryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateInquiryResponse";
    };

    return CreateInquiryResponse;
})();

$root.ClassBookingRequestProto = (function() {

    /**
     * Properties of a ClassBookingRequestProto.
     * @exports IClassBookingRequestProto
     * @interface IClassBookingRequestProto
     * @property {string|null} [eventInstanceId] ClassBookingRequestProto eventInstanceId
     */

    /**
     * Constructs a new ClassBookingRequestProto.
     * @exports ClassBookingRequestProto
     * @classdesc Represents a ClassBookingRequestProto.
     * @implements IClassBookingRequestProto
     * @constructor
     * @param {IClassBookingRequestProto=} [properties] Properties to set
     */
    function ClassBookingRequestProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClassBookingRequestProto eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof ClassBookingRequestProto
     * @instance
     */
    ClassBookingRequestProto.prototype.eventInstanceId = "";

    /**
     * Creates a new ClassBookingRequestProto instance using the specified properties.
     * @function create
     * @memberof ClassBookingRequestProto
     * @static
     * @param {IClassBookingRequestProto=} [properties] Properties to set
     * @returns {ClassBookingRequestProto} ClassBookingRequestProto instance
     */
    ClassBookingRequestProto.create = function create(properties) {
        return new ClassBookingRequestProto(properties);
    };

    /**
     * Encodes the specified ClassBookingRequestProto message. Does not implicitly {@link ClassBookingRequestProto.verify|verify} messages.
     * @function encode
     * @memberof ClassBookingRequestProto
     * @static
     * @param {IClassBookingRequestProto} message ClassBookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingRequestProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.eventInstanceId);
        return writer;
    };

    /**
     * Encodes the specified ClassBookingRequestProto message, length delimited. Does not implicitly {@link ClassBookingRequestProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClassBookingRequestProto
     * @static
     * @param {IClassBookingRequestProto} message ClassBookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingRequestProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClassBookingRequestProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClassBookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClassBookingRequestProto} ClassBookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingRequestProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClassBookingRequestProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClassBookingRequestProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClassBookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClassBookingRequestProto} ClassBookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingRequestProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClassBookingRequestProto message.
     * @function verify
     * @memberof ClassBookingRequestProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClassBookingRequestProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        return null;
    };

    /**
     * Creates a ClassBookingRequestProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClassBookingRequestProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClassBookingRequestProto} ClassBookingRequestProto
     */
    ClassBookingRequestProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClassBookingRequestProto)
            return object;
        var message = new $root.ClassBookingRequestProto();
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        return message;
    };

    /**
     * Creates a plain object from a ClassBookingRequestProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClassBookingRequestProto
     * @static
     * @param {ClassBookingRequestProto} message ClassBookingRequestProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClassBookingRequestProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.eventInstanceId = "";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        return object;
    };

    /**
     * Converts this ClassBookingRequestProto to JSON.
     * @function toJSON
     * @memberof ClassBookingRequestProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClassBookingRequestProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClassBookingRequestProto
     * @function getTypeUrl
     * @memberof ClassBookingRequestProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClassBookingRequestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClassBookingRequestProto";
    };

    return ClassBookingRequestProto;
})();

$root.AppointmentBookingRequestProto = (function() {

    /**
     * Properties of an AppointmentBookingRequestProto.
     * @exports IAppointmentBookingRequestProto
     * @interface IAppointmentBookingRequestProto
     * @property {string|null} [practitionerId] AppointmentBookingRequestProto practitionerId
     * @property {string|null} [serviceId] AppointmentBookingRequestProto serviceId
     * @property {string|null} [locationId] AppointmentBookingRequestProto locationId
     * @property {number|Long|null} [appointmentTime] AppointmentBookingRequestProto appointmentTime
     */

    /**
     * Constructs a new AppointmentBookingRequestProto.
     * @exports AppointmentBookingRequestProto
     * @classdesc Represents an AppointmentBookingRequestProto.
     * @implements IAppointmentBookingRequestProto
     * @constructor
     * @param {IAppointmentBookingRequestProto=} [properties] Properties to set
     */
    function AppointmentBookingRequestProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AppointmentBookingRequestProto practitionerId.
     * @member {string} practitionerId
     * @memberof AppointmentBookingRequestProto
     * @instance
     */
    AppointmentBookingRequestProto.prototype.practitionerId = "";

    /**
     * AppointmentBookingRequestProto serviceId.
     * @member {string} serviceId
     * @memberof AppointmentBookingRequestProto
     * @instance
     */
    AppointmentBookingRequestProto.prototype.serviceId = "";

    /**
     * AppointmentBookingRequestProto locationId.
     * @member {string} locationId
     * @memberof AppointmentBookingRequestProto
     * @instance
     */
    AppointmentBookingRequestProto.prototype.locationId = "";

    /**
     * AppointmentBookingRequestProto appointmentTime.
     * @member {number|Long} appointmentTime
     * @memberof AppointmentBookingRequestProto
     * @instance
     */
    AppointmentBookingRequestProto.prototype.appointmentTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new AppointmentBookingRequestProto instance using the specified properties.
     * @function create
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {IAppointmentBookingRequestProto=} [properties] Properties to set
     * @returns {AppointmentBookingRequestProto} AppointmentBookingRequestProto instance
     */
    AppointmentBookingRequestProto.create = function create(properties) {
        return new AppointmentBookingRequestProto(properties);
    };

    /**
     * Encodes the specified AppointmentBookingRequestProto message. Does not implicitly {@link AppointmentBookingRequestProto.verify|verify} messages.
     * @function encode
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {IAppointmentBookingRequestProto} message AppointmentBookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentBookingRequestProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
        if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceId);
        if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.locationId);
        if (message.appointmentTime != null && Object.hasOwnProperty.call(message, "appointmentTime"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.appointmentTime);
        return writer;
    };

    /**
     * Encodes the specified AppointmentBookingRequestProto message, length delimited. Does not implicitly {@link AppointmentBookingRequestProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {IAppointmentBookingRequestProto} message AppointmentBookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentBookingRequestProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AppointmentBookingRequestProto message from the specified reader or buffer.
     * @function decode
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AppointmentBookingRequestProto} AppointmentBookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentBookingRequestProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AppointmentBookingRequestProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.practitionerId = reader.string();
                    break;
                }
            case 2: {
                    message.serviceId = reader.string();
                    break;
                }
            case 3: {
                    message.locationId = reader.string();
                    break;
                }
            case 4: {
                    message.appointmentTime = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AppointmentBookingRequestProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AppointmentBookingRequestProto} AppointmentBookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentBookingRequestProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AppointmentBookingRequestProto message.
     * @function verify
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AppointmentBookingRequestProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            if (!$util.isString(message.practitionerId))
                return "practitionerId: string expected";
        if (message.serviceId != null && message.hasOwnProperty("serviceId"))
            if (!$util.isString(message.serviceId))
                return "serviceId: string expected";
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            if (!$util.isString(message.locationId))
                return "locationId: string expected";
        if (message.appointmentTime != null && message.hasOwnProperty("appointmentTime"))
            if (!$util.isInteger(message.appointmentTime) && !(message.appointmentTime && $util.isInteger(message.appointmentTime.low) && $util.isInteger(message.appointmentTime.high)))
                return "appointmentTime: integer|Long expected";
        return null;
    };

    /**
     * Creates an AppointmentBookingRequestProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AppointmentBookingRequestProto} AppointmentBookingRequestProto
     */
    AppointmentBookingRequestProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AppointmentBookingRequestProto)
            return object;
        var message = new $root.AppointmentBookingRequestProto();
        if (object.practitionerId != null)
            message.practitionerId = String(object.practitionerId);
        if (object.serviceId != null)
            message.serviceId = String(object.serviceId);
        if (object.locationId != null)
            message.locationId = String(object.locationId);
        if (object.appointmentTime != null)
            if ($util.Long)
                (message.appointmentTime = $util.Long.fromValue(object.appointmentTime)).unsigned = false;
            else if (typeof object.appointmentTime === "string")
                message.appointmentTime = parseInt(object.appointmentTime, 10);
            else if (typeof object.appointmentTime === "number")
                message.appointmentTime = object.appointmentTime;
            else if (typeof object.appointmentTime === "object")
                message.appointmentTime = new $util.LongBits(object.appointmentTime.low >>> 0, object.appointmentTime.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from an AppointmentBookingRequestProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {AppointmentBookingRequestProto} message AppointmentBookingRequestProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AppointmentBookingRequestProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.practitionerId = "";
            object.serviceId = "";
            object.locationId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.appointmentTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.appointmentTime = options.longs === String ? "0" : 0;
        }
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            object.practitionerId = message.practitionerId;
        if (message.serviceId != null && message.hasOwnProperty("serviceId"))
            object.serviceId = message.serviceId;
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            object.locationId = message.locationId;
        if (message.appointmentTime != null && message.hasOwnProperty("appointmentTime"))
            if (typeof message.appointmentTime === "number")
                object.appointmentTime = options.longs === String ? String(message.appointmentTime) : message.appointmentTime;
            else
                object.appointmentTime = options.longs === String ? $util.Long.prototype.toString.call(message.appointmentTime) : options.longs === Number ? new $util.LongBits(message.appointmentTime.low >>> 0, message.appointmentTime.high >>> 0).toNumber() : message.appointmentTime;
        return object;
    };

    /**
     * Converts this AppointmentBookingRequestProto to JSON.
     * @function toJSON
     * @memberof AppointmentBookingRequestProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AppointmentBookingRequestProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AppointmentBookingRequestProto
     * @function getTypeUrl
     * @memberof AppointmentBookingRequestProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AppointmentBookingRequestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AppointmentBookingRequestProto";
    };

    return AppointmentBookingRequestProto;
})();

$root.BookingRequestProto = (function() {

    /**
     * Properties of a BookingRequestProto.
     * @exports IBookingRequestProto
     * @interface IBookingRequestProto
     * @property {string|null} [businessId] BookingRequestProto businessId
     * @property {IClassBookingRequestProto|null} [classBooking] BookingRequestProto classBooking
     * @property {IAppointmentBookingRequestProto|null} [appointmentBooking] BookingRequestProto appointmentBooking
     */

    /**
     * Constructs a new BookingRequestProto.
     * @exports BookingRequestProto
     * @classdesc Represents a BookingRequestProto.
     * @implements IBookingRequestProto
     * @constructor
     * @param {IBookingRequestProto=} [properties] Properties to set
     */
    function BookingRequestProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookingRequestProto businessId.
     * @member {string} businessId
     * @memberof BookingRequestProto
     * @instance
     */
    BookingRequestProto.prototype.businessId = "";

    /**
     * BookingRequestProto classBooking.
     * @member {IClassBookingRequestProto|null|undefined} classBooking
     * @memberof BookingRequestProto
     * @instance
     */
    BookingRequestProto.prototype.classBooking = null;

    /**
     * BookingRequestProto appointmentBooking.
     * @member {IAppointmentBookingRequestProto|null|undefined} appointmentBooking
     * @memberof BookingRequestProto
     * @instance
     */
    BookingRequestProto.prototype.appointmentBooking = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * BookingRequestProto BookingType.
     * @member {"classBooking"|"appointmentBooking"|undefined} BookingType
     * @memberof BookingRequestProto
     * @instance
     */
    Object.defineProperty(BookingRequestProto.prototype, "BookingType", {
        get: $util.oneOfGetter($oneOfFields = ["classBooking", "appointmentBooking"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BookingRequestProto instance using the specified properties.
     * @function create
     * @memberof BookingRequestProto
     * @static
     * @param {IBookingRequestProto=} [properties] Properties to set
     * @returns {BookingRequestProto} BookingRequestProto instance
     */
    BookingRequestProto.create = function create(properties) {
        return new BookingRequestProto(properties);
    };

    /**
     * Encodes the specified BookingRequestProto message. Does not implicitly {@link BookingRequestProto.verify|verify} messages.
     * @function encode
     * @memberof BookingRequestProto
     * @static
     * @param {IBookingRequestProto} message BookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookingRequestProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.classBooking != null && Object.hasOwnProperty.call(message, "classBooking"))
            $root.ClassBookingRequestProto.encode(message.classBooking, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.appointmentBooking != null && Object.hasOwnProperty.call(message, "appointmentBooking"))
            $root.AppointmentBookingRequestProto.encode(message.appointmentBooking, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BookingRequestProto message, length delimited. Does not implicitly {@link BookingRequestProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookingRequestProto
     * @static
     * @param {IBookingRequestProto} message BookingRequestProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookingRequestProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookingRequestProto message from the specified reader or buffer.
     * @function decode
     * @memberof BookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookingRequestProto} BookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookingRequestProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookingRequestProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 10: {
                    message.classBooking = $root.ClassBookingRequestProto.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    message.appointmentBooking = $root.AppointmentBookingRequestProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookingRequestProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookingRequestProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookingRequestProto} BookingRequestProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookingRequestProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookingRequestProto message.
     * @function verify
     * @memberof BookingRequestProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookingRequestProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            properties.BookingType = 1;
            {
                var error = $root.ClassBookingRequestProto.verify(message.classBooking);
                if (error)
                    return "classBooking." + error;
            }
        }
        if (message.appointmentBooking != null && message.hasOwnProperty("appointmentBooking")) {
            if (properties.BookingType === 1)
                return "BookingType: multiple values";
            properties.BookingType = 1;
            {
                var error = $root.AppointmentBookingRequestProto.verify(message.appointmentBooking);
                if (error)
                    return "appointmentBooking." + error;
            }
        }
        return null;
    };

    /**
     * Creates a BookingRequestProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookingRequestProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookingRequestProto} BookingRequestProto
     */
    BookingRequestProto.fromObject = function fromObject(object) {
        if (object instanceof $root.BookingRequestProto)
            return object;
        var message = new $root.BookingRequestProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.classBooking != null) {
            if (typeof object.classBooking !== "object")
                throw TypeError(".BookingRequestProto.classBooking: object expected");
            message.classBooking = $root.ClassBookingRequestProto.fromObject(object.classBooking);
        }
        if (object.appointmentBooking != null) {
            if (typeof object.appointmentBooking !== "object")
                throw TypeError(".BookingRequestProto.appointmentBooking: object expected");
            message.appointmentBooking = $root.AppointmentBookingRequestProto.fromObject(object.appointmentBooking);
        }
        return message;
    };

    /**
     * Creates a plain object from a BookingRequestProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookingRequestProto
     * @static
     * @param {BookingRequestProto} message BookingRequestProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookingRequestProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.businessId = "";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            object.classBooking = $root.ClassBookingRequestProto.toObject(message.classBooking, options);
            if (options.oneofs)
                object.BookingType = "classBooking";
        }
        if (message.appointmentBooking != null && message.hasOwnProperty("appointmentBooking")) {
            object.appointmentBooking = $root.AppointmentBookingRequestProto.toObject(message.appointmentBooking, options);
            if (options.oneofs)
                object.BookingType = "appointmentBooking";
        }
        return object;
    };

    /**
     * Converts this BookingRequestProto to JSON.
     * @function toJSON
     * @memberof BookingRequestProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookingRequestProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookingRequestProto
     * @function getTypeUrl
     * @memberof BookingRequestProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookingRequestProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookingRequestProto";
    };

    return BookingRequestProto;
})();

$root.VerificationRequest = (function() {

    /**
     * Properties of a VerificationRequest.
     * @exports IVerificationRequest
     * @interface IVerificationRequest
     * @property {space.kenko.proto.ContactMethodType|null} [type] VerificationRequest type
     * @property {string|null} [value] VerificationRequest value
     */

    /**
     * Constructs a new VerificationRequest.
     * @exports VerificationRequest
     * @classdesc Represents a VerificationRequest.
     * @implements IVerificationRequest
     * @constructor
     * @param {IVerificationRequest=} [properties] Properties to set
     */
    function VerificationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * VerificationRequest type.
     * @member {space.kenko.proto.ContactMethodType} type
     * @memberof VerificationRequest
     * @instance
     */
    VerificationRequest.prototype.type = 0;

    /**
     * VerificationRequest value.
     * @member {string} value
     * @memberof VerificationRequest
     * @instance
     */
    VerificationRequest.prototype.value = "";

    /**
     * Creates a new VerificationRequest instance using the specified properties.
     * @function create
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest=} [properties] Properties to set
     * @returns {VerificationRequest} VerificationRequest instance
     */
    VerificationRequest.create = function create(properties) {
        return new VerificationRequest(properties);
    };

    /**
     * Encodes the specified VerificationRequest message. Does not implicitly {@link VerificationRequest.verify|verify} messages.
     * @function encode
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest} message VerificationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
        return writer;
    };

    /**
     * Encodes the specified VerificationRequest message, length delimited. Does not implicitly {@link VerificationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest} message VerificationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VerificationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof VerificationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VerificationRequest} VerificationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerificationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.value = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a VerificationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof VerificationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {VerificationRequest} VerificationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VerificationRequest message.
     * @function verify
     * @memberof VerificationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VerificationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        return null;
    };

    /**
     * Creates a VerificationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VerificationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VerificationRequest} VerificationRequest
     */
    VerificationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.VerificationRequest)
            return object;
        var message = new $root.VerificationRequest();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "EMAIL":
        case 1:
            message.type = 1;
            break;
        case "MOBILE_PHONE":
        case 2:
            message.type = 2;
            break;
        }
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    /**
     * Creates a plain object from a VerificationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VerificationRequest
     * @static
     * @param {VerificationRequest} message VerificationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VerificationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.value = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.space.kenko.proto.ContactMethodType[message.type] === undefined ? message.type : $root.space.kenko.proto.ContactMethodType[message.type] : message.type;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    /**
     * Converts this VerificationRequest to JSON.
     * @function toJSON
     * @memberof VerificationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VerificationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for VerificationRequest
     * @function getTypeUrl
     * @memberof VerificationRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    VerificationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/VerificationRequest";
    };

    return VerificationRequest;
})();

$root.VerificationResponse = (function() {

    /**
     * Properties of a VerificationResponse.
     * @exports IVerificationResponse
     * @interface IVerificationResponse
     * @property {boolean|null} [okay] VerificationResponse okay
     * @property {string|null} [error] VerificationResponse error
     * @property {IApiUserProto|null} [updatedUser] VerificationResponse updatedUser
     */

    /**
     * Constructs a new VerificationResponse.
     * @exports VerificationResponse
     * @classdesc Represents a VerificationResponse.
     * @implements IVerificationResponse
     * @constructor
     * @param {IVerificationResponse=} [properties] Properties to set
     */
    function VerificationResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * VerificationResponse okay.
     * @member {boolean} okay
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.okay = false;

    /**
     * VerificationResponse error.
     * @member {string} error
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.error = "";

    /**
     * VerificationResponse updatedUser.
     * @member {IApiUserProto|null|undefined} updatedUser
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.updatedUser = null;

    /**
     * Creates a new VerificationResponse instance using the specified properties.
     * @function create
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse=} [properties] Properties to set
     * @returns {VerificationResponse} VerificationResponse instance
     */
    VerificationResponse.create = function create(properties) {
        return new VerificationResponse(properties);
    };

    /**
     * Encodes the specified VerificationResponse message. Does not implicitly {@link VerificationResponse.verify|verify} messages.
     * @function encode
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse} message VerificationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.updatedUser != null && Object.hasOwnProperty.call(message, "updatedUser"))
            $root.ApiUserProto.encode(message.updatedUser, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified VerificationResponse message, length delimited. Does not implicitly {@link VerificationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse} message VerificationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VerificationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof VerificationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VerificationResponse} VerificationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerificationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    message.updatedUser = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a VerificationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof VerificationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {VerificationResponse} VerificationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VerificationResponse message.
     * @function verify
     * @memberof VerificationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VerificationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.updatedUser != null && message.hasOwnProperty("updatedUser")) {
            var error = $root.ApiUserProto.verify(message.updatedUser);
            if (error)
                return "updatedUser." + error;
        }
        return null;
    };

    /**
     * Creates a VerificationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VerificationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VerificationResponse} VerificationResponse
     */
    VerificationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.VerificationResponse)
            return object;
        var message = new $root.VerificationResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.updatedUser != null) {
            if (typeof object.updatedUser !== "object")
                throw TypeError(".VerificationResponse.updatedUser: object expected");
            message.updatedUser = $root.ApiUserProto.fromObject(object.updatedUser);
        }
        return message;
    };

    /**
     * Creates a plain object from a VerificationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VerificationResponse
     * @static
     * @param {VerificationResponse} message VerificationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VerificationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.error = "";
            object.updatedUser = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.updatedUser != null && message.hasOwnProperty("updatedUser"))
            object.updatedUser = $root.ApiUserProto.toObject(message.updatedUser, options);
        return object;
    };

    /**
     * Converts this VerificationResponse to JSON.
     * @function toJSON
     * @memberof VerificationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VerificationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for VerificationResponse
     * @function getTypeUrl
     * @memberof VerificationResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    VerificationResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/VerificationResponse";
    };

    return VerificationResponse;
})();

$root.space = (function() {

    /**
     * Namespace space.
     * @exports space
     * @namespace
     */
    var space = {};

    space.kenko = (function() {

        /**
         * Namespace kenko.
         * @memberof space
         * @namespace
         */
        var kenko = {};

        kenko.proto = (function() {

            /**
             * Namespace proto.
             * @memberof space.kenko
             * @namespace
             */
            var proto = {};

            proto.BusinessProfileProto = (function() {

                /**
                 * Properties of a BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessProfileProto
                 * @property {string|null} [businessName] BusinessProfileProto businessName
                 * @property {string|null} [businessDescription] BusinessProfileProto businessDescription
                 * @property {string|null} [websiteUrl] BusinessProfileProto websiteUrl
                 * @property {string|null} [phoneNumber] BusinessProfileProto phoneNumber
                 * @property {string|null} [email] BusinessProfileProto email
                 * @property {string|null} [imageUrl] BusinessProfileProto imageUrl
                 * @property {Array.<string>|null} [servicesOffered] BusinessProfileProto servicesOffered
                 */

                /**
                 * Constructs a new BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessProfileProto.
                 * @implements IBusinessProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 */
                function BusinessProfileProto(properties) {
                    this.servicesOffered = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessProfileProto businessName.
                 * @member {string} businessName
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessName = "";

                /**
                 * BusinessProfileProto businessDescription.
                 * @member {string} businessDescription
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessDescription = "";

                /**
                 * BusinessProfileProto websiteUrl.
                 * @member {string} websiteUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.websiteUrl = "";

                /**
                 * BusinessProfileProto phoneNumber.
                 * @member {string} phoneNumber
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.phoneNumber = "";

                /**
                 * BusinessProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.email = "";

                /**
                 * BusinessProfileProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.imageUrl = "";

                /**
                 * BusinessProfileProto servicesOffered.
                 * @member {Array.<string>} servicesOffered
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.servicesOffered = $util.emptyArray;

                /**
                 * Creates a new BusinessProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto instance
                 */
                BusinessProfileProto.create = function create(properties) {
                    return new BusinessProfileProto(properties);
                };

                /**
                 * Encodes the specified BusinessProfileProto message. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessDescription);
                    if (message.websiteUrl != null && Object.hasOwnProperty.call(message, "websiteUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.websiteUrl);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.imageUrl);
                    if (message.servicesOffered != null && message.servicesOffered.length)
                        for (var i = 0; i < message.servicesOffered.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.servicesOffered[i]);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessProfileProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessDescription = reader.string();
                                break;
                            }
                        case 3: {
                                message.websiteUrl = reader.string();
                                break;
                            }
                        case 4: {
                                message.phoneNumber = reader.string();
                                break;
                            }
                        case 5: {
                                message.email = reader.string();
                                break;
                            }
                        case 6: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                if (!(message.servicesOffered && message.servicesOffered.length))
                                    message.servicesOffered = [];
                                message.servicesOffered.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        if (!$util.isString(message.businessDescription))
                            return "businessDescription: string expected";
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        if (!$util.isString(message.websiteUrl))
                            return "websiteUrl: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        if (!$util.isString(message.phoneNumber))
                            return "phoneNumber: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.servicesOffered != null && message.hasOwnProperty("servicesOffered")) {
                        if (!Array.isArray(message.servicesOffered))
                            return "servicesOffered: array expected";
                        for (var i = 0; i < message.servicesOffered.length; ++i)
                            if (!$util.isString(message.servicesOffered[i]))
                                return "servicesOffered: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a BusinessProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 */
                BusinessProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessProfileProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessProfileProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.businessDescription != null)
                        message.businessDescription = String(object.businessDescription);
                    if (object.websiteUrl != null)
                        message.websiteUrl = String(object.websiteUrl);
                    if (object.phoneNumber != null)
                        message.phoneNumber = String(object.phoneNumber);
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.servicesOffered) {
                        if (!Array.isArray(object.servicesOffered))
                            throw TypeError(".space.kenko.proto.BusinessProfileProto.servicesOffered: array expected");
                        message.servicesOffered = [];
                        for (var i = 0; i < object.servicesOffered.length; ++i)
                            message.servicesOffered[i] = String(object.servicesOffered[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.BusinessProfileProto} message BusinessProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.servicesOffered = [];
                    if (options.defaults) {
                        object.businessName = "";
                        object.businessDescription = "";
                        object.websiteUrl = "";
                        object.phoneNumber = "";
                        object.email = "";
                        object.imageUrl = "";
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        object.businessDescription = message.businessDescription;
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        object.websiteUrl = message.websiteUrl;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = message.phoneNumber;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.servicesOffered && message.servicesOffered.length) {
                        object.servicesOffered = [];
                        for (var j = 0; j < message.servicesOffered.length; ++j)
                            object.servicesOffered[j] = message.servicesOffered[j];
                    }
                    return object;
                };

                /**
                 * Converts this BusinessProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessProfileProto";
                };

                return BusinessProfileProto;
            })();

            proto.VirtualAppointmentInfo = (function() {

                /**
                 * Properties of a VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @interface IVirtualAppointmentInfo
                 * @property {boolean|null} [acceptsVirtualAppointments] VirtualAppointmentInfo acceptsVirtualAppointments
                 */

                /**
                 * Constructs a new VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VirtualAppointmentInfo.
                 * @implements IVirtualAppointmentInfo
                 * @constructor
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 */
                function VirtualAppointmentInfo(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VirtualAppointmentInfo acceptsVirtualAppointments.
                 * @member {boolean} acceptsVirtualAppointments
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 */
                VirtualAppointmentInfo.prototype.acceptsVirtualAppointments = false;

                /**
                 * Creates a new VirtualAppointmentInfo instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo instance
                 */
                VirtualAppointmentInfo.create = function create(properties) {
                    return new VirtualAppointmentInfo(properties);
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.acceptsVirtualAppointments != null && Object.hasOwnProperty.call(message, "acceptsVirtualAppointments"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.acceptsVirtualAppointments);
                    return writer;
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message, length delimited. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.acceptsVirtualAppointments = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VirtualAppointmentInfo message.
                 * @function verify
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VirtualAppointmentInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        if (typeof message.acceptsVirtualAppointments !== "boolean")
                            return "acceptsVirtualAppointments: boolean expected";
                    return null;
                };

                /**
                 * Creates a VirtualAppointmentInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 */
                VirtualAppointmentInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VirtualAppointmentInfo)
                        return object;
                    var message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    if (object.acceptsVirtualAppointments != null)
                        message.acceptsVirtualAppointments = Boolean(object.acceptsVirtualAppointments);
                    return message;
                };

                /**
                 * Creates a plain object from a VirtualAppointmentInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.VirtualAppointmentInfo} message VirtualAppointmentInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VirtualAppointmentInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.acceptsVirtualAppointments = false;
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        object.acceptsVirtualAppointments = message.acceptsVirtualAppointments;
                    return object;
                };

                /**
                 * Converts this VirtualAppointmentInfo to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VirtualAppointmentInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VirtualAppointmentInfo
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VirtualAppointmentInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VirtualAppointmentInfo";
                };

                return VirtualAppointmentInfo;
            })();

            /**
             * ProviderApprovalState enum.
             * @name space.kenko.proto.ProviderApprovalState
             * @enum {number}
             * @property {number} APPROVAL_STATE_UNKNOWN=0 APPROVAL_STATE_UNKNOWN value
             * @property {number} NEW_PROVIDER_MANUAL_APPROVE=10 NEW_PROVIDER_MANUAL_APPROVE value
             * @property {number} NEW_PROVIDER_AUTO_APPROVE=11 NEW_PROVIDER_AUTO_APPROVE value
             * @property {number} AWAITING_REVIEW=20 AWAITING_REVIEW value
             * @property {number} PROVIDER_APPROVED=30 PROVIDER_APPROVED value
             * @property {number} PROVIDER_REJECTED=40 PROVIDER_REJECTED value
             */
            proto.ProviderApprovalState = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "APPROVAL_STATE_UNKNOWN"] = 0;
                values[valuesById[10] = "NEW_PROVIDER_MANUAL_APPROVE"] = 10;
                values[valuesById[11] = "NEW_PROVIDER_AUTO_APPROVE"] = 11;
                values[valuesById[20] = "AWAITING_REVIEW"] = 20;
                values[valuesById[30] = "PROVIDER_APPROVED"] = 30;
                values[valuesById[40] = "PROVIDER_REJECTED"] = 40;
                return values;
            })();

            proto.BusinessLocationProto = (function() {

                /**
                 * Properties of a BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessLocationProto
                 * @property {string|null} [locationId] BusinessLocationProto locationId
                 * @property {string|null} [locationName] BusinessLocationProto locationName
                 * @property {space.kenko.proto.IPhysicalBusinessLocation|null} [physicalLocation] BusinessLocationProto physicalLocation
                 * @property {boolean|null} [archived] BusinessLocationProto archived
                 */

                /**
                 * Constructs a new BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessLocationProto.
                 * @implements IBusinessLocationProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 */
                function BusinessLocationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessLocationProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationId = "";

                /**
                 * BusinessLocationProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationName = "";

                /**
                 * BusinessLocationProto physicalLocation.
                 * @member {space.kenko.proto.IPhysicalBusinessLocation|null|undefined} physicalLocation
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.physicalLocation = null;

                /**
                 * BusinessLocationProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.archived = false;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BusinessLocationProto LocationType.
                 * @member {"physicalLocation"|undefined} LocationType
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                Object.defineProperty(BusinessLocationProto.prototype, "LocationType", {
                    get: $util.oneOfGetter($oneOfFields = ["physicalLocation"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BusinessLocationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto instance
                 */
                BusinessLocationProto.create = function create(properties) {
                    return new BusinessLocationProto(properties);
                };

                /**
                 * Encodes the specified BusinessLocationProto message. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationName);
                    if (message.physicalLocation != null && Object.hasOwnProperty.call(message, "physicalLocation"))
                        $root.space.kenko.proto.PhysicalBusinessLocation.encode(message.physicalLocation, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessLocationProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessLocationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 21: {
                                message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessLocationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessLocationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        properties.LocationType = 1;
                        {
                            var error = $root.space.kenko.proto.PhysicalBusinessLocation.verify(message.physicalLocation);
                            if (error)
                                return "physicalLocation." + error;
                        }
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessLocationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 */
                BusinessLocationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessLocationProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessLocationProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.physicalLocation != null) {
                        if (typeof object.physicalLocation !== "object")
                            throw TypeError(".space.kenko.proto.BusinessLocationProto.physicalLocation: object expected");
                        message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.fromObject(object.physicalLocation);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessLocationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.BusinessLocationProto} message BusinessLocationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessLocationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationName = "";
                        object.archived = false;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        object.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.toObject(message.physicalLocation, options);
                        if (options.oneofs)
                            object.LocationType = "physicalLocation";
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this BusinessLocationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessLocationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessLocationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessLocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessLocationProto";
                };

                return BusinessLocationProto;
            })();

            proto.PhysicalBusinessLocation = (function() {

                /**
                 * Properties of a PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @interface IPhysicalBusinessLocation
                 * @property {string|null} [address] PhysicalBusinessLocation address
                 * @property {number|null} [lat] PhysicalBusinessLocation lat
                 * @property {number|null} [lng] PhysicalBusinessLocation lng
                 * @property {string|null} [timeZone] PhysicalBusinessLocation timeZone
                 * @property {boolean|null} ["private"] PhysicalBusinessLocation private
                 * @property {string|null} [imageUrl] PhysicalBusinessLocation imageUrl
                 * @property {string|null} [phone] PhysicalBusinessLocation phone
                 * @property {string|null} [email] PhysicalBusinessLocation email
                 */

                /**
                 * Constructs a new PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhysicalBusinessLocation.
                 * @implements IPhysicalBusinessLocation
                 * @constructor
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 */
                function PhysicalBusinessLocation(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhysicalBusinessLocation address.
                 * @member {string} address
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.address = "";

                /**
                 * PhysicalBusinessLocation lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lat = 0;

                /**
                 * PhysicalBusinessLocation lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lng = 0;

                /**
                 * PhysicalBusinessLocation timeZone.
                 * @member {string} timeZone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.timeZone = "";

                /**
                 * PhysicalBusinessLocation private.
                 * @member {boolean} private
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype["private"] = false;

                /**
                 * PhysicalBusinessLocation imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.imageUrl = "";

                /**
                 * PhysicalBusinessLocation phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.phone = "";

                /**
                 * PhysicalBusinessLocation email.
                 * @member {string} email
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.email = "";

                /**
                 * Creates a new PhysicalBusinessLocation instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation instance
                 */
                PhysicalBusinessLocation.create = function create(properties) {
                    return new PhysicalBusinessLocation(properties);
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.address);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 5, wireType 1 =*/41).double(message.lng);
                    if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.timeZone);
                    if (message["private"] != null && Object.hasOwnProperty.call(message, "private"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message["private"]);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.imageUrl);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message, length delimited. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = reader.string();
                                break;
                            }
                        case 4: {
                                message.lat = reader.double();
                                break;
                            }
                        case 5: {
                                message.lng = reader.double();
                                break;
                            }
                        case 6: {
                                message.timeZone = reader.string();
                                break;
                            }
                        case 7: {
                                message["private"] = reader.bool();
                                break;
                            }
                        case 8: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                message.phone = reader.string();
                                break;
                            }
                        case 10: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhysicalBusinessLocation message.
                 * @function verify
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhysicalBusinessLocation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        if (!$util.isString(message.timeZone))
                            return "timeZone: string expected";
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        if (typeof message["private"] !== "boolean")
                            return "private: boolean expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a PhysicalBusinessLocation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 */
                PhysicalBusinessLocation.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhysicalBusinessLocation)
                        return object;
                    var message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    if (object.address != null)
                        message.address = String(object.address);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    if (object.timeZone != null)
                        message.timeZone = String(object.timeZone);
                    if (object["private"] != null)
                        message["private"] = Boolean(object["private"]);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a PhysicalBusinessLocation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.PhysicalBusinessLocation} message PhysicalBusinessLocation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhysicalBusinessLocation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.address = "";
                        object.lat = 0;
                        object.lng = 0;
                        object.timeZone = "";
                        object["private"] = false;
                        object.imageUrl = "";
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        object.timeZone = message.timeZone;
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        object["private"] = message["private"];
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this PhysicalBusinessLocation to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhysicalBusinessLocation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhysicalBusinessLocation
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhysicalBusinessLocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhysicalBusinessLocation";
                };

                return PhysicalBusinessLocation;
            })();

            proto.ProviderProfileProto = (function() {

                /**
                 * Properties of a ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderProfileProto
                 * @property {string|null} [firstName] ProviderProfileProto firstName
                 * @property {string|null} [lastName] ProviderProfileProto lastName
                 * @property {string|null} [countryCode] ProviderProfileProto countryCode
                 * @property {boolean|null} [agreedToTerms] ProviderProfileProto agreedToTerms
                 * @property {string|null} [phone] ProviderProfileProto phone
                 * @property {string|null} [email] ProviderProfileProto email
                 */

                /**
                 * Constructs a new ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderProfileProto.
                 * @implements IProviderProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 */
                function ProviderProfileProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderProfileProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.firstName = "";

                /**
                 * ProviderProfileProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.lastName = "";

                /**
                 * ProviderProfileProto countryCode.
                 * @member {string} countryCode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.countryCode = "";

                /**
                 * ProviderProfileProto agreedToTerms.
                 * @member {boolean} agreedToTerms
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.agreedToTerms = false;

                /**
                 * ProviderProfileProto phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.phone = "";

                /**
                 * ProviderProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.email = "";

                /**
                 * Creates a new ProviderProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto instance
                 */
                ProviderProfileProto.create = function create(properties) {
                    return new ProviderProfileProto(properties);
                };

                /**
                 * Encodes the specified ProviderProfileProto message. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);
                    if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                    if (message.agreedToTerms != null && Object.hasOwnProperty.call(message, "agreedToTerms"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.agreedToTerms);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderProfileProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 2: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 5: {
                                message.countryCode = reader.string();
                                break;
                            }
                        case 6: {
                                message.agreedToTerms = reader.bool();
                                break;
                            }
                        case 7: {
                                message.phone = reader.string();
                                break;
                            }
                        case 8: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        if (!$util.isString(message.countryCode))
                            return "countryCode: string expected";
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        if (typeof message.agreedToTerms !== "boolean")
                            return "agreedToTerms: boolean expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 */
                ProviderProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderProfileProto)
                        return object;
                    var message = new $root.space.kenko.proto.ProviderProfileProto();
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.countryCode != null)
                        message.countryCode = String(object.countryCode);
                    if (object.agreedToTerms != null)
                        message.agreedToTerms = Boolean(object.agreedToTerms);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.ProviderProfileProto} message ProviderProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.firstName = "";
                        object.lastName = "";
                        object.countryCode = "";
                        object.agreedToTerms = false;
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        object.countryCode = message.countryCode;
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        object.agreedToTerms = message.agreedToTerms;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this ProviderProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderProfileProto";
                };

                return ProviderProfileProto;
            })();

            proto.AddressProto = (function() {

                /**
                 * Properties of an AddressProto.
                 * @memberof space.kenko.proto
                 * @interface IAddressProto
                 * @property {string|null} [formattedAddress] AddressProto formattedAddress
                 * @property {number|null} [lat] AddressProto lat
                 * @property {number|null} [lng] AddressProto lng
                 */

                /**
                 * Constructs a new AddressProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an AddressProto.
                 * @implements IAddressProto
                 * @constructor
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 */
                function AddressProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AddressProto formattedAddress.
                 * @member {string} formattedAddress
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.formattedAddress = "";

                /**
                 * AddressProto lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lat = 0;

                /**
                 * AddressProto lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lng = 0;

                /**
                 * Creates a new AddressProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.AddressProto} AddressProto instance
                 */
                AddressProto.create = function create(properties) {
                    return new AddressProto(properties);
                };

                /**
                 * Encodes the specified AddressProto message. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.formattedAddress != null && Object.hasOwnProperty.call(message, "formattedAddress"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.formattedAddress);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.lng);
                    return writer;
                };

                /**
                 * Encodes the specified AddressProto message, length delimited. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.AddressProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.formattedAddress = reader.string();
                                break;
                            }
                        case 2: {
                                message.lat = reader.double();
                                break;
                            }
                        case 3: {
                                message.lng = reader.double();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AddressProto message.
                 * @function verify
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AddressProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        if (!$util.isString(message.formattedAddress))
                            return "formattedAddress: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    return null;
                };

                /**
                 * Creates an AddressProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 */
                AddressProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.AddressProto)
                        return object;
                    var message = new $root.space.kenko.proto.AddressProto();
                    if (object.formattedAddress != null)
                        message.formattedAddress = String(object.formattedAddress);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    return message;
                };

                /**
                 * Creates a plain object from an AddressProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.AddressProto} message AddressProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AddressProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.formattedAddress = "";
                        object.lat = 0;
                        object.lng = 0;
                    }
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        object.formattedAddress = message.formattedAddress;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    return object;
                };

                /**
                 * Converts this AddressProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AddressProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AddressProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.AddressProto";
                };

                return AddressProto;
            })();

            proto.PractitionerProto = (function() {

                /**
                 * Properties of a PractitionerProto.
                 * @memberof space.kenko.proto
                 * @interface IPractitionerProto
                 * @property {string|null} [practitionerId] PractitionerProto practitionerId
                 * @property {string|null} [firstName] PractitionerProto firstName
                 * @property {string|null} [lastName] PractitionerProto lastName
                 * @property {string|null} [bio] PractitionerProto bio
                 * @property {string|null} [imageUrl] PractitionerProto imageUrl
                 * @property {string|null} [jobTitle] PractitionerProto jobTitle
                 * @property {Array.<space.kenko.proto.IEducationProto>|null} [education] PractitionerProto education
                 * @property {Array.<space.kenko.proto.ILicenseOrCredentialsProto>|null} [credentials] PractitionerProto credentials
                 * @property {Array.<string>|null} [languages] PractitionerProto languages
                 * @property {string|null} [calendarExportKey] PractitionerProto calendarExportKey
                 * @property {string|null} [virtualMeetingLink] PractitionerProto virtualMeetingLink
                 * @property {boolean|null} [archived] PractitionerProto archived
                 */

                /**
                 * Constructs a new PractitionerProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PractitionerProto.
                 * @implements IPractitionerProto
                 * @constructor
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 */
                function PractitionerProto(properties) {
                    this.education = [];
                    this.credentials = [];
                    this.languages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PractitionerProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.practitionerId = "";

                /**
                 * PractitionerProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.firstName = "";

                /**
                 * PractitionerProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.lastName = "";

                /**
                 * PractitionerProto bio.
                 * @member {string} bio
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.bio = "";

                /**
                 * PractitionerProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.imageUrl = "";

                /**
                 * PractitionerProto jobTitle.
                 * @member {string} jobTitle
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.jobTitle = "";

                /**
                 * PractitionerProto education.
                 * @member {Array.<space.kenko.proto.IEducationProto>} education
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.education = $util.emptyArray;

                /**
                 * PractitionerProto credentials.
                 * @member {Array.<space.kenko.proto.ILicenseOrCredentialsProto>} credentials
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.credentials = $util.emptyArray;

                /**
                 * PractitionerProto languages.
                 * @member {Array.<string>} languages
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.languages = $util.emptyArray;

                /**
                 * PractitionerProto calendarExportKey.
                 * @member {string} calendarExportKey
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.calendarExportKey = "";

                /**
                 * PractitionerProto virtualMeetingLink.
                 * @member {string} virtualMeetingLink
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.virtualMeetingLink = "";

                /**
                 * PractitionerProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.archived = false;

                /**
                 * Creates a new PractitionerProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto instance
                 */
                PractitionerProto.create = function create(properties) {
                    return new PractitionerProto(properties);
                };

                /**
                 * Encodes the specified PractitionerProto message. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.lastName);
                    if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.bio);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.imageUrl);
                    if (message.jobTitle != null && Object.hasOwnProperty.call(message, "jobTitle"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.jobTitle);
                    if (message.education != null && message.education.length)
                        for (var i = 0; i < message.education.length; ++i)
                            $root.space.kenko.proto.EducationProto.encode(message.education[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.credentials != null && message.credentials.length)
                        for (var i = 0; i < message.credentials.length; ++i)
                            $root.space.kenko.proto.LicenseOrCredentialsProto.encode(message.credentials[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.languages != null && message.languages.length)
                        for (var i = 0; i < message.languages.length; ++i)
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.languages[i]);
                    if (message.calendarExportKey != null && Object.hasOwnProperty.call(message, "calendarExportKey"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.calendarExportKey);
                    if (message.virtualMeetingLink != null && Object.hasOwnProperty.call(message, "virtualMeetingLink"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.virtualMeetingLink);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified PractitionerProto message, length delimited. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PractitionerProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 3: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 4: {
                                message.bio = reader.string();
                                break;
                            }
                        case 5: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 10: {
                                message.jobTitle = reader.string();
                                break;
                            }
                        case 11: {
                                if (!(message.education && message.education.length))
                                    message.education = [];
                                message.education.push($root.space.kenko.proto.EducationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 12: {
                                if (!(message.credentials && message.credentials.length))
                                    message.credentials = [];
                                message.credentials.push($root.space.kenko.proto.LicenseOrCredentialsProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 13: {
                                if (!(message.languages && message.languages.length))
                                    message.languages = [];
                                message.languages.push(reader.string());
                                break;
                            }
                        case 14: {
                                message.calendarExportKey = reader.string();
                                break;
                            }
                        case 15: {
                                message.virtualMeetingLink = reader.string();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PractitionerProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PractitionerProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        if (!$util.isString(message.bio))
                            return "bio: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        if (!$util.isString(message.jobTitle))
                            return "jobTitle: string expected";
                    if (message.education != null && message.hasOwnProperty("education")) {
                        if (!Array.isArray(message.education))
                            return "education: array expected";
                        for (var i = 0; i < message.education.length; ++i) {
                            var error = $root.space.kenko.proto.EducationProto.verify(message.education[i]);
                            if (error)
                                return "education." + error;
                        }
                    }
                    if (message.credentials != null && message.hasOwnProperty("credentials")) {
                        if (!Array.isArray(message.credentials))
                            return "credentials: array expected";
                        for (var i = 0; i < message.credentials.length; ++i) {
                            var error = $root.space.kenko.proto.LicenseOrCredentialsProto.verify(message.credentials[i]);
                            if (error)
                                return "credentials." + error;
                        }
                    }
                    if (message.languages != null && message.hasOwnProperty("languages")) {
                        if (!Array.isArray(message.languages))
                            return "languages: array expected";
                        for (var i = 0; i < message.languages.length; ++i)
                            if (!$util.isString(message.languages[i]))
                                return "languages: string[] expected";
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        if (!$util.isString(message.calendarExportKey))
                            return "calendarExportKey: string expected";
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        if (!$util.isString(message.virtualMeetingLink))
                            return "virtualMeetingLink: string expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a PractitionerProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 */
                PractitionerProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PractitionerProto)
                        return object;
                    var message = new $root.space.kenko.proto.PractitionerProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.bio != null)
                        message.bio = String(object.bio);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.jobTitle != null)
                        message.jobTitle = String(object.jobTitle);
                    if (object.education) {
                        if (!Array.isArray(object.education))
                            throw TypeError(".space.kenko.proto.PractitionerProto.education: array expected");
                        message.education = [];
                        for (var i = 0; i < object.education.length; ++i) {
                            if (typeof object.education[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.education: object expected");
                            message.education[i] = $root.space.kenko.proto.EducationProto.fromObject(object.education[i]);
                        }
                    }
                    if (object.credentials) {
                        if (!Array.isArray(object.credentials))
                            throw TypeError(".space.kenko.proto.PractitionerProto.credentials: array expected");
                        message.credentials = [];
                        for (var i = 0; i < object.credentials.length; ++i) {
                            if (typeof object.credentials[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.credentials: object expected");
                            message.credentials[i] = $root.space.kenko.proto.LicenseOrCredentialsProto.fromObject(object.credentials[i]);
                        }
                    }
                    if (object.languages) {
                        if (!Array.isArray(object.languages))
                            throw TypeError(".space.kenko.proto.PractitionerProto.languages: array expected");
                        message.languages = [];
                        for (var i = 0; i < object.languages.length; ++i)
                            message.languages[i] = String(object.languages[i]);
                    }
                    if (object.calendarExportKey != null)
                        message.calendarExportKey = String(object.calendarExportKey);
                    if (object.virtualMeetingLink != null)
                        message.virtualMeetingLink = String(object.virtualMeetingLink);
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a PractitionerProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.PractitionerProto} message PractitionerProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PractitionerProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.education = [];
                        object.credentials = [];
                        object.languages = [];
                    }
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.firstName = "";
                        object.lastName = "";
                        object.bio = "";
                        object.imageUrl = "";
                        object.jobTitle = "";
                        object.calendarExportKey = "";
                        object.virtualMeetingLink = "";
                        object.archived = false;
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        object.bio = message.bio;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        object.jobTitle = message.jobTitle;
                    if (message.education && message.education.length) {
                        object.education = [];
                        for (var j = 0; j < message.education.length; ++j)
                            object.education[j] = $root.space.kenko.proto.EducationProto.toObject(message.education[j], options);
                    }
                    if (message.credentials && message.credentials.length) {
                        object.credentials = [];
                        for (var j = 0; j < message.credentials.length; ++j)
                            object.credentials[j] = $root.space.kenko.proto.LicenseOrCredentialsProto.toObject(message.credentials[j], options);
                    }
                    if (message.languages && message.languages.length) {
                        object.languages = [];
                        for (var j = 0; j < message.languages.length; ++j)
                            object.languages[j] = message.languages[j];
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        object.calendarExportKey = message.calendarExportKey;
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        object.virtualMeetingLink = message.virtualMeetingLink;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this PractitionerProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PractitionerProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PractitionerProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PractitionerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PractitionerProto";
                };

                return PractitionerProto;
            })();

            proto.SpecialtyProto = (function() {

                /**
                 * Properties of a SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @interface ISpecialtyProto
                 * @property {string|null} [specialty] SpecialtyProto specialty
                 * @property {number|null} [yearsExperience] SpecialtyProto yearsExperience
                 */

                /**
                 * Constructs a new SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SpecialtyProto.
                 * @implements ISpecialtyProto
                 * @constructor
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 */
                function SpecialtyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SpecialtyProto specialty.
                 * @member {string} specialty
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.specialty = "";

                /**
                 * SpecialtyProto yearsExperience.
                 * @member {number} yearsExperience
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.yearsExperience = 0;

                /**
                 * Creates a new SpecialtyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto instance
                 */
                SpecialtyProto.create = function create(properties) {
                    return new SpecialtyProto(properties);
                };

                /**
                 * Encodes the specified SpecialtyProto message. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.specialty != null && Object.hasOwnProperty.call(message, "specialty"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.specialty);
                    if (message.yearsExperience != null && Object.hasOwnProperty.call(message, "yearsExperience"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.yearsExperience);
                    return writer;
                };

                /**
                 * Encodes the specified SpecialtyProto message, length delimited. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SpecialtyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.specialty = reader.string();
                                break;
                            }
                        case 2: {
                                message.yearsExperience = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SpecialtyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SpecialtyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        if (!$util.isString(message.specialty))
                            return "specialty: string expected";
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        if (!$util.isInteger(message.yearsExperience))
                            return "yearsExperience: integer expected";
                    return null;
                };

                /**
                 * Creates a SpecialtyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 */
                SpecialtyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SpecialtyProto)
                        return object;
                    var message = new $root.space.kenko.proto.SpecialtyProto();
                    if (object.specialty != null)
                        message.specialty = String(object.specialty);
                    if (object.yearsExperience != null)
                        message.yearsExperience = object.yearsExperience | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SpecialtyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.SpecialtyProto} message SpecialtyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SpecialtyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.specialty = "";
                        object.yearsExperience = 0;
                    }
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        object.specialty = message.specialty;
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        object.yearsExperience = message.yearsExperience;
                    return object;
                };

                /**
                 * Converts this SpecialtyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SpecialtyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SpecialtyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SpecialtyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SpecialtyProto";
                };

                return SpecialtyProto;
            })();

            proto.EducationProto = (function() {

                /**
                 * Properties of an EducationProto.
                 * @memberof space.kenko.proto
                 * @interface IEducationProto
                 * @property {string|null} [school] EducationProto school
                 * @property {string|null} [degree] EducationProto degree
                 * @property {number|null} [yearCompleted] EducationProto yearCompleted
                 */

                /**
                 * Constructs a new EducationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EducationProto.
                 * @implements IEducationProto
                 * @constructor
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 */
                function EducationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EducationProto school.
                 * @member {string} school
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.school = "";

                /**
                 * EducationProto degree.
                 * @member {string} degree
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.degree = "";

                /**
                 * EducationProto yearCompleted.
                 * @member {number} yearCompleted
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.yearCompleted = 0;

                /**
                 * Creates a new EducationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EducationProto} EducationProto instance
                 */
                EducationProto.create = function create(properties) {
                    return new EducationProto(properties);
                };

                /**
                 * Encodes the specified EducationProto message. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.school != null && Object.hasOwnProperty.call(message, "school"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.school);
                    if (message.degree != null && Object.hasOwnProperty.call(message, "degree"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.degree);
                    if (message.yearCompleted != null && Object.hasOwnProperty.call(message, "yearCompleted"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.yearCompleted);
                    return writer;
                };

                /**
                 * Encodes the specified EducationProto message, length delimited. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EducationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.school = reader.string();
                                break;
                            }
                        case 2: {
                                message.degree = reader.string();
                                break;
                            }
                        case 3: {
                                message.yearCompleted = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EducationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EducationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.school != null && message.hasOwnProperty("school"))
                        if (!$util.isString(message.school))
                            return "school: string expected";
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        if (!$util.isString(message.degree))
                            return "degree: string expected";
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        if (!$util.isInteger(message.yearCompleted))
                            return "yearCompleted: integer expected";
                    return null;
                };

                /**
                 * Creates an EducationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 */
                EducationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EducationProto)
                        return object;
                    var message = new $root.space.kenko.proto.EducationProto();
                    if (object.school != null)
                        message.school = String(object.school);
                    if (object.degree != null)
                        message.degree = String(object.degree);
                    if (object.yearCompleted != null)
                        message.yearCompleted = object.yearCompleted | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an EducationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.EducationProto} message EducationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EducationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.school = "";
                        object.degree = "";
                        object.yearCompleted = 0;
                    }
                    if (message.school != null && message.hasOwnProperty("school"))
                        object.school = message.school;
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        object.degree = message.degree;
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        object.yearCompleted = message.yearCompleted;
                    return object;
                };

                /**
                 * Converts this EducationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EducationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EducationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EducationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EducationProto";
                };

                return EducationProto;
            })();

            proto.LicenseOrCredentialsProto = (function() {

                /**
                 * Properties of a LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @interface ILicenseOrCredentialsProto
                 * @property {string|null} [licenseOrCredential] LicenseOrCredentialsProto licenseOrCredential
                 * @property {string|null} [supportDocumentationUrl] LicenseOrCredentialsProto supportDocumentationUrl
                 */

                /**
                 * Constructs a new LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LicenseOrCredentialsProto.
                 * @implements ILicenseOrCredentialsProto
                 * @constructor
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 */
                function LicenseOrCredentialsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LicenseOrCredentialsProto licenseOrCredential.
                 * @member {string} licenseOrCredential
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.licenseOrCredential = "";

                /**
                 * LicenseOrCredentialsProto supportDocumentationUrl.
                 * @member {string} supportDocumentationUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.supportDocumentationUrl = "";

                /**
                 * Creates a new LicenseOrCredentialsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto instance
                 */
                LicenseOrCredentialsProto.create = function create(properties) {
                    return new LicenseOrCredentialsProto(properties);
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.licenseOrCredential != null && Object.hasOwnProperty.call(message, "licenseOrCredential"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.licenseOrCredential);
                    if (message.supportDocumentationUrl != null && Object.hasOwnProperty.call(message, "supportDocumentationUrl"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.supportDocumentationUrl);
                    return writer;
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message, length delimited. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.licenseOrCredential = reader.string();
                                break;
                            }
                        case 2: {
                                message.supportDocumentationUrl = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LicenseOrCredentialsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LicenseOrCredentialsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        if (!$util.isString(message.licenseOrCredential))
                            return "licenseOrCredential: string expected";
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        if (!$util.isString(message.supportDocumentationUrl))
                            return "supportDocumentationUrl: string expected";
                    return null;
                };

                /**
                 * Creates a LicenseOrCredentialsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 */
                LicenseOrCredentialsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LicenseOrCredentialsProto)
                        return object;
                    var message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    if (object.licenseOrCredential != null)
                        message.licenseOrCredential = String(object.licenseOrCredential);
                    if (object.supportDocumentationUrl != null)
                        message.supportDocumentationUrl = String(object.supportDocumentationUrl);
                    return message;
                };

                /**
                 * Creates a plain object from a LicenseOrCredentialsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.LicenseOrCredentialsProto} message LicenseOrCredentialsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LicenseOrCredentialsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.licenseOrCredential = "";
                        object.supportDocumentationUrl = "";
                    }
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        object.licenseOrCredential = message.licenseOrCredential;
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        object.supportDocumentationUrl = message.supportDocumentationUrl;
                    return object;
                };

                /**
                 * Converts this LicenseOrCredentialsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LicenseOrCredentialsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LicenseOrCredentialsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LicenseOrCredentialsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LicenseOrCredentialsProto";
                };

                return LicenseOrCredentialsProto;
            })();

            proto.PracticeDetailsProto = (function() {

                /**
                 * Properties of a PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPracticeDetailsProto
                 * @property {Array.<space.kenko.proto.IServiceProto>|null} [services] PracticeDetailsProto services
                 */

                /**
                 * Constructs a new PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PracticeDetailsProto.
                 * @implements IPracticeDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 */
                function PracticeDetailsProto(properties) {
                    this.services = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PracticeDetailsProto services.
                 * @member {Array.<space.kenko.proto.IServiceProto>} services
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 */
                PracticeDetailsProto.prototype.services = $util.emptyArray;

                /**
                 * Creates a new PracticeDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto instance
                 */
                PracticeDetailsProto.create = function create(properties) {
                    return new PracticeDetailsProto(properties);
                };

                /**
                 * Encodes the specified PracticeDetailsProto message. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.services != null && message.services.length)
                        for (var i = 0; i < message.services.length; ++i)
                            $root.space.kenko.proto.ServiceProto.encode(message.services[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PracticeDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PracticeDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.services && message.services.length))
                                    message.services = [];
                                message.services.push($root.space.kenko.proto.ServiceProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PracticeDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PracticeDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.services != null && message.hasOwnProperty("services")) {
                        if (!Array.isArray(message.services))
                            return "services: array expected";
                        for (var i = 0; i < message.services.length; ++i) {
                            var error = $root.space.kenko.proto.ServiceProto.verify(message.services[i]);
                            if (error)
                                return "services." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PracticeDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 */
                PracticeDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PracticeDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.PracticeDetailsProto();
                    if (object.services) {
                        if (!Array.isArray(object.services))
                            throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: array expected");
                        message.services = [];
                        for (var i = 0; i < object.services.length; ++i) {
                            if (typeof object.services[i] !== "object")
                                throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: object expected");
                            message.services[i] = $root.space.kenko.proto.ServiceProto.fromObject(object.services[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PracticeDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.PracticeDetailsProto} message PracticeDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PracticeDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.services = [];
                    if (message.services && message.services.length) {
                        object.services = [];
                        for (var j = 0; j < message.services.length; ++j)
                            object.services[j] = $root.space.kenko.proto.ServiceProto.toObject(message.services[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PracticeDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PracticeDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PracticeDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PracticeDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PracticeDetailsProto";
                };

                return PracticeDetailsProto;
            })();

            proto.StudioDetailsProto = (function() {

                /**
                 * Properties of a StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IStudioDetailsProto
                 * @property {Array.<space.kenko.proto.IClassTemplateProto>|null} [classTemplates] StudioDetailsProto classTemplates
                 */

                /**
                 * Constructs a new StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a StudioDetailsProto.
                 * @implements IStudioDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 */
                function StudioDetailsProto(properties) {
                    this.classTemplates = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StudioDetailsProto classTemplates.
                 * @member {Array.<space.kenko.proto.IClassTemplateProto>} classTemplates
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 */
                StudioDetailsProto.prototype.classTemplates = $util.emptyArray;

                /**
                 * Creates a new StudioDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto instance
                 */
                StudioDetailsProto.create = function create(properties) {
                    return new StudioDetailsProto(properties);
                };

                /**
                 * Encodes the specified StudioDetailsProto message. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplates != null && message.classTemplates.length)
                        for (var i = 0; i < message.classTemplates.length; ++i)
                            $root.space.kenko.proto.ClassTemplateProto.encode(message.classTemplates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StudioDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.StudioDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.classTemplates && message.classTemplates.length))
                                    message.classTemplates = [];
                                message.classTemplates.push($root.space.kenko.proto.ClassTemplateProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StudioDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StudioDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplates != null && message.hasOwnProperty("classTemplates")) {
                        if (!Array.isArray(message.classTemplates))
                            return "classTemplates: array expected";
                        for (var i = 0; i < message.classTemplates.length; ++i) {
                            var error = $root.space.kenko.proto.ClassTemplateProto.verify(message.classTemplates[i]);
                            if (error)
                                return "classTemplates." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StudioDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 */
                StudioDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.StudioDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.StudioDetailsProto();
                    if (object.classTemplates) {
                        if (!Array.isArray(object.classTemplates))
                            throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: array expected");
                        message.classTemplates = [];
                        for (var i = 0; i < object.classTemplates.length; ++i) {
                            if (typeof object.classTemplates[i] !== "object")
                                throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: object expected");
                            message.classTemplates[i] = $root.space.kenko.proto.ClassTemplateProto.fromObject(object.classTemplates[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StudioDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.StudioDetailsProto} message StudioDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StudioDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.classTemplates = [];
                    if (message.classTemplates && message.classTemplates.length) {
                        object.classTemplates = [];
                        for (var j = 0; j < message.classTemplates.length; ++j)
                            object.classTemplates[j] = $root.space.kenko.proto.ClassTemplateProto.toObject(message.classTemplates[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this StudioDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StudioDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StudioDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StudioDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.StudioDetailsProto";
                };

                return StudioDetailsProto;
            })();

            proto.PricingDetailsProto = (function() {

                /**
                 * Properties of a PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPricingDetailsProto
                 * @property {Array.<IPriceCategoryProto>|null} [priceCategories] PricingDetailsProto priceCategories
                 * @property {Array.<IPackageProto>|null} [packages] PricingDetailsProto packages
                 * @property {Array.<space.kenko.proto.ISubscriptionProto>|null} [subscriptions] PricingDetailsProto subscriptions
                 */

                /**
                 * Constructs a new PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PricingDetailsProto.
                 * @implements IPricingDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 */
                function PricingDetailsProto(properties) {
                    this.priceCategories = [];
                    this.packages = [];
                    this.subscriptions = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PricingDetailsProto priceCategories.
                 * @member {Array.<IPriceCategoryProto>} priceCategories
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.priceCategories = $util.emptyArray;

                /**
                 * PricingDetailsProto packages.
                 * @member {Array.<IPackageProto>} packages
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.packages = $util.emptyArray;

                /**
                 * PricingDetailsProto subscriptions.
                 * @member {Array.<space.kenko.proto.ISubscriptionProto>} subscriptions
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.subscriptions = $util.emptyArray;

                /**
                 * Creates a new PricingDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto instance
                 */
                PricingDetailsProto.create = function create(properties) {
                    return new PricingDetailsProto(properties);
                };

                /**
                 * Encodes the specified PricingDetailsProto message. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategories != null && message.priceCategories.length)
                        for (var i = 0; i < message.priceCategories.length; ++i)
                            $root.PriceCategoryProto.encode(message.priceCategories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.packages != null && message.packages.length)
                        for (var i = 0; i < message.packages.length; ++i)
                            $root.PackageProto.encode(message.packages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.subscriptions != null && message.subscriptions.length)
                        for (var i = 0; i < message.subscriptions.length; ++i)
                            $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PricingDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PricingDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.priceCategories && message.priceCategories.length))
                                    message.priceCategories = [];
                                message.priceCategories.push($root.PriceCategoryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 2: {
                                if (!(message.packages && message.packages.length))
                                    message.packages = [];
                                message.packages.push($root.PackageProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.subscriptions && message.subscriptions.length))
                                    message.subscriptions = [];
                                message.subscriptions.push($root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PricingDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PricingDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategories != null && message.hasOwnProperty("priceCategories")) {
                        if (!Array.isArray(message.priceCategories))
                            return "priceCategories: array expected";
                        for (var i = 0; i < message.priceCategories.length; ++i) {
                            var error = $root.PriceCategoryProto.verify(message.priceCategories[i]);
                            if (error)
                                return "priceCategories." + error;
                        }
                    }
                    if (message.packages != null && message.hasOwnProperty("packages")) {
                        if (!Array.isArray(message.packages))
                            return "packages: array expected";
                        for (var i = 0; i < message.packages.length; ++i) {
                            var error = $root.PackageProto.verify(message.packages[i]);
                            if (error)
                                return "packages." + error;
                        }
                    }
                    if (message.subscriptions != null && message.hasOwnProperty("subscriptions")) {
                        if (!Array.isArray(message.subscriptions))
                            return "subscriptions: array expected";
                        for (var i = 0; i < message.subscriptions.length; ++i) {
                            var error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptions[i]);
                            if (error)
                                return "subscriptions." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PricingDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 */
                PricingDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PricingDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.PricingDetailsProto();
                    if (object.priceCategories) {
                        if (!Array.isArray(object.priceCategories))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: array expected");
                        message.priceCategories = [];
                        for (var i = 0; i < object.priceCategories.length; ++i) {
                            if (typeof object.priceCategories[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: object expected");
                            message.priceCategories[i] = $root.PriceCategoryProto.fromObject(object.priceCategories[i]);
                        }
                    }
                    if (object.packages) {
                        if (!Array.isArray(object.packages))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: array expected");
                        message.packages = [];
                        for (var i = 0; i < object.packages.length; ++i) {
                            if (typeof object.packages[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: object expected");
                            message.packages[i] = $root.PackageProto.fromObject(object.packages[i]);
                        }
                    }
                    if (object.subscriptions) {
                        if (!Array.isArray(object.subscriptions))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: array expected");
                        message.subscriptions = [];
                        for (var i = 0; i < object.subscriptions.length; ++i) {
                            if (typeof object.subscriptions[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: object expected");
                            message.subscriptions[i] = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptions[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PricingDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.PricingDetailsProto} message PricingDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PricingDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.priceCategories = [];
                        object.packages = [];
                        object.subscriptions = [];
                    }
                    if (message.priceCategories && message.priceCategories.length) {
                        object.priceCategories = [];
                        for (var j = 0; j < message.priceCategories.length; ++j)
                            object.priceCategories[j] = $root.PriceCategoryProto.toObject(message.priceCategories[j], options);
                    }
                    if (message.packages && message.packages.length) {
                        object.packages = [];
                        for (var j = 0; j < message.packages.length; ++j)
                            object.packages[j] = $root.PackageProto.toObject(message.packages[j], options);
                    }
                    if (message.subscriptions && message.subscriptions.length) {
                        object.subscriptions = [];
                        for (var j = 0; j < message.subscriptions.length; ++j)
                            object.subscriptions[j] = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptions[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PricingDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PricingDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PricingDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PricingDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PricingDetailsProto";
                };

                return PricingDetailsProto;
            })();

            proto.ServiceProto = (function() {

                /**
                 * Properties of a ServiceProto.
                 * @memberof space.kenko.proto
                 * @interface IServiceProto
                 * @property {string|null} [sku] ServiceProto sku
                 * @property {string|null} [name] ServiceProto name
                 * @property {string|null} [description] ServiceProto description
                 * @property {number|null} [lengthMinutes] ServiceProto lengthMinutes
                 * @property {string|null} [category] ServiceProto category
                 * @property {Array.<string>|null} [availableLocationIds] ServiceProto availableLocationIds
                 * @property {boolean|null} [isVirtual] ServiceProto isVirtual
                 * @property {Array.<string>|null} [practitionerId] ServiceProto practitionerId
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ServiceProto paymentPolicy
                 * @property {boolean|null} [archived] ServiceProto archived
                 */

                /**
                 * Constructs a new ServiceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ServiceProto.
                 * @implements IServiceProto
                 * @constructor
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 */
                function ServiceProto(properties) {
                    this.availableLocationIds = [];
                    this.practitionerId = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ServiceProto sku.
                 * @member {string} sku
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.sku = "";

                /**
                 * ServiceProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.name = "";

                /**
                 * ServiceProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.description = "";

                /**
                 * ServiceProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.lengthMinutes = 0;

                /**
                 * ServiceProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.category = "";

                /**
                 * ServiceProto availableLocationIds.
                 * @member {Array.<string>} availableLocationIds
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.availableLocationIds = $util.emptyArray;

                /**
                 * ServiceProto isVirtual.
                 * @member {boolean} isVirtual
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.isVirtual = false;

                /**
                 * ServiceProto practitionerId.
                 * @member {Array.<string>} practitionerId
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.practitionerId = $util.emptyArray;

                /**
                 * ServiceProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.paymentPolicy = null;

                /**
                 * ServiceProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.archived = false;

                /**
                 * Creates a new ServiceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto instance
                 */
                ServiceProto.create = function create(properties) {
                    return new ServiceProto(properties);
                };

                /**
                 * Encodes the specified ServiceProto message. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sku != null && Object.hasOwnProperty.call(message, "sku"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.sku);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.availableLocationIds != null && message.availableLocationIds.length)
                        for (var i = 0; i < message.availableLocationIds.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.availableLocationIds[i]);
                    if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isVirtual);
                    if (message.practitionerId != null && message.practitionerId.length)
                        for (var i = 0; i < message.practitionerId.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.practitionerId[i]);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ServiceProto message, length delimited. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ServiceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.sku = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 6: {
                                if (!(message.availableLocationIds && message.availableLocationIds.length))
                                    message.availableLocationIds = [];
                                message.availableLocationIds.push(reader.string());
                                break;
                            }
                        case 7: {
                                message.isVirtual = reader.bool();
                                break;
                            }
                        case 9: {
                                if (!(message.practitionerId && message.practitionerId.length))
                                    message.practitionerId = [];
                                message.practitionerId.push(reader.string());
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ServiceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        if (!$util.isString(message.sku))
                            return "sku: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.availableLocationIds != null && message.hasOwnProperty("availableLocationIds")) {
                        if (!Array.isArray(message.availableLocationIds))
                            return "availableLocationIds: array expected";
                        for (var i = 0; i < message.availableLocationIds.length; ++i)
                            if (!$util.isString(message.availableLocationIds[i]))
                                return "availableLocationIds: string[] expected";
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        if (typeof message.isVirtual !== "boolean")
                            return "isVirtual: boolean expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId")) {
                        if (!Array.isArray(message.practitionerId))
                            return "practitionerId: array expected";
                        for (var i = 0; i < message.practitionerId.length; ++i)
                            if (!$util.isString(message.practitionerId[i]))
                                return "practitionerId: string[] expected";
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ServiceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 */
                ServiceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ServiceProto)
                        return object;
                    var message = new $root.space.kenko.proto.ServiceProto();
                    if (object.sku != null)
                        message.sku = String(object.sku);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.availableLocationIds) {
                        if (!Array.isArray(object.availableLocationIds))
                            throw TypeError(".space.kenko.proto.ServiceProto.availableLocationIds: array expected");
                        message.availableLocationIds = [];
                        for (var i = 0; i < object.availableLocationIds.length; ++i)
                            message.availableLocationIds[i] = String(object.availableLocationIds[i]);
                    }
                    if (object.isVirtual != null)
                        message.isVirtual = Boolean(object.isVirtual);
                    if (object.practitionerId) {
                        if (!Array.isArray(object.practitionerId))
                            throw TypeError(".space.kenko.proto.ServiceProto.practitionerId: array expected");
                        message.practitionerId = [];
                        for (var i = 0; i < object.practitionerId.length; ++i)
                            message.practitionerId[i] = String(object.practitionerId[i]);
                    }
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ServiceProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ServiceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.ServiceProto} message ServiceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.availableLocationIds = [];
                        object.practitionerId = [];
                    }
                    if (options.defaults) {
                        object.sku = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.isVirtual = false;
                        object.paymentPolicy = null;
                        object.archived = false;
                    }
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        object.sku = message.sku;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.availableLocationIds && message.availableLocationIds.length) {
                        object.availableLocationIds = [];
                        for (var j = 0; j < message.availableLocationIds.length; ++j)
                            object.availableLocationIds[j] = message.availableLocationIds[j];
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        object.isVirtual = message.isVirtual;
                    if (message.practitionerId && message.practitionerId.length) {
                        object.practitionerId = [];
                        for (var j = 0; j < message.practitionerId.length; ++j)
                            object.practitionerId[j] = message.practitionerId[j];
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ServiceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ServiceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ServiceProto";
                };

                return ServiceProto;
            })();

            proto.ClassTemplateProto = (function() {

                /**
                 * Properties of a ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @interface IClassTemplateProto
                 * @property {string|null} [classTemplateId] ClassTemplateProto classTemplateId
                 * @property {string|null} [name] ClassTemplateProto name
                 * @property {string|null} [description] ClassTemplateProto description
                 * @property {number|null} [lengthMinutes] ClassTemplateProto lengthMinutes
                 * @property {string|null} [category] ClassTemplateProto category
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ClassTemplateProto paymentPolicy
                 * @property {number|null} [maxAttendees] ClassTemplateProto maxAttendees
                 * @property {boolean|null} [archived] ClassTemplateProto archived
                 */

                /**
                 * Constructs a new ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassTemplateProto.
                 * @implements IClassTemplateProto
                 * @constructor
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 */
                function ClassTemplateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassTemplateProto classTemplateId.
                 * @member {string} classTemplateId
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.classTemplateId = "";

                /**
                 * ClassTemplateProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.name = "";

                /**
                 * ClassTemplateProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.description = "";

                /**
                 * ClassTemplateProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.lengthMinutes = 0;

                /**
                 * ClassTemplateProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.category = "";

                /**
                 * ClassTemplateProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.paymentPolicy = null;

                /**
                 * ClassTemplateProto maxAttendees.
                 * @member {number} maxAttendees
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.maxAttendees = 0;

                /**
                 * ClassTemplateProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.archived = false;

                /**
                 * Creates a new ClassTemplateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto instance
                 */
                ClassTemplateProto.create = function create(properties) {
                    return new ClassTemplateProto(properties);
                };

                /**
                 * Encodes the specified ClassTemplateProto message. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.maxAttendees != null && Object.hasOwnProperty.call(message, "maxAttendees"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int32(message.maxAttendees);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ClassTemplateProto message, length delimited. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassTemplateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.classTemplateId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.maxAttendees = reader.int32();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassTemplateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassTemplateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        if (!$util.isString(message.classTemplateId))
                            return "classTemplateId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        var error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        if (!$util.isInteger(message.maxAttendees))
                            return "maxAttendees: integer expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ClassTemplateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 */
                ClassTemplateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassTemplateProto)
                        return object;
                    var message = new $root.space.kenko.proto.ClassTemplateProto();
                    if (object.classTemplateId != null)
                        message.classTemplateId = String(object.classTemplateId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ClassTemplateProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.maxAttendees != null)
                        message.maxAttendees = object.maxAttendees | 0;
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ClassTemplateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.ClassTemplateProto} message ClassTemplateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassTemplateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.classTemplateId = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.paymentPolicy = null;
                        object.maxAttendees = 0;
                        object.archived = false;
                    }
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        object.classTemplateId = message.classTemplateId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        object.maxAttendees = message.maxAttendees;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ClassTemplateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassTemplateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassTemplateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassTemplateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassTemplateProto";
                };

                return ClassTemplateProto;
            })();

            proto.SubscriptionProto = (function() {

                /**
                 * Properties of a SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionProto
                 * @property {string|null} [stripeSubscriptionId] SubscriptionProto stripeSubscriptionId
                 * @property {string|null} [name] SubscriptionProto name
                 * @property {string|null} [description] SubscriptionProto description
                 * @property {space.kenko.proto.IBillingPeriodProto|null} [billingPeriod] SubscriptionProto billingPeriod
                 * @property {space.kenko.proto.IPriceProto|null} [price] SubscriptionProto price
                 * @property {space.kenko.proto.ISubscriptionEntitlementProto|null} [entitlement] SubscriptionProto entitlement
                 * @property {boolean|null} [archived] SubscriptionProto archived
                 */

                /**
                 * Constructs a new SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionProto.
                 * @implements ISubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 */
                function SubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionProto stripeSubscriptionId.
                 * @member {string} stripeSubscriptionId
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.stripeSubscriptionId = "";

                /**
                 * SubscriptionProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.name = "";

                /**
                 * SubscriptionProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.description = "";

                /**
                 * SubscriptionProto billingPeriod.
                 * @member {space.kenko.proto.IBillingPeriodProto|null|undefined} billingPeriod
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.billingPeriod = null;

                /**
                 * SubscriptionProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.price = null;

                /**
                 * SubscriptionProto entitlement.
                 * @member {space.kenko.proto.ISubscriptionEntitlementProto|null|undefined} entitlement
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.entitlement = null;

                /**
                 * SubscriptionProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.archived = false;

                /**
                 * Creates a new SubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto instance
                 */
                SubscriptionProto.create = function create(properties) {
                    return new SubscriptionProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionProto message. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeSubscriptionId != null && Object.hasOwnProperty.call(message, "stripeSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeSubscriptionId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.billingPeriod != null && Object.hasOwnProperty.call(message, "billingPeriod"))
                        $root.space.kenko.proto.BillingPeriodProto.encode(message.billingPeriod, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.entitlement != null && Object.hasOwnProperty.call(message, "entitlement"))
                        $root.space.kenko.proto.SubscriptionEntitlementProto.encode(message.entitlement, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        if (!$util.isString(message.stripeSubscriptionId))
                            return "stripeSubscriptionId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod")) {
                        var error = $root.space.kenko.proto.BillingPeriodProto.verify(message.billingPeriod);
                        if (error)
                            return "billingPeriod." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.entitlement != null && message.hasOwnProperty("entitlement")) {
                        var error = $root.space.kenko.proto.SubscriptionEntitlementProto.verify(message.entitlement);
                        if (error)
                            return "entitlement." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a SubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 */
                SubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.SubscriptionProto();
                    if (object.stripeSubscriptionId != null)
                        message.stripeSubscriptionId = String(object.stripeSubscriptionId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.billingPeriod != null) {
                        if (typeof object.billingPeriod !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.billingPeriod: object expected");
                        message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.fromObject(object.billingPeriod);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.entitlement != null) {
                        if (typeof object.entitlement !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.entitlement: object expected");
                        message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.fromObject(object.entitlement);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionProto} message SubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.stripeSubscriptionId = "";
                        object.name = "";
                        object.description = "";
                        object.billingPeriod = null;
                        object.price = null;
                        object.entitlement = null;
                        object.archived = false;
                    }
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        object.stripeSubscriptionId = message.stripeSubscriptionId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod"))
                        object.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.toObject(message.billingPeriod, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.entitlement != null && message.hasOwnProperty("entitlement"))
                        object.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.toObject(message.entitlement, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this SubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionProto";
                };

                return SubscriptionProto;
            })();

            /**
             * BillingPeriodUnitProto enum.
             * @name space.kenko.proto.BillingPeriodUnitProto
             * @enum {number}
             * @property {number} BILLING_PERIOD_UNKNOWN=0 BILLING_PERIOD_UNKNOWN value
             * @property {number} MONTH=1 MONTH value
             * @property {number} YEAR=2 YEAR value
             */
            proto.BillingPeriodUnitProto = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BILLING_PERIOD_UNKNOWN"] = 0;
                values[valuesById[1] = "MONTH"] = 1;
                values[valuesById[2] = "YEAR"] = 2;
                return values;
            })();

            proto.BillingPeriodProto = (function() {

                /**
                 * Properties of a BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @interface IBillingPeriodProto
                 * @property {number|null} [amount] BillingPeriodProto amount
                 * @property {space.kenko.proto.BillingPeriodUnitProto|null} [unit] BillingPeriodProto unit
                 */

                /**
                 * Constructs a new BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BillingPeriodProto.
                 * @implements IBillingPeriodProto
                 * @constructor
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 */
                function BillingPeriodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BillingPeriodProto amount.
                 * @member {number} amount
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.amount = 0;

                /**
                 * BillingPeriodProto unit.
                 * @member {space.kenko.proto.BillingPeriodUnitProto} unit
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.unit = 0;

                /**
                 * Creates a new BillingPeriodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto instance
                 */
                BillingPeriodProto.create = function create(properties) {
                    return new BillingPeriodProto(properties);
                };

                /**
                 * Encodes the specified BillingPeriodProto message. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.amount);
                    if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.unit);
                    return writer;
                };

                /**
                 * Encodes the specified BillingPeriodProto message, length delimited. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BillingPeriodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int32();
                                break;
                            }
                        case 2: {
                                message.unit = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BillingPeriodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BillingPeriodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount))
                            return "amount: integer expected";
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        switch (message.unit) {
                        default:
                            return "unit: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a BillingPeriodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 */
                BillingPeriodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BillingPeriodProto)
                        return object;
                    var message = new $root.space.kenko.proto.BillingPeriodProto();
                    if (object.amount != null)
                        message.amount = object.amount | 0;
                    switch (object.unit) {
                    default:
                        if (typeof object.unit === "number") {
                            message.unit = object.unit;
                            break;
                        }
                        break;
                    case "BILLING_PERIOD_UNKNOWN":
                    case 0:
                        message.unit = 0;
                        break;
                    case "MONTH":
                    case 1:
                        message.unit = 1;
                        break;
                    case "YEAR":
                    case 2:
                        message.unit = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BillingPeriodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.BillingPeriodProto} message BillingPeriodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BillingPeriodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.amount = 0;
                        object.unit = options.enums === String ? "BILLING_PERIOD_UNKNOWN" : 0;
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = message.amount;
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        object.unit = options.enums === String ? $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] === undefined ? message.unit : $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] : message.unit;
                    return object;
                };

                /**
                 * Converts this BillingPeriodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BillingPeriodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BillingPeriodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BillingPeriodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BillingPeriodProto";
                };

                return BillingPeriodProto;
            })();

            proto.SubscriptionEntitlementProto = (function() {

                /**
                 * Properties of a SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionEntitlementProto
                 * @property {string|null} [id] SubscriptionEntitlementProto id
                 * @property {string|null} [displayName] SubscriptionEntitlementProto displayName
                 * @property {space.kenko.proto.IClassSubscriptionEntitlement|null} [classes] SubscriptionEntitlementProto classes
                 */

                /**
                 * Constructs a new SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionEntitlementProto.
                 * @implements ISubscriptionEntitlementProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 */
                function SubscriptionEntitlementProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionEntitlementProto id.
                 * @member {string} id
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.id = "";

                /**
                 * SubscriptionEntitlementProto displayName.
                 * @member {string} displayName
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.displayName = "";

                /**
                 * SubscriptionEntitlementProto classes.
                 * @member {space.kenko.proto.IClassSubscriptionEntitlement|null|undefined} classes
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.classes = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * SubscriptionEntitlementProto EntitlementType.
                 * @member {"classes"|undefined} EntitlementType
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                Object.defineProperty(SubscriptionEntitlementProto.prototype, "EntitlementType", {
                    get: $util.oneOfGetter($oneOfFields = ["classes"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SubscriptionEntitlementProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto instance
                 */
                SubscriptionEntitlementProto.create = function create(properties) {
                    return new SubscriptionEntitlementProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                    if (message.classes != null && Object.hasOwnProperty.call(message, "classes"))
                        $root.space.kenko.proto.ClassSubscriptionEntitlement.encode(message.classes, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.displayName = reader.string();
                                break;
                            }
                        case 10: {
                                message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionEntitlementProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionEntitlementProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        if (!$util.isString(message.displayName))
                            return "displayName: string expected";
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        properties.EntitlementType = 1;
                        {
                            var error = $root.space.kenko.proto.ClassSubscriptionEntitlement.verify(message.classes);
                            if (error)
                                return "classes." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SubscriptionEntitlementProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 */
                SubscriptionEntitlementProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionEntitlementProto)
                        return object;
                    var message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.displayName != null)
                        message.displayName = String(object.displayName);
                    if (object.classes != null) {
                        if (typeof object.classes !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionEntitlementProto.classes: object expected");
                        message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.fromObject(object.classes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionEntitlementProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionEntitlementProto} message SubscriptionEntitlementProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionEntitlementProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.displayName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        object.displayName = message.displayName;
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        object.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.toObject(message.classes, options);
                        if (options.oneofs)
                            object.EntitlementType = "classes";
                    }
                    return object;
                };

                /**
                 * Converts this SubscriptionEntitlementProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionEntitlementProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionEntitlementProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionEntitlementProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionEntitlementProto";
                };

                return SubscriptionEntitlementProto;
            })();

            proto.ClassSubscriptionEntitlement = (function() {

                /**
                 * Properties of a ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @interface IClassSubscriptionEntitlement
                 * @property {string|null} [includedPriceCategory] ClassSubscriptionEntitlement includedPriceCategory
                 * @property {number|null} [maxClassesPerDay] ClassSubscriptionEntitlement maxClassesPerDay
                 */

                /**
                 * Constructs a new ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassSubscriptionEntitlement.
                 * @implements IClassSubscriptionEntitlement
                 * @constructor
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 */
                function ClassSubscriptionEntitlement(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassSubscriptionEntitlement includedPriceCategory.
                 * @member {string} includedPriceCategory
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.includedPriceCategory = "";

                /**
                 * ClassSubscriptionEntitlement maxClassesPerDay.
                 * @member {number} maxClassesPerDay
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.maxClassesPerDay = 0;

                /**
                 * Creates a new ClassSubscriptionEntitlement instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement instance
                 */
                ClassSubscriptionEntitlement.create = function create(properties) {
                    return new ClassSubscriptionEntitlement(properties);
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.includedPriceCategory != null && Object.hasOwnProperty.call(message, "includedPriceCategory"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.includedPriceCategory);
                    if (message.maxClassesPerDay != null && Object.hasOwnProperty.call(message, "maxClassesPerDay"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxClassesPerDay);
                    return writer;
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message, length delimited. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.includedPriceCategory = reader.string();
                                break;
                            }
                        case 2: {
                                message.maxClassesPerDay = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassSubscriptionEntitlement message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassSubscriptionEntitlement.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        if (!$util.isString(message.includedPriceCategory))
                            return "includedPriceCategory: string expected";
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        if (!$util.isInteger(message.maxClassesPerDay))
                            return "maxClassesPerDay: integer expected";
                    return null;
                };

                /**
                 * Creates a ClassSubscriptionEntitlement message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 */
                ClassSubscriptionEntitlement.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassSubscriptionEntitlement)
                        return object;
                    var message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    if (object.includedPriceCategory != null)
                        message.includedPriceCategory = String(object.includedPriceCategory);
                    if (object.maxClassesPerDay != null)
                        message.maxClassesPerDay = object.maxClassesPerDay | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a ClassSubscriptionEntitlement message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.ClassSubscriptionEntitlement} message ClassSubscriptionEntitlement
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassSubscriptionEntitlement.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.includedPriceCategory = "";
                        object.maxClassesPerDay = 0;
                    }
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        object.includedPriceCategory = message.includedPriceCategory;
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        object.maxClassesPerDay = message.maxClassesPerDay;
                    return object;
                };

                /**
                 * Converts this ClassSubscriptionEntitlement to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassSubscriptionEntitlement.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassSubscriptionEntitlement
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassSubscriptionEntitlement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassSubscriptionEntitlement";
                };

                return ClassSubscriptionEntitlement;
            })();

            proto.PurchasedSubscriptionProto = (function() {

                /**
                 * Properties of a PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IPurchasedSubscriptionProto
                 * @property {string|null} [purchasedSubscriptionId] PurchasedSubscriptionProto purchasedSubscriptionId
                 * @property {space.kenko.proto.ISubscriptionProto|null} [subscriptionDetails] PurchasedSubscriptionProto subscriptionDetails
                 * @property {number|Long|null} [purchaseTimestamp] PurchasedSubscriptionProto purchaseTimestamp
                 * @property {string|null} [subscriptionState] PurchasedSubscriptionProto subscriptionState
                 * @property {number|Long|null} [lastPaidInvoice] PurchasedSubscriptionProto lastPaidInvoice
                 */

                /**
                 * Constructs a new PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PurchasedSubscriptionProto.
                 * @implements IPurchasedSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 */
                function PurchasedSubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PurchasedSubscriptionProto purchasedSubscriptionId.
                 * @member {string} purchasedSubscriptionId
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchasedSubscriptionId = "";

                /**
                 * PurchasedSubscriptionProto subscriptionDetails.
                 * @member {space.kenko.proto.ISubscriptionProto|null|undefined} subscriptionDetails
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionDetails = null;

                /**
                 * PurchasedSubscriptionProto purchaseTimestamp.
                 * @member {number|Long} purchaseTimestamp
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PurchasedSubscriptionProto subscriptionState.
                 * @member {string} subscriptionState
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionState = "";

                /**
                 * PurchasedSubscriptionProto lastPaidInvoice.
                 * @member {number|Long} lastPaidInvoice
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.lastPaidInvoice = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new PurchasedSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto instance
                 */
                PurchasedSubscriptionProto.create = function create(properties) {
                    return new PurchasedSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.purchasedSubscriptionId != null && Object.hasOwnProperty.call(message, "purchasedSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedSubscriptionId);
                    if (message.subscriptionDetails != null && Object.hasOwnProperty.call(message, "subscriptionDetails"))
                        $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptionDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
                    if (message.subscriptionState != null && Object.hasOwnProperty.call(message, "subscriptionState"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.subscriptionState);
                    if (message.lastPaidInvoice != null && Object.hasOwnProperty.call(message, "lastPaidInvoice"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastPaidInvoice);
                    return writer;
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.purchasedSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.purchaseTimestamp = reader.int64();
                                break;
                            }
                        case 4: {
                                message.subscriptionState = reader.string();
                                break;
                            }
                        case 5: {
                                message.lastPaidInvoice = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PurchasedSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PurchasedSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        if (!$util.isString(message.purchasedSubscriptionId))
                            return "purchasedSubscriptionId: string expected";
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails")) {
                        var error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptionDetails);
                        if (error)
                            return "subscriptionDetails." + error;
                    }
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                            return "purchaseTimestamp: integer|Long expected";
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        if (!$util.isString(message.subscriptionState))
                            return "subscriptionState: string expected";
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (!$util.isInteger(message.lastPaidInvoice) && !(message.lastPaidInvoice && $util.isInteger(message.lastPaidInvoice.low) && $util.isInteger(message.lastPaidInvoice.high)))
                            return "lastPaidInvoice: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a PurchasedSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 */
                PurchasedSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PurchasedSubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    if (object.purchasedSubscriptionId != null)
                        message.purchasedSubscriptionId = String(object.purchasedSubscriptionId);
                    if (object.subscriptionDetails != null) {
                        if (typeof object.subscriptionDetails !== "object")
                            throw TypeError(".space.kenko.proto.PurchasedSubscriptionProto.subscriptionDetails: object expected");
                        message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptionDetails);
                    }
                    if (object.purchaseTimestamp != null)
                        if ($util.Long)
                            (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
                        else if (typeof object.purchaseTimestamp === "string")
                            message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
                        else if (typeof object.purchaseTimestamp === "number")
                            message.purchaseTimestamp = object.purchaseTimestamp;
                        else if (typeof object.purchaseTimestamp === "object")
                            message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
                    if (object.subscriptionState != null)
                        message.subscriptionState = String(object.subscriptionState);
                    if (object.lastPaidInvoice != null)
                        if ($util.Long)
                            (message.lastPaidInvoice = $util.Long.fromValue(object.lastPaidInvoice)).unsigned = false;
                        else if (typeof object.lastPaidInvoice === "string")
                            message.lastPaidInvoice = parseInt(object.lastPaidInvoice, 10);
                        else if (typeof object.lastPaidInvoice === "number")
                            message.lastPaidInvoice = object.lastPaidInvoice;
                        else if (typeof object.lastPaidInvoice === "object")
                            message.lastPaidInvoice = new $util.LongBits(object.lastPaidInvoice.low >>> 0, object.lastPaidInvoice.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a PurchasedSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.PurchasedSubscriptionProto} message PurchasedSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PurchasedSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.purchasedSubscriptionId = "";
                        object.subscriptionDetails = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.purchaseTimestamp = options.longs === String ? "0" : 0;
                        object.subscriptionState = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastPaidInvoice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastPaidInvoice = options.longs === String ? "0" : 0;
                    }
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        object.purchasedSubscriptionId = message.purchasedSubscriptionId;
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails"))
                        object.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptionDetails, options);
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (typeof message.purchaseTimestamp === "number")
                            object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
                        else
                            object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        object.subscriptionState = message.subscriptionState;
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (typeof message.lastPaidInvoice === "number")
                            object.lastPaidInvoice = options.longs === String ? String(message.lastPaidInvoice) : message.lastPaidInvoice;
                        else
                            object.lastPaidInvoice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPaidInvoice) : options.longs === Number ? new $util.LongBits(message.lastPaidInvoice.low >>> 0, message.lastPaidInvoice.high >>> 0).toNumber() : message.lastPaidInvoice;
                    return object;
                };

                /**
                 * Converts this PurchasedSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PurchasedSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PurchasedSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PurchasedSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PurchasedSubscriptionProto";
                };

                return PurchasedSubscriptionProto;
            })();

            /**
             * BusinessSubscriptionType enum.
             * @name space.kenko.proto.BusinessSubscriptionType
             * @enum {number}
             * @property {number} SUBSCRIPTION_TYPE_UNKNOWN=0 SUBSCRIPTION_TYPE_UNKNOWN value
             * @property {number} LISTING=1 LISTING value
             * @property {number} LISTING_PLUS_BOOKING=2 LISTING_PLUS_BOOKING value
             */
            proto.BusinessSubscriptionType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SUBSCRIPTION_TYPE_UNKNOWN"] = 0;
                values[valuesById[1] = "LISTING"] = 1;
                values[valuesById[2] = "LISTING_PLUS_BOOKING"] = 2;
                return values;
            })();

            proto.BusinessSubscriptionProto = (function() {

                /**
                 * Properties of a BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSubscriptionProto
                 * @property {space.kenko.proto.BusinessSubscriptionType|null} [type] BusinessSubscriptionProto type
                 * @property {number|null} [quantity] BusinessSubscriptionProto quantity
                 * @property {string|null} [paymentProvider] BusinessSubscriptionProto paymentProvider
                 * @property {boolean|null} [isActive] BusinessSubscriptionProto isActive
                 * @property {string|null} [subscriptionId] BusinessSubscriptionProto subscriptionId
                 */

                /**
                 * Constructs a new BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSubscriptionProto.
                 * @implements IBusinessSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 */
                function BusinessSubscriptionProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSubscriptionProto type.
                 * @member {space.kenko.proto.BusinessSubscriptionType} type
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.type = 0;

                /**
                 * BusinessSubscriptionProto quantity.
                 * @member {number} quantity
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.quantity = 0;

                /**
                 * BusinessSubscriptionProto paymentProvider.
                 * @member {string} paymentProvider
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.paymentProvider = "";

                /**
                 * BusinessSubscriptionProto isActive.
                 * @member {boolean} isActive
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.isActive = false;

                /**
                 * BusinessSubscriptionProto subscriptionId.
                 * @member {string} subscriptionId
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.subscriptionId = "";

                /**
                 * Creates a new BusinessSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto instance
                 */
                BusinessSubscriptionProto.create = function create(properties) {
                    return new BusinessSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.quantity);
                    if (message.paymentProvider != null && Object.hasOwnProperty.call(message, "paymentProvider"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.paymentProvider);
                    if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isActive);
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.subscriptionId);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.quantity = reader.int32();
                                break;
                            }
                        case 3: {
                                message.paymentProvider = reader.string();
                                break;
                            }
                        case 4: {
                                message.isActive = reader.bool();
                                break;
                            }
                        case 5: {
                                message.subscriptionId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        if (!$util.isInteger(message.quantity))
                            return "quantity: integer expected";
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        if (!$util.isString(message.paymentProvider))
                            return "paymentProvider: string expected";
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        if (typeof message.isActive !== "boolean")
                            return "isActive: boolean expected";
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        if (!$util.isString(message.subscriptionId))
                            return "subscriptionId: string expected";
                    return null;
                };

                /**
                 * Creates a BusinessSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 */
                BusinessSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSubscriptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "SUBSCRIPTION_TYPE_UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "LISTING":
                    case 1:
                        message.type = 1;
                        break;
                    case "LISTING_PLUS_BOOKING":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.quantity != null)
                        message.quantity = object.quantity | 0;
                    if (object.paymentProvider != null)
                        message.paymentProvider = String(object.paymentProvider);
                    if (object.isActive != null)
                        message.isActive = Boolean(object.isActive);
                    if (object.subscriptionId != null)
                        message.subscriptionId = String(object.subscriptionId);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.BusinessSubscriptionProto} message BusinessSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                        object.quantity = 0;
                        object.paymentProvider = "";
                        object.isActive = false;
                        object.subscriptionId = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.type] === undefined ? message.type : $root.space.kenko.proto.BusinessSubscriptionType[message.type] : message.type;
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        object.quantity = message.quantity;
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        object.paymentProvider = message.paymentProvider;
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        object.isActive = message.isActive;
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        object.subscriptionId = message.subscriptionId;
                    return object;
                };

                /**
                 * Converts this BusinessSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSubscriptionProto";
                };

                return BusinessSubscriptionProto;
            })();

            proto.ConnectedAccountStatusProto = (function() {

                /**
                 * Properties of a ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @interface IConnectedAccountStatusProto
                 * @property {boolean|null} [accountIsReady] ConnectedAccountStatusProto accountIsReady
                 * @property {boolean|null} [stripeChargesEnabled] ConnectedAccountStatusProto stripeChargesEnabled
                 * @property {boolean|null} [stripeDetailsSubmitted] ConnectedAccountStatusProto stripeDetailsSubmitted
                 */

                /**
                 * Constructs a new ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ConnectedAccountStatusProto.
                 * @implements IConnectedAccountStatusProto
                 * @constructor
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 */
                function ConnectedAccountStatusProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConnectedAccountStatusProto accountIsReady.
                 * @member {boolean} accountIsReady
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.accountIsReady = false;

                /**
                 * ConnectedAccountStatusProto stripeChargesEnabled.
                 * @member {boolean} stripeChargesEnabled
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeChargesEnabled = false;

                /**
                 * ConnectedAccountStatusProto stripeDetailsSubmitted.
                 * @member {boolean} stripeDetailsSubmitted
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeDetailsSubmitted = false;

                /**
                 * Creates a new ConnectedAccountStatusProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto instance
                 */
                ConnectedAccountStatusProto.create = function create(properties) {
                    return new ConnectedAccountStatusProto(properties);
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.accountIsReady != null && Object.hasOwnProperty.call(message, "accountIsReady"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.accountIsReady);
                    if (message.stripeChargesEnabled != null && Object.hasOwnProperty.call(message, "stripeChargesEnabled"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.stripeChargesEnabled);
                    if (message.stripeDetailsSubmitted != null && Object.hasOwnProperty.call(message, "stripeDetailsSubmitted"))
                        writer.uint32(/* id 101, wireType 0 =*/808).bool(message.stripeDetailsSubmitted);
                    return writer;
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message, length delimited. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.accountIsReady = reader.bool();
                                break;
                            }
                        case 100: {
                                message.stripeChargesEnabled = reader.bool();
                                break;
                            }
                        case 101: {
                                message.stripeDetailsSubmitted = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConnectedAccountStatusProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConnectedAccountStatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        if (typeof message.accountIsReady !== "boolean")
                            return "accountIsReady: boolean expected";
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        if (typeof message.stripeChargesEnabled !== "boolean")
                            return "stripeChargesEnabled: boolean expected";
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        if (typeof message.stripeDetailsSubmitted !== "boolean")
                            return "stripeDetailsSubmitted: boolean expected";
                    return null;
                };

                /**
                 * Creates a ConnectedAccountStatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 */
                ConnectedAccountStatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ConnectedAccountStatusProto)
                        return object;
                    var message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    if (object.accountIsReady != null)
                        message.accountIsReady = Boolean(object.accountIsReady);
                    if (object.stripeChargesEnabled != null)
                        message.stripeChargesEnabled = Boolean(object.stripeChargesEnabled);
                    if (object.stripeDetailsSubmitted != null)
                        message.stripeDetailsSubmitted = Boolean(object.stripeDetailsSubmitted);
                    return message;
                };

                /**
                 * Creates a plain object from a ConnectedAccountStatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.ConnectedAccountStatusProto} message ConnectedAccountStatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConnectedAccountStatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.accountIsReady = false;
                        object.stripeChargesEnabled = false;
                        object.stripeDetailsSubmitted = false;
                    }
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        object.accountIsReady = message.accountIsReady;
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        object.stripeChargesEnabled = message.stripeChargesEnabled;
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        object.stripeDetailsSubmitted = message.stripeDetailsSubmitted;
                    return object;
                };

                /**
                 * Converts this ConnectedAccountStatusProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConnectedAccountStatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConnectedAccountStatusProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConnectedAccountStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ConnectedAccountStatusProto";
                };

                return ConnectedAccountStatusProto;
            })();

            proto.BusinessSettingsProto = (function() {

                /**
                 * Properties of a BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSettingsProto
                 * @property {boolean|null} [offersClasses] BusinessSettingsProto offersClasses
                 * @property {boolean|null} [offersAppointments] BusinessSettingsProto offersAppointments
                 * @property {boolean|null} [offersVirtualServices] BusinessSettingsProto offersVirtualServices
                 * @property {boolean|null} [offersInPersonServices] BusinessSettingsProto offersInPersonServices
                 * @property {boolean|null} [newClientsMustInquire] BusinessSettingsProto newClientsMustInquire
                 */

                /**
                 * Constructs a new BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSettingsProto.
                 * @implements IBusinessSettingsProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 */
                function BusinessSettingsProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSettingsProto offersClasses.
                 * @member {boolean} offersClasses
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersClasses = false;

                /**
                 * BusinessSettingsProto offersAppointments.
                 * @member {boolean} offersAppointments
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersAppointments = false;

                /**
                 * BusinessSettingsProto offersVirtualServices.
                 * @member {boolean} offersVirtualServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersVirtualServices = false;

                /**
                 * BusinessSettingsProto offersInPersonServices.
                 * @member {boolean} offersInPersonServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersInPersonServices = false;

                /**
                 * BusinessSettingsProto newClientsMustInquire.
                 * @member {boolean} newClientsMustInquire
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.newClientsMustInquire = false;

                /**
                 * Creates a new BusinessSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto instance
                 */
                BusinessSettingsProto.create = function create(properties) {
                    return new BusinessSettingsProto(properties);
                };

                /**
                 * Encodes the specified BusinessSettingsProto message. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.offersClasses != null && Object.hasOwnProperty.call(message, "offersClasses"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.offersClasses);
                    if (message.offersAppointments != null && Object.hasOwnProperty.call(message, "offersAppointments"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.offersAppointments);
                    if (message.offersVirtualServices != null && Object.hasOwnProperty.call(message, "offersVirtualServices"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.offersVirtualServices);
                    if (message.offersInPersonServices != null && Object.hasOwnProperty.call(message, "offersInPersonServices"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.offersInPersonServices);
                    if (message.newClientsMustInquire != null && Object.hasOwnProperty.call(message, "newClientsMustInquire"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.newClientsMustInquire);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSettingsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.offersClasses = reader.bool();
                                break;
                            }
                        case 2: {
                                message.offersAppointments = reader.bool();
                                break;
                            }
                        case 3: {
                                message.offersVirtualServices = reader.bool();
                                break;
                            }
                        case 4: {
                                message.offersInPersonServices = reader.bool();
                                break;
                            }
                        case 10: {
                                message.newClientsMustInquire = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        if (typeof message.offersClasses !== "boolean")
                            return "offersClasses: boolean expected";
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        if (typeof message.offersAppointments !== "boolean")
                            return "offersAppointments: boolean expected";
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        if (typeof message.offersVirtualServices !== "boolean")
                            return "offersVirtualServices: boolean expected";
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        if (typeof message.offersInPersonServices !== "boolean")
                            return "offersInPersonServices: boolean expected";
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        if (typeof message.newClientsMustInquire !== "boolean")
                            return "newClientsMustInquire: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 */
                BusinessSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSettingsProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessSettingsProto();
                    if (object.offersClasses != null)
                        message.offersClasses = Boolean(object.offersClasses);
                    if (object.offersAppointments != null)
                        message.offersAppointments = Boolean(object.offersAppointments);
                    if (object.offersVirtualServices != null)
                        message.offersVirtualServices = Boolean(object.offersVirtualServices);
                    if (object.offersInPersonServices != null)
                        message.offersInPersonServices = Boolean(object.offersInPersonServices);
                    if (object.newClientsMustInquire != null)
                        message.newClientsMustInquire = Boolean(object.newClientsMustInquire);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.BusinessSettingsProto} message BusinessSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.offersClasses = false;
                        object.offersAppointments = false;
                        object.offersVirtualServices = false;
                        object.offersInPersonServices = false;
                        object.newClientsMustInquire = false;
                    }
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        object.offersClasses = message.offersClasses;
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        object.offersAppointments = message.offersAppointments;
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        object.offersVirtualServices = message.offersVirtualServices;
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        object.offersInPersonServices = message.offersInPersonServices;
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        object.newClientsMustInquire = message.newClientsMustInquire;
                    return object;
                };

                /**
                 * Converts this BusinessSettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSettingsProto";
                };

                return BusinessSettingsProto;
            })();

            proto.BusinessOnboardingStateProto = (function() {

                /**
                 * Properties of a BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessOnboardingStateProto
                 * @property {boolean|null} [createdFirstCalendarAppt] BusinessOnboardingStateProto createdFirstCalendarAppt
                 */

                /**
                 * Constructs a new BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessOnboardingStateProto.
                 * @implements IBusinessOnboardingStateProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 */
                function BusinessOnboardingStateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessOnboardingStateProto createdFirstCalendarAppt.
                 * @member {boolean} createdFirstCalendarAppt
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 */
                BusinessOnboardingStateProto.prototype.createdFirstCalendarAppt = false;

                /**
                 * Creates a new BusinessOnboardingStateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto instance
                 */
                BusinessOnboardingStateProto.create = function create(properties) {
                    return new BusinessOnboardingStateProto(properties);
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.createdFirstCalendarAppt != null && Object.hasOwnProperty.call(message, "createdFirstCalendarAppt"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.createdFirstCalendarAppt);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.createdFirstCalendarAppt = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessOnboardingStateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessOnboardingStateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        if (typeof message.createdFirstCalendarAppt !== "boolean")
                            return "createdFirstCalendarAppt: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessOnboardingStateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 */
                BusinessOnboardingStateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessOnboardingStateProto)
                        return object;
                    var message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    if (object.createdFirstCalendarAppt != null)
                        message.createdFirstCalendarAppt = Boolean(object.createdFirstCalendarAppt);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessOnboardingStateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.BusinessOnboardingStateProto} message BusinessOnboardingStateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessOnboardingStateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.createdFirstCalendarAppt = false;
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        object.createdFirstCalendarAppt = message.createdFirstCalendarAppt;
                    return object;
                };

                /**
                 * Converts this BusinessOnboardingStateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessOnboardingStateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessOnboardingStateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessOnboardingStateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessOnboardingStateProto";
                };

                return BusinessOnboardingStateProto;
            })();

            proto.LocalTimeProto = (function() {

                /**
                 * Properties of a LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalTimeProto
                 * @property {number|null} [hour] LocalTimeProto hour
                 * @property {number|null} [minute] LocalTimeProto minute
                 */

                /**
                 * Constructs a new LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalTimeProto.
                 * @implements ILocalTimeProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 */
                function LocalTimeProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalTimeProto hour.
                 * @member {number} hour
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.hour = 0;

                /**
                 * LocalTimeProto minute.
                 * @member {number} minute
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.minute = 0;

                /**
                 * Creates a new LocalTimeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto instance
                 */
                LocalTimeProto.create = function create(properties) {
                    return new LocalTimeProto(properties);
                };

                /**
                 * Encodes the specified LocalTimeProto message. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hour);
                    if (message.minute != null && Object.hasOwnProperty.call(message, "minute"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minute);
                    return writer;
                };

                /**
                 * Encodes the specified LocalTimeProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalTimeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.hour = reader.int32();
                                break;
                            }
                        case 2: {
                                message.minute = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalTimeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalTimeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        if (!$util.isInteger(message.hour))
                            return "hour: integer expected";
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        if (!$util.isInteger(message.minute))
                            return "minute: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalTimeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 */
                LocalTimeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalTimeProto)
                        return object;
                    var message = new $root.space.kenko.proto.LocalTimeProto();
                    if (object.hour != null)
                        message.hour = object.hour | 0;
                    if (object.minute != null)
                        message.minute = object.minute | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalTimeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.LocalTimeProto} message LocalTimeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalTimeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.hour = 0;
                        object.minute = 0;
                    }
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        object.hour = message.hour;
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        object.minute = message.minute;
                    return object;
                };

                /**
                 * Converts this LocalTimeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalTimeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalTimeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalTimeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalTimeProto";
                };

                return LocalTimeProto;
            })();

            proto.LocalDateProto = (function() {

                /**
                 * Properties of a LocalDateProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalDateProto
                 * @property {number|null} [year] LocalDateProto year
                 * @property {number|null} [month] LocalDateProto month
                 * @property {number|null} [date] LocalDateProto date
                 */

                /**
                 * Constructs a new LocalDateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalDateProto.
                 * @implements ILocalDateProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 */
                function LocalDateProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalDateProto year.
                 * @member {number} year
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.year = 0;

                /**
                 * LocalDateProto month.
                 * @member {number} month
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.month = 0;

                /**
                 * LocalDateProto date.
                 * @member {number} date
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.date = 0;

                /**
                 * Creates a new LocalDateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto instance
                 */
                LocalDateProto.create = function create(properties) {
                    return new LocalDateProto(properties);
                };

                /**
                 * Encodes the specified LocalDateProto message. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                    if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.date);
                    return writer;
                };

                /**
                 * Encodes the specified LocalDateProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalDateProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                message.month = reader.int32();
                                break;
                            }
                        case 3: {
                                message.date = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalDateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalDateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        if (!$util.isInteger(message.month))
                            return "month: integer expected";
                    if (message.date != null && message.hasOwnProperty("date"))
                        if (!$util.isInteger(message.date))
                            return "date: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalDateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 */
                LocalDateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalDateProto)
                        return object;
                    var message = new $root.space.kenko.proto.LocalDateProto();
                    if (object.year != null)
                        message.year = object.year | 0;
                    if (object.month != null)
                        message.month = object.month | 0;
                    if (object.date != null)
                        message.date = object.date | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalDateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.LocalDateProto} message LocalDateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalDateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.year = 0;
                        object.month = 0;
                        object.date = 0;
                    }
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = message.month;
                    if (message.date != null && message.hasOwnProperty("date"))
                        object.date = message.date;
                    return object;
                };

                /**
                 * Converts this LocalDateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalDateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalDateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalDateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalDateProto";
                };

                return LocalDateProto;
            })();

            proto.PriceProto = (function() {

                /**
                 * Properties of a PriceProto.
                 * @memberof space.kenko.proto
                 * @interface IPriceProto
                 * @property {number|Long|null} [amount] PriceProto amount
                 * @property {string|null} [currencyCode] PriceProto currencyCode
                 */

                /**
                 * Constructs a new PriceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PriceProto.
                 * @implements IPriceProto
                 * @constructor
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 */
                function PriceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PriceProto amount.
                 * @member {number|Long} amount
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PriceProto currencyCode.
                 * @member {string} currencyCode
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.currencyCode = "";

                /**
                 * Creates a new PriceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PriceProto} PriceProto instance
                 */
                PriceProto.create = function create(properties) {
                    return new PriceProto(properties);
                };

                /**
                 * Encodes the specified PriceProto message. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.amount);
                    if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyCode);
                    return writer;
                };

                /**
                 * Encodes the specified PriceProto message, length delimited. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PriceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int64();
                                break;
                            }
                        case 2: {
                                message.currencyCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PriceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PriceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                            return "amount: integer|Long expected";
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        if (!$util.isString(message.currencyCode))
                            return "currencyCode: string expected";
                    return null;
                };

                /**
                 * Creates a PriceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 */
                PriceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PriceProto)
                        return object;
                    var message = new $root.space.kenko.proto.PriceProto();
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
                    if (object.currencyCode != null)
                        message.currencyCode = String(object.currencyCode);
                    return message;
                };

                /**
                 * Creates a plain object from a PriceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.PriceProto} message PriceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PriceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                        object.currencyCode = "";
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        object.currencyCode = message.currencyCode;
                    return object;
                };

                /**
                 * Converts this PriceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PriceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PriceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PriceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PriceProto";
                };

                return PriceProto;
            })();

            proto.ErrorProto = (function() {

                /**
                 * Properties of an ErrorProto.
                 * @memberof space.kenko.proto
                 * @interface IErrorProto
                 * @property {string|null} [path] ErrorProto path
                 * @property {string|null} [error] ErrorProto error
                 */

                /**
                 * Constructs a new ErrorProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ErrorProto.
                 * @implements IErrorProto
                 * @constructor
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 */
                function ErrorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorProto path.
                 * @member {string} path
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.path = "";

                /**
                 * ErrorProto error.
                 * @member {string} error
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.error = "";

                /**
                 * Creates a new ErrorProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto instance
                 */
                ErrorProto.create = function create(properties) {
                    return new ErrorProto(properties);
                };

                /**
                 * Encodes the specified ErrorProto message. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorProto message, length delimited. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ErrorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.path = reader.string();
                                break;
                            }
                        case 2: {
                                message.error = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path"))
                        if (!$util.isString(message.path))
                            return "path: string expected";
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    return null;
                };

                /**
                 * Creates an ErrorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 */
                ErrorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ErrorProto)
                        return object;
                    var message = new $root.space.kenko.proto.ErrorProto();
                    if (object.path != null)
                        message.path = String(object.path);
                    if (object.error != null)
                        message.error = String(object.error);
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.ErrorProto} message ErrorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.path = "";
                        object.error = "";
                    }
                    if (message.path != null && message.hasOwnProperty("path"))
                        object.path = message.path;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    return object;
                };

                /**
                 * Converts this ErrorProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ErrorProto";
                };

                return ErrorProto;
            })();

            proto.SystemNoteProto = (function() {

                /**
                 * Properties of a SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @interface ISystemNoteProto
                 * @property {string|null} [note] SystemNoteProto note
                 * @property {number|Long|null} [timestamp] SystemNoteProto timestamp
                 * @property {space.kenko.proto.ILoginProto|null} [loggedInUser] SystemNoteProto loggedInUser
                 */

                /**
                 * Constructs a new SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SystemNoteProto.
                 * @implements ISystemNoteProto
                 * @constructor
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 */
                function SystemNoteProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemNoteProto note.
                 * @member {string} note
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.note = "";

                /**
                 * SystemNoteProto timestamp.
                 * @member {number|Long} timestamp
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * SystemNoteProto loggedInUser.
                 * @member {space.kenko.proto.ILoginProto|null|undefined} loggedInUser
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.loggedInUser = null;

                /**
                 * Creates a new SystemNoteProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto instance
                 */
                SystemNoteProto.create = function create(properties) {
                    return new SystemNoteProto(properties);
                };

                /**
                 * Encodes the specified SystemNoteProto message. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.note);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
                    if (message.loggedInUser != null && Object.hasOwnProperty.call(message, "loggedInUser"))
                        $root.space.kenko.proto.LoginProto.encode(message.loggedInUser, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemNoteProto message, length delimited. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SystemNoteProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.note = reader.string();
                                break;
                            }
                        case 2: {
                                message.timestamp = reader.int64();
                                break;
                            }
                        case 3: {
                                message.loggedInUser = $root.space.kenko.proto.LoginProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemNoteProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemNoteProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.note != null && message.hasOwnProperty("note"))
                        if (!$util.isString(message.note))
                            return "note: string expected";
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                            return "timestamp: integer|Long expected";
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser")) {
                        var error = $root.space.kenko.proto.LoginProto.verify(message.loggedInUser);
                        if (error)
                            return "loggedInUser." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemNoteProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 */
                SystemNoteProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SystemNoteProto)
                        return object;
                    var message = new $root.space.kenko.proto.SystemNoteProto();
                    if (object.note != null)
                        message.note = String(object.note);
                    if (object.timestamp != null)
                        if ($util.Long)
                            (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                        else if (typeof object.timestamp === "string")
                            message.timestamp = parseInt(object.timestamp, 10);
                        else if (typeof object.timestamp === "number")
                            message.timestamp = object.timestamp;
                        else if (typeof object.timestamp === "object")
                            message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                    if (object.loggedInUser != null) {
                        if (typeof object.loggedInUser !== "object")
                            throw TypeError(".space.kenko.proto.SystemNoteProto.loggedInUser: object expected");
                        message.loggedInUser = $root.space.kenko.proto.LoginProto.fromObject(object.loggedInUser);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemNoteProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.SystemNoteProto} message SystemNoteProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemNoteProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.note = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.timestamp = options.longs === String ? "0" : 0;
                        object.loggedInUser = null;
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = message.note;
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (typeof message.timestamp === "number")
                            object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                        else
                            object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser"))
                        object.loggedInUser = $root.space.kenko.proto.LoginProto.toObject(message.loggedInUser, options);
                    return object;
                };

                /**
                 * Converts this SystemNoteProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemNoteProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemNoteProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemNoteProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SystemNoteProto";
                };

                return SystemNoteProto;
            })();

            proto.LoginProto = (function() {

                /**
                 * Properties of a LoginProto.
                 * @memberof space.kenko.proto
                 * @interface ILoginProto
                 * @property {string|null} [loginId] LoginProto loginId
                 * @property {string|null} [loginName] LoginProto loginName
                 * @property {string|null} [loginEmail] LoginProto loginEmail
                 */

                /**
                 * Constructs a new LoginProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LoginProto.
                 * @implements ILoginProto
                 * @constructor
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 */
                function LoginProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LoginProto loginId.
                 * @member {string} loginId
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginId = "";

                /**
                 * LoginProto loginName.
                 * @member {string} loginName
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginName = "";

                /**
                 * LoginProto loginEmail.
                 * @member {string} loginEmail
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginEmail = "";

                /**
                 * Creates a new LoginProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LoginProto} LoginProto instance
                 */
                LoginProto.create = function create(properties) {
                    return new LoginProto(properties);
                };

                /**
                 * Encodes the specified LoginProto message. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.loginId != null && Object.hasOwnProperty.call(message, "loginId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.loginId);
                    if (message.loginName != null && Object.hasOwnProperty.call(message, "loginName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.loginName);
                    if (message.loginEmail != null && Object.hasOwnProperty.call(message, "loginEmail"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.loginEmail);
                    return writer;
                };

                /**
                 * Encodes the specified LoginProto message, length delimited. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LoginProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.loginId = reader.string();
                                break;
                            }
                        case 2: {
                                message.loginName = reader.string();
                                break;
                            }
                        case 3: {
                                message.loginEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LoginProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LoginProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        if (!$util.isString(message.loginId))
                            return "loginId: string expected";
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        if (!$util.isString(message.loginName))
                            return "loginName: string expected";
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        if (!$util.isString(message.loginEmail))
                            return "loginEmail: string expected";
                    return null;
                };

                /**
                 * Creates a LoginProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 */
                LoginProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LoginProto)
                        return object;
                    var message = new $root.space.kenko.proto.LoginProto();
                    if (object.loginId != null)
                        message.loginId = String(object.loginId);
                    if (object.loginName != null)
                        message.loginName = String(object.loginName);
                    if (object.loginEmail != null)
                        message.loginEmail = String(object.loginEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a LoginProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.LoginProto} message LoginProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LoginProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.loginId = "";
                        object.loginName = "";
                        object.loginEmail = "";
                    }
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        object.loginId = message.loginId;
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        object.loginName = message.loginName;
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        object.loginEmail = message.loginEmail;
                    return object;
                };

                /**
                 * Converts this LoginProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LoginProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LoginProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LoginProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LoginProto";
                };

                return LoginProto;
            })();

            proto.EmailProto = (function() {

                /**
                 * Properties of an EmailProto.
                 * @memberof space.kenko.proto
                 * @interface IEmailProto
                 * @property {string|null} [email] EmailProto email
                 * @property {boolean|null} [isVerified] EmailProto isVerified
                 */

                /**
                 * Constructs a new EmailProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EmailProto.
                 * @implements IEmailProto
                 * @constructor
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 */
                function EmailProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EmailProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.email = "";

                /**
                 * EmailProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.isVerified = false;

                /**
                 * Creates a new EmailProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EmailProto} EmailProto instance
                 */
                EmailProto.create = function create(properties) {
                    return new EmailProto(properties);
                };

                /**
                 * Encodes the specified EmailProto message. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified EmailProto message, length delimited. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EmailProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EmailProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmailProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates an EmailProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 */
                EmailProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EmailProto)
                        return object;
                    var message = new $root.space.kenko.proto.EmailProto();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from an EmailProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.EmailProto} message EmailProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmailProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.isVerified = false;
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this EmailProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmailProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EmailProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EmailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EmailProto";
                };

                return EmailProto;
            })();

            proto.PhoneProto = (function() {

                /**
                 * Properties of a PhoneProto.
                 * @memberof space.kenko.proto
                 * @interface IPhoneProto
                 * @property {string|null} [number] PhoneProto number
                 * @property {boolean|null} [isVerified] PhoneProto isVerified
                 */

                /**
                 * Constructs a new PhoneProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhoneProto.
                 * @implements IPhoneProto
                 * @constructor
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 */
                function PhoneProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhoneProto number.
                 * @member {string} number
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.number = "";

                /**
                 * PhoneProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.isVerified = false;

                /**
                 * Creates a new PhoneProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto instance
                 */
                PhoneProto.create = function create(properties) {
                    return new PhoneProto(properties);
                };

                /**
                 * Encodes the specified PhoneProto message. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.number);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified PhoneProto message, length delimited. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhoneProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.number = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhoneProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhoneProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isString(message.number))
                            return "number: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates a PhoneProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 */
                PhoneProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhoneProto)
                        return object;
                    var message = new $root.space.kenko.proto.PhoneProto();
                    if (object.number != null)
                        message.number = String(object.number);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from a PhoneProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.PhoneProto} message PhoneProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhoneProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.number = "";
                        object.isVerified = false;
                    }
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this PhoneProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhoneProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhoneProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhoneProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhoneProto";
                };

                return PhoneProto;
            })();

            proto.KensuExceptionProto = (function() {

                /**
                 * Properties of a KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @interface IKensuExceptionProto
                 * @property {string|null} [message] KensuExceptionProto message
                 * @property {Array.<space.kenko.proto.IErrorProto>|null} [fieldErrors] KensuExceptionProto fieldErrors
                 */

                /**
                 * Constructs a new KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a KensuExceptionProto.
                 * @implements IKensuExceptionProto
                 * @constructor
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 */
                function KensuExceptionProto(properties) {
                    this.fieldErrors = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * KensuExceptionProto message.
                 * @member {string} message
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.message = "";

                /**
                 * KensuExceptionProto fieldErrors.
                 * @member {Array.<space.kenko.proto.IErrorProto>} fieldErrors
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.fieldErrors = $util.emptyArray;

                /**
                 * Creates a new KensuExceptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto instance
                 */
                KensuExceptionProto.create = function create(properties) {
                    return new KensuExceptionProto(properties);
                };

                /**
                 * Encodes the specified KensuExceptionProto message. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                    if (message.fieldErrors != null && message.fieldErrors.length)
                        for (var i = 0; i < message.fieldErrors.length; ++i)
                            $root.space.kenko.proto.ErrorProto.encode(message.fieldErrors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified KensuExceptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.KensuExceptionProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.message = reader.string();
                                break;
                            }
                        case 2: {
                                if (!(message.fieldErrors && message.fieldErrors.length))
                                    message.fieldErrors = [];
                                message.fieldErrors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a KensuExceptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                KensuExceptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.fieldErrors != null && message.hasOwnProperty("fieldErrors")) {
                        if (!Array.isArray(message.fieldErrors))
                            return "fieldErrors: array expected";
                        for (var i = 0; i < message.fieldErrors.length; ++i) {
                            var error = $root.space.kenko.proto.ErrorProto.verify(message.fieldErrors[i]);
                            if (error)
                                return "fieldErrors." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a KensuExceptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 */
                KensuExceptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.KensuExceptionProto)
                        return object;
                    var message = new $root.space.kenko.proto.KensuExceptionProto();
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.fieldErrors) {
                        if (!Array.isArray(object.fieldErrors))
                            throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: array expected");
                        message.fieldErrors = [];
                        for (var i = 0; i < object.fieldErrors.length; ++i) {
                            if (typeof object.fieldErrors[i] !== "object")
                                throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: object expected");
                            message.fieldErrors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.fieldErrors[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a KensuExceptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.KensuExceptionProto} message KensuExceptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                KensuExceptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.fieldErrors = [];
                    if (options.defaults)
                        object.message = "";
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    if (message.fieldErrors && message.fieldErrors.length) {
                        object.fieldErrors = [];
                        for (var j = 0; j < message.fieldErrors.length; ++j)
                            object.fieldErrors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.fieldErrors[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this KensuExceptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                KensuExceptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for KensuExceptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                KensuExceptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.KensuExceptionProto";
                };

                return KensuExceptionProto;
            })();

            /**
             * ContactMethodType enum.
             * @name space.kenko.proto.ContactMethodType
             * @enum {number}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} EMAIL=1 EMAIL value
             * @property {number} MOBILE_PHONE=2 MOBILE_PHONE value
             */
            proto.ContactMethodType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "EMAIL"] = 1;
                values[valuesById[2] = "MOBILE_PHONE"] = 2;
                return values;
            })();

            proto.ContactMethodProto = (function() {

                /**
                 * Properties of a ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IContactMethodProto
                 * @property {space.kenko.proto.ContactMethodType|null} [type] ContactMethodProto type
                 * @property {string|null} [address] ContactMethodProto address
                 */

                /**
                 * Constructs a new ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ContactMethodProto.
                 * @implements IContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 */
                function ContactMethodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ContactMethodProto type.
                 * @member {space.kenko.proto.ContactMethodType} type
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.type = 0;

                /**
                 * ContactMethodProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.address = "";

                /**
                 * Creates a new ContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto instance
                 */
                ContactMethodProto.create = function create(properties) {
                    return new ContactMethodProto(properties);
                };

                /**
                 * Encodes the specified ContactMethodProto message. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.address);
                    return writer;
                };

                /**
                 * Encodes the specified ContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ContactMethodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.address = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    return null;
                };

                /**
                 * Creates a ContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 */
                ContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ContactMethodProto)
                        return object;
                    var message = new $root.space.kenko.proto.ContactMethodProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "EMAIL":
                    case 1:
                        message.type = 1;
                        break;
                    case "MOBILE_PHONE":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.address != null)
                        message.address = String(object.address);
                    return message;
                };

                /**
                 * Creates a plain object from a ContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.ContactMethodProto} message ContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "UNKNOWN" : 0;
                        object.address = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.ContactMethodType[message.type] === undefined ? message.type : $root.space.kenko.proto.ContactMethodType[message.type] : message.type;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    return object;
                };

                /**
                 * Converts this ContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ContactMethodProto";
                };

                return ContactMethodProto;
            })();

            proto.VerifiedContactMethodProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodProto
                 * @property {space.kenko.proto.IContactMethodProto|null} [contactMethod] VerifiedContactMethodProto contactMethod
                 * @property {number|Long|null} [verificationTimeMs] VerifiedContactMethodProto verificationTimeMs
                 */

                /**
                 * Constructs a new VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodProto.
                 * @implements IVerifiedContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodProto contactMethod.
                 * @member {space.kenko.proto.IContactMethodProto|null|undefined} contactMethod
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.contactMethod = null;

                /**
                 * VerifiedContactMethodProto verificationTimeMs.
                 * @member {number|Long} verificationTimeMs
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.verificationTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new VerifiedContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto instance
                 */
                VerifiedContactMethodProto.create = function create(properties) {
                    return new VerifiedContactMethodProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethod != null && Object.hasOwnProperty.call(message, "contactMethod"))
                        $root.space.kenko.proto.ContactMethodProto.encode(message.contactMethod, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationTimeMs != null && Object.hasOwnProperty.call(message, "verificationTimeMs"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.verificationTimeMs);
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.contactMethod = $root.space.kenko.proto.ContactMethodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationTimeMs = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod")) {
                        var error = $root.space.kenko.proto.ContactMethodProto.verify(message.contactMethod);
                        if (error)
                            return "contactMethod." + error;
                    }
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (!$util.isInteger(message.verificationTimeMs) && !(message.verificationTimeMs && $util.isInteger(message.verificationTimeMs.low) && $util.isInteger(message.verificationTimeMs.high)))
                            return "verificationTimeMs: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 */
                VerifiedContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodProto)
                        return object;
                    var message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    if (object.contactMethod != null) {
                        if (typeof object.contactMethod !== "object")
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodProto.contactMethod: object expected");
                        message.contactMethod = $root.space.kenko.proto.ContactMethodProto.fromObject(object.contactMethod);
                    }
                    if (object.verificationTimeMs != null)
                        if ($util.Long)
                            (message.verificationTimeMs = $util.Long.fromValue(object.verificationTimeMs)).unsigned = false;
                        else if (typeof object.verificationTimeMs === "string")
                            message.verificationTimeMs = parseInt(object.verificationTimeMs, 10);
                        else if (typeof object.verificationTimeMs === "number")
                            message.verificationTimeMs = object.verificationTimeMs;
                        else if (typeof object.verificationTimeMs === "object")
                            message.verificationTimeMs = new $util.LongBits(object.verificationTimeMs.low >>> 0, object.verificationTimeMs.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodProto} message VerifiedContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.contactMethod = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.verificationTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.verificationTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod"))
                        object.contactMethod = $root.space.kenko.proto.ContactMethodProto.toObject(message.contactMethod, options);
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (typeof message.verificationTimeMs === "number")
                            object.verificationTimeMs = options.longs === String ? String(message.verificationTimeMs) : message.verificationTimeMs;
                        else
                            object.verificationTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.verificationTimeMs) : options.longs === Number ? new $util.LongBits(message.verificationTimeMs.low >>> 0, message.verificationTimeMs.high >>> 0).toNumber() : message.verificationTimeMs;
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodProto";
                };

                return VerifiedContactMethodProto;
            })();

            proto.VerifiedContactMethodsProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodsProto
                 * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [contactMethods] VerifiedContactMethodsProto contactMethods
                 */

                /**
                 * Constructs a new VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodsProto.
                 * @implements IVerifiedContactMethodsProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodsProto(properties) {
                    this.contactMethods = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodsProto contactMethods.
                 * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} contactMethods
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 */
                VerifiedContactMethodsProto.prototype.contactMethods = $util.emptyArray;

                /**
                 * Creates a new VerifiedContactMethodsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto instance
                 */
                VerifiedContactMethodsProto.create = function create(properties) {
                    return new VerifiedContactMethodsProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethods != null && message.contactMethods.length)
                        for (var i = 0; i < message.contactMethods.length; ++i)
                            $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.contactMethods[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.contactMethods && message.contactMethods.length))
                                    message.contactMethods = [];
                                message.contactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethods != null && message.hasOwnProperty("contactMethods")) {
                        if (!Array.isArray(message.contactMethods))
                            return "contactMethods: array expected";
                        for (var i = 0; i < message.contactMethods.length; ++i) {
                            var error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.contactMethods[i]);
                            if (error)
                                return "contactMethods." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 */
                VerifiedContactMethodsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodsProto)
                        return object;
                    var message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    if (object.contactMethods) {
                        if (!Array.isArray(object.contactMethods))
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: array expected");
                        message.contactMethods = [];
                        for (var i = 0; i < object.contactMethods.length; ++i) {
                            if (typeof object.contactMethods[i] !== "object")
                                throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: object expected");
                            message.contactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.contactMethods[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodsProto} message VerifiedContactMethodsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.contactMethods = [];
                    if (message.contactMethods && message.contactMethods.length) {
                        object.contactMethods = [];
                        for (var j = 0; j < message.contactMethods.length; ++j)
                            object.contactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.contactMethods[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodsProto";
                };

                return VerifiedContactMethodsProto;
            })();

            proto.PaymentPolicyProto = (function() {

                /**
                 * Properties of a PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPaymentPolicyProto
                 * @property {space.kenko.proto.IPrepaidPaymentPolicyProto|null} [prepaid] PaymentPolicyProto prepaid
                 * @property {space.kenko.proto.IPostpaidPaymentPolicyProto|null} [postpaid] PaymentPolicyProto postpaid
                 */

                /**
                 * Constructs a new PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PaymentPolicyProto.
                 * @implements IPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 */
                function PaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PaymentPolicyProto prepaid.
                 * @member {space.kenko.proto.IPrepaidPaymentPolicyProto|null|undefined} prepaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.prepaid = null;

                /**
                 * PaymentPolicyProto postpaid.
                 * @member {space.kenko.proto.IPostpaidPaymentPolicyProto|null|undefined} postpaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.postpaid = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * PaymentPolicyProto PaymentPolicy.
                 * @member {"prepaid"|"postpaid"|undefined} PaymentPolicy
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                Object.defineProperty(PaymentPolicyProto.prototype, "PaymentPolicy", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaid", "postpaid"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto instance
                 */
                PaymentPolicyProto.create = function create(properties) {
                    return new PaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaid != null && Object.hasOwnProperty.call(message, "prepaid"))
                        $root.space.kenko.proto.PrepaidPaymentPolicyProto.encode(message.prepaid, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.postpaid != null && Object.hasOwnProperty.call(message, "postpaid"))
                        $root.space.kenko.proto.PostpaidPaymentPolicyProto.encode(message.postpaid, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        properties.PaymentPolicy = 1;
                        {
                            var error = $root.space.kenko.proto.PrepaidPaymentPolicyProto.verify(message.prepaid);
                            if (error)
                                return "prepaid." + error;
                        }
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        if (properties.PaymentPolicy === 1)
                            return "PaymentPolicy: multiple values";
                        properties.PaymentPolicy = 1;
                        {
                            var error = $root.space.kenko.proto.PostpaidPaymentPolicyProto.verify(message.postpaid);
                            if (error)
                                return "postpaid." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 */
                PaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PaymentPolicyProto();
                    if (object.prepaid != null) {
                        if (typeof object.prepaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.prepaid: object expected");
                        message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.fromObject(object.prepaid);
                    }
                    if (object.postpaid != null) {
                        if (typeof object.postpaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.postpaid: object expected");
                        message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.fromObject(object.postpaid);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PaymentPolicyProto} message PaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        object.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.toObject(message.prepaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "prepaid";
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        object.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.toObject(message.postpaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "postpaid";
                    }
                    return object;
                };

                /**
                 * Converts this PaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PaymentPolicyProto";
                };

                return PaymentPolicyProto;
            })();

            proto.PrepaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPrepaidPaymentPolicyProto
                 * @property {string|null} [priceCategoryId] PrepaidPaymentPolicyProto priceCategoryId
                 * @property {space.kenko.proto.IPriceProto|null} [price] PrepaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PrepaidPaymentPolicyProto.
                 * @implements IPrepaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PrepaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PrepaidPaymentPolicyProto priceCategoryId.
                 * @member {string} priceCategoryId
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.priceCategoryId = "";

                /**
                 * PrepaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PrepaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto instance
                 */
                PrepaidPaymentPolicyProto.create = function create(properties) {
                    return new PrepaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategoryId != null && Object.hasOwnProperty.call(message, "priceCategoryId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.priceCategoryId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.priceCategoryId = reader.string();
                                break;
                            }
                        case 2: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PrepaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PrepaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        if (!$util.isString(message.priceCategoryId))
                            return "priceCategoryId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PrepaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 */
                PrepaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PrepaidPaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    if (object.priceCategoryId != null)
                        message.priceCategoryId = String(object.priceCategoryId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PrepaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PrepaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PrepaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.priceCategoryId = "";
                        object.price = null;
                    }
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        object.priceCategoryId = message.priceCategoryId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PrepaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PrepaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PrepaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PrepaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PrepaidPaymentPolicyProto";
                };

                return PrepaidPaymentPolicyProto;
            })();

            proto.PostpaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidPaymentPolicyProto
                 * @property {space.kenko.proto.IPriceProto|null} [price] PostpaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidPaymentPolicyProto.
                 * @implements IPostpaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PostpaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PostpaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 */
                PostpaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PostpaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto instance
                 */
                PostpaidPaymentPolicyProto.create = function create(properties) {
                    return new PostpaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PostpaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 */
                PostpaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidPaymentPolicyProto)
                        return object;
                    var message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PostpaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PostpaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.price = null;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PostpaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidPaymentPolicyProto";
                };

                return PostpaidPaymentPolicyProto;
            })();

            proto.ApiPaymentProto = (function() {

                /**
                 * Properties of an ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @interface IApiPaymentProto
                 * @property {string|null} [paymentId] ApiPaymentProto paymentId
                 * @property {string|null} [userId] ApiPaymentProto userId
                 * @property {string|null} [userName] ApiPaymentProto userName
                 * @property {string|null} [businessId] ApiPaymentProto businessId
                 * @property {space.kenko.proto.IPriceProto|null} [price] ApiPaymentProto price
                 * @property {number|Long|null} [createdTimestampMs] ApiPaymentProto createdTimestampMs
                 * @property {string|null} [status] ApiPaymentProto status
                 * @property {string|null} [purchasedThingName] ApiPaymentProto purchasedThingName
                 */

                /**
                 * Constructs a new ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ApiPaymentProto.
                 * @implements IApiPaymentProto
                 * @constructor
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 */
                function ApiPaymentProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ApiPaymentProto paymentId.
                 * @member {string} paymentId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.paymentId = "";

                /**
                 * ApiPaymentProto userId.
                 * @member {string} userId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userId = "";

                /**
                 * ApiPaymentProto userName.
                 * @member {string} userName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userName = "";

                /**
                 * ApiPaymentProto businessId.
                 * @member {string} businessId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.businessId = "";

                /**
                 * ApiPaymentProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.price = null;

                /**
                 * ApiPaymentProto createdTimestampMs.
                 * @member {number|Long} createdTimestampMs
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiPaymentProto status.
                 * @member {string} status
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.status = "";

                /**
                 * ApiPaymentProto purchasedThingName.
                 * @member {string} purchasedThingName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.purchasedThingName = "";

                /**
                 * Creates a new ApiPaymentProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto instance
                 */
                ApiPaymentProto.create = function create(properties) {
                    return new ApiPaymentProto(properties);
                };

                /**
                 * Encodes the specified ApiPaymentProto message. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paymentId != null && Object.hasOwnProperty.call(message, "paymentId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.paymentId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.userName);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.businessId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdTimestampMs);
                    if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                    if (message.purchasedThingName != null && Object.hasOwnProperty.call(message, "purchasedThingName"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.purchasedThingName);
                    return writer;
                };

                /**
                 * Encodes the specified ApiPaymentProto message, length delimited. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ApiPaymentProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.paymentId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.userName = reader.string();
                                break;
                            }
                        case 4: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.createdTimestampMs = reader.int64();
                                break;
                            }
                        case 7: {
                                message.status = reader.string();
                                break;
                            }
                        case 8: {
                                message.purchasedThingName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ApiPaymentProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ApiPaymentProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        if (!$util.isString(message.paymentId))
                            return "paymentId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        if (!$util.isString(message.userName))
                            return "userName: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                            return "createdTimestampMs: integer|Long expected";
                    if (message.status != null && message.hasOwnProperty("status"))
                        if (!$util.isString(message.status))
                            return "status: string expected";
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        if (!$util.isString(message.purchasedThingName))
                            return "purchasedThingName: string expected";
                    return null;
                };

                /**
                 * Creates an ApiPaymentProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 */
                ApiPaymentProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ApiPaymentProto)
                        return object;
                    var message = new $root.space.kenko.proto.ApiPaymentProto();
                    if (object.paymentId != null)
                        message.paymentId = String(object.paymentId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.userName != null)
                        message.userName = String(object.userName);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.ApiPaymentProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.createdTimestampMs != null)
                        if ($util.Long)
                            (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
                        else if (typeof object.createdTimestampMs === "string")
                            message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
                        else if (typeof object.createdTimestampMs === "number")
                            message.createdTimestampMs = object.createdTimestampMs;
                        else if (typeof object.createdTimestampMs === "object")
                            message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
                    if (object.status != null)
                        message.status = String(object.status);
                    if (object.purchasedThingName != null)
                        message.purchasedThingName = String(object.purchasedThingName);
                    return message;
                };

                /**
                 * Creates a plain object from an ApiPaymentProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.ApiPaymentProto} message ApiPaymentProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ApiPaymentProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.paymentId = "";
                        object.userId = "";
                        object.userName = "";
                        object.businessId = "";
                        object.price = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createdTimestampMs = options.longs === String ? "0" : 0;
                        object.status = "";
                        object.purchasedThingName = "";
                    }
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        object.paymentId = message.paymentId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        object.userName = message.userName;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (typeof message.createdTimestampMs === "number")
                            object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
                        else
                            object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
                    if (message.status != null && message.hasOwnProperty("status"))
                        object.status = message.status;
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        object.purchasedThingName = message.purchasedThingName;
                    return object;
                };

                /**
                 * Converts this ApiPaymentProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ApiPaymentProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ApiPaymentProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ApiPaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ApiPaymentProto";
                };

                return ApiPaymentProto;
            })();

            proto.ApiBookingProto = (function() {

                /**
                 * Properties of an ApiBookingProto.
                 * @memberof space.kenko.proto
                 * @interface IApiBookingProto
                 * @property {string|null} [bookingId] ApiBookingProto bookingId
                 * @property {string|null} [userId] ApiBookingProto userId
                 * @property {string|null} [businessId] ApiBookingProto businessId
                 * @property {number|Long|null} [startTimeMs] ApiBookingProto startTimeMs
                 * @property {number|Long|null} [endTimeMs] ApiBookingProto endTimeMs
                 * @property {string|null} [timeZoneId] ApiBookingProto timeZoneId
                 * @property {string|null} [eventInstanceId] ApiBookingProto eventInstanceId
                 * @property {space.kenko.proto.IBookingDetailsProto|null} [details] ApiBookingProto details
                 */

                /**
                 * Constructs a new ApiBookingProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ApiBookingProto.
                 * @implements IApiBookingProto
                 * @constructor
                 * @param {space.kenko.proto.IApiBookingProto=} [properties] Properties to set
                 */
                function ApiBookingProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ApiBookingProto bookingId.
                 * @member {string} bookingId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.bookingId = "";

                /**
                 * ApiBookingProto userId.
                 * @member {string} userId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.userId = "";

                /**
                 * ApiBookingProto businessId.
                 * @member {string} businessId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.businessId = "";

                /**
                 * ApiBookingProto startTimeMs.
                 * @member {number|Long} startTimeMs
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.startTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiBookingProto endTimeMs.
                 * @member {number|Long} endTimeMs
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.endTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiBookingProto timeZoneId.
                 * @member {string} timeZoneId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.timeZoneId = "";

                /**
                 * ApiBookingProto eventInstanceId.
                 * @member {string} eventInstanceId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.eventInstanceId = "";

                /**
                 * ApiBookingProto details.
                 * @member {space.kenko.proto.IBookingDetailsProto|null|undefined} details
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.details = null;

                /**
                 * Creates a new ApiBookingProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto instance
                 */
                ApiBookingProto.create = function create(properties) {
                    return new ApiBookingProto(properties);
                };

                /**
                 * Encodes the specified ApiBookingProto message. Does not implicitly {@link space.kenko.proto.ApiBookingProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto} message ApiBookingProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiBookingProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    if (message.startTimeMs != null && Object.hasOwnProperty.call(message, "startTimeMs"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.startTimeMs);
                    if (message.endTimeMs != null && Object.hasOwnProperty.call(message, "endTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.endTimeMs);
                    if (message.timeZoneId != null && Object.hasOwnProperty.call(message, "timeZoneId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.timeZoneId);
                    if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.eventInstanceId);
                    if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                        $root.space.kenko.proto.BookingDetailsProto.encode(message.details, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ApiBookingProto message, length delimited. Does not implicitly {@link space.kenko.proto.ApiBookingProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto} message ApiBookingProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiBookingProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ApiBookingProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiBookingProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ApiBookingProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.bookingId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 5: {
                                message.startTimeMs = reader.int64();
                                break;
                            }
                        case 6: {
                                message.endTimeMs = reader.int64();
                                break;
                            }
                        case 7: {
                                message.timeZoneId = reader.string();
                                break;
                            }
                        case 8: {
                                message.eventInstanceId = reader.string();
                                break;
                            }
                        case 9: {
                                message.details = $root.space.kenko.proto.BookingDetailsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ApiBookingProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiBookingProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ApiBookingProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ApiBookingProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                        if (!$util.isString(message.bookingId))
                            return "bookingId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                        if (!$util.isInteger(message.startTimeMs) && !(message.startTimeMs && $util.isInteger(message.startTimeMs.low) && $util.isInteger(message.startTimeMs.high)))
                            return "startTimeMs: integer|Long expected";
                    if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                        if (!$util.isInteger(message.endTimeMs) && !(message.endTimeMs && $util.isInteger(message.endTimeMs.low) && $util.isInteger(message.endTimeMs.high)))
                            return "endTimeMs: integer|Long expected";
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        if (!$util.isString(message.timeZoneId))
                            return "timeZoneId: string expected";
                    if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
                        if (!$util.isString(message.eventInstanceId))
                            return "eventInstanceId: string expected";
                    if (message.details != null && message.hasOwnProperty("details")) {
                        var error = $root.space.kenko.proto.BookingDetailsProto.verify(message.details);
                        if (error)
                            return "details." + error;
                    }
                    return null;
                };

                /**
                 * Creates an ApiBookingProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 */
                ApiBookingProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ApiBookingProto)
                        return object;
                    var message = new $root.space.kenko.proto.ApiBookingProto();
                    if (object.bookingId != null)
                        message.bookingId = String(object.bookingId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.startTimeMs != null)
                        if ($util.Long)
                            (message.startTimeMs = $util.Long.fromValue(object.startTimeMs)).unsigned = false;
                        else if (typeof object.startTimeMs === "string")
                            message.startTimeMs = parseInt(object.startTimeMs, 10);
                        else if (typeof object.startTimeMs === "number")
                            message.startTimeMs = object.startTimeMs;
                        else if (typeof object.startTimeMs === "object")
                            message.startTimeMs = new $util.LongBits(object.startTimeMs.low >>> 0, object.startTimeMs.high >>> 0).toNumber();
                    if (object.endTimeMs != null)
                        if ($util.Long)
                            (message.endTimeMs = $util.Long.fromValue(object.endTimeMs)).unsigned = false;
                        else if (typeof object.endTimeMs === "string")
                            message.endTimeMs = parseInt(object.endTimeMs, 10);
                        else if (typeof object.endTimeMs === "number")
                            message.endTimeMs = object.endTimeMs;
                        else if (typeof object.endTimeMs === "object")
                            message.endTimeMs = new $util.LongBits(object.endTimeMs.low >>> 0, object.endTimeMs.high >>> 0).toNumber();
                    if (object.timeZoneId != null)
                        message.timeZoneId = String(object.timeZoneId);
                    if (object.eventInstanceId != null)
                        message.eventInstanceId = String(object.eventInstanceId);
                    if (object.details != null) {
                        if (typeof object.details !== "object")
                            throw TypeError(".space.kenko.proto.ApiBookingProto.details: object expected");
                        message.details = $root.space.kenko.proto.BookingDetailsProto.fromObject(object.details);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ApiBookingProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.ApiBookingProto} message ApiBookingProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ApiBookingProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.bookingId = "";
                        object.userId = "";
                        object.businessId = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.startTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.startTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.endTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.endTimeMs = options.longs === String ? "0" : 0;
                        object.timeZoneId = "";
                        object.eventInstanceId = "";
                        object.details = null;
                    }
                    if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                        object.bookingId = message.bookingId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                        if (typeof message.startTimeMs === "number")
                            object.startTimeMs = options.longs === String ? String(message.startTimeMs) : message.startTimeMs;
                        else
                            object.startTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeMs) : options.longs === Number ? new $util.LongBits(message.startTimeMs.low >>> 0, message.startTimeMs.high >>> 0).toNumber() : message.startTimeMs;
                    if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                        if (typeof message.endTimeMs === "number")
                            object.endTimeMs = options.longs === String ? String(message.endTimeMs) : message.endTimeMs;
                        else
                            object.endTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeMs) : options.longs === Number ? new $util.LongBits(message.endTimeMs.low >>> 0, message.endTimeMs.high >>> 0).toNumber() : message.endTimeMs;
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        object.timeZoneId = message.timeZoneId;
                    if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
                        object.eventInstanceId = message.eventInstanceId;
                    if (message.details != null && message.hasOwnProperty("details"))
                        object.details = $root.space.kenko.proto.BookingDetailsProto.toObject(message.details, options);
                    return object;
                };

                /**
                 * Converts this ApiBookingProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ApiBookingProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ApiBookingProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ApiBookingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ApiBookingProto";
                };

                return ApiBookingProto;
            })();

            proto.BookingDetailsProto = (function() {

                /**
                 * Properties of a BookingDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IBookingDetailsProto
                 * @property {space.kenko.proto.IBookedServiceProto|null} [service] BookingDetailsProto service
                 * @property {space.kenko.proto.IBookedClassProto|null} ["class"] BookingDetailsProto class
                 * @property {space.kenko.proto.IBookingPaymentProto|null} [paymentInfo] BookingDetailsProto paymentInfo
                 * @property {number|Long|null} [bookingTimestamp] BookingDetailsProto bookingTimestamp
                 * @property {string|null} [clientName] BookingDetailsProto clientName
                 * @property {string|null} [clientEmail] BookingDetailsProto clientEmail
                 * @property {boolean|null} [clientEmailVerified] BookingDetailsProto clientEmailVerified
                 * @property {string|null} [clientPhone] BookingDetailsProto clientPhone
                 * @property {boolean|null} [clientPhoneVerified] BookingDetailsProto clientPhoneVerified
                 * @property {Array.<space.kenko.proto.ISystemNoteProto>|null} [notes] BookingDetailsProto notes
                 */

                /**
                 * Constructs a new BookingDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingDetailsProto.
                 * @implements IBookingDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IBookingDetailsProto=} [properties] Properties to set
                 */
                function BookingDetailsProto(properties) {
                    this.notes = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingDetailsProto service.
                 * @member {space.kenko.proto.IBookedServiceProto|null|undefined} service
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.service = null;

                /**
                 * BookingDetailsProto class.
                 * @member {space.kenko.proto.IBookedClassProto|null|undefined} class
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype["class"] = null;

                /**
                 * BookingDetailsProto paymentInfo.
                 * @member {space.kenko.proto.IBookingPaymentProto|null|undefined} paymentInfo
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.paymentInfo = null;

                /**
                 * BookingDetailsProto bookingTimestamp.
                 * @member {number|Long} bookingTimestamp
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.bookingTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * BookingDetailsProto clientName.
                 * @member {string} clientName
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientName = "";

                /**
                 * BookingDetailsProto clientEmail.
                 * @member {string} clientEmail
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientEmail = "";

                /**
                 * BookingDetailsProto clientEmailVerified.
                 * @member {boolean} clientEmailVerified
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientEmailVerified = false;

                /**
                 * BookingDetailsProto clientPhone.
                 * @member {string} clientPhone
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientPhone = "";

                /**
                 * BookingDetailsProto clientPhoneVerified.
                 * @member {boolean} clientPhoneVerified
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientPhoneVerified = false;

                /**
                 * BookingDetailsProto notes.
                 * @member {Array.<space.kenko.proto.ISystemNoteProto>} notes
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.notes = $util.emptyArray;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BookingDetailsProto BookingType.
                 * @member {"service"|"class"|undefined} BookingType
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                Object.defineProperty(BookingDetailsProto.prototype, "BookingType", {
                    get: $util.oneOfGetter($oneOfFields = ["service", "class"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto instance
                 */
                BookingDetailsProto.create = function create(properties) {
                    return new BookingDetailsProto(properties);
                };

                /**
                 * Encodes the specified BookingDetailsProto message. Does not implicitly {@link space.kenko.proto.BookingDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto} message BookingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.service != null && Object.hasOwnProperty.call(message, "service"))
                        $root.space.kenko.proto.BookedServiceProto.encode(message.service, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message["class"] != null && Object.hasOwnProperty.call(message, "class"))
                        $root.space.kenko.proto.BookedClassProto.encode(message["class"], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.paymentInfo != null && Object.hasOwnProperty.call(message, "paymentInfo"))
                        $root.space.kenko.proto.BookingPaymentProto.encode(message.paymentInfo, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                    if (message.bookingTimestamp != null && Object.hasOwnProperty.call(message, "bookingTimestamp"))
                        writer.uint32(/* id 100, wireType 0 =*/800).int64(message.bookingTimestamp);
                    if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                        writer.uint32(/* id 101, wireType 2 =*/810).string(message.clientName);
                    if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                        writer.uint32(/* id 102, wireType 2 =*/818).string(message.clientEmail);
                    if (message.clientEmailVerified != null && Object.hasOwnProperty.call(message, "clientEmailVerified"))
                        writer.uint32(/* id 103, wireType 0 =*/824).bool(message.clientEmailVerified);
                    if (message.clientPhone != null && Object.hasOwnProperty.call(message, "clientPhone"))
                        writer.uint32(/* id 104, wireType 2 =*/834).string(message.clientPhone);
                    if (message.clientPhoneVerified != null && Object.hasOwnProperty.call(message, "clientPhoneVerified"))
                        writer.uint32(/* id 105, wireType 0 =*/840).bool(message.clientPhoneVerified);
                    if (message.notes != null && message.notes.length)
                        for (var i = 0; i < message.notes.length; ++i)
                            $root.space.kenko.proto.SystemNoteProto.encode(message.notes[i], writer.uint32(/* id 200, wireType 2 =*/1602).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookingDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto} message BookingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingDetailsProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.service = $root.space.kenko.proto.BookedServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message["class"] = $root.space.kenko.proto.BookedClassProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 50: {
                                message.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.bookingTimestamp = reader.int64();
                                break;
                            }
                        case 101: {
                                message.clientName = reader.string();
                                break;
                            }
                        case 102: {
                                message.clientEmail = reader.string();
                                break;
                            }
                        case 103: {
                                message.clientEmailVerified = reader.bool();
                                break;
                            }
                        case 104: {
                                message.clientPhone = reader.string();
                                break;
                            }
                        case 105: {
                                message.clientPhoneVerified = reader.bool();
                                break;
                            }
                        case 200: {
                                if (!(message.notes && message.notes.length))
                                    message.notes = [];
                                message.notes.push($root.space.kenko.proto.SystemNoteProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.service != null && message.hasOwnProperty("service")) {
                        properties.BookingType = 1;
                        {
                            var error = $root.space.kenko.proto.BookedServiceProto.verify(message.service);
                            if (error)
                                return "service." + error;
                        }
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        if (properties.BookingType === 1)
                            return "BookingType: multiple values";
                        properties.BookingType = 1;
                        {
                            var error = $root.space.kenko.proto.BookedClassProto.verify(message["class"]);
                            if (error)
                                return "class." + error;
                        }
                    }
                    if (message.paymentInfo != null && message.hasOwnProperty("paymentInfo")) {
                        var error = $root.space.kenko.proto.BookingPaymentProto.verify(message.paymentInfo);
                        if (error)
                            return "paymentInfo." + error;
                    }
                    if (message.bookingTimestamp != null && message.hasOwnProperty("bookingTimestamp"))
                        if (!$util.isInteger(message.bookingTimestamp) && !(message.bookingTimestamp && $util.isInteger(message.bookingTimestamp.low) && $util.isInteger(message.bookingTimestamp.high)))
                            return "bookingTimestamp: integer|Long expected";
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        if (!$util.isString(message.clientName))
                            return "clientName: string expected";
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        if (!$util.isString(message.clientEmail))
                            return "clientEmail: string expected";
                    if (message.clientEmailVerified != null && message.hasOwnProperty("clientEmailVerified"))
                        if (typeof message.clientEmailVerified !== "boolean")
                            return "clientEmailVerified: boolean expected";
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        if (!$util.isString(message.clientPhone))
                            return "clientPhone: string expected";
                    if (message.clientPhoneVerified != null && message.hasOwnProperty("clientPhoneVerified"))
                        if (typeof message.clientPhoneVerified !== "boolean")
                            return "clientPhoneVerified: boolean expected";
                    if (message.notes != null && message.hasOwnProperty("notes")) {
                        if (!Array.isArray(message.notes))
                            return "notes: array expected";
                        for (var i = 0; i < message.notes.length; ++i) {
                            var error = $root.space.kenko.proto.SystemNoteProto.verify(message.notes[i]);
                            if (error)
                                return "notes." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 */
                BookingDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingDetailsProto)
                        return object;
                    var message = new $root.space.kenko.proto.BookingDetailsProto();
                    if (object.service != null) {
                        if (typeof object.service !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.service: object expected");
                        message.service = $root.space.kenko.proto.BookedServiceProto.fromObject(object.service);
                    }
                    if (object["class"] != null) {
                        if (typeof object["class"] !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.class: object expected");
                        message["class"] = $root.space.kenko.proto.BookedClassProto.fromObject(object["class"]);
                    }
                    if (object.paymentInfo != null) {
                        if (typeof object.paymentInfo !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.paymentInfo: object expected");
                        message.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.fromObject(object.paymentInfo);
                    }
                    if (object.bookingTimestamp != null)
                        if ($util.Long)
                            (message.bookingTimestamp = $util.Long.fromValue(object.bookingTimestamp)).unsigned = false;
                        else if (typeof object.bookingTimestamp === "string")
                            message.bookingTimestamp = parseInt(object.bookingTimestamp, 10);
                        else if (typeof object.bookingTimestamp === "number")
                            message.bookingTimestamp = object.bookingTimestamp;
                        else if (typeof object.bookingTimestamp === "object")
                            message.bookingTimestamp = new $util.LongBits(object.bookingTimestamp.low >>> 0, object.bookingTimestamp.high >>> 0).toNumber();
                    if (object.clientName != null)
                        message.clientName = String(object.clientName);
                    if (object.clientEmail != null)
                        message.clientEmail = String(object.clientEmail);
                    if (object.clientEmailVerified != null)
                        message.clientEmailVerified = Boolean(object.clientEmailVerified);
                    if (object.clientPhone != null)
                        message.clientPhone = String(object.clientPhone);
                    if (object.clientPhoneVerified != null)
                        message.clientPhoneVerified = Boolean(object.clientPhoneVerified);
                    if (object.notes) {
                        if (!Array.isArray(object.notes))
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.notes: array expected");
                        message.notes = [];
                        for (var i = 0; i < object.notes.length; ++i) {
                            if (typeof object.notes[i] !== "object")
                                throw TypeError(".space.kenko.proto.BookingDetailsProto.notes: object expected");
                            message.notes[i] = $root.space.kenko.proto.SystemNoteProto.fromObject(object.notes[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.BookingDetailsProto} message BookingDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.notes = [];
                    if (options.defaults) {
                        object.paymentInfo = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.bookingTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.bookingTimestamp = options.longs === String ? "0" : 0;
                        object.clientName = "";
                        object.clientEmail = "";
                        object.clientEmailVerified = false;
                        object.clientPhone = "";
                        object.clientPhoneVerified = false;
                    }
                    if (message.service != null && message.hasOwnProperty("service")) {
                        object.service = $root.space.kenko.proto.BookedServiceProto.toObject(message.service, options);
                        if (options.oneofs)
                            object.BookingType = "service";
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        object["class"] = $root.space.kenko.proto.BookedClassProto.toObject(message["class"], options);
                        if (options.oneofs)
                            object.BookingType = "class";
                    }
                    if (message.paymentInfo != null && message.hasOwnProperty("paymentInfo"))
                        object.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.toObject(message.paymentInfo, options);
                    if (message.bookingTimestamp != null && message.hasOwnProperty("bookingTimestamp"))
                        if (typeof message.bookingTimestamp === "number")
                            object.bookingTimestamp = options.longs === String ? String(message.bookingTimestamp) : message.bookingTimestamp;
                        else
                            object.bookingTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.bookingTimestamp) : options.longs === Number ? new $util.LongBits(message.bookingTimestamp.low >>> 0, message.bookingTimestamp.high >>> 0).toNumber() : message.bookingTimestamp;
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        object.clientName = message.clientName;
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        object.clientEmail = message.clientEmail;
                    if (message.clientEmailVerified != null && message.hasOwnProperty("clientEmailVerified"))
                        object.clientEmailVerified = message.clientEmailVerified;
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        object.clientPhone = message.clientPhone;
                    if (message.clientPhoneVerified != null && message.hasOwnProperty("clientPhoneVerified"))
                        object.clientPhoneVerified = message.clientPhoneVerified;
                    if (message.notes && message.notes.length) {
                        object.notes = [];
                        for (var j = 0; j < message.notes.length; ++j)
                            object.notes[j] = $root.space.kenko.proto.SystemNoteProto.toObject(message.notes[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this BookingDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingDetailsProto";
                };

                return BookingDetailsProto;
            })();

            proto.BookedServiceProto = (function() {

                /**
                 * Properties of a BookedServiceProto.
                 * @memberof space.kenko.proto
                 * @interface IBookedServiceProto
                 * @property {string|null} [practitionerId] BookedServiceProto practitionerId
                 * @property {string|null} [practitionerName] BookedServiceProto practitionerName
                 * @property {string|null} [serviceId] BookedServiceProto serviceId
                 * @property {string|null} [serviceName] BookedServiceProto serviceName
                 * @property {string|null} [locationId] BookedServiceProto locationId
                 * @property {string|null} [locationName] BookedServiceProto locationName
                 * @property {string|null} [address] BookedServiceProto address
                 * @property {string|null} [virtualMeetingLink] BookedServiceProto virtualMeetingLink
                 * @property {boolean|null} [isVirtual] BookedServiceProto isVirtual
                 */

                /**
                 * Constructs a new BookedServiceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookedServiceProto.
                 * @implements IBookedServiceProto
                 * @constructor
                 * @param {space.kenko.proto.IBookedServiceProto=} [properties] Properties to set
                 */
                function BookedServiceProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookedServiceProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.practitionerId = "";

                /**
                 * BookedServiceProto practitionerName.
                 * @member {string} practitionerName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.practitionerName = "";

                /**
                 * BookedServiceProto serviceId.
                 * @member {string} serviceId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.serviceId = "";

                /**
                 * BookedServiceProto serviceName.
                 * @member {string} serviceName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.serviceName = "";

                /**
                 * BookedServiceProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.locationId = "";

                /**
                 * BookedServiceProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.locationName = "";

                /**
                 * BookedServiceProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.address = "";

                /**
                 * BookedServiceProto virtualMeetingLink.
                 * @member {string} virtualMeetingLink
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.virtualMeetingLink = "";

                /**
                 * BookedServiceProto isVirtual.
                 * @member {boolean} isVirtual
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.isVirtual = false;

                /**
                 * Creates a new BookedServiceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto instance
                 */
                BookedServiceProto.create = function create(properties) {
                    return new BookedServiceProto(properties);
                };

                /**
                 * Encodes the specified BookedServiceProto message. Does not implicitly {@link space.kenko.proto.BookedServiceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto} message BookedServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedServiceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.practitionerName != null && Object.hasOwnProperty.call(message, "practitionerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerName);
                    if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.serviceId);
                    if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.serviceName);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.locationName);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.address);
                    if (message.virtualMeetingLink != null && Object.hasOwnProperty.call(message, "virtualMeetingLink"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.virtualMeetingLink);
                    if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isVirtual);
                    return writer;
                };

                /**
                 * Encodes the specified BookedServiceProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookedServiceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto} message BookedServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookedServiceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedServiceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookedServiceProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.practitionerName = reader.string();
                                break;
                            }
                        case 4: {
                                message.serviceId = reader.string();
                                break;
                            }
                        case 5: {
                                message.serviceName = reader.string();
                                break;
                            }
                        case 6: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 7: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 8: {
                                message.address = reader.string();
                                break;
                            }
                        case 9: {
                                message.virtualMeetingLink = reader.string();
                                break;
                            }
                        case 10: {
                                message.isVirtual = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookedServiceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedServiceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookedServiceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookedServiceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        if (!$util.isString(message.practitionerName))
                            return "practitionerName: string expected";
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        if (!$util.isString(message.serviceId))
                            return "serviceId: string expected";
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        if (!$util.isString(message.serviceName))
                            return "serviceName: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        if (!$util.isString(message.virtualMeetingLink))
                            return "virtualMeetingLink: string expected";
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        if (typeof message.isVirtual !== "boolean")
                            return "isVirtual: boolean expected";
                    return null;
                };

                /**
                 * Creates a BookedServiceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 */
                BookedServiceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookedServiceProto)
                        return object;
                    var message = new $root.space.kenko.proto.BookedServiceProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.practitionerName != null)
                        message.practitionerName = String(object.practitionerName);
                    if (object.serviceId != null)
                        message.serviceId = String(object.serviceId);
                    if (object.serviceName != null)
                        message.serviceName = String(object.serviceName);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.address != null)
                        message.address = String(object.address);
                    if (object.virtualMeetingLink != null)
                        message.virtualMeetingLink = String(object.virtualMeetingLink);
                    if (object.isVirtual != null)
                        message.isVirtual = Boolean(object.isVirtual);
                    return message;
                };

                /**
                 * Creates a plain object from a BookedServiceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.BookedServiceProto} message BookedServiceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookedServiceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.practitionerName = "";
                        object.serviceId = "";
                        object.serviceName = "";
                        object.locationId = "";
                        object.locationName = "";
                        object.address = "";
                        object.virtualMeetingLink = "";
                        object.isVirtual = false;
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        object.practitionerName = message.practitionerName;
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        object.serviceId = message.serviceId;
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        object.serviceName = message.serviceName;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        object.virtualMeetingLink = message.virtualMeetingLink;
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        object.isVirtual = message.isVirtual;
                    return object;
                };

                /**
                 * Converts this BookedServiceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookedServiceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookedServiceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookedServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookedServiceProto";
                };

                return BookedServiceProto;
            })();

            proto.BookingPurchaseOption = (function() {

                /**
                 * Properties of a BookingPurchaseOption.
                 * @memberof space.kenko.proto
                 * @interface IBookingPurchaseOption
                 * @property {string|null} [prepaidSingleCreditId] BookingPurchaseOption prepaidSingleCreditId
                 * @property {string|null} [prepaidPackageId] BookingPurchaseOption prepaidPackageId
                 * @property {space.kenko.proto.IPriceProto|null} [postpaidReservationOnly] BookingPurchaseOption postpaidReservationOnly
                 */

                /**
                 * Constructs a new BookingPurchaseOption.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingPurchaseOption.
                 * @implements IBookingPurchaseOption
                 * @constructor
                 * @param {space.kenko.proto.IBookingPurchaseOption=} [properties] Properties to set
                 */
                function BookingPurchaseOption(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingPurchaseOption prepaidSingleCreditId.
                 * @member {string|null|undefined} prepaidSingleCreditId
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.prepaidSingleCreditId = null;

                /**
                 * BookingPurchaseOption prepaidPackageId.
                 * @member {string|null|undefined} prepaidPackageId
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.prepaidPackageId = null;

                /**
                 * BookingPurchaseOption postpaidReservationOnly.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} postpaidReservationOnly
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.postpaidReservationOnly = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BookingPurchaseOption Type.
                 * @member {"prepaidSingleCreditId"|"prepaidPackageId"|"postpaidReservationOnly"|undefined} Type
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                Object.defineProperty(BookingPurchaseOption.prototype, "Type", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaidSingleCreditId", "prepaidPackageId", "postpaidReservationOnly"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingPurchaseOption instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption instance
                 */
                BookingPurchaseOption.create = function create(properties) {
                    return new BookingPurchaseOption(properties);
                };

                /**
                 * Encodes the specified BookingPurchaseOption message. Does not implicitly {@link space.kenko.proto.BookingPurchaseOption.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption} message BookingPurchaseOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPurchaseOption.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaidSingleCreditId != null && Object.hasOwnProperty.call(message, "prepaidSingleCreditId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.prepaidSingleCreditId);
                    if (message.prepaidPackageId != null && Object.hasOwnProperty.call(message, "prepaidPackageId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.prepaidPackageId);
                    if (message.postpaidReservationOnly != null && Object.hasOwnProperty.call(message, "postpaidReservationOnly"))
                        $root.space.kenko.proto.PriceProto.encode(message.postpaidReservationOnly, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingPurchaseOption message, length delimited. Does not implicitly {@link space.kenko.proto.BookingPurchaseOption.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption} message BookingPurchaseOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPurchaseOption.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingPurchaseOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPurchaseOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingPurchaseOption();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.prepaidSingleCreditId = reader.string();
                                break;
                            }
                        case 2: {
                                message.prepaidPackageId = reader.string();
                                break;
                            }
                        case 3: {
                                message.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingPurchaseOption message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPurchaseOption.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingPurchaseOption message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingPurchaseOption.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.prepaidSingleCreditId != null && message.hasOwnProperty("prepaidSingleCreditId")) {
                        properties.Type = 1;
                        if (!$util.isString(message.prepaidSingleCreditId))
                            return "prepaidSingleCreditId: string expected";
                    }
                    if (message.prepaidPackageId != null && message.hasOwnProperty("prepaidPackageId")) {
                        if (properties.Type === 1)
                            return "Type: multiple values";
                        properties.Type = 1;
                        if (!$util.isString(message.prepaidPackageId))
                            return "prepaidPackageId: string expected";
                    }
                    if (message.postpaidReservationOnly != null && message.hasOwnProperty("postpaidReservationOnly")) {
                        if (properties.Type === 1)
                            return "Type: multiple values";
                        properties.Type = 1;
                        {
                            var error = $root.space.kenko.proto.PriceProto.verify(message.postpaidReservationOnly);
                            if (error)
                                return "postpaidReservationOnly." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingPurchaseOption message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 */
                BookingPurchaseOption.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingPurchaseOption)
                        return object;
                    var message = new $root.space.kenko.proto.BookingPurchaseOption();
                    if (object.prepaidSingleCreditId != null)
                        message.prepaidSingleCreditId = String(object.prepaidSingleCreditId);
                    if (object.prepaidPackageId != null)
                        message.prepaidPackageId = String(object.prepaidPackageId);
                    if (object.postpaidReservationOnly != null) {
                        if (typeof object.postpaidReservationOnly !== "object")
                            throw TypeError(".space.kenko.proto.BookingPurchaseOption.postpaidReservationOnly: object expected");
                        message.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.fromObject(object.postpaidReservationOnly);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingPurchaseOption message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.BookingPurchaseOption} message BookingPurchaseOption
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingPurchaseOption.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.prepaidSingleCreditId != null && message.hasOwnProperty("prepaidSingleCreditId")) {
                        object.prepaidSingleCreditId = message.prepaidSingleCreditId;
                        if (options.oneofs)
                            object.Type = "prepaidSingleCreditId";
                    }
                    if (message.prepaidPackageId != null && message.hasOwnProperty("prepaidPackageId")) {
                        object.prepaidPackageId = message.prepaidPackageId;
                        if (options.oneofs)
                            object.Type = "prepaidPackageId";
                    }
                    if (message.postpaidReservationOnly != null && message.hasOwnProperty("postpaidReservationOnly")) {
                        object.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.toObject(message.postpaidReservationOnly, options);
                        if (options.oneofs)
                            object.Type = "postpaidReservationOnly";
                    }
                    return object;
                };

                /**
                 * Converts this BookingPurchaseOption to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingPurchaseOption.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingPurchaseOption
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingPurchaseOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingPurchaseOption";
                };

                return BookingPurchaseOption;
            })();

            proto.BookingPaymentProto = (function() {

                /**
                 * Properties of a BookingPaymentProto.
                 * @memberof space.kenko.proto
                 * @interface IBookingPaymentProto
                 * @property {IPurchasedSingleClassCreditProto|null} [prepaidSingleClassCredit] BookingPaymentProto prepaidSingleClassCredit
                 * @property {IPurchasedPackageProto|null} [prepaidPackage] BookingPaymentProto prepaidPackage
                 * @property {space.kenko.proto.IPostpaidReservationProto|null} [postpaidReservation] BookingPaymentProto postpaidReservation
                 * @property {space.kenko.proto.IPostpaidExternalPayment|null} [postpaidExternalPayment] BookingPaymentProto postpaidExternalPayment
                 */

                /**
                 * Constructs a new BookingPaymentProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingPaymentProto.
                 * @implements IBookingPaymentProto
                 * @constructor
                 * @param {space.kenko.proto.IBookingPaymentProto=} [properties] Properties to set
                 */
                function BookingPaymentProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingPaymentProto prepaidSingleClassCredit.
                 * @member {IPurchasedSingleClassCreditProto|null|undefined} prepaidSingleClassCredit
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.prepaidSingleClassCredit = null;

                /**
                 * BookingPaymentProto prepaidPackage.
                 * @member {IPurchasedPackageProto|null|undefined} prepaidPackage
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.prepaidPackage = null;

                /**
                 * BookingPaymentProto postpaidReservation.
                 * @member {space.kenko.proto.IPostpaidReservationProto|null|undefined} postpaidReservation
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.postpaidReservation = null;

                /**
                 * BookingPaymentProto postpaidExternalPayment.
                 * @member {space.kenko.proto.IPostpaidExternalPayment|null|undefined} postpaidExternalPayment
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.postpaidExternalPayment = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BookingPaymentProto PaymentType.
                 * @member {"prepaidSingleClassCredit"|"prepaidPackage"|"postpaidReservation"|"postpaidExternalPayment"|undefined} PaymentType
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                Object.defineProperty(BookingPaymentProto.prototype, "PaymentType", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaidSingleClassCredit", "prepaidPackage", "postpaidReservation", "postpaidExternalPayment"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingPaymentProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto instance
                 */
                BookingPaymentProto.create = function create(properties) {
                    return new BookingPaymentProto(properties);
                };

                /**
                 * Encodes the specified BookingPaymentProto message. Does not implicitly {@link space.kenko.proto.BookingPaymentProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto} message BookingPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPaymentProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaidSingleClassCredit != null && Object.hasOwnProperty.call(message, "prepaidSingleClassCredit"))
                        $root.PurchasedSingleClassCreditProto.encode(message.prepaidSingleClassCredit, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    if (message.prepaidPackage != null && Object.hasOwnProperty.call(message, "prepaidPackage"))
                        $root.PurchasedPackageProto.encode(message.prepaidPackage, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
                    if (message.postpaidReservation != null && Object.hasOwnProperty.call(message, "postpaidReservation"))
                        $root.space.kenko.proto.PostpaidReservationProto.encode(message.postpaidReservation, writer.uint32(/* id 201, wireType 2 =*/1610).fork()).ldelim();
                    if (message.postpaidExternalPayment != null && Object.hasOwnProperty.call(message, "postpaidExternalPayment"))
                        $root.space.kenko.proto.PostpaidExternalPayment.encode(message.postpaidExternalPayment, writer.uint32(/* id 202, wireType 2 =*/1618).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingPaymentProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookingPaymentProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto} message BookingPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingPaymentProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPaymentProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingPaymentProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 100: {
                                message.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 101: {
                                message.prepaidPackage = $root.PurchasedPackageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 201: {
                                message.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 202: {
                                message.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingPaymentProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPaymentProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingPaymentProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingPaymentProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.prepaidSingleClassCredit != null && message.hasOwnProperty("prepaidSingleClassCredit")) {
                        properties.PaymentType = 1;
                        {
                            var error = $root.PurchasedSingleClassCreditProto.verify(message.prepaidSingleClassCredit);
                            if (error)
                                return "prepaidSingleClassCredit." + error;
                        }
                    }
                    if (message.prepaidPackage != null && message.hasOwnProperty("prepaidPackage")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            var error = $root.PurchasedPackageProto.verify(message.prepaidPackage);
                            if (error)
                                return "prepaidPackage." + error;
                        }
                    }
                    if (message.postpaidReservation != null && message.hasOwnProperty("postpaidReservation")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            var error = $root.space.kenko.proto.PostpaidReservationProto.verify(message.postpaidReservation);
                            if (error)
                                return "postpaidReservation." + error;
                        }
                    }
                    if (message.postpaidExternalPayment != null && message.hasOwnProperty("postpaidExternalPayment")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            var error = $root.space.kenko.proto.PostpaidExternalPayment.verify(message.postpaidExternalPayment);
                            if (error)
                                return "postpaidExternalPayment." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingPaymentProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 */
                BookingPaymentProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingPaymentProto)
                        return object;
                    var message = new $root.space.kenko.proto.BookingPaymentProto();
                    if (object.prepaidSingleClassCredit != null) {
                        if (typeof object.prepaidSingleClassCredit !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.prepaidSingleClassCredit: object expected");
                        message.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.fromObject(object.prepaidSingleClassCredit);
                    }
                    if (object.prepaidPackage != null) {
                        if (typeof object.prepaidPackage !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.prepaidPackage: object expected");
                        message.prepaidPackage = $root.PurchasedPackageProto.fromObject(object.prepaidPackage);
                    }
                    if (object.postpaidReservation != null) {
                        if (typeof object.postpaidReservation !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.postpaidReservation: object expected");
                        message.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.fromObject(object.postpaidReservation);
                    }
                    if (object.postpaidExternalPayment != null) {
                        if (typeof object.postpaidExternalPayment !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.postpaidExternalPayment: object expected");
                        message.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.fromObject(object.postpaidExternalPayment);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingPaymentProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.BookingPaymentProto} message BookingPaymentProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingPaymentProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.prepaidSingleClassCredit != null && message.hasOwnProperty("prepaidSingleClassCredit")) {
                        object.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.toObject(message.prepaidSingleClassCredit, options);
                        if (options.oneofs)
                            object.PaymentType = "prepaidSingleClassCredit";
                    }
                    if (message.prepaidPackage != null && message.hasOwnProperty("prepaidPackage")) {
                        object.prepaidPackage = $root.PurchasedPackageProto.toObject(message.prepaidPackage, options);
                        if (options.oneofs)
                            object.PaymentType = "prepaidPackage";
                    }
                    if (message.postpaidReservation != null && message.hasOwnProperty("postpaidReservation")) {
                        object.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.toObject(message.postpaidReservation, options);
                        if (options.oneofs)
                            object.PaymentType = "postpaidReservation";
                    }
                    if (message.postpaidExternalPayment != null && message.hasOwnProperty("postpaidExternalPayment")) {
                        object.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.toObject(message.postpaidExternalPayment, options);
                        if (options.oneofs)
                            object.PaymentType = "postpaidExternalPayment";
                    }
                    return object;
                };

                /**
                 * Converts this BookingPaymentProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingPaymentProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingPaymentProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingPaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingPaymentProto";
                };

                return BookingPaymentProto;
            })();

            proto.PostpaidReservationProto = (function() {

                /**
                 * Properties of a PostpaidReservationProto.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidReservationProto
                 * @property {space.kenko.proto.IPriceProto|null} [price] PostpaidReservationProto price
                 */

                /**
                 * Constructs a new PostpaidReservationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidReservationProto.
                 * @implements IPostpaidReservationProto
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidReservationProto=} [properties] Properties to set
                 */
                function PostpaidReservationProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PostpaidReservationProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @instance
                 */
                PostpaidReservationProto.prototype.price = null;

                /**
                 * Creates a new PostpaidReservationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto instance
                 */
                PostpaidReservationProto.create = function create(properties) {
                    return new PostpaidReservationProto(properties);
                };

                /**
                 * Encodes the specified PostpaidReservationProto message. Does not implicitly {@link space.kenko.proto.PostpaidReservationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto} message PostpaidReservationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidReservationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidReservationProto message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidReservationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto} message PostpaidReservationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidReservationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidReservationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidReservationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidReservationProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidReservationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidReservationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidReservationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidReservationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        var error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PostpaidReservationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 */
                PostpaidReservationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidReservationProto)
                        return object;
                    var message = new $root.space.kenko.proto.PostpaidReservationProto();
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PostpaidReservationProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PostpaidReservationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.PostpaidReservationProto} message PostpaidReservationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidReservationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.price = null;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PostpaidReservationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidReservationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidReservationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidReservationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidReservationProto";
                };

                return PostpaidReservationProto;
            })();

            proto.PostpaidExternalPayment = (function() {

                /**
                 * Properties of a PostpaidExternalPayment.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidExternalPayment
                 */

                /**
                 * Constructs a new PostpaidExternalPayment.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidExternalPayment.
                 * @implements IPostpaidExternalPayment
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidExternalPayment=} [properties] Properties to set
                 */
                function PostpaidExternalPayment(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new PostpaidExternalPayment instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment instance
                 */
                PostpaidExternalPayment.create = function create(properties) {
                    return new PostpaidExternalPayment(properties);
                };

                /**
                 * Encodes the specified PostpaidExternalPayment message. Does not implicitly {@link space.kenko.proto.PostpaidExternalPayment.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment} message PostpaidExternalPayment message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidExternalPayment.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidExternalPayment message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidExternalPayment.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment} message PostpaidExternalPayment message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidExternalPayment.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidExternalPayment message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidExternalPayment.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidExternalPayment();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidExternalPayment message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidExternalPayment.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidExternalPayment message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidExternalPayment.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a PostpaidExternalPayment message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 */
                PostpaidExternalPayment.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidExternalPayment)
                        return object;
                    return new $root.space.kenko.proto.PostpaidExternalPayment();
                };

                /**
                 * Creates a plain object from a PostpaidExternalPayment message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.PostpaidExternalPayment} message PostpaidExternalPayment
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidExternalPayment.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this PostpaidExternalPayment to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidExternalPayment.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidExternalPayment
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidExternalPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidExternalPayment";
                };

                return PostpaidExternalPayment;
            })();

            proto.BookedClassProto = (function() {

                /**
                 * Properties of a BookedClassProto.
                 * @memberof space.kenko.proto
                 * @interface IBookedClassProto
                 * @property {string|null} [practitionerId] BookedClassProto practitionerId
                 * @property {string|null} [practitionerName] BookedClassProto practitionerName
                 * @property {string|null} [className] BookedClassProto className
                 * @property {string|null} [locationName] BookedClassProto locationName
                 * @property {string|null} [locationId] BookedClassProto locationId
                 * @property {string|null} [address] BookedClassProto address
                 */

                /**
                 * Constructs a new BookedClassProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookedClassProto.
                 * @implements IBookedClassProto
                 * @constructor
                 * @param {space.kenko.proto.IBookedClassProto=} [properties] Properties to set
                 */
                function BookedClassProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookedClassProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.practitionerId = "";

                /**
                 * BookedClassProto practitionerName.
                 * @member {string} practitionerName
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.practitionerName = "";

                /**
                 * BookedClassProto className.
                 * @member {string} className
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.className = "";

                /**
                 * BookedClassProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.locationName = "";

                /**
                 * BookedClassProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.locationId = "";

                /**
                 * BookedClassProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.address = "";

                /**
                 * Creates a new BookedClassProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto instance
                 */
                BookedClassProto.create = function create(properties) {
                    return new BookedClassProto(properties);
                };

                /**
                 * Encodes the specified BookedClassProto message. Does not implicitly {@link space.kenko.proto.BookedClassProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto} message BookedClassProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedClassProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.practitionerName != null && Object.hasOwnProperty.call(message, "practitionerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerName);
                    if (message.className != null && Object.hasOwnProperty.call(message, "className"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.className);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationName);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.locationId);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.address);
                    return writer;
                };

                /**
                 * Encodes the specified BookedClassProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookedClassProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto} message BookedClassProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedClassProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookedClassProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedClassProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookedClassProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.practitionerName = reader.string();
                                break;
                            }
                        case 3: {
                                message.className = reader.string();
                                break;
                            }
                        case 4: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 5: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 6: {
                                message.address = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookedClassProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedClassProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookedClassProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookedClassProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        if (!$util.isString(message.practitionerName))
                            return "practitionerName: string expected";
                    if (message.className != null && message.hasOwnProperty("className"))
                        if (!$util.isString(message.className))
                            return "className: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    return null;
                };

                /**
                 * Creates a BookedClassProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 */
                BookedClassProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookedClassProto)
                        return object;
                    var message = new $root.space.kenko.proto.BookedClassProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.practitionerName != null)
                        message.practitionerName = String(object.practitionerName);
                    if (object.className != null)
                        message.className = String(object.className);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.address != null)
                        message.address = String(object.address);
                    return message;
                };

                /**
                 * Creates a plain object from a BookedClassProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.BookedClassProto} message BookedClassProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookedClassProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.practitionerName = "";
                        object.className = "";
                        object.locationName = "";
                        object.locationId = "";
                        object.address = "";
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        object.practitionerName = message.practitionerName;
                    if (message.className != null && message.hasOwnProperty("className"))
                        object.className = message.className;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    return object;
                };

                /**
                 * Converts this BookedClassProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookedClassProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookedClassProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookedClassProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookedClassProto";
                };

                return BookedClassProto;
            })();

            proto.RequestEnvelopeProto = (function() {

                /**
                 * Properties of a RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @interface IRequestEnvelopeProto
                 * @property {string|null} [authToken] RequestEnvelopeProto authToken
                 * @property {Uint8Array|null} [requestMessage] RequestEnvelopeProto requestMessage
                 * @property {space.kenko.proto.IProviderContextProto|null} [impersonation] RequestEnvelopeProto impersonation
                 */

                /**
                 * Constructs a new RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a RequestEnvelopeProto.
                 * @implements IRequestEnvelopeProto
                 * @constructor
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 */
                function RequestEnvelopeProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RequestEnvelopeProto authToken.
                 * @member {string} authToken
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.authToken = "";

                /**
                 * RequestEnvelopeProto requestMessage.
                 * @member {Uint8Array} requestMessage
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.requestMessage = $util.newBuffer([]);

                /**
                 * RequestEnvelopeProto impersonation.
                 * @member {space.kenko.proto.IProviderContextProto|null|undefined} impersonation
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.impersonation = null;

                /**
                 * Creates a new RequestEnvelopeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto instance
                 */
                RequestEnvelopeProto.create = function create(properties) {
                    return new RequestEnvelopeProto(properties);
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.authToken);
                    if (message.requestMessage != null && Object.hasOwnProperty.call(message, "requestMessage"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.requestMessage);
                    if (message.impersonation != null && Object.hasOwnProperty.call(message, "impersonation"))
                        $root.space.kenko.proto.ProviderContextProto.encode(message.impersonation, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message, length delimited. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 2: {
                                message.requestMessage = reader.bytes();
                                break;
                            }
                        case 100: {
                                message.impersonation = $root.space.kenko.proto.ProviderContextProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RequestEnvelopeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RequestEnvelopeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        if (!(message.requestMessage && typeof message.requestMessage.length === "number" || $util.isString(message.requestMessage)))
                            return "requestMessage: buffer expected";
                    if (message.impersonation != null && message.hasOwnProperty("impersonation")) {
                        var error = $root.space.kenko.proto.ProviderContextProto.verify(message.impersonation);
                        if (error)
                            return "impersonation." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RequestEnvelopeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 */
                RequestEnvelopeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.RequestEnvelopeProto)
                        return object;
                    var message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.requestMessage != null)
                        if (typeof object.requestMessage === "string")
                            $util.base64.decode(object.requestMessage, message.requestMessage = $util.newBuffer($util.base64.length(object.requestMessage)), 0);
                        else if (object.requestMessage.length >= 0)
                            message.requestMessage = object.requestMessage;
                    if (object.impersonation != null) {
                        if (typeof object.impersonation !== "object")
                            throw TypeError(".space.kenko.proto.RequestEnvelopeProto.impersonation: object expected");
                        message.impersonation = $root.space.kenko.proto.ProviderContextProto.fromObject(object.impersonation);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RequestEnvelopeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.RequestEnvelopeProto} message RequestEnvelopeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RequestEnvelopeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.authToken = "";
                        if (options.bytes === String)
                            object.requestMessage = "";
                        else {
                            object.requestMessage = [];
                            if (options.bytes !== Array)
                                object.requestMessage = $util.newBuffer(object.requestMessage);
                        }
                        object.impersonation = null;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        object.requestMessage = options.bytes === String ? $util.base64.encode(message.requestMessage, 0, message.requestMessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.requestMessage) : message.requestMessage;
                    if (message.impersonation != null && message.hasOwnProperty("impersonation"))
                        object.impersonation = $root.space.kenko.proto.ProviderContextProto.toObject(message.impersonation, options);
                    return object;
                };

                /**
                 * Converts this RequestEnvelopeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RequestEnvelopeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RequestEnvelopeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RequestEnvelopeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.RequestEnvelopeProto";
                };

                return RequestEnvelopeProto;
            })();

            proto.ProviderContextProto = (function() {

                /**
                 * Properties of a ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderContextProto
                 * @property {string|null} [impersonatedBusinessId] ProviderContextProto impersonatedBusinessId
                 * @property {string|null} [impersonatedProviderId] ProviderContextProto impersonatedProviderId
                 */

                /**
                 * Constructs a new ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderContextProto.
                 * @implements IProviderContextProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 */
                function ProviderContextProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderContextProto impersonatedBusinessId.
                 * @member {string} impersonatedBusinessId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedBusinessId = "";

                /**
                 * ProviderContextProto impersonatedProviderId.
                 * @member {string} impersonatedProviderId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedProviderId = "";

                /**
                 * Creates a new ProviderContextProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto instance
                 */
                ProviderContextProto.create = function create(properties) {
                    return new ProviderContextProto(properties);
                };

                /**
                 * Encodes the specified ProviderContextProto message. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.impersonatedBusinessId != null && Object.hasOwnProperty.call(message, "impersonatedBusinessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.impersonatedBusinessId);
                    if (message.impersonatedProviderId != null && Object.hasOwnProperty.call(message, "impersonatedProviderId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.impersonatedProviderId);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderContextProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderContextProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.impersonatedBusinessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.impersonatedProviderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderContextProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderContextProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        if (!$util.isString(message.impersonatedBusinessId))
                            return "impersonatedBusinessId: string expected";
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        if (!$util.isString(message.impersonatedProviderId))
                            return "impersonatedProviderId: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderContextProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 */
                ProviderContextProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderContextProto)
                        return object;
                    var message = new $root.space.kenko.proto.ProviderContextProto();
                    if (object.impersonatedBusinessId != null)
                        message.impersonatedBusinessId = String(object.impersonatedBusinessId);
                    if (object.impersonatedProviderId != null)
                        message.impersonatedProviderId = String(object.impersonatedProviderId);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderContextProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.ProviderContextProto} message ProviderContextProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderContextProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.impersonatedBusinessId = "";
                        object.impersonatedProviderId = "";
                    }
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        object.impersonatedBusinessId = message.impersonatedBusinessId;
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        object.impersonatedProviderId = message.impersonatedProviderId;
                    return object;
                };

                /**
                 * Converts this ProviderContextProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderContextProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderContextProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderContextProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderContextProto";
                };

                return ProviderContextProto;
            })();

            return proto;
        })();

        return kenko;
    })();

    return space;
})();

$root.ApiUserProto = (function() {

    /**
     * Properties of an ApiUserProto.
     * @exports IApiUserProto
     * @interface IApiUserProto
     * @property {string|null} [userId] ApiUserProto userId
     * @property {string|null} [familyName] ApiUserProto familyName
     * @property {string|null} [givenName] ApiUserProto givenName
     * @property {IWellnessSurveyProto|null} [wellnessSurveyAnswers] ApiUserProto wellnessSurveyAnswers
     * @property {string|null} [mobileNumber] ApiUserProto mobileNumber
     * @property {string|null} [contactEmail] ApiUserProto contactEmail
     * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [verifiedContactMethods] ApiUserProto verifiedContactMethods
     * @property {Array.<string>|null} [acceptedTermsVersions] ApiUserProto acceptedTermsVersions
     * @property {space.kenko.proto.ILocalDateProto|null} [birthDate] ApiUserProto birthDate
     */

    /**
     * Constructs a new ApiUserProto.
     * @exports ApiUserProto
     * @classdesc Represents an ApiUserProto.
     * @implements IApiUserProto
     * @constructor
     * @param {IApiUserProto=} [properties] Properties to set
     */
    function ApiUserProto(properties) {
        this.verifiedContactMethods = [];
        this.acceptedTermsVersions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiUserProto userId.
     * @member {string} userId
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.userId = "";

    /**
     * ApiUserProto familyName.
     * @member {string} familyName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.familyName = "";

    /**
     * ApiUserProto givenName.
     * @member {string} givenName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.givenName = "";

    /**
     * ApiUserProto wellnessSurveyAnswers.
     * @member {IWellnessSurveyProto|null|undefined} wellnessSurveyAnswers
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.wellnessSurveyAnswers = null;

    /**
     * ApiUserProto mobileNumber.
     * @member {string} mobileNumber
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.mobileNumber = "";

    /**
     * ApiUserProto contactEmail.
     * @member {string} contactEmail
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.contactEmail = "";

    /**
     * ApiUserProto verifiedContactMethods.
     * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} verifiedContactMethods
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.verifiedContactMethods = $util.emptyArray;

    /**
     * ApiUserProto acceptedTermsVersions.
     * @member {Array.<string>} acceptedTermsVersions
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.acceptedTermsVersions = $util.emptyArray;

    /**
     * ApiUserProto birthDate.
     * @member {space.kenko.proto.ILocalDateProto|null|undefined} birthDate
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.birthDate = null;

    /**
     * Creates a new ApiUserProto instance using the specified properties.
     * @function create
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto=} [properties] Properties to set
     * @returns {ApiUserProto} ApiUserProto instance
     */
    ApiUserProto.create = function create(properties) {
        return new ApiUserProto(properties);
    };

    /**
     * Encodes the specified ApiUserProto message. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encode
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.familyName != null && Object.hasOwnProperty.call(message, "familyName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.familyName);
        if (message.givenName != null && Object.hasOwnProperty.call(message, "givenName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.givenName);
        if (message.wellnessSurveyAnswers != null && Object.hasOwnProperty.call(message, "wellnessSurveyAnswers"))
            $root.WellnessSurveyProto.encode(message.wellnessSurveyAnswers, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.mobileNumber != null && Object.hasOwnProperty.call(message, "mobileNumber"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mobileNumber);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.contactEmail);
        if (message.verifiedContactMethods != null && message.verifiedContactMethods.length)
            for (var i = 0; i < message.verifiedContactMethods.length; ++i)
                $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.verifiedContactMethods[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.acceptedTermsVersions != null && message.acceptedTermsVersions.length)
            for (var i = 0; i < message.acceptedTermsVersions.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.acceptedTermsVersions[i]);
        if (message.birthDate != null && Object.hasOwnProperty.call(message, "birthDate"))
            $root.space.kenko.proto.LocalDateProto.encode(message.birthDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiUserProto message, length delimited. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiUserProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.familyName = reader.string();
                    break;
                }
            case 3: {
                    message.givenName = reader.string();
                    break;
                }
            case 4: {
                    message.wellnessSurveyAnswers = $root.WellnessSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.mobileNumber = reader.string();
                    break;
                }
            case 6: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 7: {
                    if (!(message.verifiedContactMethods && message.verifiedContactMethods.length))
                        message.verifiedContactMethods = [];
                    message.verifiedContactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                    break;
                }
            case 8: {
                    if (!(message.acceptedTermsVersions && message.acceptedTermsVersions.length))
                        message.acceptedTermsVersions = [];
                    message.acceptedTermsVersions.push(reader.string());
                    break;
                }
            case 9: {
                    message.birthDate = $root.space.kenko.proto.LocalDateProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiUserProto message.
     * @function verify
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiUserProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            if (!$util.isString(message.familyName))
                return "familyName: string expected";
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            if (!$util.isString(message.givenName))
                return "givenName: string expected";
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers")) {
            var error = $root.WellnessSurveyProto.verify(message.wellnessSurveyAnswers);
            if (error)
                return "wellnessSurveyAnswers." + error;
        }
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            if (!$util.isString(message.mobileNumber))
                return "mobileNumber: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.verifiedContactMethods != null && message.hasOwnProperty("verifiedContactMethods")) {
            if (!Array.isArray(message.verifiedContactMethods))
                return "verifiedContactMethods: array expected";
            for (var i = 0; i < message.verifiedContactMethods.length; ++i) {
                var error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.verifiedContactMethods[i]);
                if (error)
                    return "verifiedContactMethods." + error;
            }
        }
        if (message.acceptedTermsVersions != null && message.hasOwnProperty("acceptedTermsVersions")) {
            if (!Array.isArray(message.acceptedTermsVersions))
                return "acceptedTermsVersions: array expected";
            for (var i = 0; i < message.acceptedTermsVersions.length; ++i)
                if (!$util.isString(message.acceptedTermsVersions[i]))
                    return "acceptedTermsVersions: string[] expected";
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate")) {
            var error = $root.space.kenko.proto.LocalDateProto.verify(message.birthDate);
            if (error)
                return "birthDate." + error;
        }
        return null;
    };

    /**
     * Creates an ApiUserProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiUserProto} ApiUserProto
     */
    ApiUserProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiUserProto)
            return object;
        var message = new $root.ApiUserProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.familyName != null)
            message.familyName = String(object.familyName);
        if (object.givenName != null)
            message.givenName = String(object.givenName);
        if (object.wellnessSurveyAnswers != null) {
            if (typeof object.wellnessSurveyAnswers !== "object")
                throw TypeError(".ApiUserProto.wellnessSurveyAnswers: object expected");
            message.wellnessSurveyAnswers = $root.WellnessSurveyProto.fromObject(object.wellnessSurveyAnswers);
        }
        if (object.mobileNumber != null)
            message.mobileNumber = String(object.mobileNumber);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.verifiedContactMethods) {
            if (!Array.isArray(object.verifiedContactMethods))
                throw TypeError(".ApiUserProto.verifiedContactMethods: array expected");
            message.verifiedContactMethods = [];
            for (var i = 0; i < object.verifiedContactMethods.length; ++i) {
                if (typeof object.verifiedContactMethods[i] !== "object")
                    throw TypeError(".ApiUserProto.verifiedContactMethods: object expected");
                message.verifiedContactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.verifiedContactMethods[i]);
            }
        }
        if (object.acceptedTermsVersions) {
            if (!Array.isArray(object.acceptedTermsVersions))
                throw TypeError(".ApiUserProto.acceptedTermsVersions: array expected");
            message.acceptedTermsVersions = [];
            for (var i = 0; i < object.acceptedTermsVersions.length; ++i)
                message.acceptedTermsVersions[i] = String(object.acceptedTermsVersions[i]);
        }
        if (object.birthDate != null) {
            if (typeof object.birthDate !== "object")
                throw TypeError(".ApiUserProto.birthDate: object expected");
            message.birthDate = $root.space.kenko.proto.LocalDateProto.fromObject(object.birthDate);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiUserProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiUserProto
     * @static
     * @param {ApiUserProto} message ApiUserProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiUserProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.verifiedContactMethods = [];
            object.acceptedTermsVersions = [];
        }
        if (options.defaults) {
            object.userId = "";
            object.familyName = "";
            object.givenName = "";
            object.wellnessSurveyAnswers = null;
            object.mobileNumber = "";
            object.contactEmail = "";
            object.birthDate = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            object.familyName = message.familyName;
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            object.givenName = message.givenName;
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers"))
            object.wellnessSurveyAnswers = $root.WellnessSurveyProto.toObject(message.wellnessSurveyAnswers, options);
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            object.mobileNumber = message.mobileNumber;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.verifiedContactMethods && message.verifiedContactMethods.length) {
            object.verifiedContactMethods = [];
            for (var j = 0; j < message.verifiedContactMethods.length; ++j)
                object.verifiedContactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.verifiedContactMethods[j], options);
        }
        if (message.acceptedTermsVersions && message.acceptedTermsVersions.length) {
            object.acceptedTermsVersions = [];
            for (var j = 0; j < message.acceptedTermsVersions.length; ++j)
                object.acceptedTermsVersions[j] = message.acceptedTermsVersions[j];
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate"))
            object.birthDate = $root.space.kenko.proto.LocalDateProto.toObject(message.birthDate, options);
        return object;
    };

    /**
     * Converts this ApiUserProto to JSON.
     * @function toJSON
     * @memberof ApiUserProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiUserProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiUserProto
     * @function getTypeUrl
     * @memberof ApiUserProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiUserProto";
    };

    return ApiUserProto;
})();

$root.WellnessSurveyProto = (function() {

    /**
     * Properties of a WellnessSurveyProto.
     * @exports IWellnessSurveyProto
     * @interface IWellnessSurveyProto
     * @property {Array.<string>|null} [wellnessGoals] WellnessSurveyProto wellnessGoals
     * @property {Array.<string>|null} [holisticHealthInterests] WellnessSurveyProto holisticHealthInterests
     * @property {string|null} [opennessToHolisticModalities] WellnessSurveyProto opennessToHolisticModalities
     * @property {string|null} [gender] WellnessSurveyProto gender
     */

    /**
     * Constructs a new WellnessSurveyProto.
     * @exports WellnessSurveyProto
     * @classdesc Represents a WellnessSurveyProto.
     * @implements IWellnessSurveyProto
     * @constructor
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     */
    function WellnessSurveyProto(properties) {
        this.wellnessGoals = [];
        this.holisticHealthInterests = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WellnessSurveyProto wellnessGoals.
     * @member {Array.<string>} wellnessGoals
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.wellnessGoals = $util.emptyArray;

    /**
     * WellnessSurveyProto holisticHealthInterests.
     * @member {Array.<string>} holisticHealthInterests
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.holisticHealthInterests = $util.emptyArray;

    /**
     * WellnessSurveyProto opennessToHolisticModalities.
     * @member {string} opennessToHolisticModalities
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.opennessToHolisticModalities = "";

    /**
     * WellnessSurveyProto gender.
     * @member {string} gender
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.gender = "";

    /**
     * Creates a new WellnessSurveyProto instance using the specified properties.
     * @function create
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     * @returns {WellnessSurveyProto} WellnessSurveyProto instance
     */
    WellnessSurveyProto.create = function create(properties) {
        return new WellnessSurveyProto(properties);
    };

    /**
     * Encodes the specified WellnessSurveyProto message. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encode
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.wellnessGoals != null && message.wellnessGoals.length)
            for (var i = 0; i < message.wellnessGoals.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.wellnessGoals[i]);
        if (message.holisticHealthInterests != null && message.holisticHealthInterests.length)
            for (var i = 0; i < message.holisticHealthInterests.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.holisticHealthInterests[i]);
        if (message.opennessToHolisticModalities != null && Object.hasOwnProperty.call(message, "opennessToHolisticModalities"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.opennessToHolisticModalities);
        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.gender);
        return writer;
    };

    /**
     * Encodes the specified WellnessSurveyProto message, length delimited. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer.
     * @function decode
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WellnessSurveyProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.wellnessGoals && message.wellnessGoals.length))
                        message.wellnessGoals = [];
                    message.wellnessGoals.push(reader.string());
                    break;
                }
            case 2: {
                    if (!(message.holisticHealthInterests && message.holisticHealthInterests.length))
                        message.holisticHealthInterests = [];
                    message.holisticHealthInterests.push(reader.string());
                    break;
                }
            case 3: {
                    message.opennessToHolisticModalities = reader.string();
                    break;
                }
            case 4: {
                    message.gender = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WellnessSurveyProto message.
     * @function verify
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WellnessSurveyProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.wellnessGoals != null && message.hasOwnProperty("wellnessGoals")) {
            if (!Array.isArray(message.wellnessGoals))
                return "wellnessGoals: array expected";
            for (var i = 0; i < message.wellnessGoals.length; ++i)
                if (!$util.isString(message.wellnessGoals[i]))
                    return "wellnessGoals: string[] expected";
        }
        if (message.holisticHealthInterests != null && message.hasOwnProperty("holisticHealthInterests")) {
            if (!Array.isArray(message.holisticHealthInterests))
                return "holisticHealthInterests: array expected";
            for (var i = 0; i < message.holisticHealthInterests.length; ++i)
                if (!$util.isString(message.holisticHealthInterests[i]))
                    return "holisticHealthInterests: string[] expected";
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            if (!$util.isString(message.opennessToHolisticModalities))
                return "opennessToHolisticModalities: string expected";
        if (message.gender != null && message.hasOwnProperty("gender"))
            if (!$util.isString(message.gender))
                return "gender: string expected";
        return null;
    };

    /**
     * Creates a WellnessSurveyProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     */
    WellnessSurveyProto.fromObject = function fromObject(object) {
        if (object instanceof $root.WellnessSurveyProto)
            return object;
        var message = new $root.WellnessSurveyProto();
        if (object.wellnessGoals) {
            if (!Array.isArray(object.wellnessGoals))
                throw TypeError(".WellnessSurveyProto.wellnessGoals: array expected");
            message.wellnessGoals = [];
            for (var i = 0; i < object.wellnessGoals.length; ++i)
                message.wellnessGoals[i] = String(object.wellnessGoals[i]);
        }
        if (object.holisticHealthInterests) {
            if (!Array.isArray(object.holisticHealthInterests))
                throw TypeError(".WellnessSurveyProto.holisticHealthInterests: array expected");
            message.holisticHealthInterests = [];
            for (var i = 0; i < object.holisticHealthInterests.length; ++i)
                message.holisticHealthInterests[i] = String(object.holisticHealthInterests[i]);
        }
        if (object.opennessToHolisticModalities != null)
            message.opennessToHolisticModalities = String(object.opennessToHolisticModalities);
        if (object.gender != null)
            message.gender = String(object.gender);
        return message;
    };

    /**
     * Creates a plain object from a WellnessSurveyProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {WellnessSurveyProto} message WellnessSurveyProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WellnessSurveyProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.wellnessGoals = [];
            object.holisticHealthInterests = [];
        }
        if (options.defaults) {
            object.opennessToHolisticModalities = "";
            object.gender = "";
        }
        if (message.wellnessGoals && message.wellnessGoals.length) {
            object.wellnessGoals = [];
            for (var j = 0; j < message.wellnessGoals.length; ++j)
                object.wellnessGoals[j] = message.wellnessGoals[j];
        }
        if (message.holisticHealthInterests && message.holisticHealthInterests.length) {
            object.holisticHealthInterests = [];
            for (var j = 0; j < message.holisticHealthInterests.length; ++j)
                object.holisticHealthInterests[j] = message.holisticHealthInterests[j];
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            object.opennessToHolisticModalities = message.opennessToHolisticModalities;
        if (message.gender != null && message.hasOwnProperty("gender"))
            object.gender = message.gender;
        return object;
    };

    /**
     * Converts this WellnessSurveyProto to JSON.
     * @function toJSON
     * @memberof WellnessSurveyProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WellnessSurveyProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WellnessSurveyProto
     * @function getTypeUrl
     * @memberof WellnessSurveyProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WellnessSurveyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WellnessSurveyProto";
    };

    return WellnessSurveyProto;
})();

$root.ClientRelationshipProto = (function() {

    /**
     * Properties of a ClientRelationshipProto.
     * @exports IClientRelationshipProto
     * @interface IClientRelationshipProto
     * @property {string|null} [businessId] ClientRelationshipProto businessId
     * @property {IClientRelationshipDetailsProto|null} [details] ClientRelationshipProto details
     */

    /**
     * Constructs a new ClientRelationshipProto.
     * @exports ClientRelationshipProto
     * @classdesc Represents a ClientRelationshipProto.
     * @implements IClientRelationshipProto
     * @constructor
     * @param {IClientRelationshipProto=} [properties] Properties to set
     */
    function ClientRelationshipProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipProto businessId.
     * @member {string} businessId
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.businessId = "";

    /**
     * ClientRelationshipProto details.
     * @member {IClientRelationshipDetailsProto|null|undefined} details
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.details = null;

    /**
     * Creates a new ClientRelationshipProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto=} [properties] Properties to set
     * @returns {ClientRelationshipProto} ClientRelationshipProto instance
     */
    ClientRelationshipProto.create = function create(properties) {
        return new ClientRelationshipProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipProto message. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientRelationshipDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipProto message, length delimited. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipProto message.
     * @function verify
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.ClientRelationshipDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     */
    ClientRelationshipProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipProto)
            return object;
        var message = new $root.ClientRelationshipProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ClientRelationshipProto.details: object expected");
            message.details = $root.ClientRelationshipDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {ClientRelationshipProto} message ClientRelationshipProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.details = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientRelationshipDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ClientRelationshipProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipProto
     * @function getTypeUrl
     * @memberof ClientRelationshipProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipProto";
    };

    return ClientRelationshipProto;
})();

$root.ClientRelationshipDetailsProto = (function() {

    /**
     * Properties of a ClientRelationshipDetailsProto.
     * @exports IClientRelationshipDetailsProto
     * @interface IClientRelationshipDetailsProto
     * @property {number|Long|null} [createdTimestampMs] ClientRelationshipDetailsProto createdTimestampMs
     * @property {Array.<IPurchasedPackageProto>|null} [purchasedClassPacks] ClientRelationshipDetailsProto purchasedClassPacks
     * @property {Array.<IPurchasedSingleClassCreditProto>|null} [singleClassCredits] ClientRelationshipDetailsProto singleClassCredits
     */

    /**
     * Constructs a new ClientRelationshipDetailsProto.
     * @exports ClientRelationshipDetailsProto
     * @classdesc Represents a ClientRelationshipDetailsProto.
     * @implements IClientRelationshipDetailsProto
     * @constructor
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     */
    function ClientRelationshipDetailsProto(properties) {
        this.purchasedClassPacks = [];
        this.singleClassCredits = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipDetailsProto createdTimestampMs.
     * @member {number|Long} createdTimestampMs
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientRelationshipDetailsProto purchasedClassPacks.
     * @member {Array.<IPurchasedPackageProto>} purchasedClassPacks
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.purchasedClassPacks = $util.emptyArray;

    /**
     * ClientRelationshipDetailsProto singleClassCredits.
     * @member {Array.<IPurchasedSingleClassCreditProto>} singleClassCredits
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.singleClassCredits = $util.emptyArray;

    /**
     * Creates a new ClientRelationshipDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto instance
     */
    ClientRelationshipDetailsProto.create = function create(properties) {
        return new ClientRelationshipDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createdTimestampMs);
        if (message.purchasedClassPacks != null && message.purchasedClassPacks.length)
            for (var i = 0; i < message.purchasedClassPacks.length; ++i)
                $root.PurchasedPackageProto.encode(message.purchasedClassPacks[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.singleClassCredits != null && message.singleClassCredits.length)
            for (var i = 0; i < message.singleClassCredits.length; ++i)
                $root.PurchasedSingleClassCreditProto.encode(message.singleClassCredits[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message, length delimited. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipDetailsProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createdTimestampMs = reader.int64();
                    break;
                }
            case 10: {
                    if (!(message.purchasedClassPacks && message.purchasedClassPacks.length))
                        message.purchasedClassPacks = [];
                    message.purchasedClassPacks.push($root.PurchasedPackageProto.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    if (!(message.singleClassCredits && message.singleClassCredits.length))
                        message.singleClassCredits = [];
                    message.singleClassCredits.push($root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipDetailsProto message.
     * @function verify
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                return "createdTimestampMs: integer|Long expected";
        if (message.purchasedClassPacks != null && message.hasOwnProperty("purchasedClassPacks")) {
            if (!Array.isArray(message.purchasedClassPacks))
                return "purchasedClassPacks: array expected";
            for (var i = 0; i < message.purchasedClassPacks.length; ++i) {
                var error = $root.PurchasedPackageProto.verify(message.purchasedClassPacks[i]);
                if (error)
                    return "purchasedClassPacks." + error;
            }
        }
        if (message.singleClassCredits != null && message.hasOwnProperty("singleClassCredits")) {
            if (!Array.isArray(message.singleClassCredits))
                return "singleClassCredits: array expected";
            for (var i = 0; i < message.singleClassCredits.length; ++i) {
                var error = $root.PurchasedSingleClassCreditProto.verify(message.singleClassCredits[i]);
                if (error)
                    return "singleClassCredits." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     */
    ClientRelationshipDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipDetailsProto)
            return object;
        var message = new $root.ClientRelationshipDetailsProto();
        if (object.createdTimestampMs != null)
            if ($util.Long)
                (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
            else if (typeof object.createdTimestampMs === "string")
                message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
            else if (typeof object.createdTimestampMs === "number")
                message.createdTimestampMs = object.createdTimestampMs;
            else if (typeof object.createdTimestampMs === "object")
                message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
        if (object.purchasedClassPacks) {
            if (!Array.isArray(object.purchasedClassPacks))
                throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: array expected");
            message.purchasedClassPacks = [];
            for (var i = 0; i < object.purchasedClassPacks.length; ++i) {
                if (typeof object.purchasedClassPacks[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: object expected");
                message.purchasedClassPacks[i] = $root.PurchasedPackageProto.fromObject(object.purchasedClassPacks[i]);
            }
        }
        if (object.singleClassCredits) {
            if (!Array.isArray(object.singleClassCredits))
                throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: array expected");
            message.singleClassCredits = [];
            for (var i = 0; i < object.singleClassCredits.length; ++i) {
                if (typeof object.singleClassCredits[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: object expected");
                message.singleClassCredits[i] = $root.PurchasedSingleClassCreditProto.fromObject(object.singleClassCredits[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {ClientRelationshipDetailsProto} message ClientRelationshipDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.purchasedClassPacks = [];
            object.singleClassCredits = [];
        }
        if (options.defaults)
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createdTimestampMs = options.longs === String ? "0" : 0;
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (typeof message.createdTimestampMs === "number")
                object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
            else
                object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
        if (message.purchasedClassPacks && message.purchasedClassPacks.length) {
            object.purchasedClassPacks = [];
            for (var j = 0; j < message.purchasedClassPacks.length; ++j)
                object.purchasedClassPacks[j] = $root.PurchasedPackageProto.toObject(message.purchasedClassPacks[j], options);
        }
        if (message.singleClassCredits && message.singleClassCredits.length) {
            object.singleClassCredits = [];
            for (var j = 0; j < message.singleClassCredits.length; ++j)
                object.singleClassCredits[j] = $root.PurchasedSingleClassCreditProto.toObject(message.singleClassCredits[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientRelationshipDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipDetailsProto
     * @function getTypeUrl
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipDetailsProto";
    };

    return ClientRelationshipDetailsProto;
})();

$root.ApiClientInquiryProto = (function() {

    /**
     * Properties of an ApiClientInquiryProto.
     * @exports IApiClientInquiryProto
     * @interface IApiClientInquiryProto
     * @property {string|null} [userId] ApiClientInquiryProto userId
     * @property {IClientInquiryDetailsProto|null} [details] ApiClientInquiryProto details
     */

    /**
     * Constructs a new ApiClientInquiryProto.
     * @exports ApiClientInquiryProto
     * @classdesc Represents an ApiClientInquiryProto.
     * @implements IApiClientInquiryProto
     * @constructor
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     */
    function ApiClientInquiryProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiClientInquiryProto userId.
     * @member {string} userId
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.userId = "";

    /**
     * ApiClientInquiryProto details.
     * @member {IClientInquiryDetailsProto|null|undefined} details
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.details = null;

    /**
     * Creates a new ApiClientInquiryProto instance using the specified properties.
     * @function create
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto instance
     */
    ApiClientInquiryProto.create = function create(properties) {
        return new ApiClientInquiryProto(properties);
    };

    /**
     * Encodes the specified ApiClientInquiryProto message. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientInquiryDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiClientInquiryProto message, length delimited. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiClientInquiryProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientInquiryDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiClientInquiryProto message.
     * @function verify
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiClientInquiryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            var error = $root.ClientInquiryDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates an ApiClientInquiryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     */
    ApiClientInquiryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiClientInquiryProto)
            return object;
        var message = new $root.ApiClientInquiryProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ApiClientInquiryProto.details: object expected");
            message.details = $root.ClientInquiryDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiClientInquiryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {ApiClientInquiryProto} message ApiClientInquiryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiClientInquiryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.userId = "";
            object.details = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientInquiryDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ApiClientInquiryProto to JSON.
     * @function toJSON
     * @memberof ApiClientInquiryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiClientInquiryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiClientInquiryProto
     * @function getTypeUrl
     * @memberof ApiClientInquiryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiClientInquiryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiClientInquiryProto";
    };

    return ApiClientInquiryProto;
})();

$root.ClientInquiryDetailsProto = (function() {

    /**
     * Properties of a ClientInquiryDetailsProto.
     * @exports IClientInquiryDetailsProto
     * @interface IClientInquiryDetailsProto
     * @property {number|Long|null} [createTimestampMs] ClientInquiryDetailsProto createTimestampMs
     * @property {string|null} [message] ClientInquiryDetailsProto message
     * @property {boolean|null} [rejectedByProvider] ClientInquiryDetailsProto rejectedByProvider
     * @property {string|null} [inquirerEmail] ClientInquiryDetailsProto inquirerEmail
     * @property {string|null} [inquirerName] ClientInquiryDetailsProto inquirerName
     */

    /**
     * Constructs a new ClientInquiryDetailsProto.
     * @exports ClientInquiryDetailsProto
     * @classdesc Represents a ClientInquiryDetailsProto.
     * @implements IClientInquiryDetailsProto
     * @constructor
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     */
    function ClientInquiryDetailsProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInquiryDetailsProto createTimestampMs.
     * @member {number|Long} createTimestampMs
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.createTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientInquiryDetailsProto message.
     * @member {string} message
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.message = "";

    /**
     * ClientInquiryDetailsProto rejectedByProvider.
     * @member {boolean} rejectedByProvider
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.rejectedByProvider = false;

    /**
     * ClientInquiryDetailsProto inquirerEmail.
     * @member {string} inquirerEmail
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerEmail = "";

    /**
     * ClientInquiryDetailsProto inquirerName.
     * @member {string} inquirerName
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerName = "";

    /**
     * Creates a new ClientInquiryDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto instance
     */
    ClientInquiryDetailsProto.create = function create(properties) {
        return new ClientInquiryDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createTimestampMs != null && Object.hasOwnProperty.call(message, "createTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createTimestampMs);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        if (message.rejectedByProvider != null && Object.hasOwnProperty.call(message, "rejectedByProvider"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.rejectedByProvider);
        if (message.inquirerEmail != null && Object.hasOwnProperty.call(message, "inquirerEmail"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.inquirerEmail);
        if (message.inquirerName != null && Object.hasOwnProperty.call(message, "inquirerName"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.inquirerName);
        return writer;
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message, length delimited. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInquiryDetailsProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createTimestampMs = reader.int64();
                    break;
                }
            case 2: {
                    message.message = reader.string();
                    break;
                }
            case 3: {
                    message.rejectedByProvider = reader.bool();
                    break;
                }
            case 4: {
                    message.inquirerEmail = reader.string();
                    break;
                }
            case 5: {
                    message.inquirerName = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInquiryDetailsProto message.
     * @function verify
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInquiryDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (!$util.isInteger(message.createTimestampMs) && !(message.createTimestampMs && $util.isInteger(message.createTimestampMs.low) && $util.isInteger(message.createTimestampMs.high)))
                return "createTimestampMs: integer|Long expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            if (typeof message.rejectedByProvider !== "boolean")
                return "rejectedByProvider: boolean expected";
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            if (!$util.isString(message.inquirerEmail))
                return "inquirerEmail: string expected";
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            if (!$util.isString(message.inquirerName))
                return "inquirerName: string expected";
        return null;
    };

    /**
     * Creates a ClientInquiryDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     */
    ClientInquiryDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInquiryDetailsProto)
            return object;
        var message = new $root.ClientInquiryDetailsProto();
        if (object.createTimestampMs != null)
            if ($util.Long)
                (message.createTimestampMs = $util.Long.fromValue(object.createTimestampMs)).unsigned = false;
            else if (typeof object.createTimestampMs === "string")
                message.createTimestampMs = parseInt(object.createTimestampMs, 10);
            else if (typeof object.createTimestampMs === "number")
                message.createTimestampMs = object.createTimestampMs;
            else if (typeof object.createTimestampMs === "object")
                message.createTimestampMs = new $util.LongBits(object.createTimestampMs.low >>> 0, object.createTimestampMs.high >>> 0).toNumber();
        if (object.message != null)
            message.message = String(object.message);
        if (object.rejectedByProvider != null)
            message.rejectedByProvider = Boolean(object.rejectedByProvider);
        if (object.inquirerEmail != null)
            message.inquirerEmail = String(object.inquirerEmail);
        if (object.inquirerName != null)
            message.inquirerName = String(object.inquirerName);
        return message;
    };

    /**
     * Creates a plain object from a ClientInquiryDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {ClientInquiryDetailsProto} message ClientInquiryDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInquiryDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.createTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createTimestampMs = options.longs === String ? "0" : 0;
            object.message = "";
            object.rejectedByProvider = false;
            object.inquirerEmail = "";
            object.inquirerName = "";
        }
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (typeof message.createTimestampMs === "number")
                object.createTimestampMs = options.longs === String ? String(message.createTimestampMs) : message.createTimestampMs;
            else
                object.createTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimestampMs) : options.longs === Number ? new $util.LongBits(message.createTimestampMs.low >>> 0, message.createTimestampMs.high >>> 0).toNumber() : message.createTimestampMs;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            object.rejectedByProvider = message.rejectedByProvider;
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            object.inquirerEmail = message.inquirerEmail;
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            object.inquirerName = message.inquirerName;
        return object;
    };

    /**
     * Converts this ClientInquiryDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientInquiryDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInquiryDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInquiryDetailsProto
     * @function getTypeUrl
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInquiryDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInquiryDetailsProto";
    };

    return ClientInquiryDetailsProto;
})();

$root.PurchasedPackageProto = (function() {

    /**
     * Properties of a PurchasedPackageProto.
     * @exports IPurchasedPackageProto
     * @interface IPurchasedPackageProto
     * @property {string|null} [purchasedClassPackId] PurchasedPackageProto purchasedClassPackId
     * @property {IPackageProto|null} [packageDetails] PurchasedPackageProto packageDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedPackageProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedPackageProto stripeSessionId
     * @property {number|null} [classesRemaining] PurchasedPackageProto classesRemaining
     */

    /**
     * Constructs a new PurchasedPackageProto.
     * @exports PurchasedPackageProto
     * @classdesc Represents a PurchasedPackageProto.
     * @implements IPurchasedPackageProto
     * @constructor
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     */
    function PurchasedPackageProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedPackageProto purchasedClassPackId.
     * @member {string} purchasedClassPackId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchasedClassPackId = "";

    /**
     * PurchasedPackageProto packageDetails.
     * @member {IPackageProto|null|undefined} packageDetails
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.packageDetails = null;

    /**
     * PurchasedPackageProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedPackageProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.stripeSessionId = "";

    /**
     * PurchasedPackageProto classesRemaining.
     * @member {number} classesRemaining
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.classesRemaining = 0;

    /**
     * Creates a new PurchasedPackageProto instance using the specified properties.
     * @function create
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     * @returns {PurchasedPackageProto} PurchasedPackageProto instance
     */
    PurchasedPackageProto.create = function create(properties) {
        return new PurchasedPackageProto(properties);
    };

    /**
     * Encodes the specified PurchasedPackageProto message. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.purchasedClassPackId != null && Object.hasOwnProperty.call(message, "purchasedClassPackId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedClassPackId);
        if (message.packageDetails != null && Object.hasOwnProperty.call(message, "packageDetails"))
            $root.PackageProto.encode(message.packageDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.classesRemaining != null && Object.hasOwnProperty.call(message, "classesRemaining"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.classesRemaining);
        return writer;
    };

    /**
     * Encodes the specified PurchasedPackageProto message, length delimited. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedPackageProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.purchasedClassPackId = reader.string();
                    break;
                }
            case 2: {
                    message.packageDetails = $root.PackageProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.classesRemaining = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedPackageProto message.
     * @function verify
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedPackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            if (!$util.isString(message.purchasedClassPackId))
                return "purchasedClassPackId: string expected";
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails")) {
            var error = $root.PackageProto.verify(message.packageDetails);
            if (error)
                return "packageDetails." + error;
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            if (!$util.isInteger(message.classesRemaining))
                return "classesRemaining: integer expected";
        return null;
    };

    /**
     * Creates a PurchasedPackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     */
    PurchasedPackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedPackageProto)
            return object;
        var message = new $root.PurchasedPackageProto();
        if (object.purchasedClassPackId != null)
            message.purchasedClassPackId = String(object.purchasedClassPackId);
        if (object.packageDetails != null) {
            if (typeof object.packageDetails !== "object")
                throw TypeError(".PurchasedPackageProto.packageDetails: object expected");
            message.packageDetails = $root.PackageProto.fromObject(object.packageDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.classesRemaining != null)
            message.classesRemaining = object.classesRemaining | 0;
        return message;
    };

    /**
     * Creates a plain object from a PurchasedPackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {PurchasedPackageProto} message PurchasedPackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedPackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.purchasedClassPackId = "";
            object.packageDetails = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.classesRemaining = 0;
        }
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            object.purchasedClassPackId = message.purchasedClassPackId;
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails"))
            object.packageDetails = $root.PackageProto.toObject(message.packageDetails, options);
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            object.classesRemaining = message.classesRemaining;
        return object;
    };

    /**
     * Converts this PurchasedPackageProto to JSON.
     * @function toJSON
     * @memberof PurchasedPackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedPackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedPackageProto
     * @function getTypeUrl
     * @memberof PurchasedPackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedPackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedPackageProto";
    };

    return PurchasedPackageProto;
})();

$root.PurchasedSingleClassCreditProto = (function() {

    /**
     * Properties of a PurchasedSingleClassCreditProto.
     * @exports IPurchasedSingleClassCreditProto
     * @interface IPurchasedSingleClassCreditProto
     * @property {string|null} [classCreditId] PurchasedSingleClassCreditProto classCreditId
     * @property {IPriceCategoryProto|null} [priceCategoryDetails] PurchasedSingleClassCreditProto priceCategoryDetails
     * @property {IPurchasedClassCreditProto|null} [classDetails] PurchasedSingleClassCreditProto classDetails
     * @property {IPurchasedServiceCreditProto|null} [serviceDetails] PurchasedSingleClassCreditProto serviceDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedSingleClassCreditProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedSingleClassCreditProto stripeSessionId
     * @property {boolean|null} [used] PurchasedSingleClassCreditProto used
     */

    /**
     * Constructs a new PurchasedSingleClassCreditProto.
     * @exports PurchasedSingleClassCreditProto
     * @classdesc Represents a PurchasedSingleClassCreditProto.
     * @implements IPurchasedSingleClassCreditProto
     * @constructor
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     */
    function PurchasedSingleClassCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedSingleClassCreditProto classCreditId.
     * @member {string} classCreditId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classCreditId = "";

    /**
     * PurchasedSingleClassCreditProto priceCategoryDetails.
     * @member {IPriceCategoryProto|null|undefined} priceCategoryDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.priceCategoryDetails = null;

    /**
     * PurchasedSingleClassCreditProto classDetails.
     * @member {IPurchasedClassCreditProto|null|undefined} classDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classDetails = null;

    /**
     * PurchasedSingleClassCreditProto serviceDetails.
     * @member {IPurchasedServiceCreditProto|null|undefined} serviceDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.serviceDetails = null;

    /**
     * PurchasedSingleClassCreditProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedSingleClassCreditProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.stripeSessionId = "";

    /**
     * PurchasedSingleClassCreditProto used.
     * @member {boolean} used
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.used = false;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * PurchasedSingleClassCreditProto CreditType.
     * @member {"priceCategoryDetails"|"classDetails"|"serviceDetails"|undefined} CreditType
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    Object.defineProperty(PurchasedSingleClassCreditProto.prototype, "CreditType", {
        get: $util.oneOfGetter($oneOfFields = ["priceCategoryDetails", "classDetails", "serviceDetails"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PurchasedSingleClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto instance
     */
    PurchasedSingleClassCreditProto.create = function create(properties) {
        return new PurchasedSingleClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classCreditId != null && Object.hasOwnProperty.call(message, "classCreditId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classCreditId);
        if (message.priceCategoryDetails != null && Object.hasOwnProperty.call(message, "priceCategoryDetails"))
            $root.PriceCategoryProto.encode(message.priceCategoryDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.used != null && Object.hasOwnProperty.call(message, "used"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.used);
        if (message.classDetails != null && Object.hasOwnProperty.call(message, "classDetails"))
            $root.PurchasedClassCreditProto.encode(message.classDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.serviceDetails != null && Object.hasOwnProperty.call(message, "serviceDetails"))
            $root.PurchasedServiceCreditProto.encode(message.serviceDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message, length delimited. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedSingleClassCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classCreditId = reader.string();
                    break;
                }
            case 2: {
                    message.priceCategoryDetails = $root.PriceCategoryProto.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.classDetails = $root.PurchasedClassCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.serviceDetails = $root.PurchasedServiceCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.used = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedSingleClassCreditProto message.
     * @function verify
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedSingleClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            if (!$util.isString(message.classCreditId))
                return "classCreditId: string expected";
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            properties.CreditType = 1;
            {
                var error = $root.PriceCategoryProto.verify(message.priceCategoryDetails);
                if (error)
                    return "priceCategoryDetails." + error;
            }
        }
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                var error = $root.PurchasedClassCreditProto.verify(message.classDetails);
                if (error)
                    return "classDetails." + error;
            }
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                var error = $root.PurchasedServiceCreditProto.verify(message.serviceDetails);
                if (error)
                    return "serviceDetails." + error;
            }
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.used != null && message.hasOwnProperty("used"))
            if (typeof message.used !== "boolean")
                return "used: boolean expected";
        return null;
    };

    /**
     * Creates a PurchasedSingleClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     */
    PurchasedSingleClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedSingleClassCreditProto)
            return object;
        var message = new $root.PurchasedSingleClassCreditProto();
        if (object.classCreditId != null)
            message.classCreditId = String(object.classCreditId);
        if (object.priceCategoryDetails != null) {
            if (typeof object.priceCategoryDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.priceCategoryDetails: object expected");
            message.priceCategoryDetails = $root.PriceCategoryProto.fromObject(object.priceCategoryDetails);
        }
        if (object.classDetails != null) {
            if (typeof object.classDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.classDetails: object expected");
            message.classDetails = $root.PurchasedClassCreditProto.fromObject(object.classDetails);
        }
        if (object.serviceDetails != null) {
            if (typeof object.serviceDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.serviceDetails: object expected");
            message.serviceDetails = $root.PurchasedServiceCreditProto.fromObject(object.serviceDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.used != null)
            message.used = Boolean(object.used);
        return message;
    };

    /**
     * Creates a plain object from a PurchasedSingleClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {PurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedSingleClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.classCreditId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.used = false;
        }
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            object.classCreditId = message.classCreditId;
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            object.priceCategoryDetails = $root.PriceCategoryProto.toObject(message.priceCategoryDetails, options);
            if (options.oneofs)
                object.CreditType = "priceCategoryDetails";
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.used != null && message.hasOwnProperty("used"))
            object.used = message.used;
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            object.classDetails = $root.PurchasedClassCreditProto.toObject(message.classDetails, options);
            if (options.oneofs)
                object.CreditType = "classDetails";
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            object.serviceDetails = $root.PurchasedServiceCreditProto.toObject(message.serviceDetails, options);
            if (options.oneofs)
                object.CreditType = "serviceDetails";
        }
        return object;
    };

    /**
     * Converts this PurchasedSingleClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedSingleClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedSingleClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedSingleClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedSingleClassCreditProto";
    };

    return PurchasedSingleClassCreditProto;
})();

$root.PurchasedClassCreditProto = (function() {

    /**
     * Properties of a PurchasedClassCreditProto.
     * @exports IPurchasedClassCreditProto
     * @interface IPurchasedClassCreditProto
     * @property {string|null} [classTemplateId] PurchasedClassCreditProto classTemplateId
     * @property {string|null} [className] PurchasedClassCreditProto className
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedClassCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedClassCreditProto.
     * @exports PurchasedClassCreditProto
     * @classdesc Represents a PurchasedClassCreditProto.
     * @implements IPurchasedClassCreditProto
     * @constructor
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     */
    function PurchasedClassCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedClassCreditProto classTemplateId.
     * @member {string} classTemplateId
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.classTemplateId = "";

    /**
     * PurchasedClassCreditProto className.
     * @member {string} className
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.className = "";

    /**
     * PurchasedClassCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto instance
     */
    PurchasedClassCreditProto.create = function create(properties) {
        return new PurchasedClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
        if (message.className != null && Object.hasOwnProperty.call(message, "className"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.className);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message, length delimited. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedClassCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classTemplateId = reader.string();
                    break;
                }
            case 2: {
                    message.className = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedClassCreditProto message.
     * @function verify
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            if (!$util.isString(message.classTemplateId))
                return "classTemplateId: string expected";
        if (message.className != null && message.hasOwnProperty("className"))
            if (!$util.isString(message.className))
                return "className: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     */
    PurchasedClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedClassCreditProto)
            return object;
        var message = new $root.PurchasedClassCreditProto();
        if (object.classTemplateId != null)
            message.classTemplateId = String(object.classTemplateId);
        if (object.className != null)
            message.className = String(object.className);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedClassCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {PurchasedClassCreditProto} message PurchasedClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.classTemplateId = "";
            object.className = "";
            object.purchasePrice = null;
        }
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            object.classTemplateId = message.classTemplateId;
        if (message.className != null && message.hasOwnProperty("className"))
            object.className = message.className;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedClassCreditProto";
    };

    return PurchasedClassCreditProto;
})();

$root.PurchasedServiceCreditProto = (function() {

    /**
     * Properties of a PurchasedServiceCreditProto.
     * @exports IPurchasedServiceCreditProto
     * @interface IPurchasedServiceCreditProto
     * @property {string|null} [serviceSku] PurchasedServiceCreditProto serviceSku
     * @property {string|null} [serviceName] PurchasedServiceCreditProto serviceName
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedServiceCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedServiceCreditProto.
     * @exports PurchasedServiceCreditProto
     * @classdesc Represents a PurchasedServiceCreditProto.
     * @implements IPurchasedServiceCreditProto
     * @constructor
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     */
    function PurchasedServiceCreditProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedServiceCreditProto serviceSku.
     * @member {string} serviceSku
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceSku = "";

    /**
     * PurchasedServiceCreditProto serviceName.
     * @member {string} serviceName
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceName = "";

    /**
     * PurchasedServiceCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedServiceCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto instance
     */
    PurchasedServiceCreditProto.create = function create(properties) {
        return new PurchasedServiceCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serviceSku != null && Object.hasOwnProperty.call(message, "serviceSku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.serviceSku);
        if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceName);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message, length delimited. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedServiceCreditProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.serviceSku = reader.string();
                    break;
                }
            case 2: {
                    message.serviceName = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedServiceCreditProto message.
     * @function verify
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedServiceCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            if (!$util.isString(message.serviceSku))
                return "serviceSku: string expected";
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            if (!$util.isString(message.serviceName))
                return "serviceName: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedServiceCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     */
    PurchasedServiceCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedServiceCreditProto)
            return object;
        var message = new $root.PurchasedServiceCreditProto();
        if (object.serviceSku != null)
            message.serviceSku = String(object.serviceSku);
        if (object.serviceName != null)
            message.serviceName = String(object.serviceName);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedServiceCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedServiceCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {PurchasedServiceCreditProto} message PurchasedServiceCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedServiceCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serviceSku = "";
            object.serviceName = "";
            object.purchasePrice = null;
        }
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            object.serviceSku = message.serviceSku;
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            object.serviceName = message.serviceName;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedServiceCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedServiceCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedServiceCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedServiceCreditProto
     * @function getTypeUrl
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedServiceCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedServiceCreditProto";
    };

    return PurchasedServiceCreditProto;
})();

$root.PriceCategoryProto = (function() {

    /**
     * Properties of a PriceCategoryProto.
     * @exports IPriceCategoryProto
     * @interface IPriceCategoryProto
     * @property {string|null} [categoryId] PriceCategoryProto categoryId
     * @property {string|null} [displayName] PriceCategoryProto displayName
     * @property {space.kenko.proto.IPriceProto|null} [singleClassPrice] PriceCategoryProto singleClassPrice
     * @property {boolean|null} [archived] PriceCategoryProto archived
     */

    /**
     * Constructs a new PriceCategoryProto.
     * @exports PriceCategoryProto
     * @classdesc Represents a PriceCategoryProto.
     * @implements IPriceCategoryProto
     * @constructor
     * @param {IPriceCategoryProto=} [properties] Properties to set
     */
    function PriceCategoryProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PriceCategoryProto categoryId.
     * @member {string} categoryId
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.categoryId = "";

    /**
     * PriceCategoryProto displayName.
     * @member {string} displayName
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.displayName = "";

    /**
     * PriceCategoryProto singleClassPrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} singleClassPrice
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.singleClassPrice = null;

    /**
     * PriceCategoryProto archived.
     * @member {boolean} archived
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.archived = false;

    /**
     * Creates a new PriceCategoryProto instance using the specified properties.
     * @function create
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto=} [properties] Properties to set
     * @returns {PriceCategoryProto} PriceCategoryProto instance
     */
    PriceCategoryProto.create = function create(properties) {
        return new PriceCategoryProto(properties);
    };

    /**
     * Encodes the specified PriceCategoryProto message. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encode
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.categoryId);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.singleClassPrice != null && Object.hasOwnProperty.call(message, "singleClassPrice"))
            $root.space.kenko.proto.PriceProto.encode(message.singleClassPrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PriceCategoryProto message, length delimited. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer.
     * @function decode
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PriceCategoryProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.categoryId = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    message.singleClassPrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PriceCategoryProto message.
     * @function verify
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PriceCategoryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            if (!$util.isString(message.categoryId))
                return "categoryId: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.singleClassPrice);
            if (error)
                return "singleClassPrice." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PriceCategoryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceCategoryProto} PriceCategoryProto
     */
    PriceCategoryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PriceCategoryProto)
            return object;
        var message = new $root.PriceCategoryProto();
        if (object.categoryId != null)
            message.categoryId = String(object.categoryId);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.singleClassPrice != null) {
            if (typeof object.singleClassPrice !== "object")
                throw TypeError(".PriceCategoryProto.singleClassPrice: object expected");
            message.singleClassPrice = $root.space.kenko.proto.PriceProto.fromObject(object.singleClassPrice);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PriceCategoryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceCategoryProto
     * @static
     * @param {PriceCategoryProto} message PriceCategoryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PriceCategoryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.categoryId = "";
            object.displayName = "";
            object.singleClassPrice = null;
            object.archived = false;
        }
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            object.categoryId = message.categoryId;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice"))
            object.singleClassPrice = $root.space.kenko.proto.PriceProto.toObject(message.singleClassPrice, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PriceCategoryProto to JSON.
     * @function toJSON
     * @memberof PriceCategoryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PriceCategoryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PriceCategoryProto
     * @function getTypeUrl
     * @memberof PriceCategoryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PriceCategoryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PriceCategoryProto";
    };

    return PriceCategoryProto;
})();

$root.PackageProto = (function() {

    /**
     * Properties of a PackageProto.
     * @exports IPackageProto
     * @interface IPackageProto
     * @property {string|null} [id] PackageProto id
     * @property {string|null} [displayName] PackageProto displayName
     * @property {Array.<string>|null} [includedClassOrServiceIds] PackageProto includedClassOrServiceIds
     * @property {number|null} [classLimit] PackageProto classLimit
     * @property {number|null} [expirationDays] PackageProto expirationDays
     * @property {space.kenko.proto.IPriceProto|null} [price] PackageProto price
     * @property {boolean|null} [archived] PackageProto archived
     */

    /**
     * Constructs a new PackageProto.
     * @exports PackageProto
     * @classdesc Represents a PackageProto.
     * @implements IPackageProto
     * @constructor
     * @param {IPackageProto=} [properties] Properties to set
     */
    function PackageProto(properties) {
        this.includedClassOrServiceIds = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PackageProto id.
     * @member {string} id
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.id = "";

    /**
     * PackageProto displayName.
     * @member {string} displayName
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.displayName = "";

    /**
     * PackageProto includedClassOrServiceIds.
     * @member {Array.<string>} includedClassOrServiceIds
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.includedClassOrServiceIds = $util.emptyArray;

    /**
     * PackageProto classLimit.
     * @member {number} classLimit
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.classLimit = 0;

    /**
     * PackageProto expirationDays.
     * @member {number} expirationDays
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.expirationDays = 0;

    /**
     * PackageProto price.
     * @member {space.kenko.proto.IPriceProto|null|undefined} price
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.price = null;

    /**
     * PackageProto archived.
     * @member {boolean} archived
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.archived = false;

    /**
     * Creates a new PackageProto instance using the specified properties.
     * @function create
     * @memberof PackageProto
     * @static
     * @param {IPackageProto=} [properties] Properties to set
     * @returns {PackageProto} PackageProto instance
     */
    PackageProto.create = function create(properties) {
        return new PackageProto(properties);
    };

    /**
     * Encodes the specified PackageProto message. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encode
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.includedClassOrServiceIds != null && message.includedClassOrServiceIds.length)
            for (var i = 0; i < message.includedClassOrServiceIds.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.includedClassOrServiceIds[i]);
        if (message.classLimit != null && Object.hasOwnProperty.call(message, "classLimit"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.classLimit);
        if (message.expirationDays != null && Object.hasOwnProperty.call(message, "expirationDays"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.expirationDays);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PackageProto message, length delimited. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PackageProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.includedClassOrServiceIds && message.includedClassOrServiceIds.length))
                        message.includedClassOrServiceIds = [];
                    message.includedClassOrServiceIds.push(reader.string());
                    break;
                }
            case 4: {
                    message.classLimit = reader.int32();
                    break;
                }
            case 5: {
                    message.expirationDays = reader.int32();
                    break;
                }
            case 6: {
                    message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PackageProto message.
     * @function verify
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.includedClassOrServiceIds != null && message.hasOwnProperty("includedClassOrServiceIds")) {
            if (!Array.isArray(message.includedClassOrServiceIds))
                return "includedClassOrServiceIds: array expected";
            for (var i = 0; i < message.includedClassOrServiceIds.length; ++i)
                if (!$util.isString(message.includedClassOrServiceIds[i]))
                    return "includedClassOrServiceIds: string[] expected";
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            if (!$util.isInteger(message.classLimit))
                return "classLimit: integer expected";
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            if (!$util.isInteger(message.expirationDays))
                return "expirationDays: integer expected";
        if (message.price != null && message.hasOwnProperty("price")) {
            var error = $root.space.kenko.proto.PriceProto.verify(message.price);
            if (error)
                return "price." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PackageProto} PackageProto
     */
    PackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PackageProto)
            return object;
        var message = new $root.PackageProto();
        if (object.id != null)
            message.id = String(object.id);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.includedClassOrServiceIds) {
            if (!Array.isArray(object.includedClassOrServiceIds))
                throw TypeError(".PackageProto.includedClassOrServiceIds: array expected");
            message.includedClassOrServiceIds = [];
            for (var i = 0; i < object.includedClassOrServiceIds.length; ++i)
                message.includedClassOrServiceIds[i] = String(object.includedClassOrServiceIds[i]);
        }
        if (object.classLimit != null)
            message.classLimit = object.classLimit | 0;
        if (object.expirationDays != null)
            message.expirationDays = object.expirationDays | 0;
        if (object.price != null) {
            if (typeof object.price !== "object")
                throw TypeError(".PackageProto.price: object expected");
            message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PackageProto
     * @static
     * @param {PackageProto} message PackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.includedClassOrServiceIds = [];
        if (options.defaults) {
            object.id = "";
            object.displayName = "";
            object.classLimit = 0;
            object.expirationDays = 0;
            object.price = null;
            object.archived = false;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.includedClassOrServiceIds && message.includedClassOrServiceIds.length) {
            object.includedClassOrServiceIds = [];
            for (var j = 0; j < message.includedClassOrServiceIds.length; ++j)
                object.includedClassOrServiceIds[j] = message.includedClassOrServiceIds[j];
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            object.classLimit = message.classLimit;
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            object.expirationDays = message.expirationDays;
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PackageProto to JSON.
     * @function toJSON
     * @memberof PackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PackageProto
     * @function getTypeUrl
     * @memberof PackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PackageProto";
    };

    return PackageProto;
})();

$root.CreateCheckoutSessionRequest = (function() {

    /**
     * Properties of a CreateCheckoutSessionRequest.
     * @exports ICreateCheckoutSessionRequest
     * @interface ICreateCheckoutSessionRequest
     * @property {string|null} [businessId] CreateCheckoutSessionRequest businessId
     * @property {IBookingTypeProto|null} [bookingType] CreateCheckoutSessionRequest bookingType
     * @property {IPaymentLineItemProto|null} [paymentLineItem] CreateCheckoutSessionRequest paymentLineItem
     */

    /**
     * Constructs a new CreateCheckoutSessionRequest.
     * @exports CreateCheckoutSessionRequest
     * @classdesc Creates a stripe session. This only gets invoked when a payment is
     * required, e.g. the user is currently paying for a single class or a
     * class pack (TODO subscriptions).
     * @implements ICreateCheckoutSessionRequest
     * @constructor
     * @param {ICreateCheckoutSessionRequest=} [properties] Properties to set
     */
    function CreateCheckoutSessionRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateCheckoutSessionRequest businessId.
     * @member {string} businessId
     * @memberof CreateCheckoutSessionRequest
     * @instance
     */
    CreateCheckoutSessionRequest.prototype.businessId = "";

    /**
     * CreateCheckoutSessionRequest bookingType.
     * @member {IBookingTypeProto|null|undefined} bookingType
     * @memberof CreateCheckoutSessionRequest
     * @instance
     */
    CreateCheckoutSessionRequest.prototype.bookingType = null;

    /**
     * CreateCheckoutSessionRequest paymentLineItem.
     * @member {IPaymentLineItemProto|null|undefined} paymentLineItem
     * @memberof CreateCheckoutSessionRequest
     * @instance
     */
    CreateCheckoutSessionRequest.prototype.paymentLineItem = null;

    /**
     * Creates a new CreateCheckoutSessionRequest instance using the specified properties.
     * @function create
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {ICreateCheckoutSessionRequest=} [properties] Properties to set
     * @returns {CreateCheckoutSessionRequest} CreateCheckoutSessionRequest instance
     */
    CreateCheckoutSessionRequest.create = function create(properties) {
        return new CreateCheckoutSessionRequest(properties);
    };

    /**
     * Encodes the specified CreateCheckoutSessionRequest message. Does not implicitly {@link CreateCheckoutSessionRequest.verify|verify} messages.
     * @function encode
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {ICreateCheckoutSessionRequest} message CreateCheckoutSessionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateCheckoutSessionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.bookingType != null && Object.hasOwnProperty.call(message, "bookingType"))
            $root.BookingTypeProto.encode(message.bookingType, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.paymentLineItem != null && Object.hasOwnProperty.call(message, "paymentLineItem"))
            $root.PaymentLineItemProto.encode(message.paymentLineItem, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CreateCheckoutSessionRequest message, length delimited. Does not implicitly {@link CreateCheckoutSessionRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {ICreateCheckoutSessionRequest} message CreateCheckoutSessionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateCheckoutSessionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateCheckoutSessionRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateCheckoutSessionRequest} CreateCheckoutSessionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateCheckoutSessionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateCheckoutSessionRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.bookingType = $root.BookingTypeProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.paymentLineItem = $root.PaymentLineItemProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateCheckoutSessionRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateCheckoutSessionRequest} CreateCheckoutSessionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateCheckoutSessionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateCheckoutSessionRequest message.
     * @function verify
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateCheckoutSessionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.bookingType != null && message.hasOwnProperty("bookingType")) {
            var error = $root.BookingTypeProto.verify(message.bookingType);
            if (error)
                return "bookingType." + error;
        }
        if (message.paymentLineItem != null && message.hasOwnProperty("paymentLineItem")) {
            var error = $root.PaymentLineItemProto.verify(message.paymentLineItem);
            if (error)
                return "paymentLineItem." + error;
        }
        return null;
    };

    /**
     * Creates a CreateCheckoutSessionRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateCheckoutSessionRequest} CreateCheckoutSessionRequest
     */
    CreateCheckoutSessionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateCheckoutSessionRequest)
            return object;
        var message = new $root.CreateCheckoutSessionRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.bookingType != null) {
            if (typeof object.bookingType !== "object")
                throw TypeError(".CreateCheckoutSessionRequest.bookingType: object expected");
            message.bookingType = $root.BookingTypeProto.fromObject(object.bookingType);
        }
        if (object.paymentLineItem != null) {
            if (typeof object.paymentLineItem !== "object")
                throw TypeError(".CreateCheckoutSessionRequest.paymentLineItem: object expected");
            message.paymentLineItem = $root.PaymentLineItemProto.fromObject(object.paymentLineItem);
        }
        return message;
    };

    /**
     * Creates a plain object from a CreateCheckoutSessionRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {CreateCheckoutSessionRequest} message CreateCheckoutSessionRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateCheckoutSessionRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.businessId = "";
            object.bookingType = null;
            object.paymentLineItem = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.bookingType != null && message.hasOwnProperty("bookingType"))
            object.bookingType = $root.BookingTypeProto.toObject(message.bookingType, options);
        if (message.paymentLineItem != null && message.hasOwnProperty("paymentLineItem"))
            object.paymentLineItem = $root.PaymentLineItemProto.toObject(message.paymentLineItem, options);
        return object;
    };

    /**
     * Converts this CreateCheckoutSessionRequest to JSON.
     * @function toJSON
     * @memberof CreateCheckoutSessionRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateCheckoutSessionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateCheckoutSessionRequest
     * @function getTypeUrl
     * @memberof CreateCheckoutSessionRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateCheckoutSessionRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateCheckoutSessionRequest";
    };

    return CreateCheckoutSessionRequest;
})();

$root.CreateCheckoutSessionResponse = (function() {

    /**
     * Properties of a CreateCheckoutSessionResponse.
     * @exports ICreateCheckoutSessionResponse
     * @interface ICreateCheckoutSessionResponse
     * @property {string|null} [clientSecret] CreateCheckoutSessionResponse clientSecret
     * @property {string|null} [sessionId] CreateCheckoutSessionResponse sessionId
     */

    /**
     * Constructs a new CreateCheckoutSessionResponse.
     * @exports CreateCheckoutSessionResponse
     * @classdesc Represents a CreateCheckoutSessionResponse.
     * @implements ICreateCheckoutSessionResponse
     * @constructor
     * @param {ICreateCheckoutSessionResponse=} [properties] Properties to set
     */
    function CreateCheckoutSessionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CreateCheckoutSessionResponse clientSecret.
     * @member {string} clientSecret
     * @memberof CreateCheckoutSessionResponse
     * @instance
     */
    CreateCheckoutSessionResponse.prototype.clientSecret = "";

    /**
     * CreateCheckoutSessionResponse sessionId.
     * @member {string} sessionId
     * @memberof CreateCheckoutSessionResponse
     * @instance
     */
    CreateCheckoutSessionResponse.prototype.sessionId = "";

    /**
     * Creates a new CreateCheckoutSessionResponse instance using the specified properties.
     * @function create
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {ICreateCheckoutSessionResponse=} [properties] Properties to set
     * @returns {CreateCheckoutSessionResponse} CreateCheckoutSessionResponse instance
     */
    CreateCheckoutSessionResponse.create = function create(properties) {
        return new CreateCheckoutSessionResponse(properties);
    };

    /**
     * Encodes the specified CreateCheckoutSessionResponse message. Does not implicitly {@link CreateCheckoutSessionResponse.verify|verify} messages.
     * @function encode
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {ICreateCheckoutSessionResponse} message CreateCheckoutSessionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateCheckoutSessionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.clientSecret != null && Object.hasOwnProperty.call(message, "clientSecret"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientSecret);
        if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sessionId);
        return writer;
    };

    /**
     * Encodes the specified CreateCheckoutSessionResponse message, length delimited. Does not implicitly {@link CreateCheckoutSessionResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {ICreateCheckoutSessionResponse} message CreateCheckoutSessionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CreateCheckoutSessionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CreateCheckoutSessionResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CreateCheckoutSessionResponse} CreateCheckoutSessionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateCheckoutSessionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CreateCheckoutSessionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.clientSecret = reader.string();
                    break;
                }
            case 2: {
                    message.sessionId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CreateCheckoutSessionResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CreateCheckoutSessionResponse} CreateCheckoutSessionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CreateCheckoutSessionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CreateCheckoutSessionResponse message.
     * @function verify
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CreateCheckoutSessionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.clientSecret != null && message.hasOwnProperty("clientSecret"))
            if (!$util.isString(message.clientSecret))
                return "clientSecret: string expected";
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            if (!$util.isString(message.sessionId))
                return "sessionId: string expected";
        return null;
    };

    /**
     * Creates a CreateCheckoutSessionResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CreateCheckoutSessionResponse} CreateCheckoutSessionResponse
     */
    CreateCheckoutSessionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CreateCheckoutSessionResponse)
            return object;
        var message = new $root.CreateCheckoutSessionResponse();
        if (object.clientSecret != null)
            message.clientSecret = String(object.clientSecret);
        if (object.sessionId != null)
            message.sessionId = String(object.sessionId);
        return message;
    };

    /**
     * Creates a plain object from a CreateCheckoutSessionResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {CreateCheckoutSessionResponse} message CreateCheckoutSessionResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CreateCheckoutSessionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.clientSecret = "";
            object.sessionId = "";
        }
        if (message.clientSecret != null && message.hasOwnProperty("clientSecret"))
            object.clientSecret = message.clientSecret;
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            object.sessionId = message.sessionId;
        return object;
    };

    /**
     * Converts this CreateCheckoutSessionResponse to JSON.
     * @function toJSON
     * @memberof CreateCheckoutSessionResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CreateCheckoutSessionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CreateCheckoutSessionResponse
     * @function getTypeUrl
     * @memberof CreateCheckoutSessionResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CreateCheckoutSessionResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CreateCheckoutSessionResponse";
    };

    return CreateCheckoutSessionResponse;
})();

$root.ClassBookingProto = (function() {

    /**
     * Properties of a ClassBookingProto.
     * @exports IClassBookingProto
     * @interface IClassBookingProto
     * @property {string|null} [eventInstanceId] ClassBookingProto eventInstanceId
     */

    /**
     * Constructs a new ClassBookingProto.
     * @exports ClassBookingProto
     * @classdesc Represents a ClassBookingProto.
     * @implements IClassBookingProto
     * @constructor
     * @param {IClassBookingProto=} [properties] Properties to set
     */
    function ClassBookingProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClassBookingProto eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof ClassBookingProto
     * @instance
     */
    ClassBookingProto.prototype.eventInstanceId = "";

    /**
     * Creates a new ClassBookingProto instance using the specified properties.
     * @function create
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto=} [properties] Properties to set
     * @returns {ClassBookingProto} ClassBookingProto instance
     */
    ClassBookingProto.create = function create(properties) {
        return new ClassBookingProto(properties);
    };

    /**
     * Encodes the specified ClassBookingProto message. Does not implicitly {@link ClassBookingProto.verify|verify} messages.
     * @function encode
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto} message ClassBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.eventInstanceId);
        return writer;
    };

    /**
     * Encodes the specified ClassBookingProto message, length delimited. Does not implicitly {@link ClassBookingProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto} message ClassBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClassBookingProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClassBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClassBookingProto} ClassBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClassBookingProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClassBookingProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClassBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClassBookingProto} ClassBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClassBookingProto message.
     * @function verify
     * @memberof ClassBookingProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClassBookingProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        return null;
    };

    /**
     * Creates a ClassBookingProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClassBookingProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClassBookingProto} ClassBookingProto
     */
    ClassBookingProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClassBookingProto)
            return object;
        var message = new $root.ClassBookingProto();
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        return message;
    };

    /**
     * Creates a plain object from a ClassBookingProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClassBookingProto
     * @static
     * @param {ClassBookingProto} message ClassBookingProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClassBookingProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.eventInstanceId = "";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        return object;
    };

    /**
     * Converts this ClassBookingProto to JSON.
     * @function toJSON
     * @memberof ClassBookingProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClassBookingProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClassBookingProto
     * @function getTypeUrl
     * @memberof ClassBookingProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClassBookingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClassBookingProto";
    };

    return ClassBookingProto;
})();

$root.BookingTypeProto = (function() {

    /**
     * Properties of a BookingTypeProto.
     * @exports IBookingTypeProto
     * @interface IBookingTypeProto
     * @property {IClassBookingProto|null} [classBooking] BookingTypeProto classBooking
     * @property {IAppointmentBookingProto|null} [appointmentBooking] BookingTypeProto appointmentBooking
     */

    /**
     * Constructs a new BookingTypeProto.
     * @exports BookingTypeProto
     * @classdesc Represents a BookingTypeProto.
     * @implements IBookingTypeProto
     * @constructor
     * @param {IBookingTypeProto=} [properties] Properties to set
     */
    function BookingTypeProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BookingTypeProto classBooking.
     * @member {IClassBookingProto|null|undefined} classBooking
     * @memberof BookingTypeProto
     * @instance
     */
    BookingTypeProto.prototype.classBooking = null;

    /**
     * BookingTypeProto appointmentBooking.
     * @member {IAppointmentBookingProto|null|undefined} appointmentBooking
     * @memberof BookingTypeProto
     * @instance
     */
    BookingTypeProto.prototype.appointmentBooking = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * BookingTypeProto Type.
     * @member {"classBooking"|"appointmentBooking"|undefined} Type
     * @memberof BookingTypeProto
     * @instance
     */
    Object.defineProperty(BookingTypeProto.prototype, "Type", {
        get: $util.oneOfGetter($oneOfFields = ["classBooking", "appointmentBooking"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new BookingTypeProto instance using the specified properties.
     * @function create
     * @memberof BookingTypeProto
     * @static
     * @param {IBookingTypeProto=} [properties] Properties to set
     * @returns {BookingTypeProto} BookingTypeProto instance
     */
    BookingTypeProto.create = function create(properties) {
        return new BookingTypeProto(properties);
    };

    /**
     * Encodes the specified BookingTypeProto message. Does not implicitly {@link BookingTypeProto.verify|verify} messages.
     * @function encode
     * @memberof BookingTypeProto
     * @static
     * @param {IBookingTypeProto} message BookingTypeProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookingTypeProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classBooking != null && Object.hasOwnProperty.call(message, "classBooking"))
            $root.ClassBookingProto.encode(message.classBooking, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.appointmentBooking != null && Object.hasOwnProperty.call(message, "appointmentBooking"))
            $root.AppointmentBookingProto.encode(message.appointmentBooking, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BookingTypeProto message, length delimited. Does not implicitly {@link BookingTypeProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BookingTypeProto
     * @static
     * @param {IBookingTypeProto} message BookingTypeProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BookingTypeProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BookingTypeProto message from the specified reader or buffer.
     * @function decode
     * @memberof BookingTypeProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BookingTypeProto} BookingTypeProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookingTypeProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BookingTypeProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classBooking = $root.ClassBookingProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.appointmentBooking = $root.AppointmentBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BookingTypeProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BookingTypeProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BookingTypeProto} BookingTypeProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BookingTypeProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BookingTypeProto message.
     * @function verify
     * @memberof BookingTypeProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BookingTypeProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            properties.Type = 1;
            {
                var error = $root.ClassBookingProto.verify(message.classBooking);
                if (error)
                    return "classBooking." + error;
            }
        }
        if (message.appointmentBooking != null && message.hasOwnProperty("appointmentBooking")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            {
                var error = $root.AppointmentBookingProto.verify(message.appointmentBooking);
                if (error)
                    return "appointmentBooking." + error;
            }
        }
        return null;
    };

    /**
     * Creates a BookingTypeProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BookingTypeProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BookingTypeProto} BookingTypeProto
     */
    BookingTypeProto.fromObject = function fromObject(object) {
        if (object instanceof $root.BookingTypeProto)
            return object;
        var message = new $root.BookingTypeProto();
        if (object.classBooking != null) {
            if (typeof object.classBooking !== "object")
                throw TypeError(".BookingTypeProto.classBooking: object expected");
            message.classBooking = $root.ClassBookingProto.fromObject(object.classBooking);
        }
        if (object.appointmentBooking != null) {
            if (typeof object.appointmentBooking !== "object")
                throw TypeError(".BookingTypeProto.appointmentBooking: object expected");
            message.appointmentBooking = $root.AppointmentBookingProto.fromObject(object.appointmentBooking);
        }
        return message;
    };

    /**
     * Creates a plain object from a BookingTypeProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BookingTypeProto
     * @static
     * @param {BookingTypeProto} message BookingTypeProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BookingTypeProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            object.classBooking = $root.ClassBookingProto.toObject(message.classBooking, options);
            if (options.oneofs)
                object.Type = "classBooking";
        }
        if (message.appointmentBooking != null && message.hasOwnProperty("appointmentBooking")) {
            object.appointmentBooking = $root.AppointmentBookingProto.toObject(message.appointmentBooking, options);
            if (options.oneofs)
                object.Type = "appointmentBooking";
        }
        return object;
    };

    /**
     * Converts this BookingTypeProto to JSON.
     * @function toJSON
     * @memberof BookingTypeProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BookingTypeProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BookingTypeProto
     * @function getTypeUrl
     * @memberof BookingTypeProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BookingTypeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BookingTypeProto";
    };

    return BookingTypeProto;
})();

$root.PaymentLineItemProto = (function() {

    /**
     * Properties of a PaymentLineItemProto.
     * @exports IPaymentLineItemProto
     * @interface IPaymentLineItemProto
     * @property {string|null} [singleClassPriceCategory] PaymentLineItemProto singleClassPriceCategory
     * @property {string|null} [packageId] PaymentLineItemProto packageId
     * @property {string|null} [classCredit] PaymentLineItemProto classCredit
     * @property {string|null} [serviceCredit] PaymentLineItemProto serviceCredit
     */

    /**
     * Constructs a new PaymentLineItemProto.
     * @exports PaymentLineItemProto
     * @classdesc Sometimes the user has options in how to pay for a thing; they
     * can buy a single credit or a package. This is
     * @implements IPaymentLineItemProto
     * @constructor
     * @param {IPaymentLineItemProto=} [properties] Properties to set
     */
    function PaymentLineItemProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PaymentLineItemProto singleClassPriceCategory.
     * @member {string|null|undefined} singleClassPriceCategory
     * @memberof PaymentLineItemProto
     * @instance
     */
    PaymentLineItemProto.prototype.singleClassPriceCategory = null;

    /**
     * PaymentLineItemProto packageId.
     * @member {string|null|undefined} packageId
     * @memberof PaymentLineItemProto
     * @instance
     */
    PaymentLineItemProto.prototype.packageId = null;

    /**
     * PaymentLineItemProto classCredit.
     * @member {string|null|undefined} classCredit
     * @memberof PaymentLineItemProto
     * @instance
     */
    PaymentLineItemProto.prototype.classCredit = null;

    /**
     * PaymentLineItemProto serviceCredit.
     * @member {string|null|undefined} serviceCredit
     * @memberof PaymentLineItemProto
     * @instance
     */
    PaymentLineItemProto.prototype.serviceCredit = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * PaymentLineItemProto Type.
     * @member {"singleClassPriceCategory"|"packageId"|"classCredit"|"serviceCredit"|undefined} Type
     * @memberof PaymentLineItemProto
     * @instance
     */
    Object.defineProperty(PaymentLineItemProto.prototype, "Type", {
        get: $util.oneOfGetter($oneOfFields = ["singleClassPriceCategory", "packageId", "classCredit", "serviceCredit"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PaymentLineItemProto instance using the specified properties.
     * @function create
     * @memberof PaymentLineItemProto
     * @static
     * @param {IPaymentLineItemProto=} [properties] Properties to set
     * @returns {PaymentLineItemProto} PaymentLineItemProto instance
     */
    PaymentLineItemProto.create = function create(properties) {
        return new PaymentLineItemProto(properties);
    };

    /**
     * Encodes the specified PaymentLineItemProto message. Does not implicitly {@link PaymentLineItemProto.verify|verify} messages.
     * @function encode
     * @memberof PaymentLineItemProto
     * @static
     * @param {IPaymentLineItemProto} message PaymentLineItemProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaymentLineItemProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.singleClassPriceCategory != null && Object.hasOwnProperty.call(message, "singleClassPriceCategory"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.singleClassPriceCategory);
        if (message.packageId != null && Object.hasOwnProperty.call(message, "packageId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.packageId);
        if (message.classCredit != null && Object.hasOwnProperty.call(message, "classCredit"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.classCredit);
        if (message.serviceCredit != null && Object.hasOwnProperty.call(message, "serviceCredit"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.serviceCredit);
        return writer;
    };

    /**
     * Encodes the specified PaymentLineItemProto message, length delimited. Does not implicitly {@link PaymentLineItemProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PaymentLineItemProto
     * @static
     * @param {IPaymentLineItemProto} message PaymentLineItemProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PaymentLineItemProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PaymentLineItemProto message from the specified reader or buffer.
     * @function decode
     * @memberof PaymentLineItemProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PaymentLineItemProto} PaymentLineItemProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaymentLineItemProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PaymentLineItemProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.singleClassPriceCategory = reader.string();
                    break;
                }
            case 2: {
                    message.packageId = reader.string();
                    break;
                }
            case 3: {
                    message.classCredit = reader.string();
                    break;
                }
            case 4: {
                    message.serviceCredit = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PaymentLineItemProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PaymentLineItemProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PaymentLineItemProto} PaymentLineItemProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PaymentLineItemProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PaymentLineItemProto message.
     * @function verify
     * @memberof PaymentLineItemProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PaymentLineItemProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.singleClassPriceCategory != null && message.hasOwnProperty("singleClassPriceCategory")) {
            properties.Type = 1;
            if (!$util.isString(message.singleClassPriceCategory))
                return "singleClassPriceCategory: string expected";
        }
        if (message.packageId != null && message.hasOwnProperty("packageId")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            if (!$util.isString(message.packageId))
                return "packageId: string expected";
        }
        if (message.classCredit != null && message.hasOwnProperty("classCredit")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            if (!$util.isString(message.classCredit))
                return "classCredit: string expected";
        }
        if (message.serviceCredit != null && message.hasOwnProperty("serviceCredit")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            if (!$util.isString(message.serviceCredit))
                return "serviceCredit: string expected";
        }
        return null;
    };

    /**
     * Creates a PaymentLineItemProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PaymentLineItemProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PaymentLineItemProto} PaymentLineItemProto
     */
    PaymentLineItemProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PaymentLineItemProto)
            return object;
        var message = new $root.PaymentLineItemProto();
        if (object.singleClassPriceCategory != null)
            message.singleClassPriceCategory = String(object.singleClassPriceCategory);
        if (object.packageId != null)
            message.packageId = String(object.packageId);
        if (object.classCredit != null)
            message.classCredit = String(object.classCredit);
        if (object.serviceCredit != null)
            message.serviceCredit = String(object.serviceCredit);
        return message;
    };

    /**
     * Creates a plain object from a PaymentLineItemProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PaymentLineItemProto
     * @static
     * @param {PaymentLineItemProto} message PaymentLineItemProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PaymentLineItemProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (message.singleClassPriceCategory != null && message.hasOwnProperty("singleClassPriceCategory")) {
            object.singleClassPriceCategory = message.singleClassPriceCategory;
            if (options.oneofs)
                object.Type = "singleClassPriceCategory";
        }
        if (message.packageId != null && message.hasOwnProperty("packageId")) {
            object.packageId = message.packageId;
            if (options.oneofs)
                object.Type = "packageId";
        }
        if (message.classCredit != null && message.hasOwnProperty("classCredit")) {
            object.classCredit = message.classCredit;
            if (options.oneofs)
                object.Type = "classCredit";
        }
        if (message.serviceCredit != null && message.hasOwnProperty("serviceCredit")) {
            object.serviceCredit = message.serviceCredit;
            if (options.oneofs)
                object.Type = "serviceCredit";
        }
        return object;
    };

    /**
     * Converts this PaymentLineItemProto to JSON.
     * @function toJSON
     * @memberof PaymentLineItemProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PaymentLineItemProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PaymentLineItemProto
     * @function getTypeUrl
     * @memberof PaymentLineItemProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PaymentLineItemProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PaymentLineItemProto";
    };

    return PaymentLineItemProto;
})();

$root.AppointmentBookingProto = (function() {

    /**
     * Properties of an AppointmentBookingProto.
     * @exports IAppointmentBookingProto
     * @interface IAppointmentBookingProto
     * @property {string|null} [serviceSku] AppointmentBookingProto serviceSku
     * @property {string|null} [locationId] AppointmentBookingProto locationId
     * @property {string|null} [practitionerId] AppointmentBookingProto practitionerId
     * @property {number|Long|null} [timestamp] AppointmentBookingProto timestamp
     * @property {boolean|null} [isVirtual] AppointmentBookingProto isVirtual
     */

    /**
     * Constructs a new AppointmentBookingProto.
     * @exports AppointmentBookingProto
     * @classdesc Represents an AppointmentBookingProto.
     * @implements IAppointmentBookingProto
     * @constructor
     * @param {IAppointmentBookingProto=} [properties] Properties to set
     */
    function AppointmentBookingProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AppointmentBookingProto serviceSku.
     * @member {string} serviceSku
     * @memberof AppointmentBookingProto
     * @instance
     */
    AppointmentBookingProto.prototype.serviceSku = "";

    /**
     * AppointmentBookingProto locationId.
     * @member {string} locationId
     * @memberof AppointmentBookingProto
     * @instance
     */
    AppointmentBookingProto.prototype.locationId = "";

    /**
     * AppointmentBookingProto practitionerId.
     * @member {string} practitionerId
     * @memberof AppointmentBookingProto
     * @instance
     */
    AppointmentBookingProto.prototype.practitionerId = "";

    /**
     * AppointmentBookingProto timestamp.
     * @member {number|Long} timestamp
     * @memberof AppointmentBookingProto
     * @instance
     */
    AppointmentBookingProto.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * AppointmentBookingProto isVirtual.
     * @member {boolean} isVirtual
     * @memberof AppointmentBookingProto
     * @instance
     */
    AppointmentBookingProto.prototype.isVirtual = false;

    /**
     * Creates a new AppointmentBookingProto instance using the specified properties.
     * @function create
     * @memberof AppointmentBookingProto
     * @static
     * @param {IAppointmentBookingProto=} [properties] Properties to set
     * @returns {AppointmentBookingProto} AppointmentBookingProto instance
     */
    AppointmentBookingProto.create = function create(properties) {
        return new AppointmentBookingProto(properties);
    };

    /**
     * Encodes the specified AppointmentBookingProto message. Does not implicitly {@link AppointmentBookingProto.verify|verify} messages.
     * @function encode
     * @memberof AppointmentBookingProto
     * @static
     * @param {IAppointmentBookingProto} message AppointmentBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentBookingProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serviceSku != null && Object.hasOwnProperty.call(message, "serviceSku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.serviceSku);
        if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
        if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.practitionerId);
        if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.timestamp);
        if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isVirtual);
        return writer;
    };

    /**
     * Encodes the specified AppointmentBookingProto message, length delimited. Does not implicitly {@link AppointmentBookingProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AppointmentBookingProto
     * @static
     * @param {IAppointmentBookingProto} message AppointmentBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentBookingProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AppointmentBookingProto message from the specified reader or buffer.
     * @function decode
     * @memberof AppointmentBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AppointmentBookingProto} AppointmentBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentBookingProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AppointmentBookingProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.serviceSku = reader.string();
                    break;
                }
            case 2: {
                    message.locationId = reader.string();
                    break;
                }
            case 3: {
                    message.practitionerId = reader.string();
                    break;
                }
            case 4: {
                    message.timestamp = reader.int64();
                    break;
                }
            case 5: {
                    message.isVirtual = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AppointmentBookingProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AppointmentBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AppointmentBookingProto} AppointmentBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentBookingProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AppointmentBookingProto message.
     * @function verify
     * @memberof AppointmentBookingProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AppointmentBookingProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            if (!$util.isString(message.serviceSku))
                return "serviceSku: string expected";
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            if (!$util.isString(message.locationId))
                return "locationId: string expected";
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            if (!$util.isString(message.practitionerId))
                return "practitionerId: string expected";
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                return "timestamp: integer|Long expected";
        if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
            if (typeof message.isVirtual !== "boolean")
                return "isVirtual: boolean expected";
        return null;
    };

    /**
     * Creates an AppointmentBookingProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AppointmentBookingProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AppointmentBookingProto} AppointmentBookingProto
     */
    AppointmentBookingProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AppointmentBookingProto)
            return object;
        var message = new $root.AppointmentBookingProto();
        if (object.serviceSku != null)
            message.serviceSku = String(object.serviceSku);
        if (object.locationId != null)
            message.locationId = String(object.locationId);
        if (object.practitionerId != null)
            message.practitionerId = String(object.practitionerId);
        if (object.timestamp != null)
            if ($util.Long)
                (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
            else if (typeof object.timestamp === "string")
                message.timestamp = parseInt(object.timestamp, 10);
            else if (typeof object.timestamp === "number")
                message.timestamp = object.timestamp;
            else if (typeof object.timestamp === "object")
                message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
        if (object.isVirtual != null)
            message.isVirtual = Boolean(object.isVirtual);
        return message;
    };

    /**
     * Creates a plain object from an AppointmentBookingProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AppointmentBookingProto
     * @static
     * @param {AppointmentBookingProto} message AppointmentBookingProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AppointmentBookingProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.serviceSku = "";
            object.locationId = "";
            object.practitionerId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.timestamp = options.longs === String ? "0" : 0;
            object.isVirtual = false;
        }
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            object.serviceSku = message.serviceSku;
        if (message.locationId != null && message.hasOwnProperty("locationId"))
            object.locationId = message.locationId;
        if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
            object.practitionerId = message.practitionerId;
        if (message.timestamp != null && message.hasOwnProperty("timestamp"))
            if (typeof message.timestamp === "number")
                object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
            else
                object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
        if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
            object.isVirtual = message.isVirtual;
        return object;
    };

    /**
     * Converts this AppointmentBookingProto to JSON.
     * @function toJSON
     * @memberof AppointmentBookingProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AppointmentBookingProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AppointmentBookingProto
     * @function getTypeUrl
     * @memberof AppointmentBookingProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AppointmentBookingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AppointmentBookingProto";
    };

    return AppointmentBookingProto;
})();

$root.BillingConfigRequest = (function() {

    /**
     * Properties of a BillingConfigRequest.
     * @exports IBillingConfigRequest
     * @interface IBillingConfigRequest
     */

    /**
     * Constructs a new BillingConfigRequest.
     * @exports BillingConfigRequest
     * @classdesc Represents a BillingConfigRequest.
     * @implements IBillingConfigRequest
     * @constructor
     * @param {IBillingConfigRequest=} [properties] Properties to set
     */
    function BillingConfigRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new BillingConfigRequest instance using the specified properties.
     * @function create
     * @memberof BillingConfigRequest
     * @static
     * @param {IBillingConfigRequest=} [properties] Properties to set
     * @returns {BillingConfigRequest} BillingConfigRequest instance
     */
    BillingConfigRequest.create = function create(properties) {
        return new BillingConfigRequest(properties);
    };

    /**
     * Encodes the specified BillingConfigRequest message. Does not implicitly {@link BillingConfigRequest.verify|verify} messages.
     * @function encode
     * @memberof BillingConfigRequest
     * @static
     * @param {IBillingConfigRequest} message BillingConfigRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BillingConfigRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified BillingConfigRequest message, length delimited. Does not implicitly {@link BillingConfigRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BillingConfigRequest
     * @static
     * @param {IBillingConfigRequest} message BillingConfigRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BillingConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BillingConfigRequest message from the specified reader or buffer.
     * @function decode
     * @memberof BillingConfigRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BillingConfigRequest} BillingConfigRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BillingConfigRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BillingConfigRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BillingConfigRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BillingConfigRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BillingConfigRequest} BillingConfigRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BillingConfigRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BillingConfigRequest message.
     * @function verify
     * @memberof BillingConfigRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BillingConfigRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a BillingConfigRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BillingConfigRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BillingConfigRequest} BillingConfigRequest
     */
    BillingConfigRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.BillingConfigRequest)
            return object;
        return new $root.BillingConfigRequest();
    };

    /**
     * Creates a plain object from a BillingConfigRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BillingConfigRequest
     * @static
     * @param {BillingConfigRequest} message BillingConfigRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BillingConfigRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this BillingConfigRequest to JSON.
     * @function toJSON
     * @memberof BillingConfigRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BillingConfigRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BillingConfigRequest
     * @function getTypeUrl
     * @memberof BillingConfigRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BillingConfigRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BillingConfigRequest";
    };

    return BillingConfigRequest;
})();

$root.BillingConfigResponse = (function() {

    /**
     * Properties of a BillingConfigResponse.
     * @exports IBillingConfigResponse
     * @interface IBillingConfigResponse
     * @property {string|null} [portalUrl] BillingConfigResponse portalUrl
     */

    /**
     * Constructs a new BillingConfigResponse.
     * @exports BillingConfigResponse
     * @classdesc Represents a BillingConfigResponse.
     * @implements IBillingConfigResponse
     * @constructor
     * @param {IBillingConfigResponse=} [properties] Properties to set
     */
    function BillingConfigResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BillingConfigResponse portalUrl.
     * @member {string} portalUrl
     * @memberof BillingConfigResponse
     * @instance
     */
    BillingConfigResponse.prototype.portalUrl = "";

    /**
     * Creates a new BillingConfigResponse instance using the specified properties.
     * @function create
     * @memberof BillingConfigResponse
     * @static
     * @param {IBillingConfigResponse=} [properties] Properties to set
     * @returns {BillingConfigResponse} BillingConfigResponse instance
     */
    BillingConfigResponse.create = function create(properties) {
        return new BillingConfigResponse(properties);
    };

    /**
     * Encodes the specified BillingConfigResponse message. Does not implicitly {@link BillingConfigResponse.verify|verify} messages.
     * @function encode
     * @memberof BillingConfigResponse
     * @static
     * @param {IBillingConfigResponse} message BillingConfigResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BillingConfigResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.portalUrl != null && Object.hasOwnProperty.call(message, "portalUrl"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.portalUrl);
        return writer;
    };

    /**
     * Encodes the specified BillingConfigResponse message, length delimited. Does not implicitly {@link BillingConfigResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BillingConfigResponse
     * @static
     * @param {IBillingConfigResponse} message BillingConfigResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BillingConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BillingConfigResponse message from the specified reader or buffer.
     * @function decode
     * @memberof BillingConfigResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BillingConfigResponse} BillingConfigResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BillingConfigResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BillingConfigResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.portalUrl = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BillingConfigResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BillingConfigResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BillingConfigResponse} BillingConfigResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BillingConfigResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BillingConfigResponse message.
     * @function verify
     * @memberof BillingConfigResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BillingConfigResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.portalUrl != null && message.hasOwnProperty("portalUrl"))
            if (!$util.isString(message.portalUrl))
                return "portalUrl: string expected";
        return null;
    };

    /**
     * Creates a BillingConfigResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BillingConfigResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BillingConfigResponse} BillingConfigResponse
     */
    BillingConfigResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.BillingConfigResponse)
            return object;
        var message = new $root.BillingConfigResponse();
        if (object.portalUrl != null)
            message.portalUrl = String(object.portalUrl);
        return message;
    };

    /**
     * Creates a plain object from a BillingConfigResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BillingConfigResponse
     * @static
     * @param {BillingConfigResponse} message BillingConfigResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BillingConfigResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.portalUrl = "";
        if (message.portalUrl != null && message.hasOwnProperty("portalUrl"))
            object.portalUrl = message.portalUrl;
        return object;
    };

    /**
     * Converts this BillingConfigResponse to JSON.
     * @function toJSON
     * @memberof BillingConfigResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BillingConfigResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for BillingConfigResponse
     * @function getTypeUrl
     * @memberof BillingConfigResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    BillingConfigResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BillingConfigResponse";
    };

    return BillingConfigResponse;
})();

$root.CheckReservationStatusRequest = (function() {

    /**
     * Properties of a CheckReservationStatusRequest.
     * @exports ICheckReservationStatusRequest
     * @interface ICheckReservationStatusRequest
     * @property {string|null} [bookingId] CheckReservationStatusRequest bookingId
     */

    /**
     * Constructs a new CheckReservationStatusRequest.
     * @exports CheckReservationStatusRequest
     * @classdesc Represents a CheckReservationStatusRequest.
     * @implements ICheckReservationStatusRequest
     * @constructor
     * @param {ICheckReservationStatusRequest=} [properties] Properties to set
     */
    function CheckReservationStatusRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckReservationStatusRequest bookingId.
     * @member {string} bookingId
     * @memberof CheckReservationStatusRequest
     * @instance
     */
    CheckReservationStatusRequest.prototype.bookingId = "";

    /**
     * Creates a new CheckReservationStatusRequest instance using the specified properties.
     * @function create
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {ICheckReservationStatusRequest=} [properties] Properties to set
     * @returns {CheckReservationStatusRequest} CheckReservationStatusRequest instance
     */
    CheckReservationStatusRequest.create = function create(properties) {
        return new CheckReservationStatusRequest(properties);
    };

    /**
     * Encodes the specified CheckReservationStatusRequest message. Does not implicitly {@link CheckReservationStatusRequest.verify|verify} messages.
     * @function encode
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {ICheckReservationStatusRequest} message CheckReservationStatusRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckReservationStatusRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
        return writer;
    };

    /**
     * Encodes the specified CheckReservationStatusRequest message, length delimited. Does not implicitly {@link CheckReservationStatusRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {ICheckReservationStatusRequest} message CheckReservationStatusRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckReservationStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckReservationStatusRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckReservationStatusRequest} CheckReservationStatusRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckReservationStatusRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckReservationStatusRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.bookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckReservationStatusRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckReservationStatusRequest} CheckReservationStatusRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckReservationStatusRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckReservationStatusRequest message.
     * @function verify
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckReservationStatusRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            if (!$util.isString(message.bookingId))
                return "bookingId: string expected";
        return null;
    };

    /**
     * Creates a CheckReservationStatusRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckReservationStatusRequest} CheckReservationStatusRequest
     */
    CheckReservationStatusRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckReservationStatusRequest)
            return object;
        var message = new $root.CheckReservationStatusRequest();
        if (object.bookingId != null)
            message.bookingId = String(object.bookingId);
        return message;
    };

    /**
     * Creates a plain object from a CheckReservationStatusRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {CheckReservationStatusRequest} message CheckReservationStatusRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckReservationStatusRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.bookingId = "";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            object.bookingId = message.bookingId;
        return object;
    };

    /**
     * Converts this CheckReservationStatusRequest to JSON.
     * @function toJSON
     * @memberof CheckReservationStatusRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckReservationStatusRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckReservationStatusRequest
     * @function getTypeUrl
     * @memberof CheckReservationStatusRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckReservationStatusRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckReservationStatusRequest";
    };

    return CheckReservationStatusRequest;
})();

$root.CheckReservationStatusResponse = (function() {

    /**
     * Properties of a CheckReservationStatusResponse.
     * @exports ICheckReservationStatusResponse
     * @interface ICheckReservationStatusResponse
     * @property {boolean|null} [okay] CheckReservationStatusResponse okay
     * @property {space.kenko.proto.IApiBookingProto|null} [booking] CheckReservationStatusResponse booking
     */

    /**
     * Constructs a new CheckReservationStatusResponse.
     * @exports CheckReservationStatusResponse
     * @classdesc Represents a CheckReservationStatusResponse.
     * @implements ICheckReservationStatusResponse
     * @constructor
     * @param {ICheckReservationStatusResponse=} [properties] Properties to set
     */
    function CheckReservationStatusResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckReservationStatusResponse okay.
     * @member {boolean} okay
     * @memberof CheckReservationStatusResponse
     * @instance
     */
    CheckReservationStatusResponse.prototype.okay = false;

    /**
     * CheckReservationStatusResponse booking.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} booking
     * @memberof CheckReservationStatusResponse
     * @instance
     */
    CheckReservationStatusResponse.prototype.booking = null;

    /**
     * Creates a new CheckReservationStatusResponse instance using the specified properties.
     * @function create
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {ICheckReservationStatusResponse=} [properties] Properties to set
     * @returns {CheckReservationStatusResponse} CheckReservationStatusResponse instance
     */
    CheckReservationStatusResponse.create = function create(properties) {
        return new CheckReservationStatusResponse(properties);
    };

    /**
     * Encodes the specified CheckReservationStatusResponse message. Does not implicitly {@link CheckReservationStatusResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {ICheckReservationStatusResponse} message CheckReservationStatusResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckReservationStatusResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.booking != null && Object.hasOwnProperty.call(message, "booking"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.booking, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CheckReservationStatusResponse message, length delimited. Does not implicitly {@link CheckReservationStatusResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {ICheckReservationStatusResponse} message CheckReservationStatusResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckReservationStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckReservationStatusResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckReservationStatusResponse} CheckReservationStatusResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckReservationStatusResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckReservationStatusResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.booking = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckReservationStatusResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckReservationStatusResponse} CheckReservationStatusResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckReservationStatusResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckReservationStatusResponse message.
     * @function verify
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckReservationStatusResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.booking != null && message.hasOwnProperty("booking")) {
            var error = $root.space.kenko.proto.ApiBookingProto.verify(message.booking);
            if (error)
                return "booking." + error;
        }
        return null;
    };

    /**
     * Creates a CheckReservationStatusResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckReservationStatusResponse} CheckReservationStatusResponse
     */
    CheckReservationStatusResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckReservationStatusResponse)
            return object;
        var message = new $root.CheckReservationStatusResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.booking != null) {
            if (typeof object.booking !== "object")
                throw TypeError(".CheckReservationStatusResponse.booking: object expected");
            message.booking = $root.space.kenko.proto.ApiBookingProto.fromObject(object.booking);
        }
        return message;
    };

    /**
     * Creates a plain object from a CheckReservationStatusResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {CheckReservationStatusResponse} message CheckReservationStatusResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckReservationStatusResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.booking = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.booking != null && message.hasOwnProperty("booking"))
            object.booking = $root.space.kenko.proto.ApiBookingProto.toObject(message.booking, options);
        return object;
    };

    /**
     * Converts this CheckReservationStatusResponse to JSON.
     * @function toJSON
     * @memberof CheckReservationStatusResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckReservationStatusResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckReservationStatusResponse
     * @function getTypeUrl
     * @memberof CheckReservationStatusResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckReservationStatusResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckReservationStatusResponse";
    };

    return CheckReservationStatusResponse;
})();

$root.GetFulfillmentStatusRequest = (function() {

    /**
     * Properties of a GetFulfillmentStatusRequest.
     * @exports IGetFulfillmentStatusRequest
     * @interface IGetFulfillmentStatusRequest
     * @property {string|null} [sessionId] GetFulfillmentStatusRequest sessionId
     */

    /**
     * Constructs a new GetFulfillmentStatusRequest.
     * @exports GetFulfillmentStatusRequest
     * @classdesc Represents a GetFulfillmentStatusRequest.
     * @implements IGetFulfillmentStatusRequest
     * @constructor
     * @param {IGetFulfillmentStatusRequest=} [properties] Properties to set
     */
    function GetFulfillmentStatusRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetFulfillmentStatusRequest sessionId.
     * @member {string} sessionId
     * @memberof GetFulfillmentStatusRequest
     * @instance
     */
    GetFulfillmentStatusRequest.prototype.sessionId = "";

    /**
     * Creates a new GetFulfillmentStatusRequest instance using the specified properties.
     * @function create
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {IGetFulfillmentStatusRequest=} [properties] Properties to set
     * @returns {GetFulfillmentStatusRequest} GetFulfillmentStatusRequest instance
     */
    GetFulfillmentStatusRequest.create = function create(properties) {
        return new GetFulfillmentStatusRequest(properties);
    };

    /**
     * Encodes the specified GetFulfillmentStatusRequest message. Does not implicitly {@link GetFulfillmentStatusRequest.verify|verify} messages.
     * @function encode
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {IGetFulfillmentStatusRequest} message GetFulfillmentStatusRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFulfillmentStatusRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.sessionId);
        return writer;
    };

    /**
     * Encodes the specified GetFulfillmentStatusRequest message, length delimited. Does not implicitly {@link GetFulfillmentStatusRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {IGetFulfillmentStatusRequest} message GetFulfillmentStatusRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFulfillmentStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetFulfillmentStatusRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetFulfillmentStatusRequest} GetFulfillmentStatusRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFulfillmentStatusRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFulfillmentStatusRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.sessionId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetFulfillmentStatusRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetFulfillmentStatusRequest} GetFulfillmentStatusRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFulfillmentStatusRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetFulfillmentStatusRequest message.
     * @function verify
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetFulfillmentStatusRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            if (!$util.isString(message.sessionId))
                return "sessionId: string expected";
        return null;
    };

    /**
     * Creates a GetFulfillmentStatusRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetFulfillmentStatusRequest} GetFulfillmentStatusRequest
     */
    GetFulfillmentStatusRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFulfillmentStatusRequest)
            return object;
        var message = new $root.GetFulfillmentStatusRequest();
        if (object.sessionId != null)
            message.sessionId = String(object.sessionId);
        return message;
    };

    /**
     * Creates a plain object from a GetFulfillmentStatusRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {GetFulfillmentStatusRequest} message GetFulfillmentStatusRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetFulfillmentStatusRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.sessionId = "";
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            object.sessionId = message.sessionId;
        return object;
    };

    /**
     * Converts this GetFulfillmentStatusRequest to JSON.
     * @function toJSON
     * @memberof GetFulfillmentStatusRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetFulfillmentStatusRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetFulfillmentStatusRequest
     * @function getTypeUrl
     * @memberof GetFulfillmentStatusRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetFulfillmentStatusRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetFulfillmentStatusRequest";
    };

    return GetFulfillmentStatusRequest;
})();

$root.GetFulfillmentStatusResponse = (function() {

    /**
     * Properties of a GetFulfillmentStatusResponse.
     * @exports IGetFulfillmentStatusResponse
     * @interface IGetFulfillmentStatusResponse
     * @property {boolean|null} [okay] GetFulfillmentStatusResponse okay
     * @property {string|null} [error] GetFulfillmentStatusResponse error
     * @property {IClientRelationshipDetailsProto|null} [updatedClientRelationship] GetFulfillmentStatusResponse updatedClientRelationship
     * @property {IFulfillmentProto|null} [fulfillment] GetFulfillmentStatusResponse fulfillment
     * @property {string|null} [businessId] GetFulfillmentStatusResponse businessId
     * @property {string|null} [eventInstanceId] GetFulfillmentStatusResponse eventInstanceId
     */

    /**
     * Constructs a new GetFulfillmentStatusResponse.
     * @exports GetFulfillmentStatusResponse
     * @classdesc Represents a GetFulfillmentStatusResponse.
     * @implements IGetFulfillmentStatusResponse
     * @constructor
     * @param {IGetFulfillmentStatusResponse=} [properties] Properties to set
     */
    function GetFulfillmentStatusResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetFulfillmentStatusResponse okay.
     * @member {boolean} okay
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.okay = false;

    /**
     * GetFulfillmentStatusResponse error.
     * @member {string} error
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.error = "";

    /**
     * GetFulfillmentStatusResponse updatedClientRelationship.
     * @member {IClientRelationshipDetailsProto|null|undefined} updatedClientRelationship
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.updatedClientRelationship = null;

    /**
     * GetFulfillmentStatusResponse fulfillment.
     * @member {IFulfillmentProto|null|undefined} fulfillment
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.fulfillment = null;

    /**
     * GetFulfillmentStatusResponse businessId.
     * @member {string} businessId
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.businessId = "";

    /**
     * GetFulfillmentStatusResponse eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof GetFulfillmentStatusResponse
     * @instance
     */
    GetFulfillmentStatusResponse.prototype.eventInstanceId = "";

    /**
     * Creates a new GetFulfillmentStatusResponse instance using the specified properties.
     * @function create
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {IGetFulfillmentStatusResponse=} [properties] Properties to set
     * @returns {GetFulfillmentStatusResponse} GetFulfillmentStatusResponse instance
     */
    GetFulfillmentStatusResponse.create = function create(properties) {
        return new GetFulfillmentStatusResponse(properties);
    };

    /**
     * Encodes the specified GetFulfillmentStatusResponse message. Does not implicitly {@link GetFulfillmentStatusResponse.verify|verify} messages.
     * @function encode
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {IGetFulfillmentStatusResponse} message GetFulfillmentStatusResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFulfillmentStatusResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.updatedClientRelationship != null && Object.hasOwnProperty.call(message, "updatedClientRelationship"))
            $root.ClientRelationshipDetailsProto.encode(message.updatedClientRelationship, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.fulfillment != null && Object.hasOwnProperty.call(message, "fulfillment"))
            $root.FulfillmentProto.encode(message.fulfillment, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.businessId);
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.eventInstanceId);
        return writer;
    };

    /**
     * Encodes the specified GetFulfillmentStatusResponse message, length delimited. Does not implicitly {@link GetFulfillmentStatusResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {IGetFulfillmentStatusResponse} message GetFulfillmentStatusResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetFulfillmentStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetFulfillmentStatusResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetFulfillmentStatusResponse} GetFulfillmentStatusResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFulfillmentStatusResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetFulfillmentStatusResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    message.updatedClientRelationship = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.fulfillment = $root.FulfillmentProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.businessId = reader.string();
                    break;
                }
            case 6: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetFulfillmentStatusResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetFulfillmentStatusResponse} GetFulfillmentStatusResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetFulfillmentStatusResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetFulfillmentStatusResponse message.
     * @function verify
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetFulfillmentStatusResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.updatedClientRelationship != null && message.hasOwnProperty("updatedClientRelationship")) {
            var error = $root.ClientRelationshipDetailsProto.verify(message.updatedClientRelationship);
            if (error)
                return "updatedClientRelationship." + error;
        }
        if (message.fulfillment != null && message.hasOwnProperty("fulfillment")) {
            var error = $root.FulfillmentProto.verify(message.fulfillment);
            if (error)
                return "fulfillment." + error;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        return null;
    };

    /**
     * Creates a GetFulfillmentStatusResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetFulfillmentStatusResponse} GetFulfillmentStatusResponse
     */
    GetFulfillmentStatusResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetFulfillmentStatusResponse)
            return object;
        var message = new $root.GetFulfillmentStatusResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.updatedClientRelationship != null) {
            if (typeof object.updatedClientRelationship !== "object")
                throw TypeError(".GetFulfillmentStatusResponse.updatedClientRelationship: object expected");
            message.updatedClientRelationship = $root.ClientRelationshipDetailsProto.fromObject(object.updatedClientRelationship);
        }
        if (object.fulfillment != null) {
            if (typeof object.fulfillment !== "object")
                throw TypeError(".GetFulfillmentStatusResponse.fulfillment: object expected");
            message.fulfillment = $root.FulfillmentProto.fromObject(object.fulfillment);
        }
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        return message;
    };

    /**
     * Creates a plain object from a GetFulfillmentStatusResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {GetFulfillmentStatusResponse} message GetFulfillmentStatusResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetFulfillmentStatusResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.okay = false;
            object.error = "";
            object.updatedClientRelationship = null;
            object.fulfillment = null;
            object.businessId = "";
            object.eventInstanceId = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.updatedClientRelationship != null && message.hasOwnProperty("updatedClientRelationship"))
            object.updatedClientRelationship = $root.ClientRelationshipDetailsProto.toObject(message.updatedClientRelationship, options);
        if (message.fulfillment != null && message.hasOwnProperty("fulfillment"))
            object.fulfillment = $root.FulfillmentProto.toObject(message.fulfillment, options);
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        return object;
    };

    /**
     * Converts this GetFulfillmentStatusResponse to JSON.
     * @function toJSON
     * @memberof GetFulfillmentStatusResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetFulfillmentStatusResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetFulfillmentStatusResponse
     * @function getTypeUrl
     * @memberof GetFulfillmentStatusResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetFulfillmentStatusResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetFulfillmentStatusResponse";
    };

    return GetFulfillmentStatusResponse;
})();

$root.MetadataProto = (function() {

    /**
     * Properties of a MetadataProto.
     * @exports IMetadataProto
     * @interface IMetadataProto
     * @property {string|null} [key] MetadataProto key
     * @property {string|null} [value] MetadataProto value
     */

    /**
     * Constructs a new MetadataProto.
     * @exports MetadataProto
     * @classdesc Represents a MetadataProto.
     * @implements IMetadataProto
     * @constructor
     * @param {IMetadataProto=} [properties] Properties to set
     */
    function MetadataProto(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MetadataProto key.
     * @member {string} key
     * @memberof MetadataProto
     * @instance
     */
    MetadataProto.prototype.key = "";

    /**
     * MetadataProto value.
     * @member {string} value
     * @memberof MetadataProto
     * @instance
     */
    MetadataProto.prototype.value = "";

    /**
     * Creates a new MetadataProto instance using the specified properties.
     * @function create
     * @memberof MetadataProto
     * @static
     * @param {IMetadataProto=} [properties] Properties to set
     * @returns {MetadataProto} MetadataProto instance
     */
    MetadataProto.create = function create(properties) {
        return new MetadataProto(properties);
    };

    /**
     * Encodes the specified MetadataProto message. Does not implicitly {@link MetadataProto.verify|verify} messages.
     * @function encode
     * @memberof MetadataProto
     * @static
     * @param {IMetadataProto} message MetadataProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetadataProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
        return writer;
    };

    /**
     * Encodes the specified MetadataProto message, length delimited. Does not implicitly {@link MetadataProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MetadataProto
     * @static
     * @param {IMetadataProto} message MetadataProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetadataProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MetadataProto message from the specified reader or buffer.
     * @function decode
     * @memberof MetadataProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetadataProto} MetadataProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetadataProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MetadataProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    message.value = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MetadataProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MetadataProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MetadataProto} MetadataProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetadataProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MetadataProto message.
     * @function verify
     * @memberof MetadataProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MetadataProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        return null;
    };

    /**
     * Creates a MetadataProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetadataProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetadataProto} MetadataProto
     */
    MetadataProto.fromObject = function fromObject(object) {
        if (object instanceof $root.MetadataProto)
            return object;
        var message = new $root.MetadataProto();
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    /**
     * Creates a plain object from a MetadataProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetadataProto
     * @static
     * @param {MetadataProto} message MetadataProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetadataProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.key = "";
            object.value = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    /**
     * Converts this MetadataProto to JSON.
     * @function toJSON
     * @memberof MetadataProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetadataProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MetadataProto
     * @function getTypeUrl
     * @memberof MetadataProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MetadataProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MetadataProto";
    };

    return MetadataProto;
})();

$root.FulfillmentProto = (function() {

    /**
     * Properties of a FulfillmentProto.
     * @exports IFulfillmentProto
     * @interface IFulfillmentProto
     * @property {IPurchasedSingleClassCreditProto|null} [purchasedCredit] FulfillmentProto purchasedCredit
     * @property {IPurchasedPackageProto|null} [purchasedPackage] FulfillmentProto purchasedPackage
     * @property {Array.<IMetadataProto>|null} [stripeMetadata] FulfillmentProto stripeMetadata
     */

    /**
     * Constructs a new FulfillmentProto.
     * @exports FulfillmentProto
     * @classdesc Represents a FulfillmentProto.
     * @implements IFulfillmentProto
     * @constructor
     * @param {IFulfillmentProto=} [properties] Properties to set
     */
    function FulfillmentProto(properties) {
        this.stripeMetadata = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FulfillmentProto purchasedCredit.
     * @member {IPurchasedSingleClassCreditProto|null|undefined} purchasedCredit
     * @memberof FulfillmentProto
     * @instance
     */
    FulfillmentProto.prototype.purchasedCredit = null;

    /**
     * FulfillmentProto purchasedPackage.
     * @member {IPurchasedPackageProto|null|undefined} purchasedPackage
     * @memberof FulfillmentProto
     * @instance
     */
    FulfillmentProto.prototype.purchasedPackage = null;

    /**
     * FulfillmentProto stripeMetadata.
     * @member {Array.<IMetadataProto>} stripeMetadata
     * @memberof FulfillmentProto
     * @instance
     */
    FulfillmentProto.prototype.stripeMetadata = $util.emptyArray;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * FulfillmentProto Fulfillment.
     * @member {"purchasedCredit"|"purchasedPackage"|undefined} Fulfillment
     * @memberof FulfillmentProto
     * @instance
     */
    Object.defineProperty(FulfillmentProto.prototype, "Fulfillment", {
        get: $util.oneOfGetter($oneOfFields = ["purchasedCredit", "purchasedPackage"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new FulfillmentProto instance using the specified properties.
     * @function create
     * @memberof FulfillmentProto
     * @static
     * @param {IFulfillmentProto=} [properties] Properties to set
     * @returns {FulfillmentProto} FulfillmentProto instance
     */
    FulfillmentProto.create = function create(properties) {
        return new FulfillmentProto(properties);
    };

    /**
     * Encodes the specified FulfillmentProto message. Does not implicitly {@link FulfillmentProto.verify|verify} messages.
     * @function encode
     * @memberof FulfillmentProto
     * @static
     * @param {IFulfillmentProto} message FulfillmentProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FulfillmentProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.purchasedCredit != null && Object.hasOwnProperty.call(message, "purchasedCredit"))
            $root.PurchasedSingleClassCreditProto.encode(message.purchasedCredit, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.purchasedPackage != null && Object.hasOwnProperty.call(message, "purchasedPackage"))
            $root.PurchasedPackageProto.encode(message.purchasedPackage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.stripeMetadata != null && message.stripeMetadata.length)
            for (var i = 0; i < message.stripeMetadata.length; ++i)
                $root.MetadataProto.encode(message.stripeMetadata[i], writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FulfillmentProto message, length delimited. Does not implicitly {@link FulfillmentProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FulfillmentProto
     * @static
     * @param {IFulfillmentProto} message FulfillmentProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FulfillmentProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FulfillmentProto message from the specified reader or buffer.
     * @function decode
     * @memberof FulfillmentProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FulfillmentProto} FulfillmentProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FulfillmentProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FulfillmentProto();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.purchasedCredit = $root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.purchasedPackage = $root.PurchasedPackageProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    if (!(message.stripeMetadata && message.stripeMetadata.length))
                        message.stripeMetadata = [];
                    message.stripeMetadata.push($root.MetadataProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FulfillmentProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FulfillmentProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FulfillmentProto} FulfillmentProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FulfillmentProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FulfillmentProto message.
     * @function verify
     * @memberof FulfillmentProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FulfillmentProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (message.purchasedCredit != null && message.hasOwnProperty("purchasedCredit")) {
            properties.Fulfillment = 1;
            {
                var error = $root.PurchasedSingleClassCreditProto.verify(message.purchasedCredit);
                if (error)
                    return "purchasedCredit." + error;
            }
        }
        if (message.purchasedPackage != null && message.hasOwnProperty("purchasedPackage")) {
            if (properties.Fulfillment === 1)
                return "Fulfillment: multiple values";
            properties.Fulfillment = 1;
            {
                var error = $root.PurchasedPackageProto.verify(message.purchasedPackage);
                if (error)
                    return "purchasedPackage." + error;
            }
        }
        if (message.stripeMetadata != null && message.hasOwnProperty("stripeMetadata")) {
            if (!Array.isArray(message.stripeMetadata))
                return "stripeMetadata: array expected";
            for (var i = 0; i < message.stripeMetadata.length; ++i) {
                var error = $root.MetadataProto.verify(message.stripeMetadata[i]);
                if (error)
                    return "stripeMetadata." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FulfillmentProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FulfillmentProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FulfillmentProto} FulfillmentProto
     */
    FulfillmentProto.fromObject = function fromObject(object) {
        if (object instanceof $root.FulfillmentProto)
            return object;
        var message = new $root.FulfillmentProto();
        if (object.purchasedCredit != null) {
            if (typeof object.purchasedCredit !== "object")
                throw TypeError(".FulfillmentProto.purchasedCredit: object expected");
            message.purchasedCredit = $root.PurchasedSingleClassCreditProto.fromObject(object.purchasedCredit);
        }
        if (object.purchasedPackage != null) {
            if (typeof object.purchasedPackage !== "object")
                throw TypeError(".FulfillmentProto.purchasedPackage: object expected");
            message.purchasedPackage = $root.PurchasedPackageProto.fromObject(object.purchasedPackage);
        }
        if (object.stripeMetadata) {
            if (!Array.isArray(object.stripeMetadata))
                throw TypeError(".FulfillmentProto.stripeMetadata: array expected");
            message.stripeMetadata = [];
            for (var i = 0; i < object.stripeMetadata.length; ++i) {
                if (typeof object.stripeMetadata[i] !== "object")
                    throw TypeError(".FulfillmentProto.stripeMetadata: object expected");
                message.stripeMetadata[i] = $root.MetadataProto.fromObject(object.stripeMetadata[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FulfillmentProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FulfillmentProto
     * @static
     * @param {FulfillmentProto} message FulfillmentProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FulfillmentProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.stripeMetadata = [];
        if (message.purchasedCredit != null && message.hasOwnProperty("purchasedCredit")) {
            object.purchasedCredit = $root.PurchasedSingleClassCreditProto.toObject(message.purchasedCredit, options);
            if (options.oneofs)
                object.Fulfillment = "purchasedCredit";
        }
        if (message.purchasedPackage != null && message.hasOwnProperty("purchasedPackage")) {
            object.purchasedPackage = $root.PurchasedPackageProto.toObject(message.purchasedPackage, options);
            if (options.oneofs)
                object.Fulfillment = "purchasedPackage";
        }
        if (message.stripeMetadata && message.stripeMetadata.length) {
            object.stripeMetadata = [];
            for (var j = 0; j < message.stripeMetadata.length; ++j)
                object.stripeMetadata[j] = $root.MetadataProto.toObject(message.stripeMetadata[j], options);
        }
        return object;
    };

    /**
     * Converts this FulfillmentProto to JSON.
     * @function toJSON
     * @memberof FulfillmentProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FulfillmentProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FulfillmentProto
     * @function getTypeUrl
     * @memberof FulfillmentProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FulfillmentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FulfillmentProto";
    };

    return FulfillmentProto;
})();

module.exports = $root;
